import doctors from "../Assets/hero1.png"
import phdBusinessAdministration from "../Assets/hero1.png"
import masters from "../Assets/hero1.png"
import undergraduate from "../Assets/hero1.png"
import diploma from "../Assets/hero1.png"
import certificate from "../Assets/hero1.png"

const phoneNumber = "+254 719 034 500"


export const programmes = [

/* ===========================
   PHD PROGRAMMES
=========================== */
{
  id: 1,

  slug: "doctor-of-philosophy-in-computer-science",

  title: "Doctor of Philosophy in Computer Science",

  shortTitle: "PhD Computer Science",

  code: "PhD CS",

  school: "School of ICT, Media and Engineering",

  // department: "Department of Computing",

  // ===============================
  // PROGRAMME CLASSIFICATION
  // ===============================

  qualification: "PHD",                 // Short qualification
  award: "Doctor of Philosophy",        // Full academic award
  category: "PHD",                      // Used for filtering
  level: "Postgraduate",                // Undergraduate / Postgraduate / TVET / Professional
  nqfLevel: "Level 10",                 // Optional KNQF level

  featured: false,

  image: doctors,

  brochure: "/downloads/brochures/phd-computer-science.pdf",

  feeStructure: "/downloads/fees/phd-computer-science-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Leading Innovation at the Highest Level of Technology",

  heroDescription:
    "Zetech University's Doctor of Philosophy in Computer Science develops world-class researchers, innovators and academic leaders capable of creating sustainable technological solutions for society.",

  overview: `
Zetech University's doctoral programme in Computer Science is designed to cultivate world-class leaders, managers, innovators and academicians. The programme combines advanced computer science research with interdisciplinary approaches that solve real-world socio-economic challenges.

Students work alongside renowned researchers, industry experts and international collaborators while producing impactful research that contributes to knowledge creation and innovation.
`,

  whyStudy: [

    "Develop advanced expertise in Computer Science research.",

    "Address real-world challenges through innovative research.",

    "Collaborate with experienced academics and industry professionals.",

    "Transform research into practical technologies and commercial solutions.",

    "Specialize in emerging technologies including AI, Cybersecurity, Data Science and Cloud Computing."

  ],

  entryRequirements: [

    "Master's degree from an accredited university with First Class or Second Class Upper undergraduate qualification.",

    "OR Master's degree plus Second Class Lower undergraduate qualification with at least two years relevant work experience.",

    "OR any equivalent qualification approved by the University Senate."

  ],

  duration: 6,

  durationType: "Total Programme Fee",

  durationYears: "3 Years",

  mode: "Online",

  fee: 699500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  specialisations: [

    "Artificial Intelligence",

    "Computer & Cyber Security",

    "Mobile Computing & Networking",

    "Software Engineering"

  ],

  // curriculum: [

  //   {

  //     specialisation: "Artificial Intelligence",

  //     years: [

  //       {

  //         year: "Year One",

  //         semesters: [

  //           {

  //             semester: "Semester One",

  //             units: [

  //               {
  //                 code: "PBA8110",
  //                 title: "Quantitative and Qualitative Research Methods"
  //               },

  //               {
  //                 code: "ICS8140",
  //                 title: "Advanced Topics in Computer Security"
  //               },

  //               {
  //                 code: "ICS8101",
  //                 title: "Advanced Topics in Theory of Computation"
  //               }

  //             ]

  //           },

  //           {

  //             semester: "Semester Two",

  //             units: [

  //               {
  //                 code: "ICS8130",
  //                 title: "Advanced Topics in Artificial Intelligence Applications"
  //               },

  //               {
  //                 code: "ICS8110",
  //                 title: "Research on Emerging Trends in Computer Science"
  //               },

  //               {
  //                 code: "ICS8291",
  //                 title: "Independent Study"
  //               }

  //             ]

  //           }

  //         ]

  //       },

  //       {

  //         year: "Year Two",

  //         semesters: [

  //           {

  //             semester: "Semester One",

  //             units: [

  //               {
  //                 code: "ICS8231",
  //                 title: "Advanced Research in Deep Learning and Intelligent Systems"
  //               },

  //               {
  //                 code: "ICS8233",
  //                 title: "Advanced Research in Speech Systems and Natural Language Processing"
  //               }

  //             ]

  //           },

  //           {

  //             semester: "Semester Two",

  //             units: [

  //               {
  //                 code: "ICS8399",
  //                 title: "Doctoral Research Thesis"
  //               }

  //             ]

  //           }

  //         ]

  //       }

  //     ]

  //   }

  // ],


curriculum: [

  /* =====================================================
     ARTIFICIAL INTELLIGENCE
  ====================================================== */

  {

    specialisation: "Artificial Intelligence",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PBA8110",
                title: "Quantitative and Qualitative Research Methods"
              },

              {
                code: "ICS8140",
                title: "Advanced Topics in Computer Security"
              },

              {
                code: "ICS8101",
                title: "Advanced Topics in Theory of Computation"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "ICS8130",
                title: "Advanced Topics in Artificial Intelligence Applications"
              },

              {
                code: "ICS8110",
                title: "Research on Emerging Trends in Computer Science (Big Data, IoT and Cloud Computing)"
              },

              {
                code: "ICS8291",
                title: "Independent Study"
              }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "ICS8231",
                title: "Advanced Research in Deep Learning and Intelligent Systems"
              },

              {
                code: "ICS8233",
                title: "Advanced Research in Speech Systems and Natural Language Processing"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {

                code: "ICS8399",

                title: "Doctoral Research Thesis"

              }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     COMPUTER & CYBER SECURITY
  ====================================================== */

  {

    specialisation: "Computer & Cyber Security",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PBA8110",
                title: "Quantitative and Qualitative Research Methods"
              },

              {
                code: "ICS8140",
                title: "Advanced Topics in Computer Security"
              },

              {
                code: "ICS8101",
                title: "Advanced Topics in Theory of Computation"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "ICS8130",
                title: "Advanced Topics in Artificial Intelligence Applications"
              },

              {
                code: "ICS8110",
                title: "Research on Emerging Trends in Computer Science (Big Data, IoT and Cloud Computing)"
              },

              {
                code: "ICS8291",
                title: "Independent Study"
              }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {

                code: "ICS8243",

                title: "Advanced Research in Digital Forensics"

              },

              {

                code: "ICS8214",

                title: "Advanced Research in Network Security and Cyber Terrorism"

              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {

                code: "ICS8399",

                title: "Doctoral Research Thesis"

              }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     MOBILE COMPUTING & NETWORKING
  ====================================================== */

  {

    specialisation: "Mobile Computing & Networking",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PBA8110",
                title: "Quantitative and Qualitative Research Methods"
              },

              {
                code: "ICS8140",
                title: "Advanced Topics in Computer Security"
              },

              {
                code: "ICS8101",
                title: "Advanced Topics in Theory of Computation"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "ICS8130",
                title: "Advanced Topics in Artificial Intelligence Applications"
              },

              {
                code: "ICS8110",
                title: "Research on Emerging Trends in Computer Science (Big Data, IoT and Cloud Computing)"
              },

              {
                code: "ICS8291",
                title: "Independent Study"
              }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {

                code: "ICS8211",

                title: "Advanced Research in Mobile Wireless Ad-Hoc Networks and 5G Technologies"

              },

              {

                code: "ICS8213",

                title: "Advanced Research in IoT Technology and Cloud Computing"

              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {

                code: "ICS8399",

                title: "Doctoral Research Thesis"

              }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     SOFTWARE ENGINEERING
  ====================================================== */

  {

    specialisation: "Software Engineering",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PBA8110",
                title: "Quantitative and Qualitative Research Methods"
              },

              {
                code: "ICS8140",
                title: "Advanced Topics in Computer Security"
              },

              {
                code: "ICS8101",
                title: "Advanced Topics in Theory of Computation"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "ICS8130",
                title: "Advanced Topics in Artificial Intelligence Applications"
              },

              {
                code: "ICS8110",
                title: "Research on Emerging Trends in Computer Science (Big Data, IoT and Cloud Computing)"
              },

              {
                code: "ICS8291",
                title: "Independent Study"
              }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {

                code: "ICS8223",

                title: "Research in Agile and DevOps Practices"

              },

              {

                code: "ICS8224",

                title: "Software Quality Engineering"

              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {

                code: "ICS8399",

                title: "Doctoral Research Thesis"

              }

            ]

          }

        ]

      }

    ]

  }

],

  careers: [

    "University Professor",

    "Research Scientist",

    "Chief Technology Officer",

    "Artificial Intelligence Researcher",

    "Cybersecurity Consultant",

    "Software Architect",

    "Innovation Director",

    "Data Scientist"

  ],

  skills: [

    "Advanced Research",

    "Artificial Intelligence",

    "Cybersecurity",

    "Academic Writing",

    "Innovation",

    "Leadership"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer: "The programme runs for three years (six semesters)."

    },

    {

      question: "Is the programme offered online?",

      answer: "Yes. The PhD is delivered through Online Learning."

    },

    {

      question: "When is the intake?",

      answer: "September intake only."

    }

  ],

  seo: {

    metaTitle: "Doctor of Philosophy in Computer Science | Zetech University",

    metaDescription:
      "Study a PhD in Computer Science at Zetech University specializing in Artificial Intelligence, Cyber Security, Mobile Computing and Software Engineering."

  }

},
{
  id: 2,

  slug: "doctor-of-philosophy-in-business-administration-and-management",

  title: "Doctor of Philosophy in Business Administration and Management",

  shortTitle: "PhD Business Administration",

  code: "PhD BAM",

  school: "School of Business and Economics",

  // ===============================
  // PROGRAMME CLASSIFICATION
  // ===============================

  qualification: "PHD",

  award: "Doctor of Philosophy",

  category: "PHD",

  level: "Postgraduate",

  nqfLevel: "Level 10",

  featured: false,

  image: phdBusinessAdministration,

  brochure:
    "/downloads/brochures/phd-business-administration-and-management.pdf",

  feeStructure:
    "/downloads/fees/phd-business-administration-and-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Generate Knowledge. Drive Progress.",

  heroDescription:
    "The Doctor of Philosophy in Business Administration and Management develops highly skilled researchers, scholars and thought leaders capable of generating new knowledge, influencing policy and driving innovation across business, management and industry.",

  overview: `
The Doctor of Philosophy in Business Administration and Management is designed to develop highly skilled researchers, scholars and thought leaders capable of advancing knowledge in business and management. The programme equips candidates with advanced research competencies, critical thinking, analytical skills and evidence-based decision-making abilities required to solve complex organisational, economic and societal challenges.

Through rigorous doctoral research, scholarly engagement and collaboration with experienced academics and industry practitioners, candidates produce original contributions that influence policy, organisational transformation and global business scholarship.
`,

  whyStudy: [

    "Conduct impactful, solution-oriented research addressing emerging business, organisational and societal challenges.",

    "Develop advanced expertise in research methodologies, data analytics and evidence-based decision making.",

    "Learn under experienced researchers and industry practitioners within a collaborative academic environment.",

    "Specialize in Strategic Management, Human Resource Management, Finance, Supply Chain Management, Entrepreneurship, and Business Intelligence & Data Analytics.",

    "Build strong academic, professional and international research networks through seminars, conferences and collaborative research.",

    "Graduate with advanced leadership, research and policy development competencies for academia, industry and government."

  ],

  entryRequirements: [

    "A Master's degree from an accredited university and First Class or Second Class Upper Division honors at undergraduate level.",

    "OR a Master's degree from an accredited university with Second Class Lower Division honors at undergraduate level and at least two (2) years relevant work experience.",

    "OR any other equivalent qualification approved by the University Senate."

  ],

  duration: 6,

  durationType: "Total Programme Fee",

  durationYears: "3 Years",

  mode: "Online",

  fee: 699500,

  feeType: "Total Fees for the entire programme",

  intake: [

    

    "September"

  ],

  specialisations: [

    "Entrepreneurship and Innovation",

    "Business Intelligence and Data Analytics",

    "Human Resource Management",

    "Financial Management and Investment",

    "Strategic Management",

    "Supply Chain Management"

  ],

  // Curriculum will be added separately (large dataset)
  curriculum: [

  /* =====================================================
     ENTREPRENEURSHIP & INNOVATION
  ===================================================== */

  {

    specialization: "Entrepreneurship & Innovation",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PBA710",
                title: "Advanced Research Methods"
              },

              {
                code: "PBA711",
                title: "Corporate Leadership and Governance"
              },

              {
                code: "PEI710",
                title: "Entrepreneurship Development and New Venture Creation"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "PBA720",
                title: "Advanced Statistical Techniques"
              },

              {
                code: "PBA721",
                title: "Innovation Management and Technology"
              },

              {
                code: "PEI720",
                title: "Contemporary Entrepreneurship Theory and Practice"
              }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              {
                code: "PEI810",
                title: "Entrepreneurship & Innovation Doctoral Seminar"
              },

              {
                code: "PEI811",
                title: "Entrepreneurship & Innovation Comprehensive Paper"
              },

              {
                code: "PEI812",
                title: "Entrepreneurship & Innovation Independent Field Study"
              },

              {
                code: "PBA810",
                title: "Doctoral Seminar"
              },

              {
                code: "PBA811",
                title: "Doctoral Comprehensive Paper"
              },

              {
                code: "PBA812",
                title: "Doctoral Independent Field Study"
              }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              {
                code: "PBA820",
                title: "Research Proposal"
              }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              {
                code: "PBA910",
                title: "Research Thesis"
              }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     HUMAN RESOURCE MANAGEMENT
  ===================================================== */

  {

    specialization: "Human Resource Management",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBA710", title: "Advanced Research Methods" },

              { code: "PBA711", title: "Corporate Leadership and Governance" },

              { code: "PHR710", title: "Human Capital Learning and Development" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA720", title: "Advanced Statistical Techniques" },

              { code: "PBA721", title: "Innovation Management and Technology" },

              { code: "PHR720", title: "Human Resource Management Theories and Information System" }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PHR810", title: "Human Resource Management Doctoral Seminar" },

              { code: "PHR811", title: "Human Resource Management Comprehensive Paper" },

              { code: "PHR812", title: "Human Resource Management Independent Field Study" },

              { code: "PBA810", title: "Doctoral Seminar" },

              { code: "PBA811", title: "Doctoral Comprehensive Paper" },

              { code: "PBA812", title: "Doctoral Independent Field Study" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA820", title: "Research Proposal" }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              { code: "PBA910", title: "Research Thesis" }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     SUPPLY CHAIN MANAGEMENT
  ===================================================== */

  {

    specialization: "Supply Chain Management",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBA710", title: "Advanced Research Methods" },

              { code: "PBA711", title: "Corporate Leadership and Governance" },

              { code: "PPL710", title: "Strategic Procurement Management" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA720", title: "Advanced Statistical Techniques" },

              { code: "PBA721", title: "Innovation Management and Technology" },

              { code: "PPL720", title: "Logistics and Distribution Management" }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PPL810", title: "Supply Chain Management Doctoral Seminar" },

              { code: "PPL811", title: "Supply Chain Management Comprehensive Paper" },

              { code: "PPL812", title: "Supply Chain Management Independent Field Study" },

              { code: "PBA810", title: "Doctoral Seminar" },

              { code: "PBA811", title: "Doctoral Comprehensive Paper" },

              { code: "PBA812", title: "Doctoral Independent Field Study" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA820", title: "Research Proposal" }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              { code: "PBA910", title: "Research Thesis" }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     BUSINESS INTELLIGENCE & DATA ANALYTICS
  ===================================================== */

  {

    specialization: "Business Intelligence & Data Analytics",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBA710", title: "Advanced Research Methods" },

              { code: "PBA711", title: "Corporate Leadership and Governance" },

              { code: "PBI710", title: "Data Mining" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA720", title: "Advanced Statistical Techniques" },

              { code: "PBA721", title: "Innovation Management and Technology" },

              { code: "PBI720", title: "Machine Learning Models" }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBI810", title: "Business Intelligence & Data Analytics Doctoral Seminar" },

              { code: "PBI811", title: "Business Intelligence & Data Analytics Comprehensive Paper" },

              { code: "PBI812", title: "Business Intelligence & Data Analytics Independent Field Study" },

              { code: "PBA810", title: "Doctoral Seminar" },

              { code: "PBA811", title: "Doctoral Comprehensive Paper" },

              { code: "PBA812", title: "Doctoral Independent Field Study" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA820", title: "Research Proposal" }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              { code: "PBA910", title: "Research Thesis" }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     STRATEGIC MANAGEMENT
  ===================================================== */

  {

    specialization: "Strategic Management",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBA710", title: "Advanced Research Methods" },

              { code: "PBA711", title: "Corporate Leadership and Governance" },

              { code: "PSM710", title: "Dynamic Capability and Competitive Advantage" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA720", title: "Advanced Statistical Techniques" },

              { code: "PBA721", title: "Innovation Management and Technology" },

              { code: "PSM720", title: "Strategic Management and Business Policy" }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PSM810", title: "Strategic Management Doctoral Seminar" },

              { code: "PSM811", title: "Strategic Management Comprehensive Paper" },

              { code: "PSM812", title: "Strategic Management Independent Field Study" },

              { code: "PBA810", title: "Doctoral Seminar" },

              { code: "PBA811", title: "Doctoral Comprehensive Paper" },

              { code: "PBA812", title: "Doctoral Independent Field Study" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA820", title: "Research Proposal" }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              { code: "PBA910", title: "Research Thesis" }

            ]

          }

        ]

      }

    ]

  },

  /* =====================================================
     FINANCIAL MANAGEMENT & INVESTMENT
  ===================================================== */

  {

    specialization: "Financial Management & Investment",

    years: [

      {

        year: "Year One",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PBA710", title: "Advanced Research Methods" },

              { code: "PBA711", title: "Corporate Leadership and Governance" },

              { code: "PFI710", title: "Theory of Finance" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA720", title: "Advanced Statistical Techniques" },

              { code: "PBA721", title: "Innovation Management and Technology" },

              { code: "PFI720", title: "Financial Institutions, Markets and Corporate Finance Strategy" }

            ]

          }

        ]

      },

      {

        year: "Year Two",

        semesters: [

          {

            semester: "Semester One",

            units: [

              { code: "PFI810", title: "Finance Doctoral Seminar" },

              { code: "PFI811", title: "Finance Comprehensive Paper" },

              { code: "PFI812", title: "Finance Independent Field Study" },

              { code: "PBA810", title: "Doctoral Seminar" },

              { code: "PBA811", title: "Doctoral Comprehensive Paper" },

              { code: "PBA812", title: "Doctoral Independent Field Study" }

            ]

          },

          {

            semester: "Semester Two",

            units: [

              { code: "PBA820", title: "Research Proposal" }

            ]

          }

        ]

      },

      {

        year: "Year Three",

        semesters: [

          {

            semester: "Research Thesis",

            units: [

              { code: "PBA910", title: "Research Thesis" }

            ]

          }

        ]

      }

    ]

  }

],

  careers: [

    "University Professor",

    "Business Researcher",

    "Policy Advisor",

    "Strategic Management Consultant",

    "Chief Executive Officer",

    "Human Resource Director",

    "Financial Consultant",

    "Supply Chain Consultant",

    "Business Intelligence Specialist",

    "Entrepreneurship Consultant",

    "Innovation Director"

  ],

  skills: [

    "Advanced Research",

    "Business Strategy",

    "Leadership",

    "Policy Analysis",

    "Critical Thinking",

    "Business Intelligence",

    "Data Analytics",

    "Innovation",

    "Academic Writing",

    "Evidence-Based Decision Making"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer:
        "The Doctor of Philosophy in Business Administration and Management is completed in three years (six semesters)."

    },

    {

      question: "Is the programme offered online?",

      answer:
        "Yes. The programme is delivered through Online Learning."

    },

    {

      question: "What specialisations are available?",

      answer:
        "Students may specialize in Entrepreneurship and Innovation, Business Intelligence and Data Analytics, Human Resource Management, Financial Management and Investment, Strategic Management, or Supply Chain Management."

    },

    {

      question: "When are intakes conducted?",

      answer:
        "The programme admits students during the September intake."

    }

  ],

  seo: {

    metaTitle:
      "Doctor of Philosophy in Business Administration and Management | Zetech University",

    metaDescription:
      "Study a Doctor of Philosophy in Business Administration and Management at Zetech University with specialisations in Entrepreneurship, Business Intelligence, Human Resource Management, Finance, Strategic Management and Supply Chain Management."

  }


},
{
  id: 56,

  slug: "doctor-of-philosophy-in-international-relations-and-diplomacy",

  title: "Doctor of Philosophy in International Relations and Diplomacy",

  shortTitle: "PhD International Relations & Diplomacy",

  code: "PIRD",

  school: "School of Education, Arts and Social Sciences",

  qualification: "PHD",
  award: "Doctor of Philosophy",
  category: "PHD",
  level: "Postgraduate",
  nqfLevel: "Level 10",

  featured: true,

  image: doctors,

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Advancing International Knowledge, Shaping Global Policy",

  heroDescription:
    "Zetech University's Doctor of Philosophy in International Relations and Diplomacy develops scholars and practitioners who generate original research, challenge established perspectives and translate evidence into policy and diplomatic practice.",

  overview: `
The programme is crafted to enhance students' critical thinking abilities, enabling them to analyze intricate issues, assess diverse viewpoints and challenge underlying assumptions. At the core of the programme lies the development of advanced research skills — research methodologies, data analysis and scholarly writing — empowering students to undertake original research that enriches the discipline.

Graduates will be instrumental towards the realisation of the Kenya Vision 2030 development goals, the East Africa Community Vision 2050, the African Union's Agenda 2063 on "The Africa We Want" and the global Sustainable Development Goals. The programme prepares learners for careers in academia, research institutions, NGOs, private and public sector organizations, regional intergovernmental and international organizations, as well as consultancy across the various thematic areas in international relations and diplomacy.

Research focus areas include International Politics; International Political Economy; International Economic Relations; International Trade; International Development; Foreign Policy and Foreign Policy Analysis; Strategic Studies; International Security; International Organizations; Gender Dynamics in International Relations; Global Environmental Politics; Peace and Conflict; and International Relations and Diplomacy theories.
`,

  whyStudy: [

    "Become a leading voice in understanding and shaping global affairs through original research on complex global challenges.",

    "Develop advanced research expertise in research methodology, data analysis and scholarly inquiry through publications, conferences and academic discourse.",

    "Challenge established perspectives by critically examining theories, assumptions and practices in international relations.",

    "Influence international policy and build thought leadership by translating research into evidence-based policy and diplomatic solutions.",

    "Specialize in global affairs across international security, foreign policy, international trade, development, climate politics, peace and conflict and strategic studies.",

    "Study flexibly through face-to-face and online modes of delivery."

  ],

  entryRequirements: [

    "Be a holder of a relevant Master's degree from an accredited university."

  ],

  duration: 6,

  durationType: "Semesters",

  durationYears: "3 Years",

  mode: "Blended",

  fee: 653500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  curriculum: [

    {
      year: "Year One",
      semesters: [
        {
          semester: "Semester One",
          units: [
            { code: "PID 910", title: "Epistemological Debates in International Relations", type: "Core" },
            { code: "PID 911", title: "Global Politics of Climate Change", type: "Core" },
            { code: "PID 912", title: "Seminar in International Relations and Diplomacy", type: "Core" },
            { code: "PID 913", title: "Research Methods in International Relations and Diplomacy", type: "Core" }
          ]
        },
        {
          semester: "Semester Two",
          electiveRule: "Choose one elective",
          units: [
            { code: "PID 920", title: "Statistical Techniques", type: "Core" },
            { code: "PID 921", title: "Economic Aspects of International Relations", type: "Core" },
            { code: "PID 922", title: "Comparative Foreign Policy Making", type: "Elective" },
            { code: "PID 923", title: "Analytical Politics and Democratic Governance", type: "Elective" }
          ]
        }
      ]
    },

    {
      year: "Year Two",
      semesters: [
        {
          semester: "Semester One & Two",
          units: [
            { code: "PID 930", title: "Field Work" },
            { code: "PID 931", title: "Proposal Writing" }
          ]
        }
      ]
    },

    {
      year: "Year Three",
      semesters: [
        {
          semester: "Semester One & Two",
          units: [
            { code: "PID 932", title: "Thesis" }
          ]
        }
      ]
    }

  ],

  careers: [

    "University Lecturer, Researcher and Academic Leader",

    "International Relations and Foreign Affairs Specialist",

    "Diplomat and Foreign Policy Practitioner",

    "Policy Analyst, Adviser and Consultant",

    "Researcher in Think Tanks and Policy Research Institutions",

    "International Development Specialist and Programme Leader",

    "International Trade and Economic Relations Specialist",

    "Security Analyst, Peacebuilding and Conflict Resolution Specialist",

    "NGO and Humanitarian Affairs Leader",

    "Political and Geopolitical Risk Analyst",

    "Senior Government and Public-Sector Policy Professional"

  ],

  skills: [

    "Advanced Research Design",

    "Data Analysis",

    "Scholarly Writing",

    "Critical Analysis",

    "Policy Advisory",

    "Diplomacy and Negotiation",

    "Geopolitical Risk Analysis"

  ],

  faqs: [

    {
      question: "What makes the PhD in International Relations & Diplomacy at Zetech University different?",
      answer: "The programme combines rigorous doctoral research with a strong focus on contemporary global challenges, policy relevance and practical impact — equipping scholars to generate original research, challenge established perspectives and translate evidence into insights that inform policy and diplomatic practice."
    },

    {
      question: "What areas can I research in?",
      answer: "Research may be undertaken across international politics, foreign policy, international security, international political economy, international trade, international development, diplomacy, strategic studies, international organizations, peace and conflict, gender and international relations, global environmental politics and International Relations and Diplomacy theories."
    },

    {
      question: "Do I need to have a research topic before I apply?",
      answer: "No, although a clear area of research interest is strongly recommended. Your research idea can be refined with academic guidance as you progress through the programme."
    },

    {
      question: "Can I study while working?",
      answer: "Yes. The programme is offered through face-to-face and online modes of delivery. Doctoral study however requires significant independent reading, research, fieldwork, analysis and scholarly writing."
    },

    {
      question: "How long does the programme take?",
      answer: "Three academic years, comprising six semesters."
    },

    {
      question: "When is the intake?",
      answer: "The programme has a September intake."
    }

  ],

  seo: {

    metaTitle:
      "PhD in International Relations and Diplomacy | Zetech University",

    metaDescription:
      "Study a Doctor of Philosophy in International Relations and Diplomacy at Zetech University — doctoral research in foreign policy, international security, trade, diplomacy and global governance, offered face-to-face and online."

  }

},


/* ===========================
   MASTERS
=========================== */

{
  id: 3,

  slug: "master-of-science-in-computer-science",

  title: "Master of Science in Computer Science",

  shortTitle: "MSc Computer Science",

  code: "MSc CS",

  school: "School of ICT, Media and Engineering",

  qualification: "MASTERS",

  award: "Master of Science",

  category: "MASTERS",

  level: "Postgraduate",

  nqfLevel: "Level 9",

  featured: false,

  image: masters,

  brochure: "/downloads/brochures/msc-computer-science.pdf",

  feeStructure: "/downloads/fees/msc-computer-science-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Design, Develop. Dominate the Digital Era.",

  heroDescription:
    "The Master of Science in Computer Science equips students with advanced computing knowledge, research capability and practical expertise to solve complex technological challenges through innovation and emerging technologies.",

  overview: `
The Master of Science in Computer Science is designed to equip students with advanced knowledge and practical expertise in computing, preparing them to address complex technological challenges in today's digital world.

The programme develops strong competencies in computational thinking, software engineering, artificial intelligence, cyber security, networking and research while nurturing innovation and leadership for academia, industry and government.
`,

  whyStudy: [

    "Gain advanced computing knowledge and leadership skills for senior technology roles.",

    "Study in an innovation-driven environment that nurtures creativity and entrepreneurship.",

    "Develop expertise in Artificial Intelligence, Machine Learning, Cyber Security, IoT and Advanced Networking.",

    "Learn from experienced lecturers with strong academic and industry backgrounds.",

    "Enjoy flexible online learning while balancing work and personal commitments.",

    "Graduate ready for leadership, research, academia, government and the global technology industry."

  ],

  entryRequirements: [

    "Bachelor of Science in Computer Science or an IT-related field from an accredited university with Second Class Upper Division or equivalent.",

    "OR Bachelor of Science in Computer Science or related field with Second Class Lower Division plus at least two years relevant computing work experience.",

    "OR any other relevant qualification approved by the University Senate."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Online",

  fee: 443500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  specialisations: [

    "Artificial Intelligence",

    "Cyber Security and Computer Forensics",

    "Computer Networks"

  ],

  curriculum: [

    /* =====================================================
       COMPUTER NETWORKS
    ====================================================== */

    {

      specialisation: "Computer Networks",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Security Systems"
                },

                {
                  code: "ICS6111",
                  title: "Advanced Theoretical Computing"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence"
                },

                {
                  code: "IIT6141",
                  title: "Strategic Management and Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6142",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6192",
                  title: "Independent Study"
                },

                {
                  code: "ICS6151",
                  title: "Advanced Data Structures and Algorithms"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "ICS6294",
                  title: "Proposal Writing"
                },

                {
                  code: "ICS6212",
                  title: "Wireless and Mobile Networks"
                },

                {
                  code: "ICS6213",
                  title: "Embedded Systems"
                },

                {
                  code: "ICS6214",
                  title: "IoT Technologies"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6191",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    },

    /* =====================================================
       ARTIFICIAL INTELLIGENCE
    ====================================================== */

    {

      specialisation: "Artificial Intelligence",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Security Systems"
                },

                {
                  code: "ICS6111",
                  title: "Advanced Theoretical Computing"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence"
                },

                {
                  code: "IIT6141",
                  title: "Strategic Management and Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6142",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6192",
                  title: "Independent Study"
                },

                {
                  code: "ICS6151",
                  title: "Advanced Data Structures and Algorithms"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "ICS6232",
                  title: "Machine Learning"
                },

                {
                  code: "ICS6233",
                  title: "Expert Systems Design and Applications"
                },

                {
                  code: "ICS6234",
                  title: "Autonomous Robotics"
                },

                {
                  code: "ICS6294",
                  title: "Proposal Writing"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6191",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    },

    /* =====================================================
       CYBER SECURITY & COMPUTER FORENSICS
    ====================================================== */

    {

      specialisation: "Cyber Security and Computer Forensics",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Security Systems"
                },

                {
                  code: "ICS6111",
                  title: "Advanced Theoretical Computing"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence"
                },

                {
                  code: "IIT6141",
                  title: "Strategic Management and Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6142",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6192",
                  title: "Independent Study"
                },

                {
                  code: "ICS6151",
                  title: "Advanced Data Structures and Algorithms"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "ICS6242",
                  title: "Digital Forensics"
                },

                {
                  code: "ICS6243",
                  title: "Cyber Crime and Cyber Security"
                },

                {
                  code: "ICS6244",
                  title: "Network Security and Forensics"
                },

                {
                  code: "ICS6294",
                  title: "Proposal Writing"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6191",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    }

  ],

  careers: [

    "Software Architect",

    "Artificial Intelligence Engineer",

    "Machine Learning Engineer",

    "Cyber Security Analyst",

    "Digital Forensics Specialist",

    "Network Architect",

    "Research Scientist",

    "University Lecturer",

    "ICT Consultant",

    "Technology Manager"

  ],

  skills: [

    "Artificial Intelligence",

    "Machine Learning",

    "Cyber Security",

    "Computer Networks",

    "Research",

    "Software Engineering",

    "Problem Solving",

    "Innovation"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer: "The programme takes two years (four semesters) to complete."

    },

    {

      question: "Is the programme offered online?",

      answer: "Yes. The programme is delivered through Online Learning."

    },

    {

      question: "What specialisations are available?",

      answer: "Students may specialize in Artificial Intelligence, Cyber Security and Computer Forensics, or Computer Networks."

    },

    {

      question: "When is the intake?",

      answer: "The programme admits students in the September intake."

    }

  ],

  seo: {

    metaTitle: "Master of Science in Computer Science | Zetech University",

    metaDescription:
      "Study the Master of Science in Computer Science at Zetech University specializing in Artificial Intelligence, Cyber Security and Computer Forensics, and Computer Networks."

  }

},

{
  id: 4,

  slug: "master-of-science-in-information-technology",

  title: "Master of Science in Information Technology",

  shortTitle: "MSc Information Technology",

  code: "MSc IT",

  school: "School of ICT, Media and Engineering",

  qualification: "MASTERS",

  award: "Master of Science",

  category: "MASTERS",

  level: "Postgraduate",

  nqfLevel: "Level 9",

  featured: false,

  image: masters,


  brochure: "/downloads/brochures/msc-information-technology.pdf",

  feeStructure: "/downloads/fees/msc-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Elevate Your Expertise in Information Technology",

  heroDescription:
    "The Master of Science in Information Technology prepares professionals with advanced technical, research and leadership skills in Software Engineering, Data Science, and Cyber Security & Computer Forensics.",

  overview: `
The Master of Science in Information Technology is designed to produce highly skilled IT professionals capable of leading digital transformation initiatives across industries.

The programme equips students with advanced knowledge in software engineering, cybersecurity, data science, cloud technologies, artificial intelligence and enterprise systems while strengthening research, innovation and leadership capabilities.

Graduates are prepared to manage complex software projects, secure enterprise infrastructure, analyse big data and lead technology teams in today's digital economy.
`,

  whyStudy: [

    "Study in a technology-focused environment that promotes innovation, creativity and lifelong learning.",

    "Develop advanced research skills and create innovative solutions to modern IT challenges.",

    "Graduate prepared for careers in IT management, software engineering, cybersecurity, data science and digital transformation.",

    "Build leadership and technical competencies required to manage modern IT projects and enterprise systems.",

    "Specialize in Software Engineering, Data Science or Cyber Security & Computer Forensics.",

    "Master emerging technologies including Artificial Intelligence, Big Data, Machine Learning, Cloud Security and IoT.",

    "Enjoy flexible online learning while balancing work and personal commitments."

  ],

  entryRequirements: [

    "Bachelor of Science in Information Technology or a related field from an accredited university with Second Class Upper Division or equivalent.",

    "OR Bachelor of Science in Information Technology or related field with Second Class Lower Division plus at least two years relevant computing work experience.",

    "OR any other relevant qualification approved by the University Senate."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Online",

  fee: 443500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  specialisations: [

    "Software Engineering",

    "Data Science",

    "Cyber Security and Computer Forensics"

  ],

  curriculum: [

    /* =====================================================
       SOFTWARE ENGINEERING
    ====================================================== */

    {

      specialisation: "Software Engineering",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Systems Security"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence and Data Science"
                },

                {
                  code: "IIT6121",
                  title: "Software Architecture and Design"
                },

                {
                  code: "IIT6101",
                  title: "Strategic Management Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6192",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6193",
                  title: "Advanced Data Structures and Algorithms"
                },

                {
                  code: "ICS6151",
                  title: "Independent Study"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "IIT6222",
                  title: "Real Time Systems Design and Development"
                },

                {
                  code: "IIT6223",
                  title: "Software Metrics"
                },

                {
                  code: "IIT6224",
                  title: "Enterprise Application Development and Architectures"
                },

                {
                  code: "ICS6294",
                  title: "Research Proposal"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6295",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    },

    /* =====================================================
       DATA SCIENCE
    ====================================================== */

    {

      specialisation: "Data Science",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Systems Security"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence and Data Science"
                },

                {
                  code: "IIT6121",
                  title: "Software Architecture and Design"
                },

                {
                  code: "IIT6101",
                  title: "Strategic Management Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6192",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6193",
                  title: "Advanced Data Structures and Algorithms"
                },

                {
                  code: "ICS6151",
                  title: "Independent Study"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "ICS6232",
                  title: "Machine Learning"
                },

                {
                  code: "IIT6233",
                  title: "Advanced Data Analytics"
                },

                {
                  code: "IIT6234",
                  title: "Big Data and Internet of Things"
                },

                {
                  code: "ICS6294",
                  title: "Research Proposal"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6295",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    },

    /* =====================================================
       CYBER SECURITY & COMPUTER FORENSICS
    ====================================================== */

    {

      specialisation: "Cyber Security and Computer Forensics",

      years: [

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                {
                  code: "ICS6140",
                  title: "Computer Systems Security"
                },

                {
                  code: "ICS6131",
                  title: "Advanced Artificial Intelligence and Data Science"
                },

                {
                  code: "IIT6121",
                  title: "Software Architecture and Design"
                },

                {
                  code: "IIT6101",
                  title: "Strategic Management Information Systems"
                },

                {
                  code: "ICS6191",
                  title: "Research Methods"
                }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                {
                  code: "ICS6112",
                  title: "Advanced Computer Networks"
                },

                {
                  code: "IIT6192",
                  title: "ICT Project Management and Communication"
                },

                {
                  code: "ICS6141",
                  title: "Advanced Cryptography"
                },

                {
                  code: "ICS6193",
                  title: "Advanced Data Structures and Algorithms"
                },

                {
                  code: "ICS6151",
                  title: "Independent Study"
                }

              ]

            }

          ]

        },

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One (Specialisation & Proposal)",

              units: [

                {
                  code: "ICS6232",
                  title: "Machine Learning"
                },

                {
                  code: "IIT6233",
                  title: "Advanced Data Analytics"
                },

                {
                  code: "IIT6234",
                  title: "Big Data and Internet of Things"
                },

                {
                  code: "ICS6294",
                  title: "Research Proposal"
                }

              ]

            },

            {

              semester: "Semester Two (Thesis)",

              units: [

                {
                  code: "ICS6295",
                  title: "Thesis"
                }

              ]

            }

          ]

        }

      ]

    }

  ],

  careers: [

    "IT Manager",

    "Software Architect",

    "Software Engineering Manager",

    "Data Scientist",

    "Machine Learning Engineer",

    "Cyber Security Analyst",

    "Digital Forensics Specialist",

    "Cloud Solutions Architect",

    "Technology Consultant",

    "Systems Analyst",

    "Enterprise Solutions Architect",

    "University Lecturer"

  ],

  skills: [

    "Software Engineering",

    "Data Science",

    "Cyber Security",

    "Artificial Intelligence",

    "Machine Learning",

    "Cloud Computing",

    "Enterprise Systems",

    "Big Data Analytics",

    "Research",

    "Leadership"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer: "The programme takes two years (four semesters) to complete."

    },

    {

      question: "Is the programme offered online?",

      answer: "Yes. The programme is delivered fully through Online Learning."

    },

    {

      question: "What specialisations are available?",

      answer: "Students may specialize in Software Engineering, Data Science, or Cyber Security and Computer Forensics."

    },

    {

      question: "When is the intake?",

      answer: "The programme admits students once every year during the September intake."

    }

  ],

  seo: {

    metaTitle: "Master of Science in Information Technology | Zetech University",

    metaDescription:
      "Study the Master of Science in Information Technology at Zetech University specialising in Software Engineering, Data Science, and Cyber Security & Computer Forensics through flexible online learning."

  }

},
{
  id: 5,

  slug: "master-of-business-administration",

  title: "Master of Business Administration (MBA)",

  shortTitle: "MBA",

  code: "MBA",

  school: "School of Business and Economics",

  qualification: "MASTERS",

  award: "Master of Business Administration",

  category: "MASTERS",

  level: "Postgraduate",

  nqfLevel: "Level 9",

  featured: false,

  image: masters,

  brochure: "/downloads/brochures/master-of-business-administration.pdf",

  feeStructure: "/downloads/fees/master-of-business-administration-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Think Beyond Business. Lead the Future.",

  heroDescription:
    "The Master of Business Administration prepares professionals with advanced leadership, managerial and strategic capabilities required to lead organizations, drive innovation and create sustainable value in today's competitive business environment.",

  overview: `
The Master of Business Administration (MBA) is a postgraduate programme designed to develop advanced leadership, managerial and strategic capabilities for today's complex business environment.

The programme integrates finance, marketing, strategic management, human resource management, entrepreneurship, operations, corporate governance and business intelligence to provide a holistic understanding of organisational performance.

Graduates acquire analytical, research, innovation and decision-making skills required to lead organizations, manage change and build sustainable competitive advantage across both public and private sectors.
`,

  whyStudy: [

    "Develop advanced leadership, strategic management and executive decision-making skills.",

    "Specialize in Strategic Management, Finance & Investment, Human Resource Management, Entrepreneurship, Procurement & Logistics, or Business Intelligence & Data Analytics.",

    "Strengthen analytical, innovation and problem-solving capabilities through research and data-driven decision making.",

    "Learn from experienced academics and industry practitioners.",

    "Build strong professional networks with executives, entrepreneurs and business leaders.",

    "Graduate prepared for executive leadership, entrepreneurship and organisational transformation."

  ],

  entryRequirements: [

    "Bachelor's degree from an accredited university with Second Class Upper Division or equivalent.",

    "OR Bachelor's degree with Second Class Lower Division plus at least two (2) years relevant work experience.",

    "OR any other qualification approved by the University Senate."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Online",

  // update if different
  fee: 443500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  specialisations: [

    "Entrepreneurship, Innovation and Technology",

    "Financial Management and Investment",

    "Human Resource Management",

    "Strategic Management",

    "Procurement, Supply Chain and Logistics",

    "Business Intelligence and Data Analytics"

  ],

  curriculum: [
    // Add the six specialisations exactly as in your MSc IT structure
  ],

  careers: [

    "Chief Executive Officer",

    "Business Development Manager",

    "Strategic Management Consultant",

    "Financial Manager",

    "Investment Analyst",

    "Human Resource Manager",

    "Operations Manager",

    "Supply Chain Manager",

    "Entrepreneur",

    "Business Intelligence Analyst",

    "Management Consultant",

    "University Lecturer"

  ],

  skills: [

    "Strategic Management",

    "Leadership",

    "Financial Analysis",

    "Business Intelligence",

    "Entrepreneurship",

    "Corporate Governance",

    "Human Resource Management",

    "Research",

    "Decision Making",

    "Business Analytics"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer: "The Master of Business Administration takes two years (four semesters) to complete."

    },

    {

      question: "Is the programme offered online?",

      answer: "Yes. The MBA is delivered through Online Learning."

    },

    {

      question: "What specialisations are available?",

      answer: "Students may specialize in Entrepreneurship, Innovation and Technology; Financial Management and Investment; Human Resource Management; Strategic Management; Procurement, Supply Chain and Logistics; or Business Intelligence and Data Analytics."

    },

    {

      question: "When is the intake?",

      answer: "The programme admits students once every year during the September intake."

    }

  ],

  seo: {

    metaTitle:
      "Master of Business Administration | Zetech University",

    metaDescription:
      "Study the Master of Business Administration (MBA) at Zetech University with specialisations in Strategic Management, Finance, HRM, Entrepreneurship, Procurement & Logistics and Business Intelligence through flexible online learning."

  }

},

{
  id: 57,

  slug: "master-of-arts-in-international-relations-and-diplomacy",

  title: "Master of Arts in International Relations and Diplomacy",

  shortTitle: "MA International Relations & Diplomacy",

  code: "MIRD",

  school: "School of Education, Arts and Social Sciences",

  qualification: "MASTERS",
  award: "Master of Arts",
  category: "MASTERS",
  level: "Postgraduate",
  nqfLevel: "Level 9",

  featured: true,

  image: masters,

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Developing Leaders for Global Impact",

  heroDescription:
    "The Master of Arts in International Relations and Diplomacy equips learners to examine global issues through multiple theoretical lenses and to take leadership positions in diplomacy, policy, development, security and international business.",

  overview: `
The programme is designed to enable learners to examine global issues and developments while adopting a range of theoretical tools and approaches that allow them to analyze and interpret the world through different conceptual lenses. It is intended to create international relations and diplomacy practitioners who will take leadership positions in their different areas of engagement.

This is instrumental towards the realisation of the Kenya Vision 2030 development goals, the East Africa Community Vision 2050, the African Union's Agenda 2063 on "The Africa We Want" and the global Sustainable Development Goals. The programme prepares learners for careers in academia, research institutions, NGOs, private and public sector organizations, regional intergovernmental and international organizations, as well as consultancy in various thematic areas in international relations and diplomacy.
`,

  whyStudy: [

    "Develop global perspectives on the international political, economic, social and security issues shaping the world.",

    "Build diplomatic networks and leadership skills — analytical, negotiation, communication and leadership competencies for international environments.",

    "Understand emerging global issues including diplomacy and technology, climate change, international security, conflict management and international trade.",

    "Learn from a multidisciplinary perspective spanning international relations, political, economic, legal and social dimensions of global affairs.",

    "Strengthen research capabilities and generate evidence-based insights on international issues.",

    "Study flexibly through face-to-face and online modes of delivery."

  ],

  entryRequirements: [

    "Relevant bachelor's degree with Upper Second-Class Honors or a cumulative GPA of 3.00 on a scale of 4.00.",

    "OR Lower Second-Class Honors or a GPA of 2.50 on a scale of 4.00 with additional relevant training, evidence of research capability (research, paper presentations or peer reviewed publications) and relevant work experience."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Blended",

  fee: 440500,

  feeType: "Total Fees for the entire programme",

  intake: [

    "September"

  ],

  curriculum: [

    {
      year: "Year One",
      semesters: [
        {
          semester: "Semester One",
          electiveRule: "Choose one elective",
          units: [
            { code: "MID 710", title: "International Relations", type: "Core" },
            { code: "MID 711", title: "Diplomacy and Technology", type: "Core" },
            { code: "MID 712", title: "Conflict Management in the International System", type: "Core" },
            { code: "MID 713", title: "International Trade Relations", type: "Core" },
            { code: "MID 714", title: "International Relations and Climate Change", type: "Core" },
            { code: "MID 715", title: "Africa in the International System", type: "Elective" },
            { code: "MID 716", title: "European Security and Defense", type: "Elective" }
          ]
        },
        {
          semester: "Semester Two",
          electiveRule: "Choose one elective",
          units: [
            { code: "MID 720", title: "Foreign Policy Analysis", type: "Core" },
            { code: "MID 721", title: "Issues in International Law", type: "Core" },
            { code: "MID 722", title: "Contemporary Powers in the International System", type: "Core" },
            { code: "MID 723", title: "Strategic and International Security Issues", type: "Core" },
            { code: "MID 724", title: "Social Science Research Methods", type: "Core" },
            { code: "MID 725", title: "Gender Issues in International Relations", type: "Elective" },
            { code: "MID 726", title: "Armament, Disarmament and Arms Control in International Relations", type: "Elective" }
          ]
        }
      ]
    },

    {
      year: "Year Two",
      semesters: [
        {
          semester: "Semester One",
          units: [
            { code: "MID 730", title: "Research Proposal", type: "Core" }
          ]
        },
        {
          semester: "Semester Two",
          units: [
            { code: "MID 740", title: "Thesis Writing", type: "Core" }
          ]
        }
      ]
    }

  ],

  careers: [

    "Foreign Service and Diplomatic Missions",

    "Government Ministries, Departments and Agencies",

    "Regional and International Organizations (AU, EAC, UN agencies)",

    "NGOs, INGOs and Humanitarian Agencies",

    "International Development",

    "Policy Research Institutes, Think Tanks and Academia",

    "International Trade and Business Organizations",

    "Peacebuilding, Conflict Management and Security Organizations",

    "Public Policy and International Affairs Consultancy",

    "Media and Communications Covering International Affairs"

  ],

  skills: [

    "Diplomacy and Negotiation",

    "Foreign Policy Analysis",

    "Conflict Management",

    "International Trade and Economic Analysis",

    "Research and Evidence-Based Policy",

    "Cross-Cultural Communication",

    "Leadership"

  ],

  faqs: [

    {
      question: "Who should study this programme?",
      answer: "Graduates and professionals interested in diplomacy, foreign affairs, international development, policy, security, international trade, research, governance and global affairs — particularly those working or aspiring to work in government, international organizations, NGOs, research institutions and the private sector."
    },

    {
      question: "Can I study the programme if my bachelor's degree is not in International Relations?",
      answer: "Yes, provided your degree is in a relevant field and you meet the University's admission requirements. Applicants from political science, development studies, economics, law, history, sociology, communication and other related disciplines are welcome."
    },

    {
      question: "Is work experience required for admission?",
      answer: "Work experience is not required for applicants who meet the Upper Second-Class Honors or equivalent GPA requirement. Applicants with a Lower Second-Class Honors degree may be considered with additional relevant training, evidence of research capability and relevant work experience."
    },

    {
      question: "How long does the programme take?",
      answer: "Two academic years, comprising four semesters."
    },

    {
      question: "What is the mode of delivery?",
      answer: "The programme is offered through face-to-face and online modes of delivery, providing flexibility for both full-time learners and working professionals."
    },

    {
      question: "When is the intake?",
      answer: "The programme has a September intake."
    }

  ],

  seo: {

    metaTitle:
      "Master of Arts in International Relations and Diplomacy | Zetech University",

    metaDescription:
      "Study the Master of Arts in International Relations and Diplomacy (MIRD) at Zetech University — diplomacy, foreign policy, international security, trade and climate politics, offered face-to-face and online with a September intake."

  }

},

/* ===========================
   POSTGRADUATE DIPLOMA
=========================== */

{
  id: 58,

  slug: "postgraduate-diploma-in-education",

  title: "Postgraduate Diploma in Education",

  shortTitle: "PGDE",

  code: "PGDE",

  school: "School of Education, Arts and Social Sciences",

  qualification: "POSTGRADUATE DIPLOMA",
  award: "Postgraduate Diploma",
  category: "POSTGRADUATE DIPLOMA",
  level: "Postgraduate",
  nqfLevel: "Level 8",

  featured: true,

  image: masters,

  brochure: "/downloads/brochures/postgraduate-diploma-in-education.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Preparing Educators for Competency-Based Learning",

  heroDescription:
    "The Postgraduate Diploma in Education equips graduates from any discipline with contemporary pedagogical, competency-based curriculum, assessment and digital teaching skills for Kenya's Competency-Based Education era.",

  overview: `
The Postgraduate Diploma in Education (PGDE) at Zetech University responds to the evolving needs of Kenya's education sector, particularly the transition to Competency-Based Education (CBE).

The programme equips graduates with contemporary pedagogical, competency-based curriculum, assessment, digital and practical teaching skills needed to facilitate learner-centred and competency-based learning. It provides a pathway for graduates from diverse disciplines to acquire professional teaching competencies and contribute effectively to the delivery of quality education in a dynamic and technology-driven learning environment.
`,

  whyStudy: [

    "Master Competency-Based Education — design, deliver and assess learner-centred, competency-based curriculum in line with Kenya's evolving education system.",

    "Become a technology-enabled educator with digital and pedagogical skills for modern teaching, learning and assessment.",

    "Learn through flexible blended learning that combines face-to-face and online study.",

    "Develop inclusive teaching skills that respond to diverse learner needs and promote equitable learning.",

    "Strengthen professional practice in curriculum development, instructional materials, assessment and classroom practice.",

    "Prepare for the future of education with creativity, critical thinking, collaboration and ethical leadership."

  ],

  entryRequirements: [

    "A minimum qualification of an undergraduate degree from a recognized institution.",

    "Applicants must also meet the relevant subject requirements for teaching."

  ],

  duration: 3,

  durationType: "Semesters",

  durationYears: "1.5 Years",

  mode: "Blended",

  fee: 175800,

  feeType: "Total Fees for the entire programme",

  intake: [

    "January",

    "September"

  ],

  curriculum: [

    {
      year: "Year One",
      semesters: [
        {
          semester: "Semester One",
          units: [
            { code: "PGDE 111", title: "History of Education" },
            { code: "PGDE 112", title: "Psychology of Teaching and Learning" },
            { code: "PGDE 113", title: "Fundamentals of Special Needs Education" },
            { code: "PGDE 114", title: "Instructional Methods in Education" },
            { code: "PGDE 115", title: "Educational Communication and Technology" },
            { code: "PGDE 116", title: "Sociology of Education" },
            { code: "PGDE 117", title: "Curriculum Development" }
          ]
        },
        {
          semester: "Semester Two",
          units: [
            { code: "PGDE 121", title: "Educational Administration and Planning" },
            { code: "PGDE 122", title: "Comparative Education and Contemporary Issues" },
            { code: "PGDE 123", title: "Human Growth and Development" },
            { code: "PGDE 124", title: "Philosophy of Education" },
            { code: "PGDE 125", title: "Educational Measurement and Evaluation" },
            { code: "PGDE 126", title: "Microteaching" },
            { code: "PGDE 127", title: "Competency-Based Curriculum" },
            { code: "PGDE 128", title: "Subject Teaching Method" }
          ]
        },
        {
          semester: "Semester Three",
          units: [
            { code: "PGDE 131", title: "Practicum I (Community Service Learning)" },
            { code: "PGDE 132", title: "Practicum II (Teaching Practice)" }
          ]
        }
      ]
    }

  ],

  careers: [

    "Secondary School Teacher",

    "Curriculum and Instructional Support Specialist",

    "Education Quality Assurance Officer",

    "Trainer of Trainers",

    "Assessment and Evaluation Specialist",

    "Educational Technology and Digital Learning Officer",

    "Education Administrator"

  ],

  skills: [

    "Competency-Based Curriculum Design",

    "Instructional Methods",

    "Educational Assessment",

    "Educational Technology",

    "Inclusive Education",

    "Classroom Management",

    "Education Leadership"

  ],

  faqs: [

    {
      question: "What is a Postgraduate Diploma in Education (PGDE)?",
      answer: "The PGDE is a professional education programme designed to equip graduates with the knowledge, skills and competencies required for effective teaching, learning, assessment and educational practice."
    },

    {
      question: "Can I pursue a PGDE if my bachelor's degree is not in Education?",
      answer: "Yes. The PGDE provides a pathway for graduates from diverse disciplines to acquire professional teaching and pedagogical competencies, subject to meeting the relevant subject requirements."
    },

    {
      question: "How long does the PGDE take?",
      answer: "The programme takes three semesters."
    },

    {
      question: "What are the intakes?",
      answer: "Zetech University offers the PGDE in January and September intakes."
    },

    {
      question: "What is the mode of delivery?",
      answer: "The programme is delivered through blended learning, combining face-to-face and online study. All course units are designed to support both modes."
    },

    {
      question: "Will I undertake teaching practice?",
      answer: "Yes. The programme includes Practicum I (Community Service Learning) and Practicum II (Teaching Practice)."
    }

  ],

  seo: {

    metaTitle:
      "Postgraduate Diploma in Education (PGDE) | Zetech University",

    metaDescription:
      "Study the Postgraduate Diploma in Education (PGDE) at Zetech University — competency-based education, digital pedagogy and teaching practice through blended learning, with January and September intakes."

  }

},


/* ===========================
   UNDERGRADUATE
=========================== */
{
  id: 6,

  slug: "bachelor-of-education-science",

  title: "Bachelor of Education Science",

  shortTitle: "Bachelor of Education Science",

  code: "B.Ed Science",

  school: "School of Education, Arts and Social Sciences",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Education Science",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-education-science.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-education-science-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Teach Science. Shape Tomorrow.",

  heroDescription:
    "Prepare to become a competent and reflective science educator through specialized training in science teaching subjects, educational psychology, curriculum development, teaching methodology and practical classroom experience.",

  overview: `
The Bachelor of Education Science is designed to prepare students to become competent, reflective and innovative science educators.

The programme combines specialised training in two teaching subjects with courses in educational psychology, curriculum development, teaching methodology, educational technology, classroom management and educational foundations.

Students develop both strong subject-matter knowledge and practical pedagogical skills, enabling them to effectively teach science and related subjects in modern learning environments.

The programme also emphasises practical teaching experience through micro-teaching, supervised teaching practicums, Competency-Based Curriculum training, educational research and technology integration.

Through a combination of academic preparation, practical teaching experience, research and innovation, graduates are prepared to make a meaningful contribution to the education sector and help shape the future of science education.
`,

  whyStudy: [

    "Develop strong subject knowledge and pedagogical skills required for effective science teaching.",

    "Choose from specialized teaching combinations that align with your academic interests and career goals.",

    "Gain practical classroom experience through micro-teaching and supervised teaching practicums.",

    "Develop competence in Competency-Based Curriculum (CBC) implementation and modern teaching approaches.",

    "Build skills in educational psychology, curriculum development, educational technology, research and classroom management.",

    "Learn in modern educational environments supported by science laboratories, ICT resources and digital learning platforms.",

    "Develop leadership, research, entrepreneurship and innovation skills for a changing education sector.",

    "Prepare for diverse careers in teaching, educational research, curriculum development, education administration and quality assurance."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C+ (plus).",

    "A minimum grade of C+ (plus) in each of the two selected teaching subjects.",

    "A minimum grade of C (Plain) in Mathematics if Mathematics is not one of the teaching subjects.",

    "A minimum grade of C (Plain) in English.",

    "At least a C grade in any science subject at KCSE level for the Physical Education combination."

  ],

  specialisations: [

    "Mathematics / Biology",

    "Mathematics / Chemistry",

    "Mathematics / Physics",

    "Biology / Physics",

    "Chemistry / Physics",

    "Geography / Physical Education",

    "Geography / Agriculture",

    "Home Science / Physical Education",

    "Geography / Home Science",

    "Biology / Chemistry",

    "Biology / Agriculture",

    "Biology / Home Science",

    "Physics / Computer Studies",

    "Agriculture / Home Science"

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66500,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "High School Teacher",

    "Primary School Teacher",

    "University Lecturer",

    "Educational Researcher",

    "Curriculum Developer",

    "Laboratory Technician",

    "Education Officer",

    "Quality Assurance Officer"

  ],

  skills: [

    "Science Education",

    "Pedagogical Skills",

    "Educational Psychology",

    "Curriculum Development",

    "Teaching Methodology",

    "Classroom Management",

    "Competency-Based Curriculum",

    "Educational Technology",

    "Micro-teaching",

    "Teaching Practicum",

    "Educational Research",

    "Assessment and Evaluation",

    "Science Laboratory Skills",

    "Digital Learning",

    "Educational Leadership",

    "Research and Innovation"

  ],

  ctaTitle:
    "Ready to Teach Science and Shape Tomorrow?",

  ctaText:
    "Join Zetech University and develop the subject knowledge, teaching expertise, practical experience and innovation skills required to inspire learners and shape the future of science education.",

  curriculum: [

    /*
    ==========================================================
    SPECIALISATION 1
    BIOLOGY / CHEMISTRY
    ==========================================================
    */

    {
      specialisation: "Biology / Chemistry",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "PSY 111",
                  title: "General Psychology"
                },

                {
                  code: "EDU 110",
                  title: "Fundamentals of Special Needs Education"
                },

                {
                  code: "EDU 111",
                  title: "History of Education"
                },

                {
                  code: "BCU 110",
                  title: "Communication Skills"
                },

                {
                  code: "CHE 111",
                  title: "Fundamentals of Laboratory Techniques"
                },

                {
                  code: "CHE 112",
                  title: "Fundamentals of Inorganic Chemistry"
                },

                {
                  code: "BIO 111",
                  title: "Fundamentals of Ecology"
                },

                {
                  code: "BIO 112",
                  title: "Introduction to Biochemistry"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 121",
                  title: "Psychology of Teaching and Learning"
                },

                {
                  code: "EDU 121",
                  title: "Fundamentals of Environmental Education"
                },

                {
                  code: "BCU 112",
                  title: "Introduction to Computers and Internet"
                },

                {
                  code: "BIO 121",
                  title: "Cell and Molecular Biology"
                },

                {
                  code: "BIO 122",
                  title: "Plant Structure and Function"
                },

                {
                  code: "CHE 121",
                  title:
                    "Introduction to Classical Analysis and Separation Techniques"
                },

                {
                  code: "CHE 122",
                  title: "Fundamentals of Physical Chemistry"
                }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 211",
                  title: "Curriculum Development"
                },

                {
                  code: "PSY 211",
                  title: "Human Growth and Development"
                },

                {
                  code: "BCU 113",
                  title: "Health and Wellness Management"
                },

                {
                  code: "BIO 211",
                  title: "Plant Taxonomy"
                },

                {
                  code: "BIO 212",
                  title: "Invertebrate Biology"
                },

                {
                  code: "CHE 211",
                  title: "Organic Chemistry I"
                },

                {
                  code: "CHE 212",
                  title: "Atomic Structure and Chemical Bonding"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 221",
                  title: "Education Communication and Technology"
                },

                {
                  code: "EDU 222",
                  title: "Educational Administration and Management"
                },

                {
                  code: "PSY 222",
                  title: "Guidance and Counseling"
                },

                {
                  code: "BIO 221",
                  title: "Vertebrate Biology"
                },

                {
                  code: "CHE 221",
                  title: "Chemical Thermodynamics"
                },

                {
                  code: "CHE 222",
                  title: "Organic Chemistry II"
                }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 311",
                  title: "Instructional Methods"
                },

                {
                  code: "ECT 320",
                  title: "Micro-teaching and Media Practical"
                },

                {
                  code: "BCU 320",
                  title: "Research Methods"
                },

                {
                  code: "BIO 311",
                  title: "Hydrobiology"
                },

                {
                  code: "BIO 312",
                  title: "Entomology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 322",
                  title: "Tests Measurement and Evaluation"
                },

                {
                  code: "ECT 321",
                  title: "E-Learning Technology in Education"
                },

                {
                  code: "BIO 321",
                  title: "Immunology"
                },

                {
                  code: "BIO 322",
                  title: "Ecology and Bioanalysis"
                },

                {
                  code: "CHE 321",
                  title: "Chemistry of Aromatic Compounds"
                },

                {
                  code: "CHE 322",
                  title:
                    "Coordination and Organometallic Chemistry"
                },

                {
                  code: "EDU 320",
                  title: "Teaching Practicum I"
                }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 411",
                  title:
                    "Comparative Education and Emerging Contemporary Issues"
                },

                {
                  code: "EDU 412",
                  title: "Sociology of Education"
                },

                {
                  code: "ECT 322",
                  title: "Competence Based Learning"
                },

                {
                  code: "BIO 411",
                  title: "Animal Physiology"
                },

                {
                  code: "BIO 412",
                  title: "General Microbiology"
                },

                {
                  code: "CHE 411",
                  title: "Radio Activity and Nuclear Chemistry"
                },

                {
                  code: "CHE 412",
                  title:
                    "Comparative Study of Transition Elements D and F Blocks"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 421",
                  title: "Philosophy of Education"
                },

                {
                  code: "EDU 422",
                  title: "Planning and Economics of Education"
                },

                {
                  code: "EDU 423",
                  title: "Education and Development"
                },

                {
                  code: "BCU 412",
                  title: "Entrepreneurship and Innovation"
                },

                {
                  code: "EDU 429",
                  title: "Practicum II"
                },

                {
                  code: "BIO 421",
                  title: "Plant Physiology"
                },

                {
                  code: "BIO 422",
                  title: "Biostatistics"
                },

                {
                  code: "CHE 421",
                  title: "Industrial Chemistry"
                },

                {
                  code: "CHE 422",
                  title: "Environmental Chemistry"
                }

              ]
            }

          ]
        }

      ]
    },


    /*
    ==========================================================
    SPECIALISATION 2
    BIOLOGY / MATHEMATICS
    ==========================================================
    */

    {
      specialisation: "Biology / Mathematics",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "PSY 111",
                  title: "General Psychology"
                },

                {
                  code: "EDU 110",
                  title: "Fundamentals of Special Needs Education"
                },

                {
                  code: "EDU 111",
                  title: "History of Education"
                },

                {
                  code: "BCU 110",
                  title: "Communication Skills"
                },

                {
                  code: "BIO 111",
                  title: "Fundamentals of Ecology"
                },

                {
                  code: "BIO 112",
                  title: "Introduction to Biochemistry"
                },

                {
                  code: "MAT 111",
                  title: "Basic Mathematics"
                },

                {
                  code: "MAT 121",
                  title: "Discrete Mathematics"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 121",
                  title: "Psychology of Teaching and Learning"
                },

                {
                  code: "EDU 121",
                  title: "Fundamentals of Environmental Education"
                },

                {
                  code: "BCU 112",
                  title: "Introduction to Computers and Internet"
                },

                {
                  code: "MAT 123",
                  title: "Geometry"
                },

                {
                  code: "MAT 120",
                  title: "Calculus I"
                },

                {
                  code: "BIO 121",
                  title: "Cell and Molecular Biology"
                },

                {
                  code: "BIO 122",
                  title: "Plant Structure and Function"
                }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 211",
                  title: "Curriculum Development"
                },

                {
                  code: "PSY 211",
                  title: "Human Growth and Development"
                },

                {
                  code: "BCU 113",
                  title: "Health and Wellness Management"
                },

                {
                  code: "MAT 213",
                  title: "Calculus II"
                },

                {
                  code: "STA 123",
                  title: "Probability and Statistics I"
                },

                {
                  code: "BIO 211",
                  title: "Plant Taxonomy"
                },

                {
                  code: "BIO 212",
                  title: "Invertebrate Biology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 221",
                  title: "Education Communication and Technology"
                },

                {
                  code: "EDU 222",
                  title: "Educational Administration and Management"
                },

                {
                  code: "PSY 222",
                  title: "Guidance and Counseling"
                },

                {
                  code: "MAT 225",
                  title: "Calculus III"
                },

                {
                  code: "STA 212",
                  title: "Probability and Statistics II"
                },

                {
                  code: "BIO 221",
                  title: "Vertebrate Biology"
                }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 311",
                  title: "Instructional Methods"
                },

                {
                  code: "ECT 320",
                  title: "Micro-teaching and Media Practical"
                },

                {
                  code: "BCU 320",
                  title: "Research Methods"
                },

                {
                  code: "MAT 210",
                  title: "Linear Algebra"
                },

                {
                  code: "MAT 211",
                  title: "Introduction to Real Analysis"
                },

                {
                  code: "BIO 311",
                  title: "Hydrobiology"
                },

                {
                  code: "BIO 312",
                  title: "Entomology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 322",
                  title: "Tests Measurement and Evaluation"
                },

                {
                  code: "ECT 321",
                  title: "E-Learning Technology in Education"
                },

                {
                  code: "EDU 320",
                  title: "Teaching Practicum I"
                },

                {
                  code: "MAT 321",
                  title: "Complex Analysis"
                },

                {
                  code: "MAT 223",
                  title: "Ordinary Differential Equation"
                },

                {
                  code: "MAT 319",
                  title: "Teaching Methods in Mathematics"
                },

                {
                  code: "BIO 321",
                  title: "Immunology"
                },

                {
                  code: "BIO 322",
                  title: "Ecology and Bioanalysis"
                },

                {
                  code: "BIO 319",
                  title: "Teaching Methods in Biology"
                }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 411",
                  title:
                    "Comparative Education and Emerging Contemporary Issues"
                },

                {
                  code: "EDU 412",
                  title: "Sociology of Education"
                },

                {
                  code: "ECT 322",
                  title: "Competence Based Learning"
                },

                {
                  code: "MAT 413",
                  title: "Partial Differential Equations"
                },

                {
                  code: "MAT 311",
                  title: "Operation Research"
                },

                {
                  code: "BIO 411",
                  title: "Animal Physiology"
                },

                {
                  code: "BIO 412",
                  title: "General Microbiology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 421",
                  title: "Philosophy of Education"
                },

                {
                  code: "EDU 422",
                  title: "Planning and Economics of Education"
                },

                {
                  code: "EDU 423",
                  title: "Education and Development"
                },

                {
                  code: "BCU 412",
                  title: "Entrepreneurship and Innovation"
                },

                {
                  code: "MAT 411",
                  title: "Vector Analysis"
                },

                {
                  code: "STA 324",
                  title: "Hypothesis Testing"
                },

                {
                  code: "BIO 421",
                  title: "Plant Physiology"
                },

                {
                  code: "BIO 422",
                  title: "Biostatistics"
                },

                {
                  code: "EDU 429",
                  title: "Practicum II"
                }

              ]
            }

          ]
        }

      ]
    },


    /*
    ==========================================================
    SPECIALISATION 3
    BIOLOGY / GEOGRAPHY
    ==========================================================
    */

    {
      specialisation: "Biology / Geography",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "PSY 111",
                  title: "General Psychology"
                },

                {
                  code: "EDU 110",
                  title: "Fundamentals of Special Needs Education"
                },

                {
                  code: "EDU 111",
                  title: "History of Education"
                },

                {
                  code: "BCU 110",
                  title: "Communication Skills"
                },

                {
                  code: "GEO 111",
                  title: "Introduction to Geography"
                },

                {
                  code: "GEO 112",
                  title: "Physical Geography I"
                },

                {
                  code: "BIO 111",
                  title: "Fundamentals of Ecology"
                },

                {
                  code: "BIO 112",
                  title: "Introduction to Biochemistry"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 121",
                  title: "Psychology of Teaching and Learning"
                },

                {
                  code: "EDU 121",
                  title: "Fundamentals of Environmental Education"
                },

                {
                  code: "BCU 112",
                  title: "Introduction to Computers and Internet"
                },

                {
                  code: "GEO 121",
                  title: "Human Geography and Spatial Organization"
                },

                {
                  code: "GEO 122",
                  title: "Geography of East Africa"
                },

                {
                  code: "BIO 121",
                  title: "Cell and Molecular Biology"
                },

                {
                  code: "BIO 122",
                  title: "Plant Structure and Function"
                }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 211",
                  title: "Curriculum Development"
                },

                {
                  code: "PSY 211",
                  title: "Human Growth and Development"
                },

                {
                  code: "BCU 113",
                  title: "Health and Wellness Management"
                },

                {
                  code: "GEO 211",
                  title: "Geography of Africa"
                },

                {
                  code: "GEO 212",
                  title: "Physical Geography II"
                },

                {
                  code: "BIO 211",
                  title: "Plant Taxonomy"
                },

                {
                  code: "BIO 212",
                  title: "Invertebrate Biology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 221",
                  title: "Education Communication and Technology"
                },

                {
                  code: "EDU 222",
                  title: "Educational Administration and Management"
                },

                {
                  code: "PSY 222",
                  title: "Guidance and Counseling"
                },

                {
                  code: "GEO 221",
                  title: "Arid and Semi-arid Lands"
                },

                {
                  code: "GEO 222",
                  title: "Cartography and Map Analysis"
                },

                {
                  code: "BIO 221",
                  title: "Vertebrate Biology"
                }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 311",
                  title: "Instructional Methods"
                },

                {
                  code: "ECT 320",
                  title: "Micro-teaching and Media Practical"
                },

                {
                  code: "BCU 320",
                  title: "Research Methods"
                },

                {
                  code: "GEO 311",
                  title: "Climatology"
                },

                {
                  code: "GEO 312",
                  title: "Agricultural Geography"
                },

                {
                  code: "BIO 311",
                  title: "Hydrobiology"
                },

                {
                  code: "BIO 312",
                  title: "Entomology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 322",
                  title: "Tests Measurement and Evaluation"
                },

                {
                  code: "ECT 321",
                  title: "E-Learning Technology in Education"
                },

                {
                  code: "EDU 320",
                  title: "Teaching Practicum I"
                },

                {
                  code: "GEO 321",
                  title:
                    "Remote Sensing and GIS and Resource Management"
                },

                {
                  code: "GEO 322",
                  title: "Geomorphology"
                },

                {
                  code: "GEO 319",
                  title: "Teaching Methods in Geography"
                },

                {
                  code: "BIO 321",
                  title: "Immunology"
                },

                {
                  code: "BIO 322",
                  title: "Ecology and Bioanalysis"
                }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 411",
                  title:
                    "Comparative Education and Emerging Contemporary Issues"
                },

                {
                  code: "EDU 412",
                  title: "Sociology of Education"
                },

                {
                  code: "ECT 322",
                  title: "Competence Based Learning"
                },

                {
                  code: "GEO 411",
                  title: "Environmental Conservation"
                },

                {
                  code: "GEO 412",
                  title: "Population Geography"
                },

                {
                  code: "BIO 411",
                  title: "Animal Physiology"
                },

                {
                  code: "BIO 412",
                  title: "General Microbiology"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 421",
                  title: "Philosophy of Education"
                },

                {
                  code: "EDU 422",
                  title: "Planning and Economics of Education"
                },

                {
                  code: "EDU 423",
                  title: "Education and Development"
                },

                {
                  code: "BCU 412",
                  title: "Entrepreneurship and Innovation"
                },

                {
                  code: "EDU 429",
                  title: "Practicum II"
                },

                {
                  code: "GEO 421",
                  title: "Economic Geography"
                },

                {
                  code: "GEO 422",
                  title: "Biogeography"
                },

                {
                  code: "BIO 421",
                  title: "Plant Physiology"
                },

                {
                  code: "BIO 422",
                  title: "Biostatistics"
                }

              ]
            }

          ]
        }

      ]
    },


    /*
    ==========================================================
    SPECIALISATION 4
    MATHEMATICS / CHEMISTRY
    ==========================================================
    */

    {
      specialisation: "Mathematics / Chemistry",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "PSY 111",
                  title: "General Psychology"
                },

                {
                  code: "EDU 110",
                  title: "Fundamentals of Special Needs Education"
                },

                {
                  code: "EDU 111",
                  title: "History of Education"
                },

                {
                  code: "BCU 110",
                  title: "Communication Skills"
                },

                {
                  code: "MAT 111",
                  title: "Basic Mathematics"
                },

                {
                  code: "MAT 121",
                  title: "Discrete Mathematics"
                },

                {
                  code: "CHE 111",
                  title: "Fundamentals of Laboratory Techniques"
                },

                {
                  code: "CHE 112",
                  title: "Fundamentals of Inorganic Chemistry"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 121",
                  title: "Psychology of Teaching and Learning"
                },

                {
                  code: "EDU 121",
                  title: "Fundamentals of Environmental Education"
                },

                {
                  code: "BCU 112",
                  title: "Introduction to Computers and Internet"
                },

                {
                  code: "MAT 123",
                  title: "Geometry"
                },

                {
                  code: "MAT 120",
                  title: "Calculus I"
                },

                {
                  code: "CHE 121",
                  title:
                    "Introduction to Classical Analysis and Separation Techniques"
                },

                {
                  code: "CHE 122",
                  title: "Fundamentals of Physical Chemistry"
                }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 211",
                  title: "Curriculum Development"
                },

                {
                  code: "PSY 211",
                  title: "Human Growth and Development"
                },

                {
                  code: "BCU 113",
                  title: "Health and Wellness Management"
                },

                {
                  code: "MAT 213",
                  title: "Calculus II"
                },

                {
                  code: "STA 123",
                  title: "Probability and Statistics I"
                },

                {
                  code: "CHE 211",
                  title: "Organic Chemistry I"
                },

                {
                  code: "CHE 212",
                  title: "Atomic Structure and Chemical Bonding"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 221",
                  title: "Education Communication and Technology"
                },

                {
                  code: "EDU 222",
                  title: "Educational Administration and Management"
                },

                {
                  code: "PSY 222",
                  title: "Guidance and Counseling"
                },

                {
                  code: "MAT 225",
                  title: "Calculus III"
                },

                {
                  code: "STA 212",
                  title: "Probability and Statistics II"
                },

                {
                  code: "CHE 221",
                  title: "Chemical Thermodynamics"
                },

                {
                  code: "CHE 222",
                  title: "Organic Chemistry II"
                }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 311",
                  title: "Instructional Methods"
                },

                {
                  code: "ECT 320",
                  title: "Micro-teaching and Media Practical"
                },

                {
                  code: "BCU 320",
                  title: "Research Methods"
                },

                {
                  code: "MAT 210",
                  title: "Linear Algebra"
                },

                {
                  code: "MAT 211",
                  title: "Introduction to Real Analysis"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "PSY 322",
                  title: "Tests Measurement and Evaluation"
                },

                {
                  code: "ECT 321",
                  title: "E-Learning Technology in Education"
                },

                {
                  code: "EDU 320",
                  title: "Teaching Practicum I"
                },

                {
                  code: "MAT 321",
                  title: "Complex Analysis"
                },

                {
                  code: "MAT 223",
                  title: "Ordinary Differential Equation"
                },

                {
                  code: "MAT 319",
                  title: "Teaching Methods in Mathematics"
                },

                {
                  code: "CHE 321",
                  title: "Chemistry of Aromatic Compounds"
                },

                {
                  code: "CHE 322",
                  title:
                    "Coordination and Organometallic Chemistry"
                }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "EDU 411",
                  title:
                    "Comparative Education and Emerging Contemporary Issues"
                },

                {
                  code: "EDU 412",
                  title: "Sociology of Education"
                },

                {
                  code: "ECT 322",
                  title: "Competence Based Learning"
                },

                {
                  code: "MAT 413",
                  title: "Partial Differential Equations"
                },

                {
                  code: "MAT 311",
                  title: "Operation Research"
                },

                {
                  code: "CHE 411",
                  title: "Radio Activity and Nuclear Chemistry"
                },

                {
                  code: "CHE 412",
                  title:
                    "Comparative Study of Transition Elements D and F Blocks"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "EDU 421",
                  title: "Philosophy of Education"
                },

                {
                  code: "EDU 422",
                  title: "Planning and Economics of Education"
                },

                {
                  code: "EDU 423",
                  title: "Education and Development"
                },

                {
                  code: "BCU 412",
                  title: "Entrepreneurship and Innovation"
                },

                {
                  code: "EDU 429",
                  title: "Practicum II"
                },

                {
                  code: "MAT 411",
                  title: "Vector Analysis"
                },

                {
                  code: "STA 324",
                  title: "Hypothesis Testing"
                },

                {
                  code: "CHE 421",
                  title: "Industrial Chemistry"
                },

                {
                  code: "CHE 422",
                  title: "Environmental Chemistry"
                }

              ]
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Education Science programme take?",

      answer:
        "The Bachelor of Education Science programme takes four years, equivalent to eight semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the teaching subject specialisations available?",

      answer:
        "The programme offers teaching combinations including Mathematics/Biology, Mathematics/Chemistry, Mathematics/Physics, Biology/Physics, Chemistry/Physics, Geography/Physical Education, Geography/Agriculture, Home Science/Physical Education, Geography/Home Science, Biology/Chemistry, Biology/Agriculture, Biology/Home Science, Physics/Computer Studies and Agriculture/Home Science."
    },

    {
      question: "Does the programme include teaching practicum?",

      answer:
        "Yes. Students undertake practical teaching experiences including micro-teaching, Teaching Practicum I and Practicum II."
    },

    {
      question: "What careers can I pursue after studying Bachelor of Education Science?",

      answer:
        "Graduates can pursue careers as teachers, university lecturers, educational researchers, curriculum developers, laboratory technicians, education officers and quality assurance officers."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Education Science | Zetech University",

    metaDescription:
      "Study Bachelor of Education Science at Zetech University and develop specialized science teaching expertise, pedagogical skills, research capabilities and practical classroom experience."

  }

},
{
  id: 7,

  slug: "bachelor-of-commerce",

  title: "Bachelor of Commerce",

  shortTitle: "Bachelor of Commerce",

  code: "BCom",

  school: "School of Business and Economics",

  qualification: "UNDERGRADUATE",

  qualificationTitle: "Bachelor of Commerce",

  award: "Bachelor of Commerce",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-commerce.pdf",

  feeStructure: "/downloads/fees/bachelor-of-commerce-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "From Business Insight to Business Impact.",

  heroDescription:
    "Develop practical business knowledge and specialized expertise in Accounting, Finance, Marketing or Human Resource Management while preparing for leadership in today's competitive business environment.",

  overview: `
The Bachelor of Commerce offers a comprehensive understanding of business and the commercial environment through the study of accounting, finance, banking, marketing, human resource management, entrepreneurship and international business.

The programme equips students with analytical, managerial and leadership skills required to solve business challenges, make strategic decisions and drive organisational success in both local and global markets.

Students combine theoretical knowledge with practical learning through case studies, research projects, business simulations and industrial attachment while developing professional competence in their chosen area of specialization.

Graduates are prepared for leadership positions in business, government, financial institutions, multinational organizations and entrepreneurial ventures.
`,

  whyStudy: [

    "Choose from four career-focused specialisations: Human Resource Management, Finance, Accounting and Marketing.",

    "Build a strong foundation in accounting, economics, finance, entrepreneurship, management and international business.",

    "Gain practical experience through business projects, research, industrial attachment and case-based learning.",

    "Learn from experienced academics and industry professionals committed to career-focused education.",

    "Study through flexible Physical and Online learning options.",

    "Graduate with the knowledge, leadership and professional skills required for today's dynamic business environment."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C+.",

    "Minimum grade of C (Plain) in Mathematics and English.",

    "OR Holder of an accredited Diploma with a Credit Pass recognized by the University Senate.",

    "OR Holder of a KACE certificate with at least two Principal Passes and a pass in Mathematics at KCSE."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  specialisations: [

    "Human Resource Management",

    "Finance",

    "Accounting",

    "Marketing"

  ],

  careers: [

    "Accountant",

    "Business Manager",

    "Financial Consultant",

    "Marketing Consultant",

    "Human Resource Manager",

    "Project Manager",

    "Entrepreneur"

  ],

  skills: [

    "Accounting",

    "Financial Management",

    "Marketing",

    "Human Resource Management",

    "Business Strategy",

    "Entrepreneurship",

    "Leadership",

    "Corporate Finance",

    "Business Analytics",

    "Strategic Management",

    "Project Management",

    "Digital Business"

  ],

  curriculum: [

    /*
      SPECIALISATION 1
      Human Resource Management
    */

    {
      specialisation: "Human Resource Management",
      years: [
        // Year 1 (Common)
        // Year 2 (Common)
        // Year 3 HR
        // Year 4 HR
      ]
    },

    /*
      SPECIALISATION 2
      Finance
    */

    {
      specialisation: "Finance",
      years: [
        // Year 1 (Common)
        // Year 2 (Common)
        // Year 3 Finance
        // Year 4 Finance
      ]
    },

    /*
      SPECIALISATION 3
      Accounting
    */

    {
      specialisation: "Accounting",
      years: [
        // Year 1 (Common)
        // Year 2 (Common)
        // Year 3 Accounting
        // Year 4 Accounting
      ]
    },

    /*
      SPECIALISATION 4
      Marketing
    */

    {
      specialisation: "Marketing",
      years: [
        // Year 1 (Common)
        // Year 2 (Common)
        // Year 3 Marketing
        // Year 4 Marketing
      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters)."
    },

    {
      question: "Which specialisations are available?",
      answer: "Students may specialize in Human Resource Management, Finance, Accounting or Marketing."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted in January, May and September."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Commerce | Zetech University",

    metaDescription:
      "Study the Bachelor of Commerce at Zetech University with specialisations in Human Resource Management, Finance, Accounting and Marketing."

  }

},
{
  id: 8,

  slug: "bachelor-of-business-information-technology",

  title: "Bachelor of Business Information Technology",

  shortTitle: "Bachelor of Business Information Technology",

  code: "BBIT",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Business Information Technology",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-business-information-technology.pdf",

  feeStructure: "/downloads/fees/bachelor-of-business-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Integrate Technology. Drive Business Success",

  heroDescription:
    "The Bachelor of Business Information Technology integrates business management with modern information technology to prepare graduates capable of leading digital transformation and solving business challenges through innovative technology solutions.",

  overview: `
The Bachelor of Business Information Technology is an interdisciplinary programme that combines business management principles with modern information technology to prepare graduates for today's digital economy.

Students develop expertise in software development, enterprise systems, databases, business intelligence, cybersecurity, e-commerce and IT strategy while gaining a solid foundation in business operations, accounting, economics and management.

Graduates acquire the technical, analytical and managerial skills required to bridge the gap between business and technology, enabling organizations to leverage digital solutions for innovation, efficiency and sustainable growth.
`,

  whyStudy: [

    "Gain practical skills in software development, databases, business intelligence, cybersecurity and digital business solutions.",

    "Work on real-world projects using modern technologies and industry-standard tools.",

    "Develop the skills required to manage enterprise IT systems, digital projects and business transformation initiatives.",

    "Learn to analyze business needs and deliver innovative technology-driven solutions.",

    "Study in a technology-focused environment that promotes innovation, entrepreneurship and career success.",

    "Graduate ready for careers in software development, IT management, business analysis, project management and digital transformation."

  ],

  entryRequirements: [

    "KCSE Mean Grade C+ with a minimum of C (Plain) in Mathematics and English/Kiswahili.",

    "OR an accredited Diploma with at least a Credit Pass from an institution recognized by the University Senate.",

    "OR KACE certificate with at least two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {

      year: "Year One",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BBM111", title: "Introduction to Business Studies" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BEC111", title: "Introduction to Microeconomics" },

            { code: "BSD111", title: "Structured Programming and Algorithms" },

            { code: "MAT111", title: "Basic Mathematics" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "STA123", title: "Probability and Statistics I" },

            { code: "BAC111", title: "Financial Accounting I" },

            { code: "BCT121", title: "Operating Systems" },

            { code: "BBM121", title: "Principles of Management" },

            { code: "BSD122", title: "Object Oriented Programming I" },

            { code: "BSD121", title: "Software Design Methods and Architectures" },

            { code: "BAC123", title: "Introduction to Computerised Business Accounting" }

          ]

        }

      ]

    },

    {

      year: "Year Two",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BBM221", title: "Principles of Marketing" },

            { code: "BCE210", title: "Computer Organization and Architecture" },

            { code: "BSD211", title: "Data Structures and Algorithms" },

            { code: "BFN211", title: "Business Law" },

            { code: "BAC212", title: "Cost Accounting" },

            { code: "BSD214", title: "Object Oriented Programming II" },

            { code: "BDM211", title: "Database Management Systems" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BEC221", title: "Introduction to Macroeconomics" },

            { code: "BSD213", title: "Object Oriented Software Design Methods" },

            { code: "BSD313", title: "Internet Programming I" },

            { code: "BNT221", title: "Data Communication and Computer Networks" },

            { code: "BMA221", title: "Quantitative Techniques" },

            { code: "BDM222", title: "Advanced Database Management Systems" },

            { code: "BSD224", title: "Multimedia Systems and Applications" }

          ]

        }

      ]

    },

    {

      year: "Year Three",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCT321", title: "Research Methods and Technical Writing" },

            { code: "BHR311", title: "Organizational Behavior" },

            { code: "BFN221", title: "Financial Risk Management" },

            { code: "BSD314", title: "Programming in Python" },

            { code: "BSD315", title: "Software Engineering" },

            { code: "BCT412", title: "Computer and Cyber Security" },

            { code: "BAC316", title: "Principles of Auditing" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BSD322", title: "Internet Programming II" },

            { code: "BCT322", title: "IT Project Management" },

            { code: "BSD323", title: "Search Engine Optimization" },

            { code: "BMK321", title: "Digital Marketing" }

          ]

        }

      ]

    },

    {

      year: "Year Four",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU410", title: "Entrepreneurship and Innovation" },

            { code: "BCT414", title: "Information Systems Audit and Assurance" },

            { code: "BDM411", title: "Business Intelligence and Analytics" },

            { code: "BSD312", title: "Mobile Programming I" },

            { code: "BCT323", title: "Electronic Commerce" },

            { code: "BCT415", title: "Project Proposal" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BCE412", title: "Machine Learning" },

            { code: "BCT421", title: "Legal and Professional Ethics in Computing" },

            { code: "BBM325", title: "Strategic Management" },

            { code: "BCT425", title: "Final Project" },

            { code: "BCU401", title: "Industrial Attachment" }

          ]

        }

      ]

    }

  ],

  careers: [

    "IT Consultant",

    "IT Manager",

    "Software Engineer",

    "Software Developer",

    "Business Systems Analyst",

    "Business Intelligence Analyst",

    "Project Manager",

    "Database Administrator",

    "Web Developer",

    "Systems Administrator",

    "Digital Transformation Consultant",

    "Business Operations Analyst"

  ],

  skills: [

    "Software Development",

    "Business Analysis",

    "Enterprise Systems",

    "Database Management",

    "Business Intelligence",

    "Cyber Security",

    "Project Management",

    "Digital Transformation",

    "Data Analytics",

    "Cloud Computing",

    "E-Commerce",

    "Leadership"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer:
        "The Bachelor of Business Information Technology takes four years (eight semesters) to complete."

    },

    {

      question: "Is the programme offered online?",

      answer:
        "Yes. The programme is offered through both Physical and Online learning modes."

    },

    {

      question: "When are the intakes?",

      answer:
        "Students are admitted during the January, May and September intakes."

    },

    {

      question: "What careers can I pursue after graduation?",

      answer:
        "Graduates can work as IT Consultants, Software Engineers, Business Analysts, Project Managers, Web Developers, Database Administrators, Business Intelligence Analysts and Digital Transformation Specialists."

    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Business Information Technology | Zetech University",

    metaDescription:
      "Study the Bachelor of Business Information Technology at Zetech University and gain practical skills in software development, business intelligence, cybersecurity, enterprise systems and digital transformation."

  }

},
{
  id: 9,

  slug: "bachelor-of-science-in-information-technology",

  title: "Bachelor of Science in Information Technology",

  shortTitle: "BSc Information Technology",

  code: "BSc IT",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-science-information-technology.pdf",

  feeStructure: "/downloads/fees/bachelor-of-science-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Powering the Next Generation of IT Innovators",

  heroDescription:
    "The Bachelor of Science in Information Technology equips students with practical and industry-driven skills in software development, networking, cybersecurity, cloud computing, databases and emerging technologies for successful careers in today's digital economy.",

  overview: `
The Bachelor of Science in Information Technology provides students with a comprehensive foundation in programming, database systems, networking, cybersecurity, cloud computing, software engineering and IT project management.

The programme combines theoretical knowledge with practical application through laboratory work, real-world projects and emerging technologies including Artificial Intelligence, Machine Learning, Blockchain, Cloud Computing and Mobile Application Development.

Graduates develop the technical, analytical and problem-solving skills required to design, implement, secure and manage modern information systems that drive digital transformation across industries.
`,

  whyStudy: [

    "Gain practical skills in programming, networking, cybersecurity, cloud computing, databases and software development.",

    "Work on real-world projects using modern technologies and industry-standard tools.",

    "Explore emerging technologies including Artificial Intelligence, Machine Learning, Blockchain, Cloud Computing and Mobile Application Development.",

    "Learn from experienced lecturers with strong academic and industry backgrounds.",

    "Develop technical, analytical and problem-solving skills required for digital transformation.",

    "Graduate ready for careers in software engineering, networking, cybersecurity, cloud computing and IT management."

  ],

  entryRequirements: [

    "KCSE mean grade of C+ (Plus) or equivalent.",

    "Minimum grade of C (Plain) in Mathematics.",

    "Minimum grade of C (Plain) in English or Kiswahili."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60650,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "ENV101", title: "Environmental Studies" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "MAT111", title: "Basic Mathematics" },

            { code: "BSD111", title: "Structured Programming and Algorithms" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "STA123", title: "Probability and Statistics I" },

            { code: "MAT120", title: "Calculus" },

            { code: "BCT121", title: "Operating Systems" },

            { code: "BSD121", title: "Software Design Methods and Architectures" },

            { code: "BCE122", title: "Fundamentals of Digital Systems" },

            { code: "BSD122", title: "Object Oriented Programming I" },

            { code: "BAC123", title: "Computerised Business Accounting" }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "MAT212", title: "Discrete Mathematics" },

            { code: "BCE210", title: "Computer Organization and Architecture" },

            { code: "BSD211", title: "Data Structures and Algorithms" },

            { code: "PHY211", title: "Electronics" },

            { code: "BCE214", title: "Computer Graphics" },

            { code: "BSD214", title: "Object Oriented Programming II" },

            { code: "BDM211", title: "Database Management Systems" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BCT221", title: "Legal and Professional Ethics in Computing" },

            { code: "BSD228", title: "Object Oriented Software Design Methods" },

            { code: "BSD227", title: "Internet Programming I" },

            { code: "BNT221", title: "Data Communication and Computer Networks" },

            { code: "BDM222", title: "Advanced Database Development" },

            { code: "BSD224", title: "Multimedia Systems and Applications" }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCT312", title: "Computer and Information Systems Security" },

            { code: "BNT313", title: "Telecommunication and Broadcasting Systems" },

            { code: "BCT311", title: "Research Methods and Technical Writing" },

            { code: "BNT311", title: "Distributed Computing" },

            { code: "BSD314", title: "Programming in Python" },

            { code: "BSD315", title: "Software Engineering" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BSD326", title: "Visual Programming" },

            { code: "BSD322", title: "Internet Programming II" },

            { code: "BSD321", title: "User Centered Design" },

            { code: "BCE322", title: "Artificial Intelligence" },

            { code: "BNT321", title: "System Integration and Collaborative Technologies" },

            { code: "BCT322", title: "IT Project Management" }

          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU410", title: "Entrepreneurship and Innovation" },

            { code: "BSD415", title: "Wireless and Mobile Technologies" },

            { code: "BCE413", title: "Blockchain Technology" },

            { code: "BSD413", title: "Software Quality Assurance" },

            { code: "BCE414", title: "Satellite and Broadband Communication" },

            { code: "BCT415", title: "Project Proposal" },

            { code: "BDM411", title: "Data Science" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BCE412", title: "Machine Learning" },

            { code: "BSD422", title: "Mobile Application Development" },

            { code: "BCT424", title: "Business Information Systems Management" },

            { code: "BCT425", title: "Final Project" },

            { code: "BSD425", title: "Microprocessors Applications" },

            { code: "BCE422", title: "Real-time Software Systems" },

            { code: "BCU401", title: "Attachment" }

          ]
        }

      ]
    }

  ],

  careers: [

    "Software Developer",

    "Information Security Analyst",

    "Computer Systems Analyst",

    "Systems Administrator",

    "Network Engineer",

    "Cloud Engineer",

    "Cyber Security Analyst",

    "Database Administrator",

    "IT Support Specialist",

    "IT Project Manager",

    "Computer Network Architect",

    "Information Research Scientist"

  ],

  skills: [

    "Programming",

    "Software Development",

    "Cyber Security",

    "Cloud Computing",

    "Networking",

    "Database Administration",

    "Artificial Intelligence",

    "Machine Learning",

    "Blockchain",

    "IT Project Management",

    "Problem Solving",

    "Systems Analysis"

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The Bachelor of Science in Information Technology takes four years (eight semesters) to complete."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are intakes conducted?",
      answer: "Students are admitted during the January, May and September intakes."
    },

    {
      question: "What careers can I pursue after graduation?",
      answer: "Graduates can work as Software Developers, Cyber Security Analysts, Systems Administrators, Network Engineers, Database Administrators, Cloud Engineers, IT Project Managers and other ICT professionals."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Information Technology | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Information Technology at Zetech University and gain practical skills in software development, cybersecurity, networking, cloud computing, AI, databases and emerging technologies."

  }

},
{
  id: 10,

  slug: "bachelor-of-science-in-computer-science",

  title: "Bachelor of Science in Computer Science",

  shortTitle: "Bachelor of Science in Computer Science",

  code: "BCS",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science in Computer Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-science-in-computer-science.pdf",

  feeStructure: "/downloads/fees/bachelor-of-science-in-computer-science-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "From Ideas to Innovation",

  heroDescription:
    "The Bachelor of Science in Computer Science equips students with advanced computing knowledge, programming expertise and problem-solving skills to develop innovative software solutions and drive digital transformation across industries.",

  overview: `
The Bachelor of Science in Computer Science is designed to develop professionals who apply computational thinking and advanced computing principles to solve complex real-world problems.

The programme combines strong theoretical foundations with practical training in programming, algorithms, software engineering, databases, networking, operating systems and systems development while exposing students to emerging technologies such as Artificial Intelligence, Machine Learning, Cloud Computing, Cyber Security, Blockchain and the Internet of Things.

Through practical projects, research and industrial attachment, graduates acquire the technical and analytical skills required to design, build, deploy and maintain modern computing systems for today's digital economy.
`,

  whyStudy: [

    "Develop strong programming, analytical and problem-solving skills required to build innovative software solutions.",

    "Gain hands-on experience through real-world projects, laboratories and practical system development.",

    "Explore emerging technologies including Artificial Intelligence, Machine Learning, Blockchain, Cloud Computing, Cyber Security and the Internet of Things.",

    "Study in a technology-driven environment that promotes creativity, innovation, research and entrepreneurship.",

    "Learn to analyze complex computing problems and develop scalable technology solutions for modern organizations.",

    "Graduate ready for careers in software engineering, cloud computing, cybersecurity, data science, game development and technology leadership."

  ],

  entryRequirements: [

    "KCSE Mean Grade C+ with a minimum of C (Plain) in Mathematics, English and Physics/Physical Sciences.",

    "OR KACE certificate with at least two Principal Passes in Mathematics and Physics.",

    "OR a related Diploma equivalent to a KNEC Diploma from an institution recognized by the University Senate with at least a Pass.",

    "OR any other relevant qualification approved by the University Senate."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {

      year: "Year One",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "PHY111", title: "Introduction to Physics" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BSD111", title: "Introduction to Programming and Algorithms" },

            { code: "MAT111", title: "Basic Mathematics" },

            { code: "BCE111", title: "Computation Logic" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "MAT212", title: "Discrete Mathematics" },

            { code: "STA123", title: "Probability and Statistics I" },

            { code: "BDM121", title: "Database Management Systems" },

            { code: "BCT121", title: "Operating Systems" },

            { code: "BSD221", title: "Assembly Language Programming" },

            { code: "BSD121", title: "Software Design and Architectures" }

          ]

        }

      ]

    },

    {

      year: "Year Two",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "MAT120", title: "Calculus" },

            { code: "STA212", title: "Probability and Statistics II" },

            { code: "BCE211", title: "Computer Vision" },

            { code: "BSD213", title: "Object Oriented Software Design Methods" },

            { code: "BCE212", title: "Computer Support and Maintenance" },

            { code: "BSD211", title: "Data Structures and Algorithms" },

            { code: "BSD122", title: "Object Oriented Programming I" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BNT221", title: "Data Communication and Computer Networks" },

            { code: "BDM221", title: "Data Science" },

            { code: "BBM321", title: "International Business Management" },

            { code: "MAT213", title: "Calculus II" },

            { code: "BSD222", title: "Design and Analysis of Algorithms" },

            { code: "BCE121", title: "Computer Organization and Architecture" }

          ]

        }

      ]

    },

    {

      year: "Year Three",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BNT311", title: "Distributed Computing" },

            { code: "BSD315", title: "Software Engineering" },

            { code: "BCE312", title: "Artificial Intelligence I" },

            { code: "BSD311", title: "Simulation and Modeling" },

            { code: "BDM311", title: "Data Mining and Warehousing" },

            { code: "BCE311", title: "Compiler Construction" },

            { code: "BSD313", title: "Internet Programming I" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BSD322", title: "Internet Programming II" },

            { code: "BCT321", title: "Research Methods and Technical Writing" },

            { code: "BCT322", title: "IT Project Management" },

            { code: "BCE321", title: "The Internet of Things" },

            { code: "BSD321", title: "User Centered Design" },

            { code: "BDM321", title: "Cloud Computing and Services" }

          ]

        }

      ]

    },

    {

      year: "Year Four",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BSD415", title: "Wireless and Mobile Technologies" },

            { code: "BCE413", title: "Blockchain Technology" },

            { code: "BSD412", title: "Game Design and Development" },

            { code: "BSD411", title: "Business Intelligence and Analytics" },

            { code: "BCT412", title: "Computer and Information Systems Security" },

            { code: "BCE412", title: "Machine Learning" },

            { code: "BCT415", title: "Project Proposal" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BCE421", title: "Artificial Intelligence II" },

            { code: "BCU410", title: "Entrepreneurship and Innovation" },

            { code: "BCT421", title: "Legal and Professional Ethics in Computing" },

            { code: "BCT425", title: "Final Project" },

            { code: "BCU401", title: "Industrial Attachment" }

          ]

        }

      ]

    }

  ],

  careers: [

    "Software Engineer",

    "Systems Developer",

    "IT Manager",

    "Chief Technology Officer",

    "Cloud Security Engineer",

    "Cloud Solutions Architect",

    "Data Scientist",

    "Machine Learning Engineer",

    "Artificial Intelligence Engineer",

    "Cyber Security Analyst",

    "Systems Administrator",

    "IoT Specialist",

    "Game Developer",

    "GIS Specialist",

    "Research Scientist"

  ],

  skills: [

    "Programming",

    "Algorithms",

    "Data Structures",

    "Software Engineering",

    "Artificial Intelligence",

    "Machine Learning",

    "Cloud Computing",

    "Cyber Security",

    "Blockchain",

    "Internet of Things",

    "Database Management",

    "Problem Solving",

    "Research",

    "Systems Design"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer:
        "The Bachelor of Science in Computer Science takes four years (eight semesters) to complete."

    },

    {

      question: "Is the programme offered online?",

      answer:
        "Yes. The programme is offered through both Physical and Online learning modes."

    },

    {

      question: "When are the intakes?",

      answer:
        "Students are admitted during the January, May and September intakes."

    },

    {

      question: "What careers can I pursue after graduation?",

      answer:
        "Graduates can work as Software Engineers, Data Scientists, AI Engineers, Cloud Engineers, Cyber Security Analysts, Systems Developers, Game Developers, CTOs and other technology professionals."

    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Computer Science | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Computer Science at Zetech University and build expertise in programming, artificial intelligence, machine learning, cloud computing, cybersecurity, software engineering and emerging technologies."

  }

},
{
  id: 11,

  slug: "bachelor-of-science-in-software-engineering",

  title: "Bachelor of Science in Software Engineering",

  shortTitle: "BSc Software Engineering",

  code: "BSE",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-science-in-software-engineering.pdf",

  feeStructure: "/downloads/fees/bachelor-of-science-in-software-engineering-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Building Tomorrow's Software Innovators.",

  heroDescription:
    "The Bachelor of Science in Software Engineering equips students with the technical knowledge and practical experience to design, develop, test, deploy and maintain modern software systems for today's digital world.",

  overview: `
The Bachelor of Science in Software Engineering is designed to equip students with the knowledge, technical skills and practical experience required to design, develop, test, deploy and maintain high-quality software systems.

The programme provides a strong foundation in software engineering principles, programming, algorithms, software architecture, user interface design, web and mobile application development, cloud technologies and DevOps practices.

Through hands-on learning, research, innovation and industry-oriented training, graduates develop competencies to build dependable, secure and scalable software solutions that address real-world business and societal challenges.
`,

  whyStudy: [

    "Gain the skills to design, develop, test and maintain high-quality software for real-world applications.",

    "Build practical experience by creating web, mobile and enterprise applications using modern development tools and technologies.",

    "Develop expertise in software engineering, cloud computing, DevOps, cybersecurity, mobile development and software quality assurance.",

    "Learn how to analyze user needs and create reliable, secure and scalable software solutions.",

    "Graduate ready for careers in software engineering, full-stack development, mobile app development, DevOps, software testing and systems development.",

    "Strengthen your career readiness through practical projects, research and industrial attachment."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum mean grade of C+ and at least C in Mathematics and English/Kiswahili.",

    "OR KACE certificate with at least a Principal Pass in Mathematics.",

    "OR a Pass in a Zetech University Diploma or any other relevant qualification recognized by the University Senate."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",
    "May",
    "September"

  ],

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BCU111",
              title: "Communication Skills"
            },
            {
              code: "BCU113",
              title: "Health and Wellness Management"
            },
            {
              code: "BCU112",
              title: "Digital Literacy"
            },
            {
              code: "BSD111",
              title: "Structured Programming and Algorithms"
            },
            {
              code: "MAT111",
              title: "Basic Mathematics"
            },
            {
              code: "BSD112",
              title: "Fundamentals of Software Engineering"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BCE121",
              title: "Computer Organization and Architecture"
            },
            {
              code: "BCT121",
              title: "Operating Systems"
            },
            {
              code: "MAT121",
              title: "Discrete Mathematics"
            },
            {
              code: "STA113",
              title: "Probability and Statistics"
            },
            {
              code: "BSD121",
              title: "Software Design and Architectures"
            },
            {
              code: "BSD122",
              title: "Object Oriented Programming I"
            }

          ]

        }

      ]

    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BDM121",
              title: "Database Management Systems"
            },
            {
              code: "BSD211",
              title: "Data Structures and Algorithms"
            },
            {
              code: "BSD213",
              title: "Object Oriented Software Design Methods"
            },
            {
              code: "BSD214",
              title: "Object Oriented Programming II"
            },
            {
              code: "BCE212",
              title: "Computer Support and Maintenance"
            },
            {
              code: "MAT120",
              title: "Calculus I"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BDM221",
              title: "Advanced Database Development"
            },
            {
              code: "BSD223",
              title: "Mobile Computing"
            },
            {
              code: "BSD226",
              title: "Software Metrics"
            },
            {
              code: "BNT221",
              title: "Data Communication and Computer Networks"
            },
            {
              code: "BSD222",
              title: "Design and Analysis of Algorithms"
            },
            {
              code: "BDM222",
              title: "Python for Data Science"
            }

          ]

        }

      ]

    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BSD313",
              title: "Internet Programming I"
            },
            {
              code: "BSD225",
              title: "Network Engineering and Programming"
            },
            {
              code: "BSD312",
              title: "Mobile Programming I"
            },
            {
              code: "BSD311",
              title: "Simulation and Modeling"
            },
            {
              code: "BSD316",
              title: "Visual Programming"
            },
            {
              code: "BNT311",
              title: "Distributed Computing"
            },
            {
              code: "BSD317",
              title: "Software Configuration Management"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BCT321",
              title: "Research Methods and Technical Writing"
            },
            {
              code: "BSD322",
              title: "Internet Programming II"
            },
            {
              code: "BSD321",
              title: "User Centered Design"
            },
            {
              code: "BSD323",
              title: "Software Testing"
            },
            {
              code: "BDM321",
              title: "Cloud Computing and Services"
            },
            {
              code: "BSD324",
              title: "Mobile Programming II"
            },
            {
              code: "BSD422",
              title: "Software Project Management"
            }

          ]

        }

      ]

    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BSD411",
              title: "Business Intelligence and Analytics"
            },
            {
              code: "BCE422",
              title: "Real-time Software Systems"
            },
            {
              code: "BSD412",
              title: "Game Design and Development"
            },
            {
              code: "BSD413",
              title: "Software Quality Assurance"
            },
            {
              code: "BCT412",
              title: "Computer and Cyber Security"
            },
            {
              code: "BSD414",
              title: "Design Thinking"
            },
            {
              code: "BCT415",
              title: "Project Proposal"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BCT421",
              title: "Legal and Professional Ethics in Computing"
            },
            {
              code: "BCU410",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "BSD421",
              title: "Enterprise Applications Development"
            },
            {
              code: "BCT425",
              title: "Final Project"
            },
            {
              code: "BDM411",
              title: "Geographical Information Systems"
            },
            {
              code: "BCU401",
              title: "Industrial Attachment"
            }

          ]

        }

      ]

    }

  ],

  careers: [

    "Software Engineer",

    "Full-Stack Developer",

    "Mobile Application Developer",

    "DevOps Engineer",

    "Software Tester",

    "Systems Developer",

    "Network Programmer",

    "Webmaster",

    "Information Systems Auditor",

    "Cloud Engineer"

  ],

  skills: [

    "Software Development",

    "Full-Stack Development",

    "Object-Oriented Programming",

    "Software Architecture",

    "DevOps",

    "Cloud Computing",

    "Cyber Security",

    "Mobile Application Development",

    "Software Testing",

    "UI/UX Design",

    "Database Management",

    "Project Management"

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters) to complete."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning modes."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted during the January, May and September intakes."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer: "Yes. Students undertake an Industrial Attachment in their final year to gain practical industry experience."
    }

  ],

  seo: {

    metaTitle: "Bachelor of Science in Software Engineering | Zetech University",

    metaDescription:
      "Study Bachelor of Science in Software Engineering at Zetech University and build expertise in software engineering, cloud computing, DevOps, mobile application development and cybersecurity."

  }

},
{
  id: 12,

  slug: "bachelor-of-journalism",

  title: "Bachelor of Journalism",

  shortTitle: "Bachelor of Journalism",

  code: "BAJ",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Journalism",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bachelor-of-journalism.pdf",

  feeStructure: "/downloads/fees/bachelor-of-journalism-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Find the Story. Tell it Well.",

  heroDescription:
    "The Bachelor of Journalism prepares students with practical, ethical and digital media skills required to produce compelling stories across television, radio, print and online media platforms.",

  overview: `
The Bachelor of Journalism equips students with the knowledge, practical experience and ethical foundation required to excel in today's dynamic media industry.

The programme combines journalism theory with hands-on training in news reporting, writing, editing, digital journalism, broadcasting, multimedia storytelling, investigative reporting, photography and media production.

Students develop strong communication, research and analytical skills while learning to produce accurate, timely and impactful content for multiple media platforms.

Graduates are prepared for careers in television, radio, print, digital media, public relations, corporate communication and media entrepreneurship.
`,

  whyStudy: [

    "Learn how to research, write and tell compelling stories that inform, educate and inspire audiences.",

    "Gain practical experience in news reporting, broadcasting, photography, multimedia production and digital journalism.",

    "Develop skills in investigative journalism, video production, data journalism and social media storytelling.",

    "Work on practical media projects using industry-standard equipment and modern digital production tools.",

    "Learn media law, journalism ethics and responsible reporting from experienced media professionals.",

    "Graduate prepared for careers in television, radio, print, digital media, public relations and communications."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C+.",

    "Minimum grade of C in Mathematics and English/Kiswahili.",

    "OR KACE certificate with at least one Principal Pass in Mathematics.",

    "OR PASS in a Zetech University Diploma or another relevant qualification recognized by the University Senate."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],
    curriculum: [

    {
      year: "Year One",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "BAJ110", title: "Introduction to Journalism" },

            { code: "BJO111", title: "English for Journalists" },

            { code: "BJO112", title: "Media and Society" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BAJ120", title: "News Writing and Reporting" },

            { code: "BAJ121", title: "Writing for Mass Media" },

            { code: "ERE111", title: "Introduction to Creative and Critical Thinking" },

            { code: "BJO120", title: "Kiswahili kwa Wanahabari" },

            { code: "BAJ122", title: "Digital Photography and Photojournalism" },

            { code: "BAJ123", title: "Graphic Design and Presentation" }

          ]

        }

      ]

    },

    {

      year: "Year Two",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BAJ210", title: "Mass Media Theories" },

            { code: "BAJ211", title: "Gender and Development" },

            { code: "BAJ212", title: "Writing and Editing Techniques" },

            { code: "BAJ213", title: "Online Journalism" },

            { code: "BPSY216", title: "Psychology of Communication" },

            { code: "BAJ214", title: "Media Law and the Constitution" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BAV223", title: "Principles of Advertising" },

            { code: "BPR220", title: "Principles of Public Relations" },

            { code: "BAJ220", title: "Writing for Print" },

            { code: "BAJ221", title: "Journalism Ethics" },

            { code: "BAJ222", title: "Broadcast Production" },

            { code: "BAJ223", title: "Sign Language" }

          ]

        }

      ]

    },

    {

      year: "Year Three",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO310", title: "Communication Research" },

            { code: "BJO312", title: "Audience Analysis" },

            { code: "BAJ310", title: "Media Management" },

            { code: "BAJ311", title: "Audio and Video Production" },

            { code: "BAJ312", title: "Conflict Reporting and Peace Journalism" },

            { code: "BAJ313", title: "Information Sourcing and Management in Communication" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BCU320", title: "Research Methodology" },

            { code: "BAJ320", title: "Critical Writing and Reviewing" },

            { code: "BAJ321", title: "Educational Broadcasting" },

            { code: "BAJ322", title: "Multimedia Storytelling" },

            { code: "BAJ323", title: "Broadcast News Production" },

            { code: "BAJ324", title: "Lighting Techniques" }

          ]

        }

      ]

    },

    {

      year: "Year Four",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO410", title: "Documentary Production" },

            { code: "BAJ410", title: "Broadcasting Programming" },

            { code: "BCU410", title: "Entrepreneurship and Innovation" },

            { code: "BAJ411", title: "Science and Technology Reporting" },

            { code: "BAJ412", title: "Newspaper and Magazine Production" },

            { code: "BAJ413", title: "Editorial Writing" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BAJ420", title: "Digital Broadcasting" },

            { code: "BAJ421", title: "Studio and Broadcast Technology Operations" },

            { code: "BMD420", title: "Media Project" },

            { code: "BAJ422", title: "Safety and Protection of Journalists" },

            { code: "BJO423", title: "Data Journalism" },

            { code: "BAJ425", title: "Investigative and Interpretative Reporting" },

            { code: "BCU401", title: "Industrial Attachment" }

          ]

        }

      ]

    }

  ],

  careers: [

    "Television News Reporter",

    "Radio News Reporter",

    "Print Media Reporter",

    "Digital Journalist",

    "Photojournalist",

    "Communications Manager",

    "Media Entrepreneur",

    "Public Relations Officer"

  ],

  skills: [

    "News Reporting",

    "Broadcast Journalism",

    "Digital Journalism",

    "Investigative Reporting",

    "Multimedia Storytelling",

    "Video Production",

    "Photography",

    "Editing",

    "Media Ethics",

    "Communication"

  ],

  faqs: [

    {

      question: "How long does the programme take?",

      answer: "The programme takes four years (eight semesters) to complete."

    },

    {

      question: "What is the mode of study?",

      answer: "The programme is offered through both Physical and Online learning."

    },

    {

      question: "When are the intakes?",

      answer: "Students are admitted in January, May and September."

    },

    {

      question: "What careers can I pursue after graduation?",

      answer: "Graduates can work in television, radio, print media, digital journalism, public relations, corporate communications and media entrepreneurship."

    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Journalism | Zetech University",

    metaDescription:
      "Study the Bachelor of Journalism at Zetech University and build professional skills in journalism, digital media, broadcasting, multimedia storytelling and investigative reporting."

  }

},
{
  id: 99,

  slug: "bachelor-of-science-in-cybersecurity-and-digital-forensics",

  title: "Bachelor of Science in Cybersecurity and Digital Forensics",

  shortTitle: "BSc Cybersecurity & Digital Forensics",

  code: "BSCDF",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: true,

  image: undergraduate,

  brochure: "/images/Bronchure/Degree/ZU_2026_Bachelor of Science in Cybersecurity and Digital Forensics_.png",

  feeStructure: "/downloads/fees/bachelor-of-science-in-cybersecurity-and-digital-forensics-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Protect. Investigate. Defend.",

  heroDescription:
    "The Bachelor of Science in Cybersecurity and Digital Forensics develops cybersecurity and digital forensics professionals to protect digital systems, detect cyber threats, investigate digital crimes and respond to cybersecurity incidents.",

  overview: `
The Bachelor of Science in Cybersecurity and Digital Forensics is designed to develop cybersecurity and digital forensics professionals who can protect digital systems, detect cyber threats, investigate digital crimes and respond to cybersecurity incidents.

The programme combines computing, cybersecurity, digital investigation, information security and emerging technologies to provide students with comprehensive knowledge and practical skills in cybersecurity and digital forensics.

Students develop the practical skills needed to secure digital infrastructure, identify vulnerabilities, conduct forensic investigations, manage digital evidence and support secure digital transformation in organizations across all sectors.
`,

  whyStudy: [
    "Develop expertise in cybersecurity, digital forensics, information security and emerging technologies.",
    "Gain practical skills in securing digital infrastructure, identifying vulnerabilities and responding to cyber threats.",
    "Learn to conduct forensic investigations, manage digital evidence and support cybersecurity incident response.",
    "Study in a technology-driven environment with modern cybersecurity labs and industry-standard tools.",
    "Build career-ready skills for high-demand roles in cybersecurity, digital forensics and threat intelligence.",
    "Prepare for industry certifications and advanced studies in cybersecurity and digital forensics."
  ],

  entryRequirements: [
    "KCSE Mean Grade C+ (Plus) or equivalent with a minimum of Grade C in Mathematics and English/Kiswahili.",
    "OR a KNEC Diploma or equivalent qualification.",
    "OR any qualification recognized and approved by the University Senate."
  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 90000,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [
    "Cybersecurity Analyst",
    "Digital Forensics Analyst",
    "Cyber Threat Intelligence Analyst",
    "Security Operations Centre (SOC) Analyst",
    "Ethical Hacker/Penetration Testing Specialist",
    "Information Security Officer",
    "Network Security Engineer",
    "Cybercrime Investigator",
    "Incident Response Analyst",
    "Security Consultant"
  ],

  skills: [
    "Cybersecurity",
    "Digital Forensics",
    "Network Security",
    "Ethical Hacking",
    "Penetration Testing",
    "Threat Intelligence",
    "Incident Response",
    "Digital Evidence Management",
    "Information Security",
    "Vulnerability Assessment"
  ],

  curriculum: [
    {
      year: "Year One",
      semesters: [
        {
          semester: "Semester One",
          units: [
            "Introduction to Computer Science",
            "Programming Fundamentals",
            "Discrete Mathematics",
            "Computer Organisation and Architecture",
            "Communication Skills",
            "Calculus for Computing",
            "Introduction to Cybersecurity",
            "Digital Literacy"
          ]
        },
        {
          semester: "Semester Two",
          units: [
            "Data Structures and Algorithms",
            "Object-Oriented Programming",
            "Operating Systems",
            "Computer Networks",
            "Database Systems",
            "Introduction to Digital Forensics",
            "Web Technologies",
            "Research Methods in Computing"
          ]
        }
      ]
    },
    {
      year: "Year Two",
      semesters: [
        {
          semester: "Semester One",
          units: [
            "Network Security",
            "Ethical Hacking",
            "Cryptography",
            "Cyber Law and Ethics",
            "Digital Evidence Collection",
            "Malware Analysis",
            "Mobile Security",
            "System Administration"
          ]
        },
        {
          semester: "Semester Two",
          units: [
            "Penetration Testing",
            "Incident Response",
            "Forensic Investigation Techniques",
            "Wireless Security",
            "Cloud Security",
            "Cyber Threat Intelligence",
            "Advanced Network Security",
            "Industrial Attachment Preparation"
          ]
        }
      ]
    },
    {
      year: "Year Three",
      semesters: [
        {
          semester: "Semester One",
          units: [
            "Advanced Digital Forensics",
            "Cybercrime Investigation",
            "Security Operations Centre Management",
            "Enterprise Security Architecture",
            "Industrial Attachment/Internship",
            "Cybersecurity Project Management",
            "Machine Learning for Security",
            "IoT Security"
          ]
        },
        {
          semester: "Semester Two",
          units: [
            "Blockchain Security",
            "Application Security",
            "Data Privacy and Protection",
            "Risk Management and Compliance",
            "Cybersecurity Research Methods",
            "Advanced Forensic Tools",
            "Security Policy Development",
            "Capstone Project"
          ]
        }
      ]
    },
    {
      year: "Year Four",
      semesters: [
        {
          semester: "Semester One",
          units: [
            "Advanced Penetration Testing",
            "Digital Forensics Case Studies",
            "Emerging Threats and Technologies",
            "Industrial Attachment/Internship",
            "Cybersecurity Leadership",
            "Advanced Research Project",
            "Professional Practice",
            "Entrepreneurship in Cybersecurity"
          ]
        },
        {
          semester: "Semester Two",
          units: [
            "Final Year Project",
            "Industry-Based Project",
            "Advanced Topics in Cybersecurity",
            "Digital Forensics Investigation",
            "Security Audit and Assessment",
            "Cyber Resilience Planning",
            "Professional Ethics",
            "Career Development"
          ]
        }
      ]
    }
  ],

  faqs: [
    {
      question: "How long does the programme take?",
      answer: "The programme takes four years, equivalent to eight semesters."
    },
    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },
    {
      question: "When are the intakes?",
      answer: "Students are admitted in January, May and September."
    },
    {
      question: "What career opportunities are available?",
      answer: "Graduates can work as Cybersecurity Analysts, Digital Forensics Analysts, Cyber Threat Intelligence Analysts, SOC Analysts, Ethical Hackers, Information Security Officers, Network Security Engineers, Cybercrime Investigators, Incident Response Analysts and Security Consultants."
    },
    {
      question: "What are the entry requirements?",
      answer: "KCSE Mean Grade C+ with minimum C in Mathematics and English/Kiswahili, OR a KNEC Diploma or equivalent qualification, OR any qualification approved by the University Senate."
    }
  ],

  seo: {
    metaTitle: "Bachelor of Science in Cybersecurity and Digital Forensics | Zetech University",
    metaDescription: "Study the Bachelor of Science in Cybersecurity and Digital Forensics at Zetech University and develop expertise in cybersecurity, digital forensics, ethical hacking, network security and incident response."
  }

},
{
  id: 13,

  slug: "bachelor-of-science-in-hospitality-and-tourism-management",

  title: "Bachelor of Science in Hospitality and Tourism Management",

  shortTitle: "BSc Hospitality & Tourism Management",

  code: "BScHTM",

  school: "School of Education, Arts and Social Sciences",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-science-in-hospitality-and-tourism-management.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-science-in-hospitality-and-tourism-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Welcome the World. Lead Destinations",

  heroDescription:
    "The Bachelor of Science in Hospitality and Tourism Management equips students with managerial, operational and entrepreneurial skills required to excel in the global hospitality and tourism industry.",

  overview: `
The Bachelor of Science in Hospitality and Tourism Management is designed to prepare professionals with the managerial, operational and entrepreneurial skills required to excel in the global hospitality and tourism industry.

The programme integrates hospitality management, tourism operations, hotel administration, event management, travel services and sustainable tourism with practical industry exposure and experiential learning.

Through practical training, industrial attachment and professional engagement, graduates develop the competencies needed to deliver exceptional customer experiences, manage hospitality enterprises and contribute to sustainable tourism development.
`,

  whyStudy: [

    "Develop comprehensive knowledge of hospitality management, tourism operations and customer service excellence.",

    "Gain practical skills through hands-on learning, industry projects and professional hospitality training.",

    "Learn hotel operations, food and beverage management, travel services, destination management and event planning.",

    "Build leadership, communication, entrepreneurial and problem-solving skills required in the hospitality industry.",

    "Benefit from industrial attachment and experiential learning that prepare you for the global workplace.",

    "Graduate ready for careers in hotels, tourism, travel, event management, resorts, airlines and hospitality entrepreneurship."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C+ (Plus).",

    "Minimum grade of C in any three of the following: Biology, English, Kiswahili, Foreign Language or Home Science.",

    "OR an accredited Diploma with a Credit Pass from an institution recognized by the University Senate.",

    "OR KACE certificate with at least two Principal Passes and one Subsidiary Pass, plus a Credit Pass in Mathematics at KCE."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BCU113", title: "Health and Wellness" },

            { code: "BFR101", title: "French Language I" },

            { code: "BTM111", title: "Introduction to Hospitality and Tourism Management" },

            { code: "BHM112", title: "Food Production Theory" },

            { code: "BHM113", title: "Food Service Theory" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BFR102", title: "French Language II" },

            { code: "BTM121", title: "Tour Guiding Techniques" },

            { code: "BHM122", title: "Food and Beverage Production Practice I" },

            { code: "BHM123", title: "Food and Beverage Service Practice I" },

            { code: "BHM124", title: "Service Quality Management" },

            { code: "BHM125", title: "Front Office Operations" },

            { code: "BHM126", title: "Food Safety and Hygiene" }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BAC111", title: "Introduction to Accounting I" },

            { code: "BFR201", title: "Intermediate French I" },

            { code: "BHM211", title: "Housekeeping and Laundry Operations" },

            { code: "BHM212", title: "Food and Beverage Production Practice II" },

            { code: "BHM213", title: "Food and Beverage Service Practice II" },

            { code: "BTM214", title: "Tourism Geography" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BBM121", title: "Principles of Management" },

            { code: "BFR202", title: "Intermediate French II" },

            { code: "BTM221", title: "Cultural and Heritage Tourism" },

            { code: "BHM222", title: "Food and Beverage Production Practice III" },

            { code: "BHM223", title: "Food and Beverage Service Practice III" },

            { code: "BHM224", title: "Bar Operations Management" }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BFR301", title: "Advanced French Language" },

            { code: "BTM311", title: "Centralized Reservation Systems" },

            { code: "BHM312", title: "Food and Beverage Production Management" },

            { code: "BTM313", title: "Domestic and International Tourism" },

            { code: "BTM314", title: "Travel Business Operations" },

            { code: "BTM315", title: "Meetings, Incentives, Conferences and Exhibitions" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BHR121", title: "Human Resource Management" },

            { code: "MAT214", title: "Probability and Statistics I" },

            { code: "BCU320", title: "Research Methods" },

            { code: "BHM321", title: "Food and Beverage Cost Control" },

            { code: "BTM322", title: "Wildlife Based Tourism Management" },

            { code: "BHM323", title: "Food and Beverage Service Management" }

          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU410", title: "Entrepreneurship and Innovation" },

            { code: "BTM411", title: "Coastal and Marine Tourism" },

            { code: "BTM412", title: "Marketing in Hospitality and Tourism" },

            { code: "BTM413", title: "Sustainable Tourism" },

            { code: "BTM414", title: "Legal Aspects in Hospitality and Tourism" },

            { code: "BTM415", title: "Destination Management" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BHR311", title: "Organizational Behavior" },

            { code: "BBM325", title: "Strategic Management" },

            { code: "BCU401", title: "Industrial Attachment" },

            { code: "BCU406", title: "Research Project" },

            { code: "BTM421", title: "Tourism Policy Planning and Development" },

            { code: "BHM422", title: "Property Management" }

          ]
        }

      ]
    }

  ],

  careers: [

    "Hotel Manager",

    "Accommodation Manager",

    "Restaurant Manager",

    "Event Manager",

    "Tourism Officer",

    "Travel Consultant",

    "Customer Service Manager",

    "Catering Manager",

    "Resort Manager",

    "Spa Manager",

    "Destination Manager",

    "Hospitality Entrepreneur"

  ],

  skills: [

    "Hospitality Management",

    "Tourism Management",

    "Food and Beverage Management",

    "Hotel Operations",

    "Event Management",

    "Customer Service",

    "Destination Management",

    "Travel Operations",

    "Leadership",

    "Entrepreneurship",

    "Communication",

    "Sustainable Tourism"

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters) to complete."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted in January, May and September."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer: "Yes. Students undertake an Industrial Attachment during the final year to gain practical industry experience."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Hospitality and Tourism Management | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Hospitality and Tourism Management at Zetech University and build expertise in hospitality, tourism, hotel management, travel services, destination management and sustainable tourism."

  }

},
{
  id: 14,

  slug: "bachelor-of-arts-in-international-relations-and-diplomacy",

  title: "Bachelor of Arts in International Relations and Diplomacy",

  shortTitle: "BA International Relations & Diplomacy",

  code: "BIRD",

  school: "School of Education, Arts and Social Sciences",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Arts",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-arts-in-international-relations-and-diplomacy.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-arts-in-international-relations-and-diplomacy-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Think Globally. Lead Diplomatically",

  heroDescription:
    "The Bachelor of Arts in International Relations and Diplomacy equips students with the knowledge, analytical skills and diplomatic competencies needed to navigate global affairs, international politics and foreign policy.",

  overview: `
The Bachelor of Arts in International Relations and Diplomacy provides students with a comprehensive understanding of global affairs, international politics and diplomatic practice.

The programme integrates international relations theory with foreign policy, international law, diplomacy, peace and conflict resolution, global governance and regional integration to prepare graduates for an increasingly interconnected world.

Through an interdisciplinary and practical approach, students develop analytical, negotiation, communication and leadership skills required to address international challenges and contribute to diplomacy, policy development and global cooperation.
`,

  whyStudy: [

    "Gain a comprehensive understanding of global politics, diplomacy, international law and foreign policy to address today's international challenges.",

    "Develop practical skills in negotiation, conflict resolution, strategic communication and cross-cultural engagement through competency-based learning.",

    "Learn from experienced faculty while exploring contemporary global issues, regional integration, peacebuilding, international security and global governance.",

    "Build strong research, analytical and critical thinking skills for evaluating international developments and formulating effective policy solutions.",

    "Benefit from diplomacy simulations, research projects, French language training and experiential learning that prepare you for international careers.",

    "Graduate with the leadership, ethical and professional competencies required for careers in diplomacy, government, NGOs, multinational organizations and international institutions."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C+ (Plus).",

    "Minimum grade of D (Plain) in English or Kiswahili, Geography, History, Social Studies, CRE or Business Studies.",

    "OR an accredited Diploma with a Credit Pass from an institution recognized by the University Senate.",

    "OR KACE certificate with at least two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills I" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BCU121", title: "Health and Wellness" },

            { code: "BIRD111", title: "Introduction to International Relations" },

            { code: "BIRD112", title: "Basic Concepts in Government" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BIRD121", title: "Introduction to Diplomacy" },

            { code: "BIRD122", title: "Theories of International Relations" },

            { code: "BIRD123", title: "Introduction to Peace and Conflict" },

            { code: "BIRD124", title: "International Organizations" },

            { code: "BIRD125", title: "Introduction to Strategic Studies" }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BIRD211", title: "Multi-cultural Communication" },

            { code: "BIRD212", title: "Foreign Relations" },

            { code: "BIRD213", title: "Globalisation and International Relations" },

            { code: "BIRD214", title: "Major Themes in Africa International Relations" },

            { code: "BIRD215", title: "Post-colonial Conflicts in Africa" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BIRD221", title: "Introduction to International Law" },

            { code: "BIRD222", title: "Geo-political Structure of the World" },

            { code: "BIRD223", title: "Africa and Contemporary World Order" },

            { code: "BIRD224", title: "International Relations in the 21st Century" },

            { code: "BIRD225", title: "International Civil Rights" },

            { code: "BIRD226", title: "Arbitration and Negotiations" }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU320", title: "Research Methods in International Relations and Diplomacy" },

            { code: "BIRD312", title: "Kenyan Foreign Policy" },

            { code: "BIRD313", title: "International Economic Relations" },

            { code: "BIRD314", title: "Gender and International Relations" },

            { code: "BFR101", title: "Beginners' French I" },

            { code: "BIRD315", title: "Global Diplomacy Seminar" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BIRD321", title: "Refugee Studies" },

            { code: "BIRD322", title: "Methods and Practice of Diplomacy" },

            { code: "BFR102", title: "Intermediate French II" },

            { code: "BIRD323", title: "Post-modernism in International Relations" }

          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BCU400", title: "Entrepreneurship" },

            { code: "BFR201", title: "Intermediate French I" },

            { code: "BIRD413", title: "Foreign Policy of the Major Powers – G8" },

            { code: "BIRD416", title: "Simulation" },

            { code: "BIRD417", title: "Terrorism and Militia Politics" },

            { code: "BIRD414", title: "Ethical Issues in International Relations" },

            { code: "BIRD415", title: "Conflict Management" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BIRD421", title: "Trends in Diplomatic Relations" },

            { code: "BIRD422", title: "Public International Law" },

            { code: "BCU406", title: "Research Project" },

            { code: "BIRD423", title: "Strategic and National Security Studies" },

            { code: "BIRD424", title: "Regional Integration in Africa" },

            { code: "BIRD425", title: "The Politics of Multi-National Corporations" }

          ]
        }

      ]
    }

  ],

  careers: [

    "Diplomat",

    "Ambassador",

    "Foreign Affairs Officer",

    "Political Analyst",

    "Public Affairs Consultant",

    "International Relations Officer",

    "Policy Analyst",

    "NGO Programme Officer",

    "Public Relations Specialist",

    "Government Social Research Officer",

    "Lobbyist",

    "International Development Consultant"

  ],

  skills: [

    "Diplomatic Practice",

    "International Relations",

    "Foreign Policy Analysis",

    "Negotiation",

    "Conflict Resolution",

    "International Law",

    "Strategic Communication",

    "Policy Analysis",

    "Cross-cultural Communication",

    "Research",

    "Leadership",

    "French Language"

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters) to complete."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted during the January, May and September intakes."
    },

    {
      question: "Does the programme include practical learning?",
      answer: "Yes. Students participate in diplomacy simulations, research projects, French language training and experiential learning to prepare them for professional practice."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Arts in International Relations and Diplomacy | Zetech University",

    metaDescription:
      "Study Bachelor of Arts in International Relations and Diplomacy at Zetech University and build expertise in diplomacy, foreign policy, international law, peace and conflict resolution, global governance and international affairs."

  }

},
{
  id: 15,

  slug: "bachelor-of-education-arts",

  title: "Bachelor of Education Arts",

  shortTitle: "Bachelor of Education Arts",

  code: "BEd Arts",

  school: "School of Education, Arts and Social Sciences",

  qualification: "UNDERGRADUATE",

  qualificationTitle: "Bachelor of Education Arts",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-education-arts.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-education-arts-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Empowering Educators. Shaping Futures.",

  heroDescription:
    "Prepare to become a professionally qualified educator with the knowledge, pedagogical skills and practical experience required to teach humanities, social sciences, mathematics and business-related subjects in modern learning environments.",

  overview: `
The Bachelor of Education Arts is designed to prepare professionally qualified teachers with the knowledge, pedagogical skills and practical experience required to teach humanities and social science subjects.

The programme integrates subject specialisation with educational foundations, curriculum studies, educational psychology, teaching methodologies, educational technology and supervised teaching practice.

Students develop the ability to design and deliver effective learning experiences, assess learners, use educational technologies and respond to the changing needs of modern education.

Through a combination of academic study, research, practical learning and teaching practicum, graduates are prepared to contribute effectively to schools, educational institutions, training organizations and the wider education sector.
`,

  whyStudy: [

    "Learn from experienced educators who combine academic excellence with practical classroom experience.",

    "Develop the knowledge, pedagogical skills and confidence required to teach humanities, social sciences, mathematics and business-related subjects.",

    "Gain hands-on teaching experience through supervised school practicum and classroom-based learning.",

    "Build expertise in educational technology, curriculum development, learner assessment and classroom management.",

    "Strengthen research, communication, leadership, guidance and counseling skills for modern education environments.",

    "Graduate prepared for careers in teaching, educational leadership, curriculum development, research and postgraduate studies."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C+ (plus).",

    "A minimum grade of C+ in the subjects of specialisation.",

    "Holder of an accredited Diploma with a Credit Pass from an institution recognized by the University Senate.",

    "Holder of a KACE certificate with a minimum of two Principal Passes and a minimum of a Pass in Mathematics at KCSE.",

    "Holder of a P1 certificate from a two-year post-secondary training institution, with a minimum KCSE mean grade of C or O-Level Division III. A TSC number is mandatory."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 54650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Secondary School Teacher",

    "Special Educational Needs Teacher",

    "Teaching Assistant",

    "Career Advisor",

    "Motivational Speaker",

    "Counsellor",

    "Museum Education Officer",

    "Lecturer"

  ],

  skills: [

    "Teaching and Pedagogy",

    "Curriculum Development",

    "Classroom Management",

    "Educational Psychology",

    "Learner Assessment",

    "Educational Technology",

    "Competency-Based Learning",

    "Research and Academic Writing",

    "Communication",

    "Guidance and Counseling",

    "Educational Leadership",

    "Subject Specialisation",

    "Teaching Practicum"

  ],

  specialisations: [

    "Mathematics / Business",

    "Mathematics / Geography",

    "English / Literature",

    "Kiswahili / Geography",

    "CRE / Geography",

    "CRE / History",

    "History / Kiswahili",

    "Business / Geography",

    "History / Geography",

    "Kiswahili / CRE"

  ],

  ctaTitle:
    "Ready to Shape the Future of Education?",

  ctaText:
    "Join Zetech University and develop the knowledge, teaching expertise and practical experience required to inspire learners, transform classrooms and contribute to the future of education.",

  curriculum: [

    /*
    ============================================================
    SPECIALISATION 1
    MATHEMATICS / BUSINESS
    ============================================================
    */

    {
      specialisation: "Mathematics / Business",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "MAT 111", title: "Basic Mathematics" },
                { code: "MAT 121", title: "Discrete Mathematics" },
                { code: "BAC 111", title: "Financial Accounting I" },
                { code: "BBM 111", title: "Introduction to Business Studies" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "MAT 123", title: "Geometry" },
                { code: "MAT 120", title: "Calculus I" },
                { code: "BEC 111", title: "Introduction to Micro-economics" },
                { code: "BAC 121", title: "Financial Accounting II" }
              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "MAT 213", title: "Calculus II" },
                { code: "STA 123", title: "Probability and Statistics I" },
                { code: "BEC 121", title: "Macro Economics" },
                { code: "BAC 212", title: "Cost Accounting" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "MAT 225", title: "Calculus III" },
                { code: "STA 212", title: "Probability and Statistics II" },
                { code: "BBM 121", title: "Principles of Management" },
                { code: "BAC 221", title: "Management Accounting" }
              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "MAT 210", title: "Linear Algebra" },
                { code: "MAT 211", title: "Introduction to Real Analysis" },
                { code: "BFN 121", title: "Introduction to Financial Management" },
                { code: "BFN 211", title: "Business Law" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "MAT 319", title: "Teaching Methods in Mathematics" },
                { code: "MAT 321", title: "Complex Analysis" },
                { code: "MAT 223", title: "Ordinary Differential Equation" },
                { code: "BAC 321", title: "Principles of Taxation" },
                { code: "BAC 316", title: "Principles of Auditing" },
                { code: "EBS 319", title: "Teaching Methods in Business" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "MAT 413", title: "Partial Differential Equations" },
                { code: "MAT 311", title: "Operation Research" },
                { code: "BFN 410", title: "Company Law" },
                { code: "BHR 220", title: "Human Resource Management" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "BCU 412", title: "Entrepreneurship and Innovation" },
                { code: "MAT 411", title: "Vector Analysis" },
                { code: "STA 324", title: "Hypothesis Testing" },
                { code: "BMK 221", title: "Principles of Marketing" },
                { code: "BHR 311", title: "Organisational Behavior" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 2
    MATHEMATICS / GEOGRAPHY
    ============================================================
    */

    {
      specialisation: "Mathematics / Geography",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "MAT 111", title: "Basic Mathematics" },
                { code: "MAT 121", title: "Discrete Mathematics" },
                { code: "GEO 111", title: "Introduction to Geography" },
                { code: "GEO 112", title: "Physical Geography I" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "MAT 123", title: "Geometry" },
                { code: "MAT 120", title: "Calculus I" },
                { code: "GEO 121", title: "Human Geography and Spatial Organization" },
                { code: "GEO 122", title: "Geography of East Africa" }
              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "MAT 213", title: "Calculus II" },
                { code: "STA 123", title: "Probability and Statistics I" },
                { code: "GEO 211", title: "Geography of Africa" },
                { code: "GEO 212", title: "Physical Geography II" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "MAT 225", title: "Calculus III" },
                { code: "STA 212", title: "Probability and Statistics II" },
                { code: "GEO 221", title: "Arid and Semi-Arid Lands" },
                { code: "GEO 222", title: "Cartography and Map Analysis" }
              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "MAT 210", title: "Linear Algebra" },
                { code: "MAT 211", title: "Introduction to Real Analysis" },
                { code: "GEO 311", title: "Climatology" },
                { code: "GEO 312", title: "Agricultural Geography" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "MAT 319", title: "Teaching Methods in Mathematics" },
                { code: "GEO 319", title: "Teaching Methods in Geography" },
                { code: "MAT 321", title: "Complex Analysis" },
                { code: "MAT 223", title: "Ordinary Differential Equation" },
                { code: "GEO 321", title: "Remote Sensing and GIS and Resource Management" },
                { code: "GEO 322", title: "Geomorphology" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "MAT 413", title: "Partial Differential Equations" },
                { code: "MAT 311", title: "Operation Research" },
                { code: "GEO 411", title: "Environmental Conservation" },
                { code: "GEO 412", title: "Population Geography" }
              ]
            },

            {
              semester: "Semester Two",

              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "BCU 412", title: "Entrepreneurship and Innovation" },
                { code: "MAT 411", title: "Vector Analysis" },
                { code: "STA 324", title: "Hypothesis Testing" },
                { code: "GEO 421", title: "Economic Geography" },
                { code: "GEO 422", title: "Biogeography" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 3
    ENGLISH / LITERATURE
    ============================================================
    */

    {
      specialisation: "English / Literature",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "ENG 111", title: "Fundamentals of Study of Language" },
                { code: "ENG 112", title: "Fundamentals of Phonetics and Phonology" },
                { code: "LIT 113", title: "Fundamentals of Literature and Literary Appreciation" },
                { code: "LIT 114", title: "Oral Literature and Digital Literacy" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "ENG 121", title: "Sociolinguistics" },
                { code: "ENG 123", title: "English for Academic Purpose" },
                { code: "LIT 123", title: "Studies in Poetry" },
                { code: "LIT 124", title: "Studies in Prose Fiction" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "ENG 211", title: "Phonology of English" },
                { code: "ENG 212", title: "Description of Modern English" },
                { code: "LIT 212", title: "Theory of Literature" },
                { code: "LIT 222", title: "Studies in Drama" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "ENG 221", title: "Second Language Acquisition" },
                { code: "ENG 222", title: "English Grammar and Usage" },
                { code: "LIT 221", title: "Eastern Africa Literature" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "ENG 315", title: "Phonetics and Phonological Analysis" },
                { code: "ENG 316", title: "Historical and Comparative Linguistic" },
                { code: "LIT 313", title: "West African Literatures" },
                { code: "LIT 211", title: "Editing and Fiction Publishing" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "ENG 319", title: "Teaching Methods in English" },
                { code: "LIT 319", title: "Teaching Methods in Literature" },
                { code: "ENG 312", title: "Syntax" },
                { code: "ENG 313", title: "Morphological Analysis" },
                { code: "LIT 321", title: "South Africa Literature" },
                { code: "LIT 322", title: "Modern Arabic Literatures" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "ENG 411", title: "Semantics and Pragmatics" },
                { code: "ENG 412", title: "Advanced Theoretical Studies in Grammar" },
                { code: "LIT 411", title: "Caribbean and Latin American Literatures" },
                { code: "LIT 412", title: "Major European Novels" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "BCU 412", title: "Entrepreneurship and Innovation" },
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "ENG 421", title: "Discourse Analysis" },
                { code: "ENG 423", title: "Varieties of English" },
                { code: "LIT 421", title: "African American Literature" },
                { code: "LIT 423", title: "Special Topics African Life Writing and Autobiography" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 4
    KISWAHILI / GEOGRAPHY
    ============================================================
    */

    {
      specialisation: "Kiswahili / Geography",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "GEO 111", title: "Introduction to Geography" },
                { code: "GEO 112", title: "Physical Geography I" },
                { code: "KIS 111", title: "Fundamentals of the Study of Kiswahili Language" },
                { code: "KIS 112", title: "Historical and Modern Development of Kiswahili" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "GEO 121", title: "Human Geography and Spatial Organization" },
                { code: "GEO 122", title: "Geography of East Africa" },
                { code: "KIS 123", title: "Fundamentals of Kiswahili Literature" },
                { code: "KIS 122", title: "Kiswahili Phonetics and Phonology" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "GEO 211", title: "Geography of Africa" },
                { code: "GEO 212", title: "Physical Geography II" },
                { code: "KIS 211", title: "Theories and Practice of Translation" },
                { code: "KIS 212", title: "Kiswahili Morphology and Syntax" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "GEO 221", title: "Arid and Semi-Arid Lands" },
                { code: "GEO 222", title: "Cartography and Map Analysis" },
                { code: "KIS 221", title: "Socio-Linguistics" },
                { code: "KIS 222", title: "Theories of Literary Criticisms in Kiswahili" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "GEO 311", title: "Climatology" },
                { code: "GEO 312", title: "Agricultural Geography" },
                { code: "KIS 311", title: "Oral Literature and Field Work" },
                { code: "KIS 312", title: "Modern Kiswahili Novel, Short Story and Play" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "GEO 319", title: "Teaching Methods in Geography" },
                { code: "GEO 321", title: "Remote Sensing and GIS and Resource Management" },
                { code: "GEO 322", title: "Geomorphology" },
                { code: "KIS 321", title: "Semantics and Pragmatics" },
                { code: "KIS 322", title: "Creative Writing" },
                { code: "KIS 319", title: "Kiswahili Teaching Methods" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "GEO 411", title: "Environmental Conservation" },
                { code: "GEO 412", title: "Population Geography" },
                { code: "KIS 411", title: "Second Language Learning" },
                { code: "KIS 412", title: "Translated Literary Texts" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "GEO 421", title: "Economic Geography" },
                { code: "GEO 422", title: "Biogeography" },
                { code: "KIS 421", title: "Research Methods in Kiswahili" },
                { code: "KIS 422", title: "Pre 20th Century Kiswahili Literature" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 5
    CRE / GEOGRAPHY
    ============================================================
    */

    {
      specialisation: "CRE / Geography",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "GEO 111", title: "Introduction to Geography" },
                { code: "GEO 112", title: "Physical Geography I" },
                { code: "ERE 111", title: "Introduction to Creative and Critical Thinking" },
                { code: "ERE 112", title: "Introduction to African Culture and Religion" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "GEO 121", title: "Human Geography and Spatial Organization" },
                { code: "GEO 122", title: "Geography of East Africa" },
                { code: "ERE 121", title: "Fundamentals of Church History" },
                { code: "ERE 122", title: "Fundamentals of the Bible" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "GEO 211", title: "Geography of Africa" },
                { code: "GEO 212", title: "Physical Geography II" },
                { code: "ERE 211", title: "Christian Response to Contemporary Issues" },
                { code: "ERE 212", title: "Contemporary Trends in Christian Theology" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "GEO 221", title: "Arid and Semi-arid Lands" },
                { code: "GEO 222", title: "Cartography and Map Analysis" },
                { code: "ERE 221", title: "Comparative Religion" },
                { code: "ERE 222", title: "Philosophy of Religion" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "GEO 311", title: "Climatology" },
                { code: "GEO 312", title: "Agricultural Geography" },
                { code: "ERE 311", title: "Initiation, Rites and Christian Sacraments" },
                { code: "ERE 312", title: "General Methodology for Social Sciences and Project Writing in CRE" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "GEO 319", title: "Teaching Methods in Geography" },
                { code: "GEO 321", title: "Remote Sensing and GIS and Resource Management" },
                { code: "GEO 322", title: "Geomorphology" },
                { code: "ERE 321", title: "Fundamentals of Metaphysics" },
                { code: "ERE 322", title: "Sociology of Religion" },
                { code: "ERE 319", title: "Teaching Methods Subject in C.R.E" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "GEO 411", title: "Environmental Conservation" },
                { code: "GEO 412", title: "Population Geography" },
                { code: "ERE 411", title: "Theology of Old Testament" },
                { code: "ERE 412", title: "Ecumenism" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "GEO 421", title: "Economic Geography" },
                { code: "GEO 422", title: "Biogeography" },
                { code: "ERE 421", title: "Theology of the New Testament" },
                { code: "ERE 422", title: "Religion and Development in Africa" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 6
    CRE / HISTORY
    ============================================================
    */

    {
      specialisation: "CRE / History",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "ERE 111", title: "Introduction to Creative and Critical Thinking" },
                { code: "ERE 112", title: "Introduction to African Culture and Religion" },
                { code: "HST 111", title: "Sources of African History" },
                { code: "HST 112", title: "Selected Topics in World History to 1500 AD" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "ERE 121", title: "Fundamentals of Church History" },
                { code: "ERE 122", title: "Fundamentals of the Bible" },
                { code: "HST 121", title: "History of Kenya Prior To 1884" },
                { code: "HST 122", title: "Introduction to African History Prior To 1884" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "ERE 211", title: "Christian Response to Contemporary Issues" },
                { code: "ERE 212", title: "Contemporary Trends in Christian Theology" },
                { code: "HST 211", title: "Politics and Law in Kenya Since 1895" },
                { code: "HST 212", title: "African History Since 1885" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "ERE 221", title: "Comparative Religion" },
                { code: "ERE 222", title: "Philosophy of Religion" },
                { code: "HST 221", title: "Selected Topics in World History Since 1500 AD" },
                { code: "HST 222", title: "Themes in the History of West Africa" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "ERE 311", title: "Initiation, Rites and Christian Sacraments" },
                { code: "ERE 312", title: "General Methodology for Social Sciences and Project Writing in CRE" },
                { code: "HST 311", title: "Methods of Historical Research" },
                { code: "HST 312", title: "History of Governments and Constitutions" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "ERE 321", title: "Fundamentals of Metaphysics" },
                { code: "ERE 322", title: "Sociology of Religion" },
                { code: "ERE 319", title: "C.R.E Teaching Methods" },
                { code: "HST 321", title: "Themes in the History of African Diaspora" },
                { code: "HST 322", title: "Issues in the History of East Africa" },
                { code: "HST 319", title: "History Teaching Methods" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "ERE 411", title: "Theology of Old Testament" },
                { code: "ERE 412", title: "Ecumenism" },
                { code: "HST 411", title: "Gender Relations in African History" },
                { code: "HST 412", title: "History of Economic Thoughts" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "ERE 421", title: "Theology of the New Testament" },
                { code: "ERE 422", title: "Religion and Development in Africa" },
                { code: "HST 421", title: "Comparative Studies in Imperialism and Nationalism in Africa and Other Third World Nations" },
                { code: "HST 422", title: "Philosophy of History" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 7
    KISWAHILI / HISTORY
    ============================================================
    */

    {
      specialisation: "Kiswahili / History",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "KIS 111", title: "Fundamentals of the Study of Kiswahili Language" },
                { code: "KIS 112", title: "Historical and Modern Development of Kiswahili" },
                { code: "HST 111", title: "Sources of African History" },
                { code: "HST 112", title: "Selected Topics in World History To 1500 AD" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "KIS 123", title: "Fundamentals of Kiswahili Literature" },
                { code: "KIS 122", title: "Kiswahili Phonetics and Phonology" },
                { code: "HST 121", title: "History of Kenya Prior To 1884" },
                { code: "HST 122", title: "Introduction to African History Prior To 1884" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "KIS 211", title: "Theories and Practice of Translation" },
                { code: "KIS 212", title: "Kiswahili Morphology and Syntax" },
                { code: "HST 211", title: "Politics and Law in Kenya Since 1895" },
                { code: "HST 212", title: "African History Since 1885" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "KIS 221", title: "Socio-Linguistics" },
                { code: "KIS 222", title: "Theories of Literary Criticisms in Kiswahili" },
                { code: "HST 221", title: "Selected Topics in World History Since 1500 AD" },
                { code: "HST 222", title: "Themes in the History of West Africa" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "KIS 311", title: "Oral Literature and Field Work" },
                { code: "KIS 312", title: "Modern Kiswahili Novel, Short Story and Play" },
                { code: "HST 311", title: "Methods of Historical Research" },
                { code: "HST 312", title: "History of Governments and Constitutions" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "KIS 321", title: "Semantics and Pragmatics" },
                { code: "KIS 322", title: "Creative Writing" },
                { code: "KIS 319", title: "Teaching Methods in Kiswahili" },
                { code: "HST 321", title: "Themes in the History of African Diaspora" },
                { code: "HST 322", title: "Issues in the History of East Africa" },
                { code: "HST 319", title: "History Teaching Methods" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "KIS 411", title: "Second Language Learning" },
                { code: "KIS 412", title: "Translated Literary Texts" },
                { code: "HST 411", title: "Gender Relations in African History" },
                { code: "HST 412", title: "History of Economic Thoughts" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "KIS 421", title: "Research Methods in Kiswahili" },
                { code: "KIS 422", title: "Pre 20th Century Kiswahili Literature" },
                { code: "HST 421", title: "Comparative Studies in Imperialism and Nationalism in Africa and Other Third World Nations" },
                { code: "HST 422", title: "Philosophy of History" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 8
    BUSINESS / GEOGRAPHY
    ============================================================
    */

    {
      specialisation: "Business / Geography",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "BMK 221", title: "Principles of Marketing" },
                { code: "BHR 311", title: "Organisational Behavior" },
                { code: "GEO 111", title: "Introduction to Geography" },
                { code: "GEO 112", title: "Physical Geography I" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "BEC 111", title: "Introduction to Micro-economics" },
                { code: "BAC 121", title: "Financial Accounting II" },
                { code: "GEO 121", title: "Human Geography and Spatial Organization" },
                { code: "GEO 122", title: "Geography of East Africa" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "BEC 121", title: "Macro Economics" },
                { code: "BAC 212", title: "Cost Accounting" },
                { code: "GEO 211", title: "Geography of Africa" },
                { code: "GEO 212", title: "Physical Geography II" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "BBM 121", title: "Principles of Management" },
                { code: "BAC 221", title: "Management Accounting" },
                { code: "GEO 221", title: "Arid and Semi-Arid Lands" },
                { code: "GEO 222", title: "Cartography and Map Analysis" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "BFN 211", title: "Business Law" },
                { code: "BFN 121", title: "Introduction to Financial Management" },
                { code: "GEO 311", title: "Climatology" },
                { code: "GEO 312", title: "Agricultural Geography" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "GEO 319", title: "Teaching Methods in Geography" },
                { code: "EBS 319", title: "Teaching Methods in Business" },
                { code: "BAC 321", title: "Principles of Taxation" },
                { code: "BAC 316", title: "Principles of Auditing" },
                { code: "GEO 321", title: "Remote Sensing and GIS and Resource Management" },
                { code: "GEO 322", title: "Geomorphology" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "BFN 410", title: "Company Law" },
                { code: "BHR 220", title: "Human Resource Management" },
                { code: "GEO 411", title: "Environmental Conservation" },
                { code: "GEO 412", title: "Population Geography" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "BCU 412", title: "Entrepreneurship and Innovation" },
                { code: "BMK 221", title: "Principles of Marketing" },
                { code: "BHR 311", title: "Organisational Behavior" },
                { code: "GEO 421", title: "Economic Geography" },
                { code: "GEO 422", title: "Biogeography" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 9
    HISTORY / GEOGRAPHY
    ============================================================
    */

    {
      specialisation: "History / Geography",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "GEO 111", title: "Introduction to Geography" },
                { code: "GEO 112", title: "Physical Geography I" },
                { code: "HST 111", title: "Sources of African History" },
                { code: "HST 112", title: "Selected Topics in World History to 1500 AD" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "GEO 121", title: "Human Geography and Spatial Organization" },
                { code: "GEO 122", title: "Geography of East Africa" },
                { code: "HST 121", title: "History of Kenya Prior to 1884" },
                { code: "HST 122", title: "Introduction to African History Prior to 1884" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "GEO 211", title: "Geography of Africa" },
                { code: "GEO 212", title: "Physical Geography II" },
                { code: "HST 211", title: "Politics and Law in Kenya Since 1895" },
                { code: "HST 212", title: "African History Since 1885" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "GEO 221", title: "Arid and Semi-Arid Lands" },
                { code: "GEO 222", title: "Cartography and Map Analysis" },
                { code: "HST 221", title: "Selected Topics in World History Since 1500 AD" },
                { code: "HST 222", title: "Themes in the History of West Africa" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "GEO 311", title: "Climatology" },
                { code: "GEO 312", title: "Agricultural Geography" },
                { code: "HST 311", title: "Methods of Historical Research" },
                { code: "HST 312", title: "History of Governments and Constitutions" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "GEO 319", title: "Teaching Methods in Geography" },
                { code: "GEO 321", title: "Remote Sensing and GIS and Resource Management" },
                { code: "GEO 322", title: "Geomorphology" },
                { code: "HST 321", title: "Themes in the History of African Diaspora" },
                { code: "HST 322", title: "Issues in the History of East Africa" },
                { code: "HST 319", title: "Teaching Methods in History" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "GEO 411", title: "Environmental Conservation" },
                { code: "GEO 412", title: "Population Geography" },
                { code: "HST 411", title: "Gender Relations in African History" },
                { code: "HST 412", title: "History of Economic Thoughts" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "GEO 421", title: "Economic Geography" },
                { code: "GEO 422", title: "Biogeography" },
                { code: "HST 421", title: "Comparative Studies in Imperialism and Nationalism in Africa and Other Third World Nations" },
                { code: "HST 422", title: "Philosophy of History" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    },


    /*
    ============================================================
    SPECIALISATION 10
    KISWAHILI / CRE
    ============================================================
    */

    {
      specialisation: "Kiswahili / CRE",

      years: [

        {
          year: "Year One",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "PSY 111", title: "General Psychology" },
                { code: "EDU 110", title: "Fundamentals of Special Needs Education" },
                { code: "EDU 111", title: "History of Education" },
                { code: "BCU 110", title: "Communication Skills" },
                { code: "KIS 111", title: "Fundamentals of the Study of Kiswahili Language" },
                { code: "KIS 112", title: "Historical and Modern Development of Kiswahili" },
                { code: "ERE 111", title: "Introduction to Creative and Critical Thinking" },
                { code: "ERE 112", title: "Introduction to African Culture and Religion" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 121", title: "Psychology of Teaching and Learning" },
                { code: "EDU 121", title: "Fundamentals of Environmental Education" },
                { code: "BCU 112", title: "Introduction to Computers and Internet" },
                { code: "KIS 123", title: "Fundamentals of Kiswahili Literature" },
                { code: "KIS 122", title: "Kiswahili Phonetics and Phonology" },
                { code: "ERE 121", title: "Fundamentals of Church History" },
                { code: "ERE 122", title: "Fundamentals of the Bible" }
              ]
            }

          ]
        },

        {
          year: "Year Two",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 211", title: "Curriculum Development" },
                { code: "PSY 211", title: "Human Growth and Development" },
                { code: "BCU 113", title: "Health and Wellness Management" },
                { code: "KIS 211", title: "Theories and Practice of Translation" },
                { code: "KIS 212", title: "Kiswahili Morphology and Syntax" },
                { code: "ERE 211", title: "Christian Response to Contemporary Issues" },
                { code: "ERE 212", title: "Contemporary Trends in Christian Theology" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 221", title: "Education Communication and Technology" },
                { code: "EDU 222", title: "Educational Administration and Management" },
                { code: "PSY 222", title: "Guidance and Counseling" },
                { code: "KIS 221", title: "Socio-Linguistics" },
                { code: "KIS 222", title: "Theories of Literary Criticisms in Kiswahili" },
                { code: "ERE 221", title: "Comparative Religion" },
                { code: "ERE 222", title: "Philosophy of Religion" }
              ]
            }

          ]
        },

        {
          year: "Year Three",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 311", title: "Instructional Methods" },
                { code: "ECT 320", title: "Micro-teaching and Media Practical" },
                { code: "BCU 320", title: "Research Methods" },
                { code: "KIS 311", title: "Oral Literature and Field Work" },
                { code: "KIS 312", title: "Modern Kiswahili Novel, Short Story and Play" },
                { code: "ERE 311", title: "Initiation, Rites and Christian Sacraments" },
                { code: "ERE 312", title: "General Methodology for Social Sciences and Project Writing in CRE" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "PSY 322", title: "Tests Measurement and Evaluation" },
                { code: "ECT 321", title: "E-Learning Technology in Education" },
                { code: "KIS 321", title: "Semantics and Pragmatics" },
                { code: "KIS 322", title: "Creative Writing" },
                { code: "KIS 319", title: "Teaching Methods in Kiswahili" },
                { code: "ERE 321", title: "Fundamentals of Metaphysics" },
                { code: "ERE 322", title: "Sociology of Religion" },
                { code: "ERE 319", title: "C.R.E Teaching Methods" },
                { code: "EDU 320", title: "Teaching Practicum I" }
              ]
            }

          ]
        },

        {
          year: "Year Four",
          semesters: [

            {
              semester: "Semester One",
              units: [
                { code: "EDU 411", title: "Comparative Education and Emerging Contemporary Issues" },
                { code: "EDU 412", title: "Sociology of Education" },
                { code: "ECT 322", title: "Competence Based Learning" },
                { code: "KIS 411", title: "Second Language Learning" },
                { code: "KIS 412", title: "Translated Literary Texts" },
                { code: "ERE 411", title: "Theology of Old Testament" },
                { code: "ERE 412", title: "Ecumenism" }
              ]
            },

            {
              semester: "Semester Two",
              units: [
                { code: "EDU 421", title: "Philosophy of Education" },
                { code: "EDU 422", title: "Planning and Economics of Education" },
                { code: "EDU 423", title: "Education and Development" },
                { code: "KIS 421", title: "Research Methods in Kiswahili" },
                { code: "KIS 422", title: "Pre 20th Century Kiswahili Literature" },
                { code: "ERE 421", title: "Theology of the New Testament" },
                { code: "ERE 422", title: "Religion and Development in Africa" },
                { code: "EDU 429", title: "Teaching Practicum II" }
              ]
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Education Arts programme take?",
      answer:
        "The Bachelor of Education Arts programme takes four years, comprising eight semesters."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What specialisations are available?",
      answer:
        "Students can choose from Mathematics/Business, Mathematics/Geography, English/Literature, Kiswahili/Geography, CRE/Geography, CRE/History, History/Kiswahili, Business/Geography, History/Geography and Kiswahili/CRE."
    },

    {
      question: "Does the programme include teaching practicum?",
      answer:
        "Yes. The programme includes supervised Teaching Practicum I and Teaching Practicum II, providing students with practical classroom experience."
    },

    {
      question: "What careers can I pursue after studying Bachelor of Education Arts?",
      answer:
        "Graduates can pursue careers as secondary school teachers, special educational needs teachers, teaching assistants, career advisors, counsellors, motivational speakers, museum education officers and lecturers."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Education Arts | Zetech University",

    metaDescription:
      "Study Bachelor of Education Arts at Zetech University and develop professional teaching, pedagogical, research and educational technology skills through flexible Physical and Online learning."

  }

},
{
  id: 16,

  slug: "bachelor-of-accounting-and-finance",

  title: "Bachelor of Accounting and Finance",

  shortTitle: "Bachelor of Accounting & Finance",

  code: "BAF",

  school: "School of Business and Economics",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Accounting and Finance",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-accounting-and-finance.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-accounting-and-finance-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Turning Financial Data into Strategic Value",

  heroDescription:
    "Develop comprehensive expertise in accounting, finance, taxation, auditing, investment analysis and financial management while building the analytical and quantitative skills required for effective financial decision-making in modern organizations.",

  overview: `
The Bachelor of Accounting and Finance examines the principles, systems and practices that underpin effective financial management in modern organizations.

The programme brings together accounting, finance, taxation, auditing, investment analysis, financial reporting and risk management to provide students with a comprehensive understanding of financial decision-making.

Students gain insight into how financial information supports business performance, regulatory compliance and long-term organisational sustainability while strengthening their analytical and quantitative capabilities.

The programme also provides practical exposure to financial reporting, computerized accounting systems, financial risk management, research, entrepreneurship and industrial attachment, preparing graduates for the technology-driven financial environment.
`,

  whyStudy: [

    "Develop expertise in accounting, finance, taxation, auditing and investment analysis through a comprehensive curriculum aligned with modern financial and business practices.",

    "Build strong analytical, quantitative and problem-solving skills to interpret financial data, evaluate business performance and support strategic decision-making.",

    "Gain practical experience with financial reporting, risk management and computerized accounting systems.",

    "Combine academic knowledge with real-world applications, research, entrepreneurship and industrial attachment.",

    "Prepare for diverse careers in accounting, auditing, banking, taxation, corporate finance, investment management and the public sector.",

    "Study in a flexible learning environment with both Physical and Online delivery supported by experienced faculty."
  ],

  entryRequirements: [

    "KCSE (or equivalent examination) certificate with a minimum aggregate grade of C+.",

    "A minimum grade of C (Plain) in Mathematics or Business Studies, and English/Kiswahili.",

    "Holder of an accredited Diploma with a Credit Pass from an institution recognized by the University Senate.",

    "Holder of a KACE certificate with a minimum of two Principal Passes and one Subsidiary Pass, and a minimum of Credit Pass in Mathematics at KCE."
  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60000,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Management Accountant",

    "Public Finance Accountant",

    "Company Secretary",

    "Forensic Accountant",

    "Stockbroker",

    "Revenue Officer",

    "Financial Analyst",

    "Budget Controller"
  ],

  skills: [

    "Financial Accounting",

    "Management Accounting",

    "Financial Management",

    "Auditing and Assurance",

    "Taxation",

    "Financial Reporting",

    "Financial Analysis",

    "Investment Analysis",

    "Financial Risk Management",

    "Financial Modeling",

    "Computerized Business Accounting",

    "Public Financial Management",

    "Portfolio Management",

    "Accounting Decision Models"
  ],

  ctaTitle:
    "Ready to Turn Financial Data into Strategic Value?",

  ctaText:
    "Join Zetech University and develop the accounting, finance, analytical and strategic skills required to support sound financial decisions and build a successful career in today's dynamic financial environment.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "BCU 111",
              title: "Communication Skills"
            },
            {
              code: "BCU 112",
              title: "Digital Literacy"
            },
            {
              code: "BEC 111",
              title: "Microeconomics"
            },
            {
              code: "BBM 111",
              title: "Foundations of Business"
            },
            {
              code: "BCU 113",
              title: "Health and Wellness Management"
            },
            {
              code: "MAT 111",
              title: "Basic Mathematics"
            },
            {
              code: "BAC 111",
              title: "Financial Accounting I"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "BEC 121",
              title: "Macroeconomics"
            },
            {
              code: "BFN 211",
              title: "Business Law"
            },
            {
              code: "BBM 121",
              title: "Principles of Management"
            },
            {
              code: "BAC 321",
              title: "Principles of Taxation"
            },
            {
              code: "BAC 121",
              title: "Financial Accounting II"
            },
            {
              code: "BFN 121",
              title: "Introduction to Financial Management"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "BAC 312",
              title: "Accounting for Assets"
            },
            {
              code: "BFN 212",
              title: "Financial Management"
            },
            {
              code: "MAT 214",
              title: "Business Statistics I"
            },
            {
              code: "BAC 212",
              title: "Cost Accounting"
            },
            {
              code: "BAC 316",
              title: "Principles of Auditing and Assurance"
            },
            {
              code: "BFN 213",
              title: "Islamic Banking and Finance"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "BEC 322",
              title: "Money and Banking"
            },
            {
              code: "BAC 221",
              title: "Management Accounting I"
            },
            {
              code: "BFN 221",
              title: "Financial Risk Management"
            },
            {
              code: "MAT 222",
              title: "Business Statistics II"
            },
            {
              code: "BAC 222",
              title: "Accounting for Equities and Liabilities"
            },
            {
              code: "BFN 322",
              title: "Financial Institutions and Markets"
            }
          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "BFN 314",
              title: "Microenterprise Finance"
            },
            {
              code: "BFN 311",
              title: "International Finance"
            },
            {
              code: "BFN 313",
              title: "Financial Modeling and Forecasting"
            },
            {
              code: "BAC 313",
              title: "Advanced Financial Accounting I"
            },
            {
              code: "BAC 315",
              title: "Public Sector Accounting"
            },
            {
              code: "BFN 315",
              title: "Development Finance"
            },
            {
              code: "BFN 321",
              title: "Financial Statement Analysis"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "BAC 322",
              title: "Advanced Auditing and Assurance"
            },
            {
              code: "BAC 123",
              title: "Computerized Business Accounting"
            },
            {
              code: "BAC 324",
              title: "Advanced Financial Accounting II"
            },
            {
              code: "BAC 323",
              title: "Management Accounting II"
            },
            {
              code: "BAC 412",
              title: "Advanced Taxation"
            },
            {
              code: "BCU 320",
              title: "Research Methods"
            }
          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "BCU 410",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "BAC 414",
              title: "Specialized Accounting"
            },
            {
              code: "BFN 423",
              title: "Public Financial Management"
            },
            {
              code: "BFN 414",
              title: "Real Estate Finance"
            },
            {
              code: "BFN 410",
              title: "Company Law"
            },
            {
              code: "BAC 411",
              title: "Financial Reporting"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "BFN 413",
              title: "Investment Analysis and Portfolio Management"
            },
            {
              code: "BFN 424",
              title: "Financial Asset Management"
            },
            {
              code: "BAC 311",
              title: "Management Decision Models"
            },
            {
              code: "BAC 425",
              title: "Trust and Executorships Accounting"
            },
            {
              code: "BCU 400",
              title: "Research Project"
            },
            {
              code: "BCU 401",
              title: "Industrial Attachment"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Accounting and Finance programme take?",

      answer:
        "The Bachelor of Accounting and Finance programme takes four years, comprising eight semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment during the final year to gain practical industry experience."
    },

    {
      question: "What areas does the Bachelor of Accounting and Finance cover?",

      answer:
        "The programme covers accounting, finance, taxation, auditing, investment analysis, financial reporting, financial risk management, financial modeling, public financial management and computerized business accounting."
    },

    {
      question: "What career opportunities are available after studying Accounting and Finance?",

      answer:
        "Graduates can pursue careers such as Management Accountant, Public Finance Accountant, Company Secretary, Forensic Accountant, Stockbroker, Revenue Officer, Financial Analyst and Budget Controller."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Accounting and Finance | Zetech University",

    metaDescription:
      "Study the Bachelor of Accounting and Finance at Zetech University and develop expertise in accounting, finance, taxation, auditing, investment analysis, financial reporting and financial risk management."

  }

},

// {
//     id:17,
//     title:"Bachelor of Economics and Statistics",
//     code:"BES",
//     school:"School of Business and Economics",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:54650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },
{
  id: 18,

  slug: "bachelor-of-business-administration-and-management",

  title: "Bachelor of Business Administration and Management",

  shortTitle: "Bachelor of Business Administration & Management",

  code: "BBAM",

  school: "School of Business and Economics",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Business Administration and Management",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-business-administration-and-management.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-business-administration-and-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Lead with Vision. Manage with Excellence",

  heroDescription:
    "The Bachelor of Business Administration and Management offers a broad exploration of the principles, practices and strategies that drive successful organizations, preparing students for leadership, decision-making and business management in a rapidly changing global environment.",

  overview: `
The Bachelor of Business Administration and Management offers a broad exploration of the principles, practices and strategies that drive successful organizations.

The programme brings together finance, marketing, human resource management, entrepreneurship, operations and strategic management while examining how businesses operate, compete and grow in a rapidly changing environment.

Students gain insight into organisational leadership, decision-making and business strategy while developing the analytical, managerial and problem-solving capabilities required to address contemporary business challenges.

The programme also provides opportunities for specialisation in Human Resource Management, Finance, Accounting or Marketing, allowing students to align their studies with their career aspirations and industry needs.
`,

  whyStudy: [

    "Build a strong foundation in business leadership, strategic management, finance, marketing, entrepreneurship and organisational development through an industry-aligned curriculum.",

    "Specialize in Human Resource Management, Finance, Accounting or Marketing to align your studies with your career aspirations and industry needs.",

    "Learn from experienced academics and industry professionals who combine practical business insights with contemporary management practices.",

    "Develop analytical, leadership and problem-solving skills using modern business technologies, research and data-driven decision-making approaches.",

    "Gain valuable hands-on experience through research projects, industrial attachment and real-world business case studies that enhance workplace readiness.",

    "Graduate with the knowledge, professional competence and entrepreneurial mindset needed to lead organizations, drive business growth or establish successful enterprises."
  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of C+.",

    "Holder of an accredited Diploma from an institution recognized by the University Senate.",

    "Holder of a KACE certificate with a minimum of two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60000,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  specialisations: [

    "Human Resource Management",

    "Finance",

    "Accounting",

    "Marketing"

  ],

  careers: [

    "Human Resource Manager",

    "Marketing Manager",

    "Accountant",

    "Financial Analyst",

    "Financial Manager",

    "Financial Controller"

  ],

  skills: [

    "Business Administration",

    "Business Management",

    "Strategic Management",

    "Leadership",

    "Financial Management",

    "Marketing",

    "Human Resource Management",

    "Accounting",

    "Entrepreneurship",

    "Business Analytics",

    "Decision Making",

    "Organisational Development"

  ],

  ctaTitle:
    "Ready to Lead with Vision and Manage with Excellence?",

  ctaText:
    "Join Zetech University and develop the business knowledge, leadership capabilities and practical experience required to lead organizations, drive growth and create value in today's dynamic global economy.",

  curriculum: [

    /*
      ==========================================================
      SPECIALISATION 1
      HUMAN RESOURCE MANAGEMENT
      ==========================================================
    */

    {
      specialisation: "Human Resource Management",

      years: [

        /*
          =======================
          YEAR ONE
          =======================
        */

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "BAC 111",
                  title: "Financial Accounting I"
                },

                {
                  code: "BBM 111",
                  title: "Foundations of Business"
                },

                {
                  code: "BCU 111",
                  title: "Communication Skills"
                },

                {
                  code: "BCU 112",
                  title: "Digital Literacy"
                },

                {
                  code: "MAT 111",
                  title: "Basic Mathematics"
                },

                {
                  code: "BEC 111",
                  title: "Microeconomics"
                },

                {
                  code: "BCU 113",
                  title: "Health and Wellness Management"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "BBM 121",
                  title: "Principles of Management"
                },

                {
                  code: "BFN 211",
                  title: "Business Law"
                },

                {
                  code: "BHR 121",
                  title: "Human Resource Management"
                },

                {
                  code: "BFN 121",
                  title: "Introduction to Financial Management"
                },

                {
                  code: "BAC 121",
                  title: "Financial Accounting II"
                },

                {
                  code: "BEC 121",
                  title: "Macroeconomics"
                },

                {
                  code: "BEC 223",
                  title: "Development Economics"
                }

              ]
            }

          ]
        },

        /*
          =======================
          YEAR TWO
          =======================
        */

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "BFN 212",
                  title: "Financial Management"
                },

                {
                  code: "BAC 321",
                  title: "Principles of Taxation"
                },

                {
                  code: "MAT 214",
                  title: "Business Statistics I"
                },

                {
                  code: "ENV 101",
                  title: "Environmental Studies"
                },

                {
                  code: "BAC 212",
                  title: "Cost Accounting"
                },

                {
                  code: "BBM 213",
                  title: "Insurance and Risk Management"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "BMK 221",
                  title: "Principles of Marketing"
                },

                {
                  code: "BPS 110",
                  title: "Supply Chain Management"
                },

                {
                  code: "BCT 423",
                  title: "Management Information System"
                },

                {
                  code: "BAC 221",
                  title: "Management Accounting I"
                },

                {
                  code: "BFN 221",
                  title: "Financial Risk Management"
                },

                {
                  code: "MAT 221",
                  title: "Quantitative Techniques"
                }

              ]
            }

          ]
        },

        /*
          =======================
          YEAR THREE
          =======================
        */

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "BHR 311",
                  title: "Organisational Behavior"
                },

                {
                  code: "BAC 311",
                  title: "Management Decision Models"
                },

                {
                  code: "BAC 316",
                  title: "Principles of Auditing and Assurance"
                },

                {
                  code: "BBM 212",
                  title: "Production and Operations Management"
                },

                {
                  code: "BHR 312",
                  title: "Labor Laws"
                },

                {
                  code: "BHR 313",
                  title: "Employee and Industrial Relations"
                },

                {
                  code: "BHR 420",
                  title: "Industrial Safety and Health"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "BBM 321",
                  title: "International Business Management"
                },

                {
                  code: "BCT 323",
                  title: "Electronic Commerce"
                },

                {
                  code: "BCU 320",
                  title: "Research Methods"
                },

                {
                  code: "BBM 323",
                  title: "Quality Control Methods"
                },

                {
                  code: "BHR 321",
                  title: "Human Resource Training and Development"
                },

                {
                  code: "BHR 322",
                  title: "Strategic Human Resource Management"
                }

              ]
            }

          ]
        },

        /*
          =======================
          YEAR FOUR
          =======================
        */

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                {
                  code: "BCU 410",
                  title: "Entrepreneurship and Innovation"
                },

                {
                  code: "BFN 410",
                  title: "Company Law"
                },

                {
                  code: "BEC 413",
                  title: "Labor Economics"
                },

                {
                  code: "BHR 411",
                  title: "Performance and Reward Management"
                },

                {
                  code: "BHR 412",
                  title: "Cross Cultural and Diversity Management"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                {
                  code: "BBM 325",
                  title: "Strategic Management"
                },

                {
                  code: "BBM 421",
                  title: "Professional Ethics and Etiquette"
                },

                {
                  code: "BHR 422",
                  title: "Retirement and Benefit"
                },

                {
                  code: "BCU 400",
                  title: "Research Project"
                },

                {
                  code: "BCU 401",
                  title: "Industrial Attachment"
                },

                {
                  code: "BHR 414",
                  title: "Contemporary Issues in Human Resource Management"
                },

                {
                  code: "BHR 424",
                  title: "Human Resource Information Systems"
                }

              ]
            }

          ]
        }

      ]
    },

    /*
      ==========================================================
      SPECIALISATION 2
      FINANCE
      ==========================================================
    */

    {
      specialisation: "Finance",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BAC 111", title: "Financial Accounting I" },

                { code: "BBM 111", title: "Foundations of Business" },

                { code: "BCU 111", title: "Communication Skills" },

                { code: "BCU 112", title: "Digital Literacy" },

                { code: "MAT 111", title: "Basic Mathematics" },

                { code: "BEC 111", title: "Microeconomics" },

                { code: "BCU 113", title: "Health and Wellness Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 121", title: "Principles of Management" },

                { code: "BFN 211", title: "Business Law" },

                { code: "BHR 121", title: "Human Resource Management" },

                { code: "BFN 121", title: "Introduction to Financial Management" },

                { code: "BAC 121", title: "Financial Accounting II" },

                { code: "BEC 121", title: "Macroeconomics" },

                { code: "BEC 223", title: "Development Economics" }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BFN 212", title: "Financial Management" },

                { code: "BAC 321", title: "Principles of Taxation" },

                { code: "MAT 214", title: "Business Statistics I" },

                { code: "ENV 101", title: "Environmental Studies" },

                { code: "BAC 212", title: "Cost Accounting" },

                { code: "BBM 213", title: "Insurance and Risk Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BMK 221", title: "Principles of Marketing" },

                { code: "BPS 110", title: "Supply Chain Management" },

                { code: "BCT 423", title: "Management Information System" },

                { code: "BAC 221", title: "Management Accounting I" },

                { code: "BFN 221", title: "Financial Risk Management" },

                { code: "MAT 221", title: "Quantitative Techniques" }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BHR 311", title: "Organisational Behavior" },

                { code: "BAC 311", title: "Management Decision Models" },

                { code: "BAC 316", title: "Principles of Auditing and Assurance" },

                { code: "BBM 212", title: "Production and Operations Management" },

                { code: "BFN 311", title: "International Finance" },

                { code: "BFN 312", title: "Corporate Finance" },

                { code: "BFN 315", title: "Development Finance" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BCT 323", title: "Electronic Commerce" },

                { code: "BBM 321", title: "International Business Management" },

                { code: "BCU 320", title: "Research Methods" },

                { code: "BBM 323", title: "Quality Control Methods" },

                { code: "BFN 321", title: "Financial Statement Analysis" },

                { code: "BFN 322", title: "Financial Institutions and Markets" }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BCU 410", title: "Entrepreneurship and Innovation" },

                { code: "BFN 410", title: "Company Law" },

                { code: "BFN 411", title: "Valuation and Analysis of Securities" },

                { code: "BFN 412", title: "Monetary Theory and Practice" },

                { code: "BFN 413", title: "Investment Analysis and Portfolio Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 325", title: "Strategic Management" },

                { code: "BBM 421", title: "Professional Ethics and Etiquette" },

                { code: "BCU 400", title: "Research Project" },

                { code: "BCU 401", title: "Industrial Attachment" },

                { code: "BFN 423", title: "Public Financial Management" },

                { code: "BFN 424", title: "Financial Asset Management" }

              ]
            }

          ]
        }

      ]
    },

    /*
      ==========================================================
      SPECIALISATION 3
      ACCOUNTING
      ==========================================================
    */

    {
      specialisation: "Accounting",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BAC 111", title: "Financial Accounting I" },

                { code: "BBM 111", title: "Foundations of Business" },

                { code: "BCU 111", title: "Communication Skills" },

                {
                  code: "BCU 112",
                  title: "Introduction to Computer Studies and Internet"
                },

                { code: "MAT 111", title: "Basic Mathematics" },

                { code: "BEC 111", title: "Microeconomics" },

                { code: "BCU 113", title: "Health and Wellness Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 121", title: "Principles of Management" },

                { code: "BFN 211", title: "Business Law" },

                { code: "BHR 121", title: "Human Resource Management" },

                { code: "BFN 121", title: "Introduction to Financial Management" },

                { code: "BAC 121", title: "Financial Accounting II" },

                { code: "BEC 121", title: "Macroeconomics" },

                { code: "BEC 223", title: "Development Economics" }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BFN 212", title: "Financial Management" },

                { code: "BAC 321", title: "Principles of Taxation" },

                { code: "MAT 214", title: "Business Statistics I" },

                { code: "ENV 101", title: "Environmental Studies" },

                { code: "BAC 212", title: "Cost Accounting" },

                { code: "BBM 213", title: "Insurance and Risk Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BMK 221", title: "Principles of Marketing" },

                { code: "BPS 110", title: "Supply Chain Management" },

                { code: "BCT 423", title: "Management Information System" },

                { code: "BAC 221", title: "Management Accounting I" },

                { code: "BFN 221", title: "Financial Risk Management" },

                { code: "MAT 221", title: "Quantitative Techniques" }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BHR 311", title: "Organisational Behavior" },

                { code: "BAC 311", title: "Management Decision Models" },

                { code: "BAC 316", title: "Principles of Auditing and Assurance" },

                { code: "BBM 212", title: "Production and Operations Management" },

                { code: "BAC 312", title: "Accounting for Assets" },

                { code: "BAC 313", title: "Advanced Financial Accounting I" },

                { code: "BAC 315", title: "Public Sector Accounting" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BCT 323", title: "Electronic Commerce" },

                { code: "BBM 321", title: "International Business Management" },

                { code: "BCU 320", title: "Research Methods" },

                { code: "BBM 323", title: "Quality Control Methods" },

                { code: "BAC 323", title: "Management Accounting II" },

                { code: "BAC 322", title: "Advanced Auditing and Assurance" }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BCU 410", title: "Entrepreneurship and Innovation" },

                { code: "BFN 410", title: "Company Law" },

                {
                  code: "BAC 123",
                  title: "Introduction to Computerized Business Accounting"
                },

                { code: "BAC 411", title: "Financial Reporting" },

                { code: "BAC 412", title: "Advanced Taxation" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 325", title: "Strategic Management" },

                { code: "BBM 421", title: "Professional Ethics and Etiquette" },

                { code: "BCU 400", title: "Research Project" },

                { code: "BCU 401", title: "Industrial Attachment" },

                { code: "BAC 422", title: "Forensic Accounting" },

                { code: "BAC 425", title: "Trust and Executorships Accounting" }

              ]
            }

          ]
        }

      ]
    },

    /*
      ==========================================================
      SPECIALISATION 4
      MARKETING
      ==========================================================
    */

    {
      specialisation: "Marketing",

      years: [

        {
          year: "Year One",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BAC 111", title: "Financial Accounting I" },

                { code: "BBM 111", title: "Foundations of Business" },

                { code: "BCU 111", title: "Communication Skills" },

                {
                  code: "BCU 112",
                  title: "Introduction to Computer Studies and Internet"
                },

                { code: "MAT 111", title: "Basic Mathematics" },

                { code: "BEC 111", title: "Microeconomics" },

                { code: "BCU 113", title: "Health and Wellness Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 121", title: "Principles of Management" },

                { code: "BFN 211", title: "Business Law" },

                { code: "BHR 121", title: "Human Resource Management" },

                { code: "BFN 121", title: "Introduction to Financial Management" },

                { code: "BAC 121", title: "Financial Accounting II" },

                { code: "BEC 121", title: "Macroeconomics" },

                { code: "BEC 223", title: "Development Economics" }

              ]
            }

          ]
        },

        {
          year: "Year Two",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BFN 212", title: "Financial Management" },

                { code: "BAC 321", title: "Principles of Taxation" },

                { code: "MAT 214", title: "Business Statistics I" },

                { code: "ENV 101", title: "Environmental Studies" },

                { code: "BAC 212", title: "Cost Accounting" },

                { code: "BBM 213", title: "Insurance and Risk Management" }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BMK 221", title: "Principles of Marketing" },

                { code: "BPS 110", title: "Supply Chain Management" },

                { code: "BCT 423", title: "Management Information System" },

                { code: "BAC 221", title: "Management Accounting I" },

                { code: "BFN 221", title: "Financial Risk Management" },

                { code: "MAT 221", title: "Quantitative Techniques" }

              ]
            }

          ]
        },

        {
          year: "Year Three",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BHR 311", title: "Organisational Behavior" },

                { code: "BAC 311", title: "Management Decision Models" },

                { code: "BAC 316", title: "Principles of Auditing and Assurance" },

                { code: "BBM 212", title: "Production and Operations Management" },

                { code: "BMK 311", title: "Consumer Behavior" },

                { code: "BMK 313", title: "Digital Marketing" },

                {
                  code: "BMK 416",
                  title: "Marketing Analytics and Measurements"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BCT 323", title: "Electronic Commerce" },

                { code: "BBM 321", title: "International Business Management" },

                { code: "BCU 320", title: "Research Methods" },

                { code: "BBM 323", title: "Quality Control Methods" },

                { code: "BMK 321", title: "Marketing Research" },

                { code: "BMK 322", title: "Product and Brand Management" }

              ]
            }

          ]
        },

        {
          year: "Year Four",

          semesters: [

            {
              semester: "Semester One",

              units: [

                { code: "BCU 410", title: "Entrepreneurship and Innovation" },

                { code: "BFN 410", title: "Company Law" },

                {
                  code: "BMK 411",
                  title: "Strategic Marketing Management"
                },

                {
                  code: "BMK 412",
                  title: "International Marketing"
                },

                {
                  code: "BMK 415",
                  title: "Search Engine Optimization"
                }

              ]
            },

            {
              semester: "Semester Two",

              units: [

                { code: "BBM 325", title: "Strategic Management" },

                { code: "BBM 421", title: "Professional Ethics and Etiquette" },

                { code: "BCU 400", title: "Research Project" },

                { code: "BCU 401", title: "Industrial Attachment" },

                { code: "BMK 422", title: "Services Marketing" },

                { code: "BMK 423", title: "Industrial Marketing" }

              ]
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Business Administration and Management take?",

      answer:
        "The programme takes four years, equivalent to eight semesters."
    },

    {
      question: "What specialisations are available?",

      answer:
        "Students can specialize in Human Resource Management, Finance, Accounting or Marketing."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment during the final year to gain practical workplace experience."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Business Administration and Management | Zetech University",

    metaDescription:
      "Study the Bachelor of Business Administration and Management at Zetech University and specialize in Human Resource Management, Finance, Accounting or Marketing while developing the leadership and business skills needed to drive organisational success."

  }

},
{
  id: 19,

  slug: "bachelor-of-purchasing-and-supply-chain-management",

  title: "Bachelor of Purchasing and Supply Chain Management",

  shortTitle: "Bachelor of Purchasing & Supply Chain Management",

  code: "BPSCM",

  school: "School of Business and Economics",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Purchasing and Supply Chain Management",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-purchasing-and-supply-chain-management.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-purchasing-and-supply-chain-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Source Smart. Deliver Value.",

  heroDescription:
    "Develop the knowledge, analytical skills and practical experience required to manage procurement, logistics and modern supply chains while supporting operational excellence in today's global business environment.",

  overview: `
The Bachelor of Purchasing and Supply Chain Management explores the systems, strategies and processes that keep organizations moving efficiently.

The programme equips students with practical knowledge in procurement, logistics, inventory management, strategic sourcing, warehousing, transportation, supplier relationship management, contract management and supply chain analytics.

Students gain hands-on experience through case studies, projects and industrial attachment while learning how modern technologies and data-driven decision-making improve supply chain performance.

Graduates develop the competence to manage procurement functions, optimize supply chains, reduce operational costs and enhance organisational competitiveness across both public and private sectors.
`,

  whyStudy: [

    "Develop practical skills in procurement, logistics, inventory management and strategic sourcing.",

    "Learn modern procurement practices using digital technologies and data-driven decision making.",

    "Gain hands-on experience through projects, industrial attachment and real-world case studies.",

    "Build expertise in supplier relationship management, negotiation and contract administration.",

    "Strengthen leadership, analytical and problem-solving skills for local and global supply chains.",

    "Graduate prepared for careers in procurement, logistics, warehousing and supply chain management."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C+.",

    "Holder of an accredited Diploma recognized by the University Senate.",

    "Minimum grade of C (Plain) in Mathematics.",

    "OR Holder of a KACE certificate with at least two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 60000,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Supply Chain Manager",

    "Logistics Analyst",

    "Director of Supplier Quality and Procurement",

    "Chief Procurement Officer",

    "Supply Management Analyst",

    "New Product Procurement Planner",

    "Strategic Sourcing Manager"

  ],

  skills: [

    "Procurement",

    "Supply Chain Management",

    "Logistics",

    "Strategic Sourcing",

    "Inventory Management",

    "Warehouse Management",

    "Supplier Relationship Management",

    "Contract Management",

    "Negotiation",

    "Risk Management",

    "Supply Chain Analytics",

    "E-Procurement"

  ],

  ctaTitle:
    "Ready to Lead Modern Supply Chains?",

  ctaText:
    "Join Zetech University and develop the knowledge, leadership skills and practical expertise required to optimize procurement, logistics and supply chains across today's global economy.",

  curriculum: [
      // Your existing curriculum remains exactly as it is.
       {
      year: "Year One",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "BPS 110", title: "Supply Chain Management" },
            { code: "BEC 111", title: "Microeconomics" },
            { code: "BAC 111", title: "Financial Accounting I" },
            { code: "BCU 111", title: "Communication Skills" },
            { code: "BCU 112", title: "Digital Literacy" },
            { code: "BCU 113", title: "Health and Wellness Management" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "BPS 120", title: "Legal Issues in Procurement" },
            { code: "BFN 121", title: "Introduction to Financial Management" },
            { code: "BHR 121", title: "Human Resource Management" },
            { code: "BEC 223", title: "Development Economics" },
            { code: "BPS 122", title: "Purchasing and Supplies Strategy" },
            { code: "BPS 123", title: "Stores Management and Stock Control" }
          ]
        }

      ]
    },

    {
      year: "Year Two",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "BPS 210", title: "Warehousing Operations and Management" },
            { code: "BPS 211", title: "Procurement for Construction Works" },
            { code: "BPS 212", title: "Sourcing in Procurement and Supply" },
            { code: "BPS 213", title: "Inventory Management" },
            { code: "BAC 212", title: "Cost Accounting" },
            { code: "BPS 214", title: "Procurement and Supply Relationships" },
            { code: "BBM 324", title: "Total Quality Management" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "BCT 423", title: "Management Information Systems" },
            { code: "BPS 223", title: "Measuring Purchasing Performance" },
            { code: "MAT 214", title: "Business Statistics I" },
            { code: "BPS 221", title: "Transport and Distribution Management" },
            { code: "BPS 225", title: "Contract Law and Negotiation" },
            { code: "BPS 224", title: "Supplies and Materials Management" },
            { code: "MAT 221", title: "Quantitative Techniques" }
          ]
        }

      ]
    },

    {
      year: "Year Three",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "BPS 121", title: "Public Procurement" },
            { code: "BHR 311", title: "Organization Behavior" },
            { code: "BCT 323", title: "Electronic Commerce" },
            { code: "BPS 313", title: "Sustainability in Supply Chain" },
            { code: "BPS 311", title: "Logistic Management" },
            { code: "BPS 312", title: "International Purchasing" },
            { code: "BPS 415", title: "Provisioning of Materials" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "BPS 322", title: "Procurement and Project Management" },
            { code: "BPS 323", title: "Procurement Audit and Investigations" },
            { code: "BPS 324", title: "Procurement Planning and Organization" },
            { code: "BPS 325", title: "Global Supply Chain" },
            { code: "BPS 321", title: "Material Production Planning and Techniques" },
            { code: "BCU 320", title: "Research Methods" }
          ]
        }

      ]
    },
    {
      year: "Year Four",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "BCU410", title: "Entrepreneurship and Innovation" },
            { code: "BPS412", title: "Freight and Fleet Management" },
            { code: "BPS413", title: "Procurement Integrity and Accountability" },
            { code: "BPS414", title: "Procurement Management" },
            { code: "BPS411", title: "E-Procurement Management" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "BPS420", title: "Category Management" },
            { code: "BPS423", title: "Operations Chain Management" },
            { code: "BPS425", title: "Leadership in Procurement and Supply" },
            { code: "BPS421", title: "Risk Management in Purchasing" },
            { code: "BCU400", title: "Research Project" },
            { code: "BCU401", title: "Industrial Attachment" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters)."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted in January, May and September."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer: "Yes. Students complete an Industrial Attachment during the final year to gain practical industry experience."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Purchasing and Supply Chain Management | Zetech University",

    metaDescription:
      "Study the Bachelor of Purchasing and Supply Chain Management at Zetech University and develop expertise in procurement, logistics, strategic sourcing and modern supply chain management."

  }

},

{
  id: 20,

  slug: "bachelor-of-laws-llb",

  title: "Bachelor of Laws (LL.B)",

  shortTitle: "Bachelor of Laws (LL.B)",

  code: "LLB",

  school: "Zetech Law School",

  qualification: "UNDERGRADUATE",

  qualificationTitle: "Bachelor of Laws",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-laws-llb.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-laws-llb-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Stand Out and Chart Your Legal Career",

  heroDescription:
    "Develop the legal knowledge, practical advocacy skills and professional competence required to navigate complex legal issues, provide innovative solutions and build a successful career in the evolving legal profession.",

  overview: `
The Zetech University Bachelor of Laws programme is designed to cultivate intellectually curious, exceptionally skilled, and thoroughly prepared legal professionals ready to provide innovative solutions to societal needs.

Approved by the Commission for University Education (CUE) and the Council of Legal Education (CLE), the programme provides a strong foundation in legal theory, research, advocacy, ethics and professional practice.

Students develop practical legal skills through Moot Court sessions, legal clinics, simulations, judicial attachments, clinical externships and community service while exploring emerging areas of law including Legal Tech, Data Privacy, Artificial Intelligence, Intellectual Property, Environmental Law and International Trade Law.

The programme prepares graduates to analyse complex legal issues, think critically, negotiate effectively and communicate with confidence across diverse legal and professional environments.
`,

  whyStudy: [

    "Pursue a Bachelor of Laws degree approved by the Commission for University Education (CUE) and Council of Legal Education (CLE), giving you a strong foundation for your legal career.",

    "Build courtroom confidence through Moot Court sessions, legal clinics, simulations, judicial attachments, and clinical externships that prepare you for real legal practice.",

    "Explore emerging areas such as Legal Tech, Data Privacy, Artificial Intelligence, Intellectual Property, Environmental Law, and International Trade Law.",

    "Learn how to analyze complex legal issues, think critically, negotiate effectively, and communicate with confidence.",

    "Graduate ready for careers in legal practice, corporate law, government, international organizations, legal technology, compliance, human rights, and alternative dispute resolution.",

    "Study in a modern learning environment that combines academic excellence, technology, and practical legal training to prepare you for the future of the legal profession."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C+.",

    "Minimum grade of B (Plain) in English or Kiswahili.",

    "OR have at least three Principal Passes in the Kenya Advanced Certificate of Education Examination."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical Classes Only (Full-time)",

  fee: 115500,

  feeType: "tuition fees per semester",

  intake: [
    "May",
    "September"
  ],

  careers: [

    "Private Legal Practice",

    "Corporate Lawyer",

    "Public Sector Legal Practitioner",

    "Alternative Dispute Resolution Practitioner",

    "Legal Practitioner in International Organizations",

    "Legal Researcher",

    "Legal Academic",

    "Legal Consultant",

    "Legal Technologist",

    "Compliance and Risk Management Professional",

    "Human Rights and Public Interest Lawyer",

    "Legal Journalist"

  ],

  skills: [

    "Legal Research",

    "Legal Writing",

    "Legal Analysis",

    "Critical Thinking",

    "Trial Advocacy",

    "Negotiation",

    "Alternative Dispute Resolution",

    "Moot Court Practice",

    "Legal Ethics",

    "Constitutional Law",

    "Commercial Law",

    "Corporate Law",

    "Intellectual Property Law",

    "Data Privacy Law",

    "International Law",

    "Legal Technology",

    "Research and Academic Writing",

    "Professional Communication"

  ],

  ctaTitle:
    "Ready to Shape Your Legal Career?",

  ctaText:
    "Join Zetech University and develop the legal knowledge, practical advocacy skills and professional competence required to succeed in today's evolving legal profession.",

  curriculum: [

    {
      year: "Year 1",

      semesters: [

        {
          semester: "Semester 1",

          units: [
            { code: "LLB 101", title: "Constitutional Law I" },
            { code: "LLB 102", title: "Criminal Law I" },
            { code: "LLB 103", title: "Law of Contract I" },
            { code: "LLB 104", title: "Law of Torts I" },
            { code: "LLB 105", title: "Legal Research & Writing I" },
            { code: "LLB 106", title: "Social and Political Foundations of Law" },
            { code: "BCU 110", title: "Communication Skills" }
          ]
        },

        {
          semester: "Semester 2",

          units: [
            { code: "LLB 107", title: "Constitutional Law II" },
            { code: "LLB 108", title: "Criminal Law II" },
            { code: "LLB 109", title: "Law of Contracts II" },
            { code: "LLB 110", title: "Law of Torts II" },
            { code: "LLB 111", title: "Legal Systems & Methods" },
            { code: "BCU 112", title: "Digital Literacy" },
            { code: "BCU 113", title: "Health and Wellness Management" }
          ],

          attachmentCourses: [
            {
              code: "LLB 114",
              title: "Community Service",
              note: "out-of-semester attachment course"
            }
          ]
        }

      ]
    },

    {
      year: "Year 2",

      semesters: [

        {
          semester: "Semester 1",

          units: [
            { code: "LLB 201", title: "Law of Evidence I" },
            { code: "LLB 202", title: "Property Law I" },
            { code: "LLB 203", title: "Criminal Procedure" },
            { code: "LLB 204", title: "Ethics and Etiquette" },
            { code: "LLB 205", title: "Administrative Law I" },
            { code: "LLB 206", title: "Legal Research & Writing II" },
            { code: "LLB 207", title: "ICT and e-Commerce Law" }
          ]
        },

        {
          semester: "Semester 2",

          units: [
            { code: "LLB 208", title: "Law of Evidence II" },
            { code: "LLB 209", title: "Property Law II" },
            { code: "LLB 210", title: "Administrative Law II" },
            { code: "LLB 211", title: "Civil Procedure" },
            { code: "LLB 212", title: "Trial Advocacy Skills" },
            { code: "LLB 213", title: "Economics for Lawyers" },
            { code: "LLB 214", title: "Law Science and Technology" }
          ],

          attachmentCourses: [
            {
              code: "LLB 215",
              title: "Judicial Attachment",
              note: "out-of-semester attachment course"
            }
          ]
        }

      ]
    },

    {
      year: "Year 3",

      semesters: [

        {
          semester: "Semester 1",

          units: [
            { code: "LLB 301", title: "Law of Business Associations I (includes Insolvency Law)" },
            { code: "LLB 302", title: "Public International Law" },
            { code: "LLB 303", title: "Commercial Law" },
            { code: "LLB 304", title: "Labour Law" },
            { code: "LLB 305", title: "Financial Services Law" }
          ],

          electiveHeading: "Electives for Year 3 Semester 1 (Choose two)",
          electives: [
            { code: "LLB 310", title: "Competition Law" },
            { code: "LLB 311", title: "Intellectual Property Law" },
            { code: "LLB 312", title: "Regional Integration Law" },
            { code: "LLB 313", title: "International Human Rights Law" },
            { code: "LLB 314", title: "Environmental & Climate Change Law" }
          ]
        },

        {
          semester: "Semester 2",

          units: [
            { code: "LLB 306", title: "Law of Business Associations II (includes Insolvency Law)" },
            { code: "LLB 307", title: "Jurisprudence" },
            { code: "LLB 308", title: "Equity & Law of Trusts" },
            { code: "LLB 309", title: "Alternative Dispute Resolution" },
            { code: "BCU 320", title: "Research Methods" }
          ],

          electiveHeading: "Electives for Year 3 Semester 2 (Choose two)",
          electives: [
            { code: "LLB 315", title: "Consumer Protection Law" },
            { code: "LLB 316", title: "International Humanitarian Law" },
            { code: "LLB 317", title: "Media and Entertainment Law" },
            { code: "LLB 318", title: "Law & Development" },
            { code: "LLB 319", title: "Energy Law" }
          ],

          attachmentCourses: [
            {
              code: "LLB 321",
              title: "Clinical Externship",
              note: "out-of-semester attachment course"
            }
          ]
        }

      ]
    },

    {
      year: "Year 4",

      semesters: [

        {
          semester: "Semester 1",

          units: [
            { code: "LLB 401", title: "Family Law" },
            { code: "LLB 402", title: "Research Paper I" },
            { code: "LLB 403", title: "Accounting for Lawyers" },
            { code: "BCU 410", title: "Entrepreneurship and Innovation" }
          ],

          electiveHeading: "Electives for Year 4 Semester 1 (Choose any two)",
          electives: [
            { code: "LLB 409", title: "Taxation Law" },
            { code: "LLB 411", title: "International Trade Law" },
            { code: "LLB 413", title: "Health Law and Policy" },
            { code: "LLB 414", title: "International Migration Law" },
            { code: "LLB 418", title: "International Criminal Law" }
          ]
        },

        {
          semester: "Semester 2",

          units: [
            { code: "LLB 405", title: "Law of Succession" },
            { code: "LLB 406", title: "Data Protection Law" },
            { code: "LLB 407", title: "Research Paper II" }
          ],

          electiveHeading: "Electives for Year 4, Semester 2 (Choose any three)",
          electives: [
            { code: "LLB 410", title: "Capital Markets and Securities Regulation Law" },
            { code: "LLB 412", title: "International Economic Law" },
            { code: "LLB 416", title: "Law, Democracy and Citizenship" },
            { code: "LLB 419", title: "International Law of the Sea" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Laws programme take?",
      answer:
        "The Bachelor of Laws programme takes four years, comprising eight semesters."
    },

    {
      question: "What are the minimum entry requirements for the Bachelor of Laws?",
      answer:
        "Applicants should have a KCSE (or equivalent) minimum aggregate grade of C+ and a minimum grade of B (Plain) in English or Kiswahili, or at least three Principal Passes in the Kenya Advanced Certificate of Education Examination."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The Bachelor of Laws programme is offered through physical classes only on a full-time basis."
    },

    {
      question: "When are the intakes for the Bachelor of Laws programme?",
      answer:
        "The programme admits students in May and September."
    },

    {
      question: "Does the programme include practical legal training?",
      answer:
        "Yes. Students gain practical experience through Moot Court sessions, legal clinics, simulations, community service, judicial attachment and clinical externship."
    },

    {
      question: "What areas of emerging law are covered?",
      answer:
        "The programme exposes students to emerging areas including Legal Tech, Data Privacy, Artificial Intelligence, Intellectual Property, Environmental Law and International Trade Law."
    },

    {
      question: "What careers can I pursue after studying Bachelor of Laws?",
      answer:
        "Graduates can pursue careers in private legal practice, corporate law, public sector organizations, alternative dispute resolution, international organizations, legal research, academia, legal technology, compliance and risk management, human rights, public interest law and legal journalism."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Laws | Zetech University",

    metaDescription:
      "Study Bachelor of Laws at Zetech University and develop practical legal skills through moot courts, legal clinics, judicial attachment, clinical externship and emerging areas of law."

  }

},

{
  id: 21,

  slug: "bachelor-of-science-in-nursing",

  title: "Bachelor of Science in Nursing",

  shortTitle: "Bachelor of Science in Nursing",

  code: "BSN",

  school: "School of Health Sciences",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Science in Nursing",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-science-in-nursing.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-science-in-nursing-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Shape the Future of Patient Care: Save Lives",

  heroDescription:
    "Develop the knowledge, clinical skills and professional competence required to provide compassionate, evidence-based nursing care while contributing to healthier communities and advancing the future of healthcare.",

  overview: `
The Bachelor of Science in Nursing is designed to nurture compassionate, highly competent and critically thinking nursing professionals equipped to address diverse healthcare needs across communities.

The programme provides a strong foundation in human anatomy, physiology, pathology, pharmacology, microbiology, medical-surgical nursing, paediatrics, midwifery, community health, mental health, critical care and specialized nursing practice.

Students combine theoretical learning with practical training through Nursing Skills Laboratory sessions, clinical rotations, community health practice, research projects and supervised healthcare placements.

The programme also incorporates emerging areas such as nursing informatics, precision medicine and healthcare technologies, preparing graduates to apply evidence-based practice, digital health solutions and innovative approaches to modern healthcare.

Graduates develop the professional, clinical, leadership, research and communication competencies required to provide quality patient care and contribute effectively to healthcare organizations, communities, research and education.
`,

  whyStudy: [

    "Pursue a Bachelor of Science in Nursing degree approved by the Nursing Council of Kenya (NCK) and the Commission for University Education (CUE), providing a strong foundation for professional nursing practice.",

    "Build practical nursing skills through clinical rotations, hospital placements, community health practice and training in modern Nursing Skills Laboratories.",

    "Gain expertise in patient care, medical-surgical nursing, midwifery, community health, critical care, nursing informatics and evidence-based nursing practice.",

    "Apply classroom knowledge through supervised clinical rotations, research projects and community outreach programmes that prepare you for professional practice.",

    "Develop critical thinking, communication, clinical decision-making and leadership skills required in modern healthcare environments.",

    "Learn in well-equipped laboratories and clinical training environments that support practical, hands-on healthcare education.",

    "Graduate prepared for careers in hospitals, community health, research, education, healthcare leadership and specialized nursing practice."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C+.",

    "Minimum grade of C+ in English or Kiswahili.",

    "Minimum grade of C+ in Mathematics or Physics.",

    "Minimum grade of C+ in Chemistry.",

    "Minimum grade of C+ in Biology.",

    "OR Holder of a KACE certificate with at least two Principal Passes, with one Principal Pass in Biology and one Principal Pass in Chemistry."

  ],

  duration: 12,

  durationType: "Trimesters",

  durationYears: "4 Years",

  mode: "Physical Classes Only (Full-time)",

  fee: 122500,

  feeType: "tuition fees per semester",

  intake: [
    "September"
  ],

  careers: [

    "Nurse Practitioner",

    "Community/Public Health Nurse",

    "Critical Care Nurse",

    "Clinical/Health Researcher",

    "Nurse Educator",

    "Clinical Nurse Specialist",

    "Healthcare Administrator"

  ],

  skills: [

    "Patient Care",

    "Clinical Nursing",

    "Medical-Surgical Nursing",

    "Community Health Nursing",

    "Midwifery",

    "Paediatric Nursing",

    "Critical Care Nursing",

    "Mental Health Nursing",

    "Nursing Informatics",

    "Health Assessment",

    "Clinical Decision Making",

    "Evidence-Based Practice",

    "Healthcare Research",

    "Nursing Leadership",

    "Health Education",

    "Emergency and Trauma Care",

    "Healthcare Management"

  ],

  ctaTitle:
    "Ready to Shape the Future of Patient Care?",

  ctaText:
    "Join Zetech University and develop the clinical knowledge, practical skills and professional competence required to deliver quality patient care and make a meaningful impact in healthcare.",

  curriculum: [

    {
      year: "Year One",
      semesters: [

        {
          semester: "Trimester One",
          units: [
            {
              code: "BSN 111",
              title: "Human Anatomy I (Integumentary; Musculoskeletal and Nervous Systems)"
            },
            {
              code: "BSN 112",
              title: "Human Physiology I (Integumentary; Musculoskeletal and Nervous Systems)"
            },
            {
              code: "BSN 113",
              title: "Medical Biochemistry"
            },
            {
              code: "BSN 114",
              title: "Fundamentals of Nursing Practice I (Nursing Theories and Basic Nursing Skills)"
            }
          ]
        },

        {
          semester: "Trimester Two",
          units: [
            {
              code: "BSN 121",
              title: "Human Anatomy II (Respiratory, Digestive, Cardiovascular, Endocrine, Genitourinary and Reproductive Systems)"
            },
            {
              code: "BSN 122",
              title: "Human Physiology II (Respiratory, Digestive, Cardiovascular, Endocrine, Genitourinary and Reproductive Systems)"
            },
            {
              code: "BSN 123",
              title: "Human Psychology"
            },
            {
              code: "BSN 124",
              title: "Medical Microbiology"
            },
            {
              code: "BSN 125",
              title: "Nutrition and Health"
            },
            {
              code: "BSN 126",
              title: "Medical Sociology and Anthropology"
            }
          ]
        },

        {
          semester: "Trimester Three",
          units: [
            {
              code: "BSN 131",
              title: "Human Pathology"
            },
            {
              code: "BSN 132",
              title: "Clinical Pharmacology I (Drug Interactions)"
            },
            {
              code: "BSN 133",
              title: "Medical Parasitology and Entomology"
            },
            {
              code: "BSN 134",
              title: "Hematology"
            },
            {
              code: "BSN 135",
              title: "Immunology"
            },
            {
              code: "BSN 136",
              title: "Health Assessment"
            },
            {
              code: "BSN 137",
              title: "Pathophysiology I (Cardiovascular, Lymphatic, Pulmonary, Endocrine and Neurologic Body Systems)"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",
      semesters: [

        {
          semester: "Trimester One",
          units: [
            {
              code: "BSN 211",
              title: "Medical-Surgical Nursing I (Respiratory, Cardiovascular, Gastrointestinal and Hematological Disorders)"
            },
            {
              code: "BSN 212",
              title: "Clinical Pharmacology II (Systemic Pharmacology)"
            },
            {
              code: "BSN 213",
              title: "Pediatrics Nursing I (Pediatric Concepts and Diagnostics)"
            },
            {
              code: "BSN 214",
              title: "Fundamentals of Nursing Practice II (Basic Life Support and Emergencies)"
            },
            {
              code: "BSN 215",
              title: "Communication and Counseling in Health"
            },
            {
              code: "BSN 216",
              title: "Pathophysiology II (Urologic, Digestive, Reproductive, Musculoskeletal and Integumentary Systems)"
            },
            {
              code: "BSN 217",
              title: "Clinical Chemistry"
            }
          ]
        },

        {
          semester: "Trimester Two",
          units: [
            {
              code: "BSN 221",
              title: "Medical-Surgical Nursing II (Lymphatic, Metabolic, Endocrine, Renal, Urinary and Male Reproductive)"
            },
            {
              code: "BSN 222",
              title: "Midwifery I (Introduction to Midwifery and Pregnancy)"
            },
            {
              code: "BSN 223",
              title: "Medical-Surgical Nursing III (Integumentary, Nervous and Musculoskeletal Conditions)"
            },
            {
              code: "BSN 224",
              title: "Pediatric Nursing II (Management of Childhood Illnesses)"
            },
            {
              code: "BSN 225",
              title: "Family Planning & Contraception"
            },
            {
              code: "BSN 226",
              title: "Community Health Nursing I (Primary Health Care)"
            },
            {
              code: "BSN 227",
              title: "Community Health Nursing II (Health Education and Promotion)"
            }
          ]
        },

        {
          semester: "Trimester Three",
          units: [
            {
              code: "BSN 231",
              title: "Clinical Rotation 1 (16 Weeks) - Assessment: Total Nursing Care of a Patient"
            }
          ]
        }

      ]
    },

    {
      year: "Year Three",
      semesters: [

        {
          semester: "Trimester One",
          units: [
            {
              code: "BSN 311",
              title: "Midwifery II (Labor, Delivery, Emergencies)"
            },
            {
              code: "BSN 312",
              title: "Gender, Sexual Reproductive Health and Rights"
            },
            {
              code: "BSN 313",
              title: "Epidemiology and Demography"
            },
            {
              code: "BSN 314",
              title: "Biostatistics"
            },
            {
              code: "BSN 315",
              title: "Gynecology Nursing"
            },
            {
              code: "BSN 316",
              title: "Environmental and Occupational Health"
            },
            {
              code: "BSN 317",
              title: "Medical Research Methodology"
            },
            {
              code: "BSN 328",
              title: "Research Project 1 (Proposal)"
            }
          ]
        },

        {
          semester: "Trimester Two",
          units: [
            {
              code: "BSN 321",
              title: "Ophthalmology and ENT"
            },
            {
              code: "BSN 322",
              title: "Midwifery III (Puerperium, Newborn)"
            },
            {
              code: "BSN 323",
              title: "Communicable & Vector Borne Diseases"
            },
            {
              code: "BSN 324",
              title: "Trauma and Emergencies, and Peri-operative Nursing"
            },
            {
              code: "BSN 325",
              title: "Academic Writing and Nursing Informatics"
            },
            {
              code: "BSN 326",
              title: "Community Health Nursing III (Public Health Legislation)"
            },
            {
              code: "MLS 427",
              title: "Precision Medicine and Technologies in Healthcare"
            }
          ]
        },

        {
          semester: "Trimester Three",
          units: [
            {
              code: "BSN 331",
              title: "Clinical Rotation 2 (17 Weeks) - Antenatal Care, Mother in Labor, Baby at Risk (Neonate Care)"
            },
            {
              code: "BSN 417",
              title: "Research Project II"
            }
          ]
        }

      ]
    },

    {
      year: "Year Four",
      semesters: [

        {
          semester: "Trimester One",
          units: [
            {
              code: "BSN 411",
              title: "Mental Health & Psychiatric Nursing"
            },
            {
              code: "BSN 412",
              title: "Oncology, Palliative and Forensic Nursing"
            },
            {
              code: "BSN 413",
              title: "Critical Care and Nephrology"
            },
            {
              code: "BSN 414",
              title: "Curriculum and Instruction in Nursing"
            },
            {
              code: "BSN 415",
              title: "Leadership, Management and Governance in Health"
            }
          ]
        },

        {
          semester: "Trimester Two",
          units: [
            {
              code: "BSN 421",
              title: "Clinical Rotation 3 (16 Weeks)"
            }
          ]
        },

        {
          semester: "Trimester Three",
          units: [
            {
              code: "BSN 431",
              title: "Clinical Rotation 4 (16 Weeks)"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Science in Nursing programme take?",
      answer:
        "The Bachelor of Science in Nursing programme takes four years, structured across twelve trimesters."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through physical classes on a full-time basis, complemented by practical sessions and supervised clinical rotations."
    },

    {
      question: "When is the intake for the Bachelor of Science in Nursing?",
      answer:
        "The programme admits students for the September intake."
    },

    {
      question: "Is the Bachelor of Science in Nursing approved?",
      answer:
        "Yes. The programme is approved by the Nursing Council of Kenya (NCK) and the Commission for University Education (CUE)."
    },

    {
      question: "Does the programme include clinical training?",
      answer:
        "Yes. Students undertake practical training in Nursing Skills Laboratories and participate in supervised clinical rotations in hospitals and community health centers."
    },

    {
      question: "What areas of nursing does the programme cover?",
      answer:
        "The programme covers areas including medical-surgical nursing, paediatric nursing, midwifery, community health nursing, mental health and psychiatric nursing, critical care, oncology, nephrology, nursing informatics and other specialized areas."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Nursing | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Nursing at Zetech University and develop professional nursing skills through clinical training, community health practice, research and evidence-based healthcare education."

  }

},
{
  id: 22,

  slug: "bachelor-of-science-in-data-science-and-analytics",

  title: "Bachelor of Science in Data Science and Analytics",

  shortTitle: "BSc in Data Science & Analytics",

  code: "BDA",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Science in Data Science and Analytics",

  award: "Bachelor",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-science-in-data-science-and-analytics.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-science-in-data-science-and-analytics-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Empowering the next generation of Data leaders",

  heroDescription:
    "Develop the mathematical, statistical and computing expertise required to collect, analyze, interpret and visualise complex data while transforming information into actionable insights for informed decision-making.",

  overview: `
The Bachelor of Science in Data Science and Analytics equips students with the knowledge and practical skills to collect, analyse, interpret, and visualise complex data for informed decision-making.

The programme integrates mathematics, statistics, computer science, and domain-specific knowledge to provide a strong foundation in data-driven problem-solving.

Students gain expertise in key areas such as data mining, machine learning, big data technologies, programming, and data visualisation, preparing them to transform data into actionable insights.

With a strong emphasis on real-world applications, the programme prepares graduates to address complex challenges and drive innovation across diverse industries in today's data-driven economy.
`,

  whyStudy: [

    "Gain practical skills in data analysis, Artificial Intelligence, machine learning, and big data to solve real-world problems.",

    "Build practical experience by working on real projects through the Zetech University Innovation Hub and modern computer laboratories.",

    "Access well-equipped computer labs and industry-standard tools that support practical learning and innovation.",

    "Graduate with the skills needed for exciting careers in data science, analytics, artificial intelligence, business intelligence, and machine learning.",

    "Learn how to collect, analyze, and turn data into valuable insights that help organizations make smarter decisions.",

    "Study in a technology-focused environment that encourages creativity, innovation, research, and entrepreneurship while benefiting from opportunities that broaden your perspective and prepare you to compete in the global digital economy."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of C+ and a minimum of C in Mathematics and English/Kiswahili.",

    "Holder of an accredited Diploma with a Credit Pass from an institution that is recognized by the University Senate.",

    "Holder of a KACE certificate with a minimum of two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 78000,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Data Analyst",

    "Machine Learning Engineer",

    "Business Intelligence Analyst",

    "Data Scientist",

    "AI Researcher",

    "Quantitative Analyst",

    "Big Data Specialist",

    "Data Engineer",

    "Risk Analyst"

  ],

  skills: [

    "Data Science",

    "Data Analytics",

    "Data Analysis",

    "Artificial Intelligence",

    "Machine Learning",

    "Big Data Analytics",

    "Data Engineering",

    "Data Visualization",

    "Data Mining",

    "Data Warehousing",

    "Statistical Analysis",

    "Programming for Data Science",

    "Python",

    "R Programming",

    "Database Management",

    "Cloud Computing",

    "Business Intelligence",

    "Deep Learning",

    "Natural Language Processing",

    "Computer Vision",

    "Data Ethics and Privacy",

    "Statistical Modeling",

    "Time Series Analysis",

    "Optimization Techniques"

  ],

  ctaTitle:
    "Ready to Lead with Data?",

  ctaText:
    "Join Zetech University and develop the technical, analytical and practical expertise required to transform data into actionable insights, drive innovation and solve complex problems in today's data-driven economy.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "BCU 111", title: "Communication Skills" },
            { code: "BCU 113", title: "Health and Wellness Management" },
            { code: "BCU 112", title: "Digital Literacy" },
            { code: "BSD 111", title: "Structured Programming and Algorithms" },
            { code: "MAT 111", title: "Basic Mathematics" },
            { code: "BDA 111", title: "Data Ethics, Privacy and Governance" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "MAT 121", title: "Discrete Mathematics" },
            { code: "STA 123", title: "Probability and Statistics 1" },
            { code: "BCT 121", title: "Operating Systems" },
            { code: "BDM 121", title: "Database Management Systems" },
            { code: "BSD 122", title: "Object Oriented Programming 1" },
            { code: "BDA 121", title: "Introduction to Data Science & Analytics" }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "BSD 211", title: "Data Structures and Algorithms" },
            { code: "MAT 120", title: "Calculus 1" },
            { code: "STA 212", title: "Probability and Statistics II" },
            { code: "MAT 210", title: "Linear Algebra" },
            { code: "BDA 211", title: "Data Engineering" },
            { code: "STA 214", title: "Statistical Hypothesis Testing" },
            { code: "BDA 212", title: "Programming for Data Science (Python And R)" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "BNT 221", title: "Data Communication and Computer Networks 1" },
            { code: "MAT 220", title: "Calculus II" },
            { code: "BDA 220", title: "Linear Regression" },
            { code: "BCE 211", title: "Computer Vision" },
            { code: "BDA 222", title: "Data Mining and Wrangling" },
            { code: "BDA 221", title: "Data Warehousing" }
          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "STA 314", title: "Multivariate Analysis" },
            { code: "BSD 313", title: "Internet Programming I" },
            { code: "BCE 312", title: "Artificial Intelligence" },
            { code: "BAS 312", title: "Survival Analysis" },
            { code: "PSY 312", title: "Cyber Psychology and Critical Thinking" },
            { code: "BSD 311", title: "Simulation and Modeling" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "BCT 321", title: "Research Methods and Technical Writing" },
            { code: "BDM 321", title: "Cloud Computing and Services" },
            { code: "BDA 321", title: "Big Data Analytics & Architecture" },
            { code: "BSD 322", title: "Internet Programming II" },
            { code: "BCT 322", title: "IT Project Management" },
            { code: "BDA 322", title: "Data Visualization" }
          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "BCE 412", title: "Machine Learning" },
            { code: "BCT 412", title: "Computer and Cyber Security" },
            { code: "BDA 413", title: "Spatial Sciences" },
            { code: "BSD 411", title: "Business Intelligence and Analytics" },
            { code: "BDA 414", title: "Bayesian Inference and Decision Theory" },
            { code: "BCT 415", title: "Project Proposal" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "BDA 421", title: "Deep Learning" },
            { code: "BDA 423", title: "Optimization Techniques" },
            { code: "BDA 424", title: "Natural Language Processing" },
            { code: "BCU 410", title: "Entrepreneurship and Innovation" },
            { code: "STA 416", title: "Time Series Analysis and Forecasting" },
            { code: "BCT 425", title: "Final Project" },
            { code: "BCU 401", title: "Industrial Attachment" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Bachelor of Science in Data Science and Analytics take?",
      answer:
        "The programme takes four years (eight semesters)."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What careers can I pursue after studying Data Science and Analytics?",
      answer:
        "Graduates can pursue careers as Data Analysts, Machine Learning Engineers, Business Intelligence Analysts, Data Scientists, AI Researchers, Quantitative Analysts, Big Data Specialists, Data Engineers and Risk Analysts."
    },

    {
      question: "Does the programme include practical learning?",
      answer:
        "Yes. Students gain practical experience through real projects, modern computer laboratories, the Zetech University Innovation Hub and an Industrial Attachment."
    },

    {
      question: "What programming languages are covered?",
      answer:
        "The curriculum includes Programming for Data Science using Python and R."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Data Science and Analytics | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Data Science and Analytics at Zetech University and develop expertise in data science, analytics, artificial intelligence, machine learning, big data, programming and data visualisation."

  }

},

// {
//     id:22,
//     title:"Bachelor of Science in Data Science and Analytics",
//     code:"BDA",
//     school:"School of ICT, Media and Engineering",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:78000,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"],

// },


// {
//     id:20,
//     title:"Bachelor of Science in Health Systems Management",
//     code:"BScHSM",
//     school:"School of Health Sciences",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:58650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

// {
//     id:21,
//     title:"Bachelor of Science in Computer Science and Mathematics",
//     code:"BCM",
//     school:"School of ICT, Media and Engineering",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:60650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

// {
//     id:22,
//     title:"Bachelor of Science in Computer Science and Applied Physics",
//     code:"BCP",
//     school:"School of ICT, Media and Engineering",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:60650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },
{
  id: 23,

  slug: "bachelor-of-science-in-media-and-digital-communication",

  title: "Bachelor of Science in Media and Digital Communication",

  shortTitle: "BSc Media & Digital Communication",

  code: "BMDC",

  school: "School of ICT, Media and Engineering",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Science",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure: "/downloads/brochures/bsc-media-and-digital-communication.pdf",

  feeStructure: "/downloads/fees/bsc-media-and-digital-communication-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Create Content. Shape Culture.",

  heroDescription:
    "The Bachelor of Science in Media and Digital Communication prepares students for careers in digital media, journalism, strategic communication, public relations, advertising, and multimedia storytelling through industry-focused training and emerging media technologies.",

  overview: `
The Bachelor of Science in Media and Digital Communication equips students with the knowledge, creativity and technical expertise required to thrive in today's rapidly evolving digital media industry.

The programme integrates communication theory with practical training in digital journalism, public relations, advertising, multimedia production, content creation, digital marketing and strategic communication.

Students gain hands-on experience using modern media technologies while developing strong storytelling, branding, communication and analytical skills that prepare them to produce engaging digital experiences across multiple platforms.

Graduates are equipped to lead communication campaigns, create compelling digital content, manage brands, engage audiences and drive communication strategies across the public, private and non-profit sectors.
`,

  whyStudy: [

    "Develop practical skills in digital content creation, multimedia production, journalism, public relations and strategic communication.",

    "Learn using modern digital media technologies, industry-standard software and emerging communication platforms.",

    "Gain practical experience through hands-on projects, media production, research and industry attachment.",

    "Explore emerging fields including digital marketing, podcasting, social media management, multimedia storytelling and web analytics.",

    "Build professional communication, branding, storytelling and audience engagement skills for today's digital economy.",

    "Study under experienced media professionals with extensive industry and academic expertise.",

    "Graduate prepared for careers in journalism, digital media, advertising, branding, public relations and corporate communications."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C+.",

    "Minimum grade of C (Plain) in English or Kiswahili.",

    "OR Holder of a relevant diploma recognized by the University Senate.",

    "OR Holder of a KACE certificate with at least two Principal Passes and one Subsidiary Pass."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 66000,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  specialisations: [

    "Digital Public Relations",

    "Digital Journalism",

    "Digital Advertising"

  ],

  curriculum: [

    /* ==========================================================
       DIGITAL PUBLIC RELATIONS
    ========================================================== */

    {

      specialisation: "Digital Public Relations",

      years: [

        /* =======================
           YEAR ONE
        ======================= */

        {

          year: "Year One",

          semesters: [

            {

              semester: "Semester One",

              units: [

                { code: "BCU111", title: "Communication Skills" },

                { code: "BCU112", title: "Digital Literacy" },

                { code: "BCU113", title: "Health and Wellness Management" },

                { code: "BJO110", title: "Introduction to Mass Communication" },

                { code: "BJO111", title: "English for Journalists" },

                { code: "BJO112", title: "Media and Society" }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                { code: "BJO120", title: "Kiswahili kwa Wanahabari" },

                { code: "DEV121", title: "Development Studies" },

                { code: "BPR121", title: "Global Communication" },

                { code: "BJO123", title: "Culture and Communication" },

                { code: "BBM121", title: "Principles of Management" },

                { code: "BJO124", title: "Photography and Photojournalism" }

              ]

            }

          ]

        },

        /* =======================
           YEAR TWO
        ======================= */

        {

          year: "Year Two",

          semesters: [

            {

              semester: "Semester One",

              units: [

                { code: "BJO210", title: "Fundamentals of Web Analytics" },

                { code: "BJO211", title: "Digital Media Ethics, Law and Human Rights" },

                { code: "BJO212", title: "Online Resources for Communication" },

                { code: "ERE111", title: "Introduction to Creative and Critical Thinking" },

                { code: "BJO213", title: "Interactive Media Design" },

                { code: "BPSY216", title: "Psychology of Communication" }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                { code: "BPR220", title: "Principles of Public Relations" },

                { code: "BPR221", title: "Writing for Print Media" },

                { code: "BJO222", title: "Broadcast Journalism" },

                { code: "BAV223", title: "Principles of Advertising" },

                { code: "BJO224", title: "Communication Theories" },

                { code: "BJO225", title: "Gender Issues in Communication" }

              ]

            }

          ]

        },

        /* =======================
           YEAR THREE
        ======================= */

        {

          year: "Year Three",

          semesters: [

            {

              semester: "Semester One",

              units: [

                { code: "BJO310", title: "Communication Research" },

                { code: "BJO311", title: "Video Production and Editing" },

                { code: "BJO312", title: "Audience Analysis" },

                { code: "BPR310", title: "Writing for Public Relations" },

                { code: "BPR311", title: "Digital Public Relations" },

                { code: "BPR312", title: "Strategic Public Relations" }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                { code: "BJO320", title: "Digital Innovation for Integrated Media" },

                { code: "BAV321", title: "Digital Marketing" },

                { code: "BCU320", title: "Research Methodology" },

                { code: "BPR320", title: "Events Planning and Management" },

                { code: "BPR321", title: "Communication Conflict and Negotiation Skills" },

                { code: "BPR322", title: "Theories of Public Relations" }

              ]

            }

          ]

        },

        /* =======================
           YEAR FOUR
        ======================= */

        {

          year: "Year Four",

          semesters: [

            {

              semester: "Semester One",

              units: [

                { code: "BJO410", title: "Documentary Production" },

                { code: "BCU410", title: "Entrepreneurship" },

                { code: "BPR410", title: "Monitoring and Evaluation of Communication Practices" },

                { code: "BPR411", title: "Strategic Communication" },

                { code: "BPR412", title: "Communication and Public Campaigns for Social Change" },

                { code: "BPR413", title: "Diplomacy" }

              ]

            },

            {

              semester: "Semester Two",

              units: [

                { code: "BMD420", title: "Project" },

                { code: "BPR420", title: "Interpretation, Translation and Communication" },

                { code: "BJO420", title: "Digital Security for Journalists" },

                { code: "BJO421", title: "Digital Journalism Ethics" },

                { code: "BPR422", title: "Crisis Communication" },

                { code: "BPR423", title: "Public Relations Case Studies" },

                { code: "BMD421", title: "Industrial Attachment" }

              ]

            }

          ]

        }

      ]

    },

    // Digital Journalism (Part 2)
    /* ==========================================================
   DIGITAL JOURNALISM
========================================================== */

{

  specialisation: "Digital Journalism",

  years: [

    /* =======================
       YEAR ONE
    ======================= */

    {

      year: "Year One",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "BJO110", title: "Introduction to Mass Communication" },

            { code: "BJO111", title: "English for Journalists" },

            { code: "BJO112", title: "Media and Society" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BJO120", title: "Kiswahili kwa Wanahabari" },

            { code: "DEV121", title: "Development Studies" },

            { code: "BPR121", title: "Global Communication" },

            { code: "BJO123", title: "Culture and Communication" },

            { code: "BBM121", title: "Principles of Management" },

            { code: "BJO124", title: "Photography and Photojournalism" }

          ]

        }

      ]

    },

    /* =======================
       YEAR TWO
    ======================= */

    {

      year: "Year Two",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO210", title: "Fundamentals of Web Analytics" },

            { code: "BJO211", title: "Digital Media Ethics, Law and Human Rights" },

            { code: "BJO212", title: "Online Resources for Communication" },

            { code: "ERE111", title: "Introduction to Creative and Critical Thinking" },

            { code: "BJO213", title: "Interactive Media Design" },

            { code: "BPSY216", title: "Psychology of Communication" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BPR220", title: "Principles of Public Relations" },

            { code: "BPR221", title: "Writing for Print Media" },

            { code: "BJO222", title: "Broadcast Journalism" },

            { code: "BAV223", title: "Principles of Advertising" },

            { code: "BJO224", title: "Communication Theories" },

            { code: "BJO225", title: "Gender Issues in Communication" }

          ]

        }

      ]

    },

    /* =======================
       YEAR THREE
    ======================= */

    {

      year: "Year Three",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO310", title: "Communication Research" },

            { code: "BJO311", title: "Video Production and Editing" },

            { code: "BJO312", title: "Audience Analysis" },

            { code: "BJO313", title: "Mobile Journalism" },

            { code: "BJO314", title: "Media Interviewing Skills" },

            { code: "BJO315", title: "Digital Storytelling" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BJO320", title: "Digital Innovation for Integrated Media" },

            { code: "BAV321", title: "Digital Marketing" },

            { code: "BCU320", title: "Research Methodology" },

            { code: "BJO321", title: "News and Fact-checking" },

            { code: "BJO322", title: "Electronic News Gathering and Reporting" },

            { code: "BJO323", title: "Digital Graphics and Communication" }

          ]

        }

      ]

    },

    /* =======================
       YEAR FOUR
    ======================= */

    {

      year: "Year Four",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO410", title: "Documentary Production" },

            { code: "BCU410", title: "Entrepreneurship" },

            { code: "BPR410", title: "Monitoring and Evaluation of Communication Practices" },

            { code: "BPR411", title: "Strategic Communication" },

            { code: "BJO411", title: "Studio Technical Operations" },

            { code: "BJO412", title: "Audiography and Podcasting" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BMD420", title: "Project" },

            { code: "BPR420", title: "Interpretation, Translation and Communication" },

            { code: "BJO420", title: "Digital Security for Journalists" },

            { code: "BJO421", title: "Digital Journalism Ethics" },

            { code: "BJO422", title: "Investigative Journalism" },

            { code: "BJO423", title: "Data Journalism" },

            { code: "BMD421", title: "Industrial Attachment" }

          ]

        }

      ]

    }

  ]

},

    // Digital Advertising (Part 3)


  /* ==========================================================
   DIGITAL ADVERTISING
========================================================== */

{

  specialisation: "Digital Advertising",

  years: [

    /* =======================
       YEAR ONE
    ======================= */

    {

      year: "Year One",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BCU111", title: "Communication Skills" },

            { code: "BCU112", title: "Digital Literacy" },

            { code: "BCU113", title: "Health and Wellness Management" },

            { code: "BJO110", title: "Introduction to Mass Communication" },

            { code: "BJO111", title: "English for Journalists" },

            { code: "BJO112", title: "Media and Society" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BJO120", title: "Kiswahili kwa Wanahabari" },

            { code: "DEV121", title: "Development Studies" },

            { code: "BPR121", title: "Global Communication" },

            { code: "BJO123", title: "Culture and Communication" },

            { code: "BBM121", title: "Principles of Management" },

            { code: "BJO124", title: "Photography and Photojournalism" }

          ]

        }

      ]

    },

    /* =======================
       YEAR TWO
    ======================= */

    {

      year: "Year Two",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO210", title: "Fundamentals of Web Analytics" },

            { code: "BJO211", title: "Digital Media Ethics, Law and Human Rights" },

            { code: "BJO212", title: "Online Resources for Communication" },

            { code: "ERE111", title: "Introduction to Creative and Critical Thinking" },

            { code: "BJO213", title: "Interactive Media Design" },

            { code: "BPSY216", title: "Psychology of Communication" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BPR220", title: "Principles of Public Relations" },

            { code: "BPR221", title: "Writing for Print Media" },

            { code: "BJO222", title: "Broadcast Journalism" },

            { code: "BAV223", title: "Principles of Advertising" },

            { code: "BJO224", title: "Communication Theories" },

            { code: "BJO225", title: "Gender Issues in Communication" }

          ]

        }

      ]

    },

    /* =======================
       YEAR THREE
    ======================= */

    {

      year: "Year Three",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO310", title: "Communication Research" },

            { code: "BJO311", title: "Video Production and Editing" },

            { code: "BJO312", title: "Audience Analysis" },

            { code: "BAV310", title: "Communication and Advertising" },

            { code: "BAV311", title: "Advertising Messaging and Campaign Design" },

            { code: "BAV312", title: "Advertising Copywriting" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BJO320", title: "Digital Innovation for Integrated Media" },

            { code: "BAV321", title: "Digital Marketing" },

            { code: "BCU320", title: "Research Methodology" },

            { code: "BAV322", title: "Media Planning, Scheduling and Buying" },

            { code: "BAV323", title: "Media Planning, Scheduling and Buying II" },

            { code: "BAV324", title: "Online Advertising" }

          ]

        }

      ]

    },

    /* =======================
       YEAR FOUR
    ======================= */

    {

      year: "Year Four",

      semesters: [

        {

          semester: "Semester One",

          units: [

            { code: "BJO410", title: "Documentary Production" },

            { code: "BCU410", title: "Entrepreneurship" },

            { code: "BPR410", title: "Monitoring and Evaluation of Communication Practices" },

            { code: "BPR411", title: "Strategic Communication" },

            { code: "BAV410", title: "Advertising Production" },

            { code: "BAV411", title: "Globalisation and Advertising" }

          ]

        },

        {

          semester: "Semester Two",

          units: [

            { code: "BMD420", title: "Project" },

            { code: "BPR420", title: "Interpretation, Translation and Communication" },

            { code: "BJO420", title: "Digital Security for Journalists" },

            { code: "BJO421", title: "Digital Journalism Ethics" },

            { code: "BAV420", title: "Branding" },

            { code: "BAV421", title: "Advertising Case Studies" },

            { code: "BMD421", title: "Industrial Attachment" }

          ]

        }

      ]

    }

  ]

}

  ],

  careers: [

    "Digital Media Specialist",

    "Public Relations and Communications Officer",

    "Social Media and Content Manager",

    "Multimedia Producer",

    "Brand Executive",

    "Copywriter",

    "Digital Journalist"

  ],

  skills: [

    "Digital Communication",

    "Content Creation",

    "Digital Marketing",

    "Video Production",

    "Podcasting",

    "Strategic Communication",

    "Public Relations",

    "Journalism",

    "Brand Management",

    "Media Analytics"

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer: "The programme takes four years (eight semesters) to complete."
    },

    {
      question: "What specialisations are available?",
      answer: "Students may specialize in Digital Public Relations, Digital Journalism or Digital Advertising."
    },

    {
      question: "What is the mode of study?",
      answer: "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer: "Students are admitted in January, May and September."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Science in Media and Digital Communication | Zetech University",

    metaDescription:
      "Study the Bachelor of Science in Media and Digital Communication at Zetech University specialising in Digital Public Relations, Digital Journalism and Digital Advertising."

  }

},
{
  id: 24,

  slug: "bachelor-of-arts-in-psychology-with-technology",

  title: "Bachelor of Arts in Psychology with Technology",

  shortTitle: "BA Psychology with Technology",

  code: "BPSY",

  school: "School of Education, Arts and Social Sciences",

  qualification: "UNDERGRADUATE",

  award: "Bachelor of Arts",

  category: "UNDERGRADUATE",

  level: "Undergraduate",

  nqfLevel: "Level 7",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-arts-in-psychology-with-technology.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-arts-in-psychology-with-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Understand Behavior. Drive Change.",

  heroDescription:
    "The Bachelor of Arts in Psychology with Technology prepares professionals to understand human behavior while applying emerging technologies to improve mental health, well-being, counseling, research, and human interactions.",

  overview: `
The Bachelor of Arts in Psychology with Technology is designed to prepare professionals who can understand human behavior and apply technology to improve mental health, well-being, and human interactions.

The programme combines core areas of psychology with emerging digital technologies including data analytics, digital mental health, virtual learning environments, teletherapy, multimedia applications, and technology-assisted behavioural interventions.

Graduates acquire the knowledge, ethical practice, research capabilities, and practical skills required to respond to the changing relationship between people, technology, and society while promoting individual and community well-being.
`,

  whyStudy: [

    "Develop a strong understanding of human behavior and mental processes while exploring how emerging technologies are transforming psychological practice and mental healthcare.",

    "Gain practical skills in digital mental health, teletherapy, human-computer interaction, and psychological research through an innovative technology-driven curriculum.",

    "Build critical thinking, research, and problem-solving capabilities to assess psychological challenges and develop evidence-based interventions.",

    "Study an industry-relevant curriculum that integrates psychology with data analytics, digital communication, multimedia applications, and technology-assisted behavioural interventions.",

    "Prepare for diverse careers in counseling, mental health, forensic psychology, rehabilitation, consumer behavior, research, and social services across public and private sectors.",

    "Learn in a flexible environment through both physical and online delivery under experienced faculty committed to producing ethical, compassionate, and technology-enabled psychology professionals."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of C+ (Plus) or its equivalent as determined by the Kenya National Qualifications Authority (KNQA).",

    "OR Diploma or Degree in a related programme or equivalent from an institution recognized by the University Senate."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  mode: "Physical & Online",

  fee: 54650,

  feeType: "tuition fees per semester",

  intake: [

    "January",

    "May",

    "September"

  ],

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BPSY111", title: "Fundamentals of Psychology" },

            { code: "BPSY112", title: "Fundamentals of Social Science" },

            { code: "BPSY113", title: "History and Systems of Psychology" },

            { code: "BCU100", title: "Communication Skills" },

            { code: "BCU101", title: "Introduction to Computers and Internet" },

            { code: "BCU102", title: "Health and Wellness Management" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BPSY121", title: "Physiological Psychology and Technology" },

            { code: "BPSY122", title: "Principles of Guidance and Counseling" },

            { code: "BPSY123", title: "Human Growth and Modern Technologies" },

            { code: "BPSY124", title: "Psychology of Personality and Technology" },

            { code: "BPSY125", title: "Introduction to Neuropsychology" },

            { code: "BPSY126", title: "Social Psychology" }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BPSY211", title: "Social Media and Human Behavior" },

            { code: "BPSY212", title: "Child and Adolescence Psychology" },

            { code: "BPSY213", title: "Human Sexuality" },

            { code: "BPSY214", title: "Teletherapy" },

            { code: "BPSY215", title: "Industrial Psychology and Modern Technology" },

            { code: "BJO214", title: "Psychology of Communication" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BPSY221", title: "Family Psychology and Technology" },

            { code: "BPSY222", title: "Self Awareness and Personal Development" },

            { code: "BPSY223", title: "Psychology of Crime and Technology" },

            { code: "BPSY224", title: "Group Dynamics and Technology" },

            { code: "BPSY225", title: "Motivation, Emotion and Technology" },

            { code: "BPSY226", title: "Multimedia and Graphic Application" }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BPSY311", title: "Techniques of Social Science Research" },

            { code: "BPSY312", title: "Behavior Modification and Technology" },

            { code: "BPSY313", title: "Psychology of Learning and Technology" },

            { code: "BPSY314", title: "Environmental Psychology and Technology" },

            { code: "BPSY315", title: "Addiction, Drugs and Substance Abuse" },

            { code: "BPSY316", title: "Abnormal Psychology" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BPSY321", title: "Clinical Psychology" },

            { code: "BPSY322", title: "Health Psychology and Technology" },

            { code: "BPSY323", title: "Forensics Psychology and Technology" },

            { code: "BPSY324", title: "Sports Psychology" },

            { code: "BCU320", title: "Research Methods and Virtual Psychology" },

            { code: "BPSY325", title: "Grief, Loss and Bereavement" },

            { code: "BPSY326", title: "Human Computer Interactions" }

          ]
        }

      ]
    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            { code: "BPSY411", title: "Psychometrics and Technology" },

            { code: "BPSY412", title: "Psychology of Human Adjustment and Technology" },

            { code: "BPSY413", title: "Statistics for Psychology and Technology" },

            { code: "BPSY414", title: "Cognitive Psychology" },

            { code: "BBM412", title: "Entrepreneurship" }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            { code: "BPSY421", title: "Consumer Psychology and Online Behavior" },

            { code: "BCU400", title: "Psychology Project / Research Project" },

            { code: "BPSY423", title: "Special Population and Technology" },

            { code: "BPST424", title: "Public Finance Management and Technology" },

            { code: "BPSY424", title: "Culture, Human Behavior and Technology" },

            { code: "BCU401", title: "Industrial Attachment" }

          ]
        }

      ]
    }

  ],

  careers: [

    "Psychiatric Technician",

    "Psychologist",

    "Psychiatrist",

    "Mental Health Coordinator",

    "Counsellor",

    "Consumer Insight Analyst",

    "Probation and Parole Officer",

    "Rehabilitation Specialist",

    "Social Services Specialist",

    "Forensic Psychologist",

    "Special Government Agent"

  ],

  skills: [

    "Psychological Assessment",

    "Counseling",

    "Digital Mental Health",

    "Teletherapy",

    "Behavioural Research",

    "Human Computer Interaction",

    "Data Analytics",

    "Critical Thinking",

    "Communication",

    "Problem Solving",

    "Ethical Practice",

    "Research Methods"

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme takes four years (eight semesters) to complete."
    },

    {
      question: "Is the programme offered online?",

      answer:
        "Yes. The programme is offered through both Physical and Online learning modes."
    },

    {
      question: "What careers can I pursue after graduation?",

      answer:
        "Graduates can work as psychologists, counsellors, mental health coordinators, forensic psychologists, rehabilitation specialists, consumer insight analysts, researchers, and social service professionals."
    },

    {
      question: "When are the intakes?",

      answer:
        "The programme admits students during the January, May, and September intakes."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Arts in Psychology with Technology | Zetech University",

    metaDescription:
      "Study the Bachelor of Arts in Psychology with Technology at Zetech University and gain expertise in psychology, digital mental health, teletherapy, behavioural research, and technology-enabled interventions."

  }

},

{
id: 56,

slug: "bachelor-of-science-in-clinical-medicine-and-community-health-bcm",

title:
"Bachelor of Science in Clinical Medicine and Community Health",

shortTitle:
"Bachelor of Science in Clinical Medicine and Community Health",

code: "BCM",

school: "School of Health Sciences",

qualification: "UNDERGRADUATE",

qualificationTitle:
"Bachelor of Science in Clinical Medicine and Community Health",

award: "Bachelor of Science",

category: "UNDERGRADUATE",

level: "Undergraduate",

nqfLevel: null,

  featured: true,

image: undergraduate,

brochure:
"/downloads/brochures/bachelor-of-science-in-clinical-medicine-and-community-health-bcm.pdf",

feeStructure:
"/downloads/fees/bachelor-of-science-in-clinical-medicine-and-community-health-bcm-fees.pdf",

applyLink: "https://sajili.zetech.ac.ke",

enquiryEmail: "admissions@zetech.ac.ke",

enquiryPhone: phoneNumber,

mantra:
"Training Compassionate Clinical and Healthcare Leaders",

heroDescription:
"Develop the knowledge, clinical skills and professional competencies required to become a competent, ethical and compassionate clinical practitioner through comprehensive training in biomedical sciences, clinical medicine, community health and hands-on clinical practice.",

overview: `
This is a comprehensive programme designed to prepare competent, ethical and compassionate clinical practitioners capable of delivering quality healthcare across diverse healthcare settings.

The programme combines rigorous biomedical sciences, clinical medicine, community health and practical training to equip graduates with the knowledge, clinical skills and professional competencies required to prevent, diagnose, treat and manage diseases while promoting health and improving the well-being of individuals and communities.

Through extensive laboratory sessions, clinical placements and community-based learning, students gain hands-on experience that prepares them for professional practice in Kenya and beyond.
`,

whyStudy: [

"Develop the knowledge, clinical skills and professional competencies required to deliver safe, evidence-based and patient-centred healthcare.",

"Gain practical experience through laboratory sessions, simulations, community-based learning and supervised clinical placements in diverse healthcare settings.",

"Build a strong foundation in biomedical sciences, clinical medicine, surgery, paediatrics, reproductive health, emergency care and community health.",

"Learn through modern teaching approaches, blended learning and well-equipped laboratories that enhance clinical competence and lifelong learning.",

"Graduate with the practical skills, professional competence and clinical exposure required for careers in healthcare while developing the ethical standards and global perspective needed to serve diverse communities and healthcare systems."


],

entryRequirements: [


"KCSE Mean Grade C+ (Plus), with a minimum grade of C+ in Biology, Chemistry, Mathematics or Physics, and English or Kiswahili.",

"OR other equivalent qualifications recognized by the Kenya National Qualifications Framework (KNQF), including relevant diploma qualifications."


],

duration: 4,

durationType: "Academic Years",

durationYears: "4 Years",

durationDetails: {


duration: "4 Academic Years (12 Trimesters)",

modeOfDelivery:
  "Blended Learning (Physical and Online). The programme combines face-to-face lectures, practical laboratory sessions, simulation-based learning, clinical skills training, hospital-based clinical rotations, community-based education, seminars, tutorials and supervised clinical attachments to provide comprehensive theoretical and hands-on professional training.",

intake: "September"


},

mode: "Blended Learning (Physical and Online)",

deliveryMode:
"Blended Learning (Physical and Online)",

/*

* IMPORTANT:
* fee must be a NUMBER because ProgrammeHero uses:
* programme.fee.toLocaleString()
*
* Do NOT use null here.
  */
  fee: 60650,

feeType: "Per Semester",

/*

* Additional fee information that can be used by
* ProgrammeHero or the Fees section.
  */
  feeDetails: {


amount: 60650,



currency: "KES",

feeType: "Per Semester",

billingPeriod: "Semester",

semesters: 12,

note:
  "Tuition fees are subject to the approved Zetech University fee structure and may be reviewed from time to time.",

feeStructure:
  "/downloads/fees/bachelor-of-science-in-clinical-medicine-and-community-health-bcm-fees.pdf"


},

intake: [
"September"
],

careers: [


"Clinical Officer",

"Emergency and Critical Care Clinician",

"Community Health Officer",

"Primary Healthcare Practitioner",

"Medical Officer in Humanitarian and Non-Governmental Organizations (NGOs)",

"Clinical Research Assistant/ Coordinator",

"Occupational Health Clinician",

"Public Health Programme Officer",

"Health Promotion Officer",

"Clinical Educator or Tutor"


],

careerOpportunities: [


"Clinical Officer",

"Emergency and Critical Care Clinician",

"Community Health Officer",

"Primary Healthcare Practitioner",

"Medical Officer in Humanitarian and Non-Governmental Organizations (NGOs)",

"Clinical Research Assistant/ Coordinator",

"Occupational Health Clinician",

"Public Health Programme Officer",

"Health Promotion Officer",

"Clinical Educator or Tutor"


],

skills: [


"Clinical Medicine",

"Community Health",

"Biomedical Sciences",

"Clinical Assessment",

"Disease Diagnosis",

"Disease Management",

"Patient-Centred Healthcare",

"Clinical Skills",

"Laboratory Practice",

"Emergency Care",

"Surgery",

"Paediatrics and Child Health",

"Reproductive Health",

"Internal Medicine",

"Pharmacology",

"Pathology",

"Anatomy",

"Physiology",

"Medical Biochemistry",

"Medical Microbiology",

"Parasitology",

"Haematology",

"Blood Transfusion",

"Primary Healthcare",

"Community Health Practice",

"Epidemiology",

"Biostatistics",

"Clinical Research",

"Healthcare Leadership",

"Healthcare Management",

"Medical Ethics",

"Medical Law",

"Professionalism",

"Health Promotion",

"Public Health",

"Clinical Education",

"Health Research",

"Diagnostic Imaging",

"Mental Health",

"Emergency Medicine",

"Occupational Health"


],

ctaTitle:
"Ready to Become a Compassionate Clinical Healthcare Leader?",

ctaText:
"Join Zetech University and develop comprehensive clinical, biomedical and community health competencies through laboratory training, simulation, clinical placements and community-based learning designed to prepare you for professional healthcare practice.",

curriculum: [


{
  year: "Year One",

  semester: "Trimester One",

  units: [

    {
      code: "BCM 110",
      title: "General Embryology and Histology"
    },

    {
      code: "BCM 111",
      title: "Cell Biology and Genetics"
    },

    {
      code: "BCM 112",
      title: "General Anatomy and Lower Limbs"
    },

    {
      code: "BCM 113",
      title: "Physiology of Body Fluids and Excitable Tissues"
    },

    {
      code: "BCM 114",
      title: "Structural Biochemistry"
    },

    {
      code: "BCM 115",
      title: "Basic Life Support and First Aid"
    },

    {
      code: "BCM 116",
      title: "Critical and Creative Thinking"
    },

    {
      code: "BCU 112",
      title: "Digital Literacy"
    },

    {
      code: "BCM 118",
      title: "Sexually Transmitted Infections Management"
    }

  ]
},

{
  year: "Year One",

  semester: "Trimester Two",

  units: [

    {
      code: "BCM 120",
      title: "Anatomy of the Upper Limbs and Thorax"
    },

    {
      code: "BCM 121",
      title: "Respiratory and Cardiovascular Physiology"
    },

    {
      code: "BCM 122",
      title: "Medical Biochemistry: Metabolism of Carbohydrates and Proteins"
    },

    {
      code: "BCM 123",
      title: "Medical Parasitology: Protozoology"
    },

    {
      code: "BCM 124",
      title: "General Microbiology and Virology"
    },

    {
      code: "BCM 125",
      title: "Clinical Methods I"
    },

    {
      code: "BCM 126",
      title: "Behavioural Sciences"
    },

    {
      code: "BCM 127",
      title: "Nursing Skills"
    },

    {
      code: "BCM 128",
      title: "Communication Skills in Health"
    }

  ]
},

{
  year: "Year One",

  semester: "Trimester Three",

  units: [

    {
      code: "BCM 130",
      title: "Anatomy of the Abdomen, Pelvis and Perineum"
    },

    {
      code: "BCM 131",
      title: "Physiology of the Gastrointestinal and Renal Systems"
    },

    {
      code: "BCM 132",
      title: "Medical Biochemistry: Metabolism of Lipids and Nucleic Acids"
    },

    {
      code: "BCM 133",
      title: "Medical Parasitology: Helminthology and Entomology"
    },

    {
      code: "BCM 134",
      title: "Medical Microbiology: Bacteriology and Mycology"
    },

    {
      code: "BCM 135",
      title: "Clinical Methods II"
    },

    {
      code: "BCM 136",
      title: "Immunology"
    },

    {
      code: "BCM 137",
      title: "General Pathology"
    },

    {
      code: "BCM 138",
      title: "Nutrition and Dietetics"
    }

  ]
},

{
  year: "Year Two",

  semester: "Trimester One",

  units: [

    {
      code: "BCM 210",
      title: "Human Anatomy IV: Head and Neck"
    },

    {
      code: "BCM 211",
      title: "Medical Physiology IV: Endocrine and Reproductive Systems"
    },

    {
      code: "BCM 212",
      title: "General Pharmacology, Analgesics and Anti-inflammatory Drugs"
    },

    {
      code: "BCM 213",
      title: "Cardiovascular, Respiratory, Gastrointestinal and Renal Pathology"
    },

    {
      code: "BCM 214",
      title: "Clinical Chemistry"
    },

    {
      code: "BCM 215",
      title: "Clinical Methods III"
    },

    {
      code: "BCM 216",
      title: "Primary Healthcare"
    }

  ]
},

{
  year: "Year Two",

  semester: "Trimester Two",

  units: [

    {
      code: "BCM 220",
      title: "Human Anatomy V: Neuroanatomy"
    },

    {
      code: "BCM 221",
      title: "Medical Physiology V: Neurophysiology"
    },

    {
      code: "BCM 222",
      title: "Antimicrobials and Antiparasitics"
    },

    {
      code: "BCM 223",
      title: "Haematology and Blood Transfusion"
    },

    {
      code: "BCM 224",
      title: "Social Work and Community Development"
    },

    {
      code: "BCM 225",
      title: "Disaster Management"
    },

    {
      code: "BCM 001",
      title: "Clinical Placement I: Junior Clerkship"
    }

  ]
},

{
  year: "Year Two",

  semester: "Trimester Three",

  units: [

    {
      code: "BCM 230",
      title: "Cardiovascular, Respiratory and Nervous System Pharmacology"
    },

    {
      code: "BCM 231",
      title: "Nervous, Musculoskeletal, Endocrine and Reproductive Pathology"
    },

    {
      code: "BCM 232",
      title: "Surgery I: Perioperative, Burns and Wound Care"
    },

    {
      code: "BCM 233",
      title: "Reproductive Health I: Normal Pregnancy"
    },

    {
      code: "BCM 234",
      title: "Paediatrics and Child Health I: Neonatology and Nutritional Disorders"
    },

    {
      code: "BCM 235",
      title: "Internal Medicine I: Cardiology"
    },

    {
      code: "BCM 236",
      title: "Tropical Medicine"
    },

    {
      code: "BCM 002",
      title: "Clinical Placement II: Junior Clerkship"
    }

  ]
},

{
  year: "Year Three",

  semester: "Trimester One",

  units: [

    {
      code: "BCM 310",
      title: "Gastrointestinal, Endocrine and Renal Pharmacology"
    },

    {
      code: "BCM 311",
      title: "Surgery II: Gastrointestinal and Cardiothoracic Surgical Conditions"
    },

    {
      code: "BCM 312",
      title: "Reproductive Health II: Obstetric Conditions"
    },

    {
      code: "BCM 313",
      title: "Paediatrics and Child Health II: Respiratory, Cardiovascular and Haematological Conditions"
    },

    {
      code: "BCM 314",
      title: "Internal Medicine II: Pulmonology and Endocrinology"
    },

    {
      code: "BCM 315",
      title: "Orthopaedics I: Fractures and Dislocations of the Limbs"
    },

    {
      code: "BCM 316",
      title: "Epidemiology and Biostatistics"
    },

    {
      code: "BCM 317",
      title: "Community Health I: Environmental and Occupational Health"
    },

    {
      code: "BCM 003",
      title: "Clinical Placement III: Junior Clerkship"
    }

  ]
},

{
  year: "Year Three",

  semester: "Trimester Two",

  units: [

    {
      code: "BCM 321",
      title: "Surgery III: Genitourinary and Skin Surgical Conditions"
    },

    {
      code: "BCM 322",
      title: "Reproductive Health III: Gynaecological Conditions"
    },

    {
      code: "BCM 323",
      title: "Paediatrics and Child Health III: Gastrointestinal and Renal Conditions"
    },

    {
      code: "BCM 324",
      title: "Internal Medicine III: Gastroenterology and Nephrology"
    },

    {
      code: "BCM 325",
      title: "Orthopaedics II: Conditions of Bones and Joints"
    },

    {
      code: "BCM 326",
      title: "Leadership and Management in Clinical Medicine"
    },

    {
      code: "BCM 327",
      title: "Community Health II: Communicable and Non-Communicable Diseases"
    },

    {
      code: "BCM 328",
      title: "Clinical Research in Health"
    },

    {
      code: "BCM 004",
      title: "Clinical Placement IV: Intermediate Clerkship"
    }

  ]
},

{
  year: "Year Three",

  semester: "Trimester Three",

  units: [

    {
      code: "BCM 330",
      title: "Community Attachment and Community Diagnosis"
    }

  ]
},

{
  year: "Year Four",

  semester: "Trimester One",

  units: [

    {
      code: "BCM 410",
      title: "Surgery IV: Head, Spine and Neurosurgery"
    },

    {
      code: "BCM 411",
      title: "Reproductive Health IV: Obstetric Medical Conditions"
    },

    {
      code: "BCM 412",
      title: "Paediatrics and Child Health IV: Neurology, Rheumatology and Endocrinology"
    },

    {
      code: "BCM 413",
      title: "Internal Medicine IV: Neurology and Rheumatology"
    },

    {
      code: "BCM 414",
      title: "Ophthalmology"
    },

    {
      code: "BCM 415",
      title: "Mental Health and Substance Abuse"
    },

    {
      code: "BCM 416",
      title: "Anesthesiology"
    },

    {
      code: "BCM 417",
      title: "Ear, Nose and Throat"
    },

    {
      code: "BCM 418",
      title: "Community Health III: Infection Prevention and Control"
    },

    {
      code: "BCM 005",
      title: "Clinical Placement V: Senior Clerkship"
    }

  ]
},

{
  year: "Year Four",

  semester: "Trimester Two",

  units: [

    {
      code: "BCM 420",
      title: "Oncology and Palliative Medicine"
    },

    {
      code: "BCM 421",
      title: "Healthcare and Resource Management"
    },

    {
      code: "BCM 422",
      title: "Forensic Medicine and Toxicology"
    },

    {
      code: "BCM 423",
      title: "Dental Health"
    },

    {
      code: "BCM 424",
      title: "Medical Ethics, Law and Professionalism"
    },

    {
      code: "BCM 425",
      title: "Diagnostic Radiology and Imaging"
    },

    {
      code: "BCM 426",
      title: "Dermato-venereology"
    },

    {
      code: "BCM 427",
      title: "Medical Education"
    },

    {
      code: "BCM 428",
      title: "Health Research Project"
    },

    {
      code: "BCM 006",
      title: "Clinical Placement VI: Senior Clerkship"
    }

  ]
},

{
  year: "Year Four",

  semester: "Trimester Three",

  units: [

    {
      code: "BCM 430",
      title: "Surgery V: Oncological Conditions in Surgery"
    },

    {
      code: "BCM 431",
      title: "Reproductive Health V: Gynaecologic Oncology"
    },

    {
      code: "BCM 432",
      title: "Paediatrics and Child Health V: Paediatric Emergencies and Oncology"
    },

    {
      code: "BCM 433",
      title: "Internal Medicine V: Emergency Medicine"
    },

    {
      code: "BCM 007",
      title: "Clinical Placement VII: Senior Clerkship"
    }

  ]
}


],

faqs: [


{
  question:
    "How long does the Bachelor of Science in Clinical Medicine and Community Health take?",

  answer:
    "The programme takes 4 Academic Years, structured across 12 Trimesters."
},

{
  question:
    "What is the mode of delivery?",

  answer:
    "The programme is delivered through Blended Learning (Physical and Online), combining face-to-face lectures, practical laboratory sessions, simulation-based learning, clinical skills training, hospital-based clinical rotations, community-based education, seminars, tutorials and supervised clinical attachments."
},

{
  question: "When is the intake?",

  answer:
    "The programme has a September intake."
},

{
  question:
    "What are the minimum entry requirements?",

  answer:
    "Applicants must possess a KCSE Mean Grade C+ (Plus), with a minimum grade of C+ in Biology, Chemistry, Mathematics or Physics, and English or Kiswahili. Other equivalent qualifications recognized by the Kenya National Qualifications Framework (KNQF), including relevant diploma qualifications, may also be considered."
},

{
  question:
    "What is the Bachelor of Science in Clinical Medicine and Community Health programme about?",

  answer:
    "The programme prepares competent, ethical and compassionate clinical practitioners through comprehensive training in biomedical sciences, clinical medicine, community health and practical clinical training."
},

{
  question:
    "Does the programme include clinical placements?",

  answer:
    "Yes. Students undertake supervised clinical placements throughout the programme, including Junior Clerkship, Intermediate Clerkship and Senior Clerkship placements in addition to community-based learning and clinical training."
},

{
  question:
    "Does the programme include practical laboratory training?",

  answer:
    "Yes. Extensive laboratory sessions, simulations and practical clinical skills training form an important part of the programme."
},

{
  question:
    "What areas of medicine are covered?",

  answer:
    "The curriculum covers biomedical sciences, anatomy, physiology, biochemistry, microbiology, parasitology, pathology, pharmacology, surgery, reproductive health, paediatrics, internal medicine, orthopaedics, emergency medicine, mental health, ophthalmology, ENT, oncology, community health and other clinical disciplines."
},

{
  question:
    "What career opportunities are available?",

  answer:
    "Graduates can pursue careers as Clinical Officers, Emergency and Critical Care Clinicians, Community Health Officers, Primary Healthcare Practitioners, Medical Officers in humanitarian and NGO settings, Clinical Research Assistants or Coordinators, Occupational Health Clinicians, Public Health Programme Officers, Health Promotion Officers, and Clinical Educators or Tutors."
},

{
  question:
    "Does the programme include community health training?",

  answer:
    "Yes. Community health is integrated throughout the programme and includes primary healthcare, community development, environmental and occupational health, communicable and non-communicable diseases, community diagnosis, community attachment, and infection prevention and control."
},

{
  question:
    "Does the programme include research training?",

  answer:
    "Yes. Students undertake Epidemiology and Biostatistics, Clinical Research in Health and a Health Research Project."
},

{
  question:
    "Does the programme include emergency care training?",

  answer:
    "Yes. The programme includes Basic Life Support and First Aid, Disaster Management, emergency medicine, paediatric emergencies, anesthesiology and other areas relevant to emergency and critical care."
}


],

seo: {


metaTitle:
  "Bachelor of Science in Clinical Medicine and Community Health | Zetech University",

metaDescription:
  "Study the Bachelor of Science in Clinical Medicine and Community Health at Zetech University and develop comprehensive clinical, biomedical and community health skills through laboratory training, clinical placements, simulations and community-based learning."


}

},

{
id: 57,

slug: "bachelor-of-economics-and-data-science",

title:
"Bachelor of Economics and Data Science",

shortTitle:
"Bachelor of Economics and Data Science",

code: "BEDS",

school: "School of Business and Economics",

qualification: "UNDERGRADUATE",

qualificationTitle:
"Bachelor of Economics and Data Science",

award: "Bachelor's Degree",

category: "Degree",

level: "Undergraduate",

nqfLevel: null,

  featured: true,

image: undergraduate,

brochure:
"/downloads/brochures/bachelor-of-economics-and-data-science-beds.pdf",

feeStructure:
"/downloads/fees/bachelor-of-economics-and-data-science-beds-fees.pdf",

applyLink: "https://sajili.zetech.ac.ke",

enquiryEmail: "admissions@zetech.ac.ke",

enquiryPhone: phoneNumber,

mantra:
"Shaping Future Economists with Intelligent Decision-Making.",

heroDescription:
"Combine economics with advanced data analytics, machine learning, artificial intelligence and statistical modeling to interpret complex economic systems, generate actionable insights and support strategic decision-making across business, government and development sectors.",

overview: `
The degree is an innovative interdisciplinary programme designed to produce professionals who combine economic expertise with advanced data analytics, machine learning, artificial intelligence and statistical modelling skills.

The programme equips graduates to interpret complex economic systems, generate actionable insights from data, and support strategic decision-making across business, government and development sectors.

Students develop strong foundations in economics, mathematics, statistics, programming, data engineering, econometrics and business intelligence, preparing them to solve real-world economic and business challenges in an increasingly digital economy.
`,

whyStudy: [


"Study an innovative programme that combines Economics with Data Science, Artificial Intelligence, Machine Learning and Business Analytics, equipping you with skills that are highly sought after in today's digital economy.",

"Gain practical experience in Python, R Programming, Data Engineering, Big Data Technologies, Business Intelligence and Data Visualisation through industry-relevant projects and practical learning.",

"Learn through case studies, real-world economic analysis, predictive modeling and practical applications that prepare you to solve business, financial and policy challenges.",

"Graduate with interdisciplinary skills that are increasingly in demand across banking, finance, technology, consulting, government, research institutions and international development organizations.",

"Build a strong foundation in data ethics, governance and responsible use of emerging technologies while developing leadership, communication and entrepreneurial skills."


],

entryRequirements: [

"KCSE Mean Grade C+ (Plus) with at least C (Plain) in Mathematics and C (Plain) in English or Kiswahili.",

"A relevant Diploma or its equivalent.",

"KACE Certificate with at least two Principal Passes and one Subsidiary Pass, including a Credit in Mathematics at KCE level."


],

duration: 4,

durationType: "Academic Years",

durationYears: "4 Years",

durationDetails: {


duration: "4 Academic Years (8 Semesters)",

modeOfDelivery:
  "Blended Learning (Physical and Online). The programme combines face-to-face instruction with digital learning to provide students with flexibility and enhanced learning experiences.",

intake: "January, May & September"


},

mode: "Blended Learning (Physical and Online)",

deliveryMode:
"Blended Learning (Physical and Online). The programme combines face-to-face instruction with digital learning to provide students with flexibility and enhanced learning experiences.",

/*

* FEES
* Keep fee as a NUMBER because ProgrammeHero uses
* fee.toLocaleString().
*
* Current value follows the published undergraduate
* Economics & Statistics fee band of KSh 54,650 per semester.
  */
  fee: 54650,

feeType: "Per Semester",

intake: [
"January",
"May",
"September"
],

careers: [


"Economic Analyst",

"Business Intelligence Analyst",

"Data Scientist",

"Financial Data Analyst",

"Policy Analyst",

"Economic Research Analyst",

"Business and Risk Analyst",

"Market Research Analyst",

"Banking and Investment Analyst",

"Public Policy Consultant",

"Monitoring & Evaluation Specialist"


],

careerOpportunities: [


"Economic Analyst",

"Business Intelligence Analyst",

"Data Scientist",

"Financial Data Analyst",

"Policy Analyst",

"Economic Research Analyst",

"Business and Risk Analyst",

"Market Research Analyst",

"Banking and Investment Analyst",

"Public Policy Consultant",

"Monitoring & Evaluation Specialist"


],

skills: [


"Economics",

"Microeconomics",

"Macroeconomics",

"Economic Analysis",

"Data Science",

"Data Analytics",

"Artificial Intelligence",

"Machine Learning",

"Statistical Modeling",

"Probability and Statistics",

"Python Programming",

"R Programming",

"Data Engineering",

"Big Data Technologies",

"Data Visualisation",

"Business Intelligence",

"Business Analytics",

"Database Management",

"Econometrics",

"Time Series Analysis",

"Forecasting",

"Financial Analysis",

"Economic Research",

"Policy Analysis",

"Research Methods",

"Project Planning and Evaluation",

"Risk Analysis",

"Entrepreneurship and Innovation",

"Data Ethics",

"Data Privacy",

"Data Governance",

"Digital Literacy",

"Communication Skills"


],

ctaTitle:
"Ready to Shape the Future with Economics and Data?",

ctaText:
"Join Zetech University and develop an interdisciplinary combination of economics, data science, artificial intelligence, machine learning, programming, econometrics and business intelligence skills designed to prepare you for intelligent decision-making in the digital economy.",

curriculum: [


{
  year: "Year One",

  semester: "Semester One",

  units: [

    {
      code: "BAC 111",
      title: "Financial Accounting I"
    },

    {
      code: "BDA 121",
      title: "Introduction to Data Science and Analytics"
    },

    {
      code: "BEC 111",
      title: "Introduction to Microeconomics"
    },

    {
      code: "BDS 102",
      title: "Data Ethics, Privacy and Governance"
    },

    {
      code: "BCU 111",
      title: "Communication Skills"
    },

    {
      code: "BCU 112",
      title: "Digital Literacy"
    }

  ]
},

{
  year: "Year One",

  semester: "Semester Two",

  units: [

    {
      code: "BAC 121",
      title: "Financial Accounting II"
    },

    {
      code: "BEC 121",
      title: "Introduction to Macroeconomics"
    },

    {
      code: "BEC 122",
      title: "Mathematics for Economists I"
    },

    {
      code: "STA 123",
      title: "Probability and Statistics I"
    }

  ]
},

{
  year: "Year Two",

  semester: "Semester One",

  units: [

    {
      code: "BEC 210",
      title: "Microeconomic Theory II"
    },

    {
      code: "BEC 214",
      title: "Economics of Global Business"
    },

    {
      code: "MAT 201",
      title: "Mathematics for Data Science I"
    },

    {
      code: "STA 201",
      title: "Statistics for Data Science I"
    },

    {
      code: "STA 203",
      title: "Linear Models and Regression Analysis"
    }

  ]
},

{
  year: "Year Two",

  semester: "Semester Two",

  units: [

    {
      code: "BEC 220",
      title: "Macroeconomic Theory II"
    },

    {
      code: "BEC 223",
      title: "Development Economics"
    },

    {
      code: "STA 212",
      title: "Probability and Statistics II"
    },

    {
      code: "BDS 201",
      title: "Machine Learning"
    },

    {
      code: "BDS 202",
      title: "Introduction to Data Engineering"
    },

    {
      code: "BDS 212",
      title: "Programming for Data Science (Python and R)"
    }

  ]
},

{
  year: "Year Three",

  semester: "Semester One",

  units: [

    {
      code: "BEC 310",
      title: "Microeconomic Theory III"
    },

    {
      code: "MAT 311",
      title: "Operation Research I"
    },

    {
      code: "STA 302",
      title: "Test of Hypothesis"
    },

    {
      code: "BDS 301",
      title: "Database Management Systems"
    },

    {
      code: "BEC 311",
      title: "International Economics"
    },

    {
      code: "BEC 313",
      title: "Economics of Public Expenditure"
    }

  ]
},

{
  year: "Year Three",

  semester: "Semester Two",

  units: [

    {
      code: "BEC 413",
      title: "Labor Economics"
    },

    {
      code: "BEC 320",
      title: "Macroeconomic Theory III"
    },

    {
      code: "BEC 225",
      title: "Money and Banking"
    },

    {
      code: "BEC 414",
      title: "Project Planning and Evaluation"
    },

    {
      code: "BDS 303",
      title: "Python for Data Science II"
    },

    {
      code: "BDA 322",
      title: "Data Visualisation"
    },

    {
      code: "BDS 302",
      title: "Time Series Analysis and Forecasting"
    },

    {
      code: "STA 303",
      title: "Probability and Statistics III"
    }

  ]
},

{
  year: "Year Four",

  semester: "Semester One",

  units: [

    {
      code: "BCU 410",
      title: "Entrepreneurship and Innovation"
    },

    {
      code: "BEC 410",
      title: "Microeconomic Theory IV"
    },

    {
      code: "BEC 415",
      title: "Fundamentals of Econometrics I"
    },

    {
      code: "BCU 320",
      title: "Research Methods"
    },

    {
      code: "BDS 401",
      title: "Big Data Technologies"
    },

    {
      code: "BSD 411",
      title: "Business Intelligence and Analytics"
    }

  ]
},

{
  year: "Year Four",

  semester: "Semester Two",

  units: [

    {
      code: "BEC 420",
      title: "Macroeconomic Theory IV"
    },

    {
      code: "BEC 423",
      title: "Econometrics II"
    },

    {
      code: "BCU 400",
      title: "Research Project"
    },

    {
      code: "BCU 401",
      title: "Industrial Attachment"
    }

  ]
}


],

faqs: [


{
  question:
    "How long does the Bachelor of Economics and Data Science take?",

  answer:
    "The programme takes 4 Academic Years, structured across 8 Semesters."
},

{
  question:
    "What is the mode of delivery?",

  answer:
    "The programme is delivered through Blended Learning (Physical and Online), combining face-to-face instruction with digital learning to provide students with flexibility and enhanced learning experiences."
},

{
  question:
    "When are the intakes?",

  answer:
    "Students are admitted in January, May and September."
},

{
  question:
    "What are the minimum entry requirements?",

  answer:
    "Applicants must have a KCSE Mean Grade C+ (Plus) with at least C (Plain) in Mathematics and C (Plain) in English or Kiswahili, a relevant Diploma or its equivalent, or a KACE Certificate with at least two Principal Passes and one Subsidiary Pass, including a Credit in Mathematics at KCE level."
},

{
  question:
    "What is the Bachelor of Economics and Data Science programme about?",

  answer:
    "The programme is an interdisciplinary degree combining economics with data analytics, machine learning, artificial intelligence and statistical modeling. It prepares graduates to interpret complex economic systems, generate insights from data and support strategic decision-making."
},

{
  question:
    "Does the programme teach programming?",

  answer:
    "Yes. Students develop programming skills through courses covering Python and R Programming for Data Science, including Programming for Data Science and Python for Data Science II."
},

{
  question:
    "Does the programme include Artificial Intelligence and Machine Learning?",

  answer:
    "Yes. The programme combines Economics with Data Science, Artificial Intelligence and Machine Learning, including a dedicated Machine Learning course."
},

{
  question:
    "Does the programme cover data engineering and Big Data?",

  answer:
    "Yes. The curriculum includes Introduction to Data Engineering, Database Management Systems and Big Data Technologies."
},

{
  question:
    "Does the programme cover econometrics and statistical analysis?",

  answer:
    "Yes. Students study probability and statistics, linear models and regression analysis, hypothesis testing, time series analysis and forecasting, and Econometrics I and II."
},

{
  question:
    "What career opportunities are available?",

  answer:
    "Graduates can pursue careers as Economic Analysts, Business Intelligence Analysts, Data Scientists, Financial Data Analysts, Policy Analysts, Economic Research Analysts, Business and Risk Analysts, Market Research Analysts, Banking and Investment Analysts, Public Policy Consultants, and Monitoring & Evaluation Specialists."
},

{
  question:
    "Does the programme include industrial attachment?",

  answer:
    "Yes. Industrial Attachment is included in Year Four, Semester Two."
},

{
  question:
    "Does the programme include a research project?",

  answer:
    "Yes. Students undertake Research Methods and complete a Research Project in Year Four, Semester Two."
},

{
  question:
    "What combination of skills does the programme provide?",

  answer:
    "The programme combines economics, mathematics, statistics, programming, data engineering, machine learning, artificial intelligence, econometrics, business intelligence, data visualisation and research skills."
},

{
  question:
    "What are the tuition fees for the programme?",

  answer:
    "The current displayed tuition fee is KSh 54,650 per semester. Students should refer to the official fee structure for the latest approved fees and any applicable additional charges."
}


],

seo: {

metaTitle:
  "Bachelor of Economics and Data Science | Zetech University",

metaDescription:
  "Study the Bachelor of Economics and Data Science at Zetech University and combine economics, data science, artificial intelligence, machine learning, programming, econometrics and business intelligence for careers in the digital economy."


}

},
{
  id: 58,

  slug: "bachelor-of-digital-marketing",

  title:
    "Bachelor of Digital Marketing",

  shortTitle:
    "Bachelor of Digital Marketing",

  code: "BDM",

  school: "School of Business and Economics",

  qualification: "UNDERGRADUATE",

  qualificationTitle:
    "Bachelor of Digital Marketing",

  award: "Bachelor's Degree",

  category: "Degree",

  level: "Undergraduate",

  nqfLevel: null,

  featured: true,

  image: undergraduate,

  brochure:
    "/downloads/brochures/bachelor-of-digital-marketing-bdm.pdf",

  feeStructure:
    "/downloads/fees/bachelor-of-digital-marketing-bdm-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Create. Connect. Convert. Build the Digital Economy",

  heroDescription:
    "Build brands, grow businesses and drive customer engagement through a future-focused digital marketing degree combining business knowledge with digital marketing, artificial intelligence, analytics, e-commerce, content creation and data-driven decision-making.",

  overview: `
This is a future-focused degree designed to develop professionals who can build brands, grow businesses, and drive customer engagement in today's digital economy.

The programme combines business knowledge with cutting-edge digital marketing skills, enabling students to create compelling content, manage digital campaigns, analyze consumer behavior, leverage artificial intelligence, and make data-driven marketing decisions.

Students gain practical experience in social media marketing, search engine optimisation, digital advertising, web analytics, e-commerce, branding, mobile marketing, digital storytelling, and marketing analytics, preparing them for careers in local and global organizations or entrepreneurship.
`,

  whyStudy: [

    "Learn the latest digital marketing strategies, AI and data analysis, digital advertising and emerging technologies aligned with current industry needs.",

    "Work on practical projects, case studies, digital campaigns, presentations, workshops, and an industrial attachment to build real-world experience.",

    "Learn emerging technologies and skills in: Artificial Intelligence (AI), Marketing Analytics, Search Engine Optimization (SEO), Search Engine Advertising, Social Media Marketing, Digital Content Creation, E-commerce and Web Analytics.",

    "Acquire strong foundations in business, management, finance, entrepreneurship, consumer behavior, communication, and digital technologies.",

    "Gain a global outlook through an internationally relevant curriculum, international partnerships, student exchange opportunities and exposure to global digital marketing trends, preparing you to build brands and compete in the international marketplace."

  ],

  entryRequirements: [

    "KCSE Mean Grade C+ (Plus) or equivalent, with a minimum of Grade C in English or Kiswahili.",

    "A relevant Diploma or equivalent qualification."

  ],

  duration: 8,

  durationType: "Semesters",

  durationYears: "4 Years",

  durationDetails: {

    duration: "4 Academic Years (8 Semesters)",

    modeOfDelivery:
      "Blended Learning (Physical and Online). The programme combines face-to-face lectures, practical sessions, online learning, workshops, seminars, industry projects, presentations, and an industrial attachment.",

    intake: "January, May & September"

  },

  mode: "Physical & Online",

  deliveryMode:
    "Blended Learning (Physical and Online)",

  /*
   * IMPORTANT:
   * fee must NOT be null because ProgrammeHero calls
   * programme.fee.toLocaleString().
   *
   * Current working fee:
   * KES 54,650 per semester.
   */
  fee: 54650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Digital Marketing Manager",

    "Social Media Manager",

    "SEO Specialist",

    "Search Engine Marketing (SEM/PPC) Specialist",

    "Content Marketing and E-commerce Specialist",

    "Digital Content Creator",

    "Brand Manager",

    "Marketing Communications Officer",

    "Web Analytics Specialist",

    "Email Marketing Specialist"

  ],

  careerOpportunities: [

    "Digital Marketing Manager",

    "Social Media Manager",

    "SEO Specialist",

    "Search Engine Marketing (SEM/PPC) Specialist",

    "Content Marketing and E-commerce Specialist",

    "Digital Content Creator",

    "Brand Manager",

    "Marketing Communications Officer",

    "Web Analytics Specialist",

    "Email Marketing Specialist"

  ],

  skills: [

    "Digital Marketing",

    "Social Media Marketing",

    "Affiliate Marketing",

    "Search Engine Optimisation (SEO)",

    "Search Engine Advertising",

    "Search Engine Marketing (SEM)",

    "Pay-Per-Click Advertising (PPC)",

    "Digital Advertising",

    "Content Marketing",

    "Digital Content Creation",

    "Digital Storytelling",

    "Marketing Analytics",

    "Data-Driven Marketing",

    "Web Analytics",

    "E-commerce",

    "Mobile Marketing",

    "Influencer Marketing",

    "Neuromarketing",

    "Customer Relationship Marketing",

    "Consumer Behavior",

    "Marketing Research",

    "Artificial Intelligence",

    "Programming for Data Science",

    "Python Programming",

    "R Programming",

    "Interactive Media Design",

    "Digital Graphics",

    "Video Production and Editing",

    "Advertising Campaign Design",

    "Advertising Production",

    "Branding",

    "Strategic Communication",

    "Public Relations",

    "Business Management",

    "Financial Accounting",

    "Human Resource Management",

    "Business Law",

    "Entrepreneurship",

    "Strategic Management",

    "Management Information Systems",

    "Professional Ethics",

    "Research Methods",

    "Digital Media Ethics",

    "Communication Skills"

  ],

  ctaTitle:
    "Ready to Build the Future of Digital Marketing?",

  ctaText:
    "Join Zetech University and develop practical digital marketing, technology, analytics, creative and business skills designed to help you build brands, grow businesses, connect with audiences and thrive in the digital economy.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BAC 111",
              title: "Financial Accounting I"
            },

            {
              code: "BCU 113",
              title: "Health and Wellness Management"
            },

            {
              code: "BDM 111",
              title: "Principles of Digital Marketing"
            },

            {
              code: "BDM 112",
              title: "Social Media Marketing"
            },

            {
              code: "BDM 113",
              title: "Affiliate Marketing"
            },

            {
              code: "BCU 111",
              title: "Communication Skills"
            },

            {
              code: "BCU 112",
              title: "Digital Literacy"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BAC 121",
              title: "Financial Accounting II"
            },

            {
              code: "BSD 111",
              title: "Structured Programming and Algorithms"
            },

            {
              code: "ERE 111",
              title: "Introduction to Creative and Critical Thinking"
            },

            {
              code: "BHR 121",
              title: "Human Resource Management"
            },

            {
              code: "BBM 121",
              title: "Principles of Management"
            },

            {
              code: "BPR 121",
              title: "Global Communication"
            },

            {
              code: "BBM 111",
              title: "Foundations of Business"
            }

          ]

        }

      ]

    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BJO 210",
              title: "Fundamentals of Web Analytics"
            },

            {
              code: "BDM 211",
              title: "Agile Online Marketing"
            },

            {
              code: "BDM 212",
              title: "Customer Relationship Marketing"
            },

            {
              code: "BJO 211",
              title: "Digital Media Ethics, Law and Human Rights"
            },

            {
              code: "BDA 212",
              title: "Programming for Data Science (Python and R)"
            },

            {
              code: "BFN 211",
              title: "Business Law"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BBM 213",
              title: "Insurance and Risk Management"
            },

            {
              code: "BDM 221",
              title: "Neuromarketing"
            },

            {
              code: "BPR 220",
              title: "Fundamentals of Public Relations"
            },

            {
              code: "BDM 222",
              title: "Search Engine Advertising"
            },

            {
              code: "BJO 213",
              title: "Interactive Media Design"
            },

            {
              code: "BDM 223",
              title: "Influencer Marketing"
            }

          ]

        }

      ]

    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BCE 312",
              title: "Artificial Intelligence"
            },

            {
              code: "BHR 311",
              title: "Organisational Behavior"
            },

            {
              code: "BMK 311",
              title: "Consumer Behavior"
            },

            {
              code: "BJO 323",
              title: "Digital Graphics and Communication"
            },

            {
              code: "BJO 315",
              title: "Digital Storytelling"
            },

            {
              code: "BMK 321",
              title: "Marketing Research"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BCU 320",
              title: "Research Methods"
            },

            {
              code: "BCT 323",
              title: "Electronic Commerce (E-commerce)"
            },

            {
              code: "BDM 321",
              title: "Mobile Marketing"
            },

            {
              code: "BJO 311",
              title: "Video Production and Editing"
            },

            {
              code: "BAV 311",
              title: "Advertising Messaging and Campaign Design"
            },

            {
              code: "BDM 322",
              title: "Data-Driven Marketing"
            }

          ]

        }

      ]

    },

    {
      year: "Year Four",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "BMK 415",
              title: "Search Engine Optimisation"
            },

            {
              code: "BCU 410",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "BPR 411",
              title: "Strategic Communication"
            },

            {
              code: "BDM 413",
              title: "Diplomacy"
            },

            {
              code: "BAV 420",
              title: "Branding"
            },

            {
              code: "BAV 410",
              title: "Advertising Production"
            }

          ]

        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "BBM 421",
              title: "Professional Ethics and Etiquette"
            },

            {
              code: "BBM 325",
              title: "Strategic Management"
            },

            {
              code: "BDM 421",
              title: "Digital Marketing Analytics & Measurements"
            },

            {
              code: "BCT 423",
              title: "Management Information Systems"
            },

            {
              code: "BCU 400",
              title: "Research Project"
            },

            {
              code: "BCU 401",
              title: "Industrial Attachment"
            }

          ]

        }

      ]

    }

  ],

  faqs: [

    {
      question:
        "How long does the Bachelor of Digital Marketing take?",

      answer:
        "The programme takes 4 Academic Years, structured across 8 Semesters."
    },

    {
      question:
        "What is the mode of study?",

      answer:
        "The programme is delivered through Blended Learning (Physical and Online), combining face-to-face lectures, practical sessions, online learning, workshops, seminars, industry projects, presentations and an industrial attachment."
    },

    {
      question:
        "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question:
        "What are the minimum entry requirements?",

      answer:
        "Applicants must have a KCSE Mean Grade C+ (Plus) or equivalent, with a minimum of Grade C in English or Kiswahili, or a relevant Diploma or equivalent qualification."
    },

    {
      question:
        "What is the Bachelor of Digital Marketing programme about?",

      answer:
        "The programme prepares professionals to build brands, grow businesses and drive customer engagement by combining business knowledge with digital marketing, artificial intelligence, analytics, content creation, e-commerce and data-driven marketing."
    },

    {
      question:
        "Does the programme cover Artificial Intelligence?",

      answer:
        "Yes. Artificial Intelligence is included in the curriculum through the BCE 312 Artificial Intelligence unit, while the programme also incorporates AI and emerging technologies into its broader digital marketing training."
    },

    {
      question:
        "Does the programme teach Search Engine Optimisation and Search Engine Marketing?",

      answer:
        "Yes. Students study Search Engine Advertising in Year Two and Search Engine Optimisation in Year Four, alongside broader digital advertising and online marketing skills."
    },

    {
      question:
        "Does the programme cover social media marketing?",

      answer:
        "Yes. Social Media Marketing is taught in Year One, alongside Affiliate Marketing, Influencer Marketing and other digital audience engagement strategies."
    },

    {
      question:
        "Does the programme include e-commerce training?",

      answer:
        "Yes. Students study Electronic Commerce (E-commerce) as part of the Year Three curriculum."
    },

    {
      question:
        "Does the programme include marketing analytics?",

      answer:
        "Yes. Students study Fundamentals of Web Analytics, Data-Driven Marketing and Digital Marketing Analytics & Measurements, alongside programming and data-related skills."
    },

    {
      question:
        "Does the programme include practical training?",

      answer:
        "Yes. The programme includes practical sessions, projects, case studies, digital campaigns, workshops, seminars, presentations, industry projects and an industrial attachment."
    },

    {
      question:
        "Does the programme include an industrial attachment?",

      answer:
        "Yes. Industrial Attachment is included in Year Four, Semester Two."
    },

    {
      question:
        "Does the programme include a research project?",

      answer:
        "Yes. Students undertake Research Methods in Year Three and complete a Research Project in Year Four, Semester Two."
    },

    {
      question:
        "What career opportunities are available?",

      answer:
        "Graduates can pursue careers as Digital Marketing Managers, Social Media Managers, SEO Specialists, Search Engine Marketing (SEM/PPC) Specialists, Content Marketing and E-commerce Specialists, Digital Content Creators, Brand Managers, Marketing Communications Officers, Web Analytics Specialists and Email Marketing Specialists."
    },

    {
      question:
        "Can I use the skills to start my own business?",

      answer:
        "Yes. The programme includes entrepreneurship and innovation, digital marketing, e-commerce, branding, advertising, content creation and business management skills that can support entrepreneurial ventures."
    },

    {
      question:
        "How much does the Bachelor of Digital Marketing cost?",

      answer:
        "The current tuition fee used for this programme is KES 54,650 per semester. Additional university charges may apply separately."
    }

  ],

  seo: {

    metaTitle:
      "Bachelor of Digital Marketing | Zetech University",

    metaDescription:
      "Study the Bachelor of Digital Marketing at Zetech University and develop practical skills in digital marketing, AI, SEO, social media, e-commerce, analytics, digital advertising, branding and content creation."

  }

},



// {
//     id:25,
//     title:"Bachelor of Arts in Sociology and Technology",
//     code:"BST",
//     school:"School of Education, Arts and Social Sciences",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:54650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

// {
//     id:26,
//     title:"Bachelor of Arts in Political Science with Technology",
//     code:"BPT",
//     school:"School of Education, Arts and Social Sciences",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:54650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

// {
//     id:27,
//     title:"Bachelor of Science in Actuarial Science",
//     code:"BSc AS",
//     school:"School of Business and Economics",
//     category:"Undergraduate",
//     feeType:"Per Semester",
//     fee:60650,
//     duration:8,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

/* ===========================
   DIPLOMA
=========================== */
{
  id: 28,

  slug: "diploma-in-purchasing-and-supply-chain-management",

  title: "Diploma in Purchasing and Supply Chain Management",

  shortTitle: "Diploma in Purchasing & Supply Chain Management",

  code: "DPSM",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Purchasing and Supply Chain Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-purchasing-and-supply-chain-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-purchasing-and-supply-chain-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "",

  heroDescription:
    "Build practical knowledge in procurement, logistics, inventory management, contract administration, warehousing, distribution and supply chain coordination while developing an understanding of how efficient supply chains support organisational performance.",

  overview: `
The Diploma in Purchasing and Supply Chain Management introduces students to the processes and systems that support the efficient movement of goods and services within organizations.

The programme covers procurement, logistics, inventory management, contract administration, warehousing, distribution, and supply chain coordination, providing a practical understanding of how supply chains operate.

Through industry exposure and applied learning, students gain insight into the activities that influence operational efficiency and organisational performance.
`,

  whyStudy: [

    "Study an industry-relevant curriculum covering procurement, logistics, inventory management, contract management, warehousing, and supply chain operations.",

    "Gain practical learning experience through real-world case studies, procurement simulations, and applied supply chain projects.",

    "Learn from experienced faculty with expertise in procurement, logistics, and supply chain management.",

    "Access flexible learning options through both Physical and Online study modes.",

    "Develop career-focused competencies for opportunities in procurement, logistics, warehousing, distribution, and supply chain management."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Supply Chain Officer",

    "Logistics Analyst",

    "Procurement Officer",

    "Supply Management Analyst",

    "New Product Procurement Planner",

    "Strategic Sourcing Manager"

  ],

  skills: [

    "Procurement",

    "Supply Chain Management",

    "Logistics",

    "Inventory Management",

    "Contract Management",

    "Stores Management",

    "Purchasing and Supplies",

    "Operations Management",

    "Supply Chain Coordination",

    "Procurement Law",

    "Project Management",

    "Research Methods"

  ],

  ctaTitle:
    "Ready to Build Your Supply Chain Career?",

  ctaText:
    "Join Zetech University and develop practical knowledge and industry-focused skills in procurement, logistics, purchasing and supply chain management.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "DCU 110",
              title: "Communication Skills"
            },
            {
              code: "DBM 111",
              title: "Principles of Management"
            },
            {
              code: "DHR 112",
              title: "Introduction to Human Resource Management"
            },
            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "DCU 112",
              title: "Digital Literacy"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "DBM 121",
              title: "Introduction to Business"
            },
            {
              code: "DEC 122",
              title: "Introduction to Economics"
            },
            {
              code: "DAC 123",
              title: "Financial Accounting 1"
            },
            {
              code: "DCU 123",
              title: "Health and Wellness"
            },
            {
              code: "DMT 125",
              title: "Introduction to Statistics"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "DCU 211",
              title: "Research Methods"
            },
            {
              code: "DAC 212",
              title: "Financial Accounting II"
            },
            {
              code: "DPS 213",
              title: "Procurement Law"
            },
            {
              code: "DPS 215",
              title: "Principles of Procurement"
            },
            {
              code: "DPS 214",
              title: "Stores Management and Stock Control"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "DAC 222",
              title: "Cost Accounting"
            },
            {
              code: "DPS 221",
              title: "Purchasing and Supplies Strategies"
            },
            {
              code: "DPS 223",
              title: "Operations Management"
            },
            {
              code: "DPS 224",
              title: "Supply Chain Vulnerability"
            },
            {
              code: "DPS 225",
              title: "Project and Contract Management"
            },
            {
              code: "DCU 226",
              title: "Research Project"
            },
            {
              code: "DCU 227",
              title: "Industrial Attachment"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme takes two years (four semesters)."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment as part of the programme to gain practical industry exposure."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Purchasing and Supply Chain Management | Zetech University",

    metaDescription:
      "Study the Diploma in Purchasing and Supply Chain Management at Zetech University and develop practical skills in procurement, logistics, inventory management, purchasing, warehousing and supply chain operations."

  }

},
{
  id: 29,

  slug: "diploma-in-human-resource-management",

  title: "Diploma in Human Resource Management",

  shortTitle: "Diploma in Human Resource Management",

  code: "DHRM",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Human Resource Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-human-resource-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-human-resource-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Shaping Productive Workplaces",

  heroDescription:
    "Build practical knowledge and professional competence in managing people and workplace processes while developing the skills required to support workforce effectiveness, organisational productivity and long-term success.",

  overview: `
The Diploma in Human Resource Management is structured to build practical knowledge and professional competence in managing people and workplace processes within modern organizations.

The programme covers recruitment and selection, training and development, employee relations, performance management, compensation and benefits, labor laws, and personnel administration, offering insight into the key functions that support workforce effectiveness.

It provides a strong foundation for understanding how human capital contributes to organisational performance, productivity, and long-term success.
`,

  whyStudy: [

    "Gain hands-on knowledge in recruitment, training, performance management, employee relations, and workplace administration.",

    "Build expertise in talent management, labor laws, industrial relations, counseling, and strategic human resource management.",

    "Develop the skills needed to manage people, promote positive workplace culture, and support organisational growth.",

    "Strengthen practical skills through research projects and industrial attachment that prepare you for professional HR roles.",

    "Graduate ready for careers in human resource management, recruitment, training and development, administration, employee relations, and HR consulting.",

    "Study in a supportive learning environment that promotes leadership, professionalism, innovation, and career growth."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "HR Consultant",

    "Human Resources Manager",

    "Training & Development Officer",

    "HR Entrepreneur",

    "Team Building Consultant",

    "Administration Manager"

  ],

  skills: [

    "Human Resource Management",

    "Recruitment and Selection",

    "Employee Sourcing",

    "Training and Development",

    "Performance Management",

    "Reward Management",

    "Employee Relations",

    "Industrial Relations",

    "Industrial Psychology",

    "Workplace Counseling",

    "Labor Economics",

    "Strategic Human Resource Management",

    "Personnel Administration",

    "Research Methods"

  ],

  ctaTitle:
    "Ready to Shape Productive Workplaces?",

  ctaText:
    "Join Zetech University and develop the practical knowledge, professional competence and people-management skills required to build effective workplaces and support organisational growth.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "DCU 110",
              title: "Communication Skills"
            },
            {
              code: "DBM 111",
              title: "Principles of Management"
            },
            {
              code: "DHR 112",
              title: "Introduction to Human Resource Management"
            },
            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "DCU 112",
              title: "Digital Literacy"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "DBM 121",
              title: "Introduction to Business"
            },
            {
              code: "DEC 122",
              title: "Introduction to Economics"
            },
            {
              code: "DAC 123",
              title: "Financial Accounting 1"
            },
            {
              code: "DCU 123",
              title: "Health and Wellness"
            },
            {
              code: "DMT 125",
              title: "Introduction to Statistics"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "DCU 211",
              title: "Research Methods"
            },
            {
              code: "DHR 213",
              title: "Employees Sourcing"
            },
            {
              code: "DCM 212",
              title: "Principles of Public Relations"
            },
            {
              code: "DHR 215",
              title: "Industrial Psychology"
            },
            {
              code: "DEC 212",
              title: "Labor Economics"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "DHR 221",
              title: "Employees Training and Development"
            },
            {
              code: "DHR 223",
              title: "Counseling in the Workplace"
            },
            {
              code: "DHR 222",
              title: "Performance aand Reward Management"
            },
            {
              code: "DHR 225",
              title: "Industrial Relations"
            },
            {
              code: "DHR 224",
              title: "Strategic Human Resource Management"
            },
            {
              code: "DCU 226",
              title: "Research Project"
            },
            {
              code: "DCU 227",
              title: "Industrial Attachment"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme takes two years (four semesters)."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment as part of the programme to gain practical industry exposure."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Human Resource Management | Zetech University",

    metaDescription:
      "Study the Diploma in Human Resource Management at Zetech University and develop practical skills in recruitment, training, employee relations, performance management, counseling and strategic human resource management."

  }

},
{
  id: 30,

  slug: "diploma-in-accounting-and-finance",

  title: "Diploma in Accounting and Finance",

  shortTitle: "Diploma in Accounting & Finance",

  code: "DAF",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Accounting and Finance",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-accounting-and-finance.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-accounting-and-finance-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Account Accurately. Manage Finances Effectively.",

  heroDescription:
    "Build practical competence in accounting and finance through training in financial accounting, management accounting, taxation, auditing, financial reporting, budgeting and financial management.",

  overview: `
The Diploma in Accounting and Finance introduces learners to the financial principles, systems, and practices that support effective business operations.

The programme covers financial accounting, management accounting, taxation, auditing, budgeting, financial reporting, and business finance, examining how financial information is recorded, analysed, and applied within organizations.

Students develop a practical foundation in accounting and finance while strengthening their ability to support financial management functions across diverse sectors.

Through applied learning, research, and industrial attachment, learners gain practical exposure that prepares them for accounting and finance roles in modern organizations.
`,

  whyStudy: [

    "Gain practical knowledge in financial accounting, taxation, auditing, financial reporting and financial management.",

    "Develop skills in analysing and applying financial information within business and organisational settings.",

    "Build competence in budgeting, management accounting and financial decision-making.",

    "Gain practical learning experience through hands-on training, case studies and real-world financial applications.",

    "Learn from faculty with academic and industry expertise in accounting and finance.",

    "Develop career-ready competencies for opportunities across the public, private and non-profit sectors.",

    "Strengthen professional skills through research and industrial attachment."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Accountant",

    "Accounts Manager",

    "Company Secretary",

    "Assistant Tax Manager",

    "Taxation Manager"

  ],

  skills: [

    "Financial Accounting",

    "Management Accounting",

    "Taxation",

    "Auditing",

    "Financial Reporting",

    "Budgeting",

    "Financial Management",

    "Business Finance",

    "Financial Analysis",

    "Accounting Systems",

    "Research",

    "Financial Decision-Making"

  ],

  ctaTitle:
    "Ready to Build Your Career in Accounting and Finance?",

  ctaText:
    "Join Zetech University and develop the practical accounting and financial management skills needed to support effective business operations and build a rewarding career across diverse sectors.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DBM 111",
              title: "Principles of Management"
            },

            {
              code: "DHR 112",
              title: "Introduction to Human Resource Management"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCU 112",
              title: "Digital Literacy"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DBM 121",
              title: "Introduction to Business"
            },

            {
              code: "DEC 122",
              title: "Introduction to Economics"
            },

            {
              code: "DAC 123",
              title: "Financial Accounting I"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DMT 125",
              title: "Introduction to Statistics"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 211",
              title: "Research Methods"
            },

            {
              code: "DAC 212",
              title: "Financial Accounting II"
            },

            {
              code: "DFN 213",
              title: "Business Law"
            },

            {
              code: "DMT 214",
              title: "Business Mathematics"
            },

            {
              code: "DFN 215",
              title: "Principles of Auditing"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DAC 222",
              title: "Cost Accounting"
            },

            {
              code: "DAC 223",
              title: "Managerial Accounting"
            },

            {
              code: "DAC 224",
              title: "Principles of Taxation"
            },

            {
              code: "DFN 221",
              title: "Financial Management"
            },

            {
              code: "DFN 225",
              title: "Financial Institutions and Capital Markets"
            },

            {
              code: "DCU 226",
              title: "Research Project"
            },

            {
              code: "DCU 227",
              title: "Industrial Attachment"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Accounting and Finance take?",

      answer:
        "The programme takes two years, comprising four semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of C- (minus), or a relevant qualification."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment during the second year to gain practical workplace experience."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Accounting and Finance | Zetech University",

    metaDescription:
      "Study the Diploma in Accounting and Finance at Zetech University and develop practical skills in financial accounting, management accounting, taxation, auditing and financial management."

  }

},
{
  id: 31,

  slug: "diploma-in-counselling-psychology",

  title: "Diploma in Counselling Psychology",

  shortTitle: "Diploma in Counselling Psychology",

  code: "DCPY",

  school: "School of Education, Arts and Social Sciences",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Counselling Psychology",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-counselling-psychology.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-counselling-psychology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Listen. Support. Empower.",

  heroDescription:
    "Develop the knowledge, practical skills and ethical competence required to support individuals facing psychological, emotional and social challenges through counselling psychology, mental health, human development and therapeutic practice.",

  overview: `
The Diploma in Counselling Psychology is designed to equip learners with the knowledge, practical skills, and ethical competence required to support individuals facing psychological, emotional, and social challenges.

The programme integrates counselling psychology, human development, mental health, therapeutic communication, and crisis intervention to build a strong foundation for professional counselling practice.

Students develop practical knowledge in counselling processes, counselling theories and techniques, group counselling, trauma counselling, child and adolescent counselling, addiction counselling, family and marriage therapy, and industrial and organisational counselling.

The programme prepares graduates to provide person-centred support across educational, healthcare, community, faith-based, and organisational settings.
`,

  whyStudy: [

    "Develop a strong foundation in counselling psychology, human behavior, mental health, and therapeutic communication to support individuals across diverse settings.",

    "Gain practical counseling skills through experiential learning, supervised practicum, and real-world case studies that prepare you for professional practice.",

    "Learn evidence-based counseling techniques, crisis intervention, trauma support, and family and group therapy to address a wide range of psychological and social challenges.",

    "Build ethical, interpersonal, and communication skills that enable you to foster trust, promote well-being, and provide person-centred support to individuals and communities.",

    "Strengthen research, critical thinking, and problem-solving abilities while exploring contemporary issues in mental health, addiction, human development, and psychological wellness.",

    "Graduate with professional knowledge, practical experience, and ethical competence required to pursue careers in counseling, mental health, education, healthcare, community development, rehabilitation, and social support services, or progress to higher qualifications."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Counseling Psychologist",

    "Counselor",

    "Social Scientist",

    "Wellness Expert",

    "Life Coach",

    "Guidance and Career Counselor",

    "Rehabilitation Counselor",

    "Mental Health Counselor"

  ],

  skills: [

    "Counselling Psychology",

    "Therapeutic Communication",

    "Human Development",

    "Counseling Theories",

    "Counseling Techniques",

    "Group Counseling",

    "Crisis Intervention",

    "Trauma Counseling",

    "Child and Adolescent Counseling",

    "Addiction Counseling",

    "Family and Marriage Therapy",

    "Mental Health Support",

    "Research",

    "Ethical Counseling Practice",

    "Psychological Wellness"

  ],

  ctaTitle:
    "Ready to Make a Difference in People's Lives?",

  ctaText:
    "Join Zetech University and develop the knowledge, practical counseling skills and ethical competence needed to support individuals, families and communities across diverse professional settings.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCP 111",
              title: "Fundamentals to Counselling Psychology"
            },

            {
              code: "DCP 112",
              title: "Human Development and Personality"
            },

            {
              code: "DCU 112",
              title: "Information Communication Technology"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCP 121",
              title: "Cognitive and Social Psychology"
            },

            {
              code: "DCP 122",
              title: "Counseling Process and Supervision"
            },

            {
              code: "DCP 123",
              title: "Counseling Theories and Techniques"
            },

            {
              code: "DCP 124",
              title: "Group Counseling"
            },

            {
              code: "DCP 125",
              title: "Physiological Psychology"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCP 211",
              title: "Counseling for Special Population"
            },

            {
              code: "DCP 212",
              title: "Loss, Grief and Trauma Counseling"
            },

            {
              code: "DCP 213",
              title: "Legal and Ethical Aspects in Counseling"
            },

            {
              code: "DCP 214",
              title: "Child and Adolescent Counseling"
            },

            {
              code: "DCU 211",
              title: "Research Methods"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCP 221",
              title: "Abnormal Psychology and Human Sexuality"
            },

            {
              code: "DCP 222",
              title: "Industrial and Organizational Counseling"
            },

            {
              code: "DCP 223",
              title: "Addiction Counseling"
            },

            {
              code: "DCP 224",
              title: "Family and Marriage Therapy"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCP 225",
              title: "Counseling Practicum"
            },

            {
              code: "DCP 226",
              title: "Research Project"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Counselling Psychology take?",

      answer:
        "The programme takes two years, comprising four semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The programme includes Counseling Practicum, providing learners with practical exposure to counseling practice."
    },

    {
      question: "Does the programme include a research project?",

      answer:
        "Yes. Students undertake a Research Project during the second year."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Counselling Psychology | Zetech University",

    metaDescription:
      "Study the Diploma in Counselling Psychology at Zetech University and develop practical skills in counseling, mental health, human development, therapeutic communication and psychological support."

  }

},
{
  id: 32,

  slug: "diploma-in-project-management",

  title: "Diploma in Project Management",

  shortTitle: "Diploma in Project Management",

  code: "DPM",

  school: "School of Education, Arts and Social Sciences",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Project Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-project-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-project-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Plan Smart. Execute Better.",

  heroDescription:
    "Develop the practical knowledge and skills required to plan, coordinate, and execute projects across diverse sectors while managing resources, risks, budgets, timelines, teams, and stakeholder expectations.",

  overview: `
The Diploma in Project Management provides students with the practical knowledge and skills required to plan, coordinate, and execute projects across diverse sectors.

The programme covers project planning, budgeting, scheduling, risk management, monitoring and evaluation, resource management, procurement, and team leadership.

Students develop the ability to apply project management tools, methodologies, and best practices while addressing project risks, resource requirements, stakeholder expectations, and organisational objectives.

Through research, practical learning, and industrial attachment, the programme prepares graduates to manage projects efficiently and contribute to successful project delivery across different sectors.
`,

  whyStudy: [

    "Develop practical skills in project planning, budgeting, scheduling, implementation, monitoring, and evaluation to successfully manage projects across diverse industries.",

    "Learn to apply industry-recognized project management tools, methodologies, and best practices to deliver projects on time, within budget, and to stakeholder expectations.",

    "Build strong leadership, communication, teamwork, and stakeholder management skills essential for coordinating multidisciplinary project teams.",

    "Gain expertise in project risk management, procurement, resource mobilization, quality assurance, and strategic planning to support organizational success.",

    "Benefit from hands-on learning through research projects, industrial attachment, and real-world case studies that prepare you for today's dynamic project environments.",

    "Graduate with the professional knowledge, problem-solving abilities, and ethical leadership skills required to pursue careers in project management, development organizations, government agencies, NGOs, consulting firms, and the private sector, or progress to higher qualifications."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Business Systems Analyst",

    "Project Manager",

    "Line Manager",

    "Project Assistant",

    "Planning Manager",

    "Consultant"

  ],

  skills: [

    "Project Planning",

    "Project Management",

    "Project Budgeting",

    "Project Scheduling",

    "Project Monitoring and Evaluation",

    "Risk Management",

    "Project Procurement",

    "Resource Mobilization",

    "Project Financing",

    "Strategic Planning",

    "Quality Management",

    "Stakeholder Management",

    "Team Leadership",

    "Research",

    "Project Implementation",

    "Environmental Management"

  ],

  ctaTitle:
    "Ready to Plan and Deliver Successful Projects?",

  ctaText:
    "Join Zetech University and develop the practical project management, leadership, planning, and problem-solving skills required to coordinate projects and deliver meaningful results across diverse sectors.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 112",
              title: "Digital Literacy"
            },

            {
              code: "DPM 111",
              title: "Fundamentals of Project Planning and Management"
            },

            {
              code: "DBM 111",
              title: "Principles of Management"
            },

            {
              code: "DCU 123",
              title: "Health & Wellness"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DPM 121",
              title: "Total Quality Management"
            },

            {
              code: "DMT 125",
              title: "Introduction to Statistics"
            },

            {
              code: "DPM 122",
              title: "Legal Aspects in Project Planning and Management"
            },

            {
              code: "DPM 123",
              title: "Project Procurement Management"
            },

            {
              code: "DPM 211",
              title: "Project Monitoring and Evaluation"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCD 224",
              title: "Disaster Management"
            },

            {
              code: "DPM 213",
              title: "Community Participation in Project Management"
            },

            {
              code: "DPM 214",
              title: "Project Planning, Design and Implementation"
            },

            {
              code: "DCU 211",
              title: "Research Methods"
            },

            {
              code: "DCD 214",
              title: "Resource Mobilization and Fundraising Techniques"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DPM 222",
              title: "Project Financing and Finance Management"
            },

            {
              code: "DPM 223",
              title: "Project Risk Management"
            },

            {
              code: "DPM 224",
              title: "Environmental Management"
            },

            {
              code: "DPM 225",
              title: "Strategic Planning and Management"
            },

            {
              code: "DCU 226",
              title: "Research Project"
            },

            {
              code: "DCU 300",
              title: "Industrial Attachment"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Project Management take?",

      answer:
        "The programme takes two years, comprising four semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-."
    },

    {
      question: "Does the programme include practical project experience?",

      answer:
        "Yes. The programme includes an Industrial Attachment and practical project management learning to help students gain workplace experience."
    },

    {
      question: "Does the programme include a research project?",

      answer:
        "Yes. Students undertake a Research Project during the second year."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Project Management | Zetech University",

    metaDescription:
      "Study the Diploma in Project Management at Zetech University and develop practical skills in project planning, budgeting, procurement, monitoring and evaluation, risk management and project implementation."

  }

},

// {
//     id:33,
//     title:"Diploma in Criminology and Security Studies",
//     code:"DCSC",
//     school:"School of Education, Arts and Social Sciences",
//     category:"Diploma",
//     feeType:"Per Semester",
//     fee:30650,
//     duration:4,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

{
  id: 33,

  slug: "diploma-in-electrical-and-electronics-engineering",

  title: "Diploma in Electrical and Electronics Engineering",

  shortTitle: "Diploma in Electrical & Electronics Engineering",

  code: "DCSC",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Electrical and Electronics Engineering",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-electrical-and-electronics-engineering.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-electrical-and-electronics-engineering-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Engineering Power. Driving Progress",

  heroDescription:
    "Develop practical electrical and electronics engineering skills to design, install, test, maintain and troubleshoot electrical systems while working with renewable energy, automation and modern engineering technologies.",

  overview: `
The Diploma in Electrical and Electronics Engineering equips students with the practical knowledge and technical skills required to plan, install, test, commission, maintain, and repair a wide range of electrical systems.

The programme covers domestic, commercial, industrial, agricultural, and horticultural electrical installations, as well as renewable energy systems, motors, generators, HVAC, integrated building management systems, and security installations.

Students gain hands-on experience in electrical installation, measurement, control, and maintenance using industry-relevant technologies.

The programme prepares graduates to meet the growing demand for skilled electrical and electronics engineering professionals across diverse industries.
`,

  whyStudy: [

    "Gain practical experience in electrical installations, industrial automation, renewable energy systems, and electronics using modern engineering laboratories and workshop facilities.",

    "Learn to install, test, troubleshoot, maintain, and repair electrical and electronic systems used in homes, commercial buildings, industries, and power systems.",

    "Learn from qualified engineering professionals who combine technical knowledge with hands-on guidance to prepare you for the workplace.",

    "Explore emerging technologies including renewable energy, programmable logic controllers (PLCs), microcontrollers, industrial automation, and smart electrical systems that are shaping the future of engineering.",

    "Apply your classroom knowledge through workshop practice, engineering projects, and industrial attachment, building valuable experience before graduation.",

    "Graduate with the technical competence and entrepreneurial skills needed to pursue careers in electrical engineering, industrial maintenance, renewable energy, automation, or establish your own electrical engineering business."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-.",

    "A minimum grade of D- in Mathematics.",

    "A minimum grade of D (Plain) in English."

  ],

  duration: 6,

  durationType: "Semesters",

  durationYears: "3 Years",

  mode: "Physical Classes Only",

  fee: 34650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Controls Engineer",

    "Project Engineer",

    "Test Engineer",

    "Design Engineer",

    "Electrical Engineer"

  ],

  skills: [

    "Electrical Installation",

    "Electrical Engineering",

    "Electronics",

    "Electrical Instrumentation",

    "Renewable Energy",

    "Analogue Electronics",

    "Digital Electronics",

    "Electrical Measurements",

    "Fault Diagnosis",

    "Programmable Logic Controllers (PLCs)",

    "Control Systems",

    "Power Systems",

    "Electrical Machines",

    "Microprocessors",

    "Microcontrollers",

    "Industrial Electronics",

    "Workshop Practice",

    "Engineering Drawing",

    "Computer Aided Design",

    "Project Management"

  ],

  ctaTitle:
    "Ready to Engineer the Future?",

  ctaText:
    "Join Zetech University and develop the practical electrical and electronics engineering skills needed to work with modern power, automation, renewable energy and electrical systems.",

  curriculum: [

    {
      year: "Year One",
      semesters: [

        {
          semester: "Semester One",
          units: [

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 112",
              title: "Digital Literacy"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DEE 100",
              title: "Engineering Mathematics I"
            },

            {
              code: "DEE 101",
              title: "Physical Science"
            },

            {
              code: "DEE 102",
              title: "Mechanical Science"
            },

            {
              code: "DEE 103",
              title: "Engineering Drawing"
            }

          ]
        },

        {
          semester: "Semester Two",
          units: [

            {
              code: "DEE 200",
              title: "Electrical Installation Technology I"
            },

            {
              code: "DEE 201",
              title: "Engineering Mathematics II"
            },

            {
              code: "DEE 202",
              title: "Analogue Electronics I"
            },

            {
              code: "DEE 203",
              title: "Electrical Engineering Principles I"
            },

            {
              code: "DEE 204",
              title: "Renewable Energy and Technologies"
            },

            {
              code: "DEE 205",
              title: "Electrical Instrumentation"
            },

            {
              code: "DEE 206",
              title: "Materials Science and Technology"
            },

            {
              code: "DEE 207",
              title: "WORKSHOP PRACTICE I"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",
      semesters: [

        {
          semester: "Semester One",
          units: [

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DEE 300",
              title: "Computer Aided Design"
            },

            {
              code: "DEE 301",
              title: "Analogue Electronics II"
            },

            {
              code: "DEE 302",
              title: "Engineering Mathematics III"
            },

            {
              code: "DEE 303",
              title: "Electrical Engineering Principles II"
            },

            {
              code: "DEE 304",
              title: "Electrical Installation Technology II"
            },

            {
              code: "DEE 305",
              title: "Digital Electronics I"
            },

            {
              code: "DEE 307",
              title: "Workshop Practice II"
            }

          ]
        },

        {
          semester: "Semester Two",
          units: [

            {
              code: "DEE 400",
              title: "Electromagnetic Fields Theory"
            },

            {
              code: "DEE 401",
              title: "Digital Electronics II"
            },

            {
              code: "DEE 402",
              title: "Engineering Mathematics IV"
            },

            {
              code: "DEE 403",
              title: "Environmental Literacy"
            },

            {
              code: "DEE 404",
              title: "Industrial Programmable Logic Controllers"
            },

            {
              code: "DEE 405",
              title: "Electrical Measurements and Fault Diagnosis"
            },

            {
              code: "DEE 406",
              title: "Workshop Practice III"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",
      semesters: [

        {
          semester: "Semester One",
          units: [

            {
              code: "DEE 500",
              title: "Projects and Contracts Management"
            },

            {
              code: "DEE 501",
              title: "Control Systems I"
            },

            {
              code: "DEE 502",
              title: "Trade Project I (Proposal)"
            },

            {
              code: "DEE 503",
              title: "Electrical Machines I"
            },

            {
              code: "DEE 504",
              title: "Industrial Electronics"
            },

            {
              code: "DEE 505",
              title: "Power Systems I"
            },

            {
              code: "DEE 506",
              title: "Microprocessor Systems"
            },

            {
              code: "DEE 507",
              title: "Workshop Practice IV"
            }

          ]
        },

        {
          semester: "Semester Two",
          units: [

            {
              code: "DEE 600",
              title: "Power System II"
            },

            {
              code: "DEE 601",
              title: "Industrial Organization and Management"
            },

            {
              code: "DEE 602",
              title: "Utilization of Electrical Energy"
            },

            {
              code: "DEE 603",
              title: "Electrical Machines II"
            },

            {
              code: "DEE 604",
              title: "Microcontrollers"
            },

            {
              code: "DEE 605",
              title: "Control Systems II"
            },

            {
              code: "DEE 606",
              title: "Trade Project II"
            },

            {
              code: "DEE 607",
              title: "Workshop Practice V"
            }

          ]
        },

        {
          semester: "Semester Three",
          units: [

            {
              code: "DCU 300",
              title: "Three Months Industrial Attachment"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Electrical and Electronics Engineering take?",
      answer:
        "The programme takes three years and includes practical engineering training and industrial attachment."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through Physical Classes only."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer:
        "Yes. Students undertake a three-month Industrial Attachment during Year Three to gain practical workplace experience."
    },

    {
      question: "What areas of engineering does the programme cover?",
      answer:
        "The programme covers electrical installation, electronics, renewable energy, electrical machines, power systems, control systems, industrial electronics, PLCs, microcontrollers, electrical measurements and fault diagnosis."
    },

    {
      question: "What careers can I pursue after completing the programme?",
      answer:
        "Graduates can pursue careers including Controls Engineer, Project Engineer, Test Engineer, Design Engineer and Electrical Engineer."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Electrical and Electronics Engineering | Zetech University",

    metaDescription:
      "Study the Diploma in Electrical and Electronics Engineering at Zetech University and gain practical skills in electrical installations, electronics, renewable energy, automation, power systems and control systems."

  }

},
{
  id: 59,

  slug: "diploma-in-data-science-and-analytics",

  title: "Diploma in Data Science and Analytics",

  shortTitle: "Diploma in Data Science & Analytics",

  code: "DCSC",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Data Science and Analytics",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-data-science-and-analytics.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-data-science-and-analytics-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Decode Data. Drive the World",

  heroDescription:
    "Develop practical skills in collecting, processing, analysing and interpreting data while building expertise in data science, analytics, programming, databases, machine learning and emerging technologies.",

  overview: `
The Diploma in Data Science and Analytics equips students with practical skills in collecting, processing, analysing, and interpreting data to support informed decision-making.

The programme combines statistics, mathematics, and computer science, covering data analysis, data visualisation, database management, machine learning fundamentals, and data analytics tools.

Students gain hands-on experience in extracting, transforming, loading, and visualising complex data using industry-relevant software and techniques.

The programme prepares graduates to manage data effectively and deliver actionable insights that drive decision-making across organizations.
`,

  whyStudy: [

    "Gain practical experience in collecting, analysing, visualising, and interpreting data using industry-standard tools, programming languages, and modern analytics platforms.",

    "Build expertise in Python programming, database management, machine learning, cloud computing, big data technologies, and data visualisation to solve real-world business challenges.",

    "Learn from knowledgeable faculty who combine academic excellence with practical guidance, preparing you to succeed in today's data-driven industries.",

    "Explore cutting-edge fields such as artificial intelligence, predictive analytics, computer vision, cloud computing, and big data to stay ahead in the rapidly evolving digital economy.",

    "Apply your knowledge through practical projects, research, and industrial attachment, building a professional portfolio and valuable workplace experience before graduation.",

    "Graduate with the analytical, technical, and problem-solving skills required for careers in data analytics, business intelligence, artificial intelligence, and data science, while also gaining the entrepreneurial skills to create innovative data-driven solutions."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of C-.",

    "Minimum grade of D- in Mathematics.",

    "Minimum grade of D- in either English or Kiswahili."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Data Analyst",

    "Data Architect",

    "Statistician",

    "Business Analyst",

    "Data Scientist",

    "Database Administrator",

    "Big Data Expert"

  ],

  skills: [

    "Data Analysis",

    "Data Science",

    "Data Visualisation",

    "Python Programming",

    "Database Management",

    "Data Engineering",

    "Big Data Analytics",

    "Machine Learning",

    "Predictive Analytics",

    "Data Mining",

    "Data Warehousing",

    "Cloud Computing",

    "Artificial Intelligence",

    "Computer Vision",

    "Data Analytics",

    "Programming",

    "Big Data Storage and Processing",

    "Research and Technical Problem Solving"

  ],

  ctaTitle:
    "Ready to Decode Data and Drive the Future?",

  ctaText:
    "Join Zetech University and develop the practical data science, analytics and technology skills needed to transform data into actionable insights and innovative solutions.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DAC 123",
              title: "Financial Accounting I"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DIT 111",
              title: "Computer Applications"
            },

            {
              code: "DIT 112",
              title: "ICT & Ethics"
            },

            {
              code: "DMT 111",
              title: "Basic Mathematics"
            },

            {
              code: "DSE 111",
              title: "Structured Programming"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DIT 122",
              title: "Operating Systems"
            },

            {
              code: "DIT 124",
              title: "Database Systems"
            },

            {
              code: "DMT 125",
              title: "Introduction to Statistics"
            },

            {
              code: "DSA 121",
              title: "Introduction to Data Engineering"
            },

            {
              code: "DSA 122",
              title: "Big Data Analytics"
            },

            {
              code: "DSA 123",
              title: "Computer Vision in Data Science"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCE 211",
              title: "Machine Learning Models"
            },

            {
              code: "DIT 213",
              title: "Data Mining and Warehousing"
            },

            {
              code: "DSA 211",
              title: "Python for Data Science"
            },

            {
              code: "DSA 212",
              title: "Predictive Analytics"
            },

            {
              code: "DSA 213",
              title: "Cloud Computing and Security"
            },

            {
              code: "DSE 222",
              title: "Research Methods in IT (System Proposal)"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DSA 222",
              title: "Programming for Data Science"
            },

            {
              code: "DSA 223",
              title: "Data Analytics and Visualization"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DSE 315",
              title: "Data Science Final Project"
            },

            {
              code: "DSE 313",
              title: "Artificial Intelligence"
            },

            {
              code: "DSA 221",
              title: "Big Data Storage and Processing"
            }

          ]
        },

        {
          semester: "Semester Three",

          units: [

            {
              code: "DCU 300",
              title: "Attachment (8 Weeks)"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The programme is structured as a two-year diploma programme with four semesters of study, followed by an eight-week industrial attachment."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants require a KCSE (or equivalent) minimum aggregate grade of C-, a minimum grade of D- in Mathematics, and D- in either English or Kiswahili."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer:
        "Yes. Students undertake an eight-week industrial attachment to gain practical workplace experience."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The programme covers data analysis, data engineering, big data analytics, database management, machine learning, Python programming, predictive analytics, cloud computing, artificial intelligence, computer vision, data visualisation and data science."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Data Science and Analytics | Zetech University",

    metaDescription:
      "Study the Diploma in Data Science and Analytics at Zetech University and develop practical skills in data analysis, Python, machine learning, big data, artificial intelligence and data visualisation."

  }

},
{
  id: 60,

  slug: "diploma-in-artificial-intelligence-and-cloud-technologies",

  title: "Diploma in Artificial Intelligence and Cloud Technologies",

  shortTitle: "Diploma in Artificial Intelligence & Cloud Technologies",

  code: "DCSC",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Artificial Intelligence and Cloud Technologies",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-artificial-intelligence-and-cloud-technologies.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-artificial-intelligence-and-cloud-technologies-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Create Smarter Solutions.",

  heroDescription:
    "Build practical expertise in artificial intelligence, machine learning, cloud computing and emerging digital technologies while learning to design, deploy and support intelligent cloud-based solutions.",

  overview: `
The Diploma in Artificial Intelligence and Cloud Technologies is designed to provide students with a strong foundation in artificial intelligence, cloud computing, and emerging digital technologies.

The programme covers machine learning, data analytics, AI algorithms, cloud infrastructure, virtualization, and the deployment of intelligent applications using leading cloud platforms such as AWS, Microsoft Azure, and Google Cloud.

Through practical learning and exposure to modern technologies, learners develop the technical competencies required to design, deploy, and support AI-powered and cloud-based solutions across diverse industries.
`,

  whyStudy: [

    "Gain practical experience in artificial intelligence, machine learning, cloud computing, automation, and intelligent systems using industry-leading technologies and platforms.",

    "Develop expertise in AI algorithms, cloud infrastructure, cloud security, big data, robotics, computer vision, and Internet of Things (IoT) technologies that are transforming today's digital world.",

    "Learn from knowledgeable faculty who combine academic excellence with real-world experience, preparing you to solve complex technology challenges with confidence.",

    "Explore cutting-edge technologies including Artificial Intelligence, AWS, Microsoft Azure, Google Cloud, DevOps, robotics, and intelligent automation while building solutions for real-world applications.",

    "Strengthen your practical skills through hands-on projects, AI solution development, cloud deployment, and industrial attachment, giving you valuable experience before graduation.",

    "Graduate with the technical, analytical, and entrepreneurial skills needed to build intelligent applications, manage cloud environments, and support digital transformation initiatives."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of C-.",

    "Minimum grade of D- in Mathematics.",

    "Minimum grade of D- in either English or Kiswahili."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "5 Semesters",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "IT Manager",

    "AI Expert",

    "Technology Officer",

    "System Administrator",

    "Cloud Security Engineer",

    "Data Engineer",

    "IoT Expert",

    "IT Infrastructure Engineer",

    "Automation Engineer"

  ],

  skills: [

    "Artificial Intelligence",

    "Machine Learning",

    "Cloud Computing",

    "Cloud Infrastructure",

    "Cloud Security",

    "AI Algorithms",

    "Big Data",

    "Data Analytics",

    "Computer Vision",

    "Robotics",

    "Internet of Things (IoT)",

    "AWS",

    "Microsoft Azure",

    "Google Cloud",

    "DevOps",

    "Intelligent Automation",

    "Cyber Security",

    "Cloud-Based Data Management",

    "Digital Transformation",

    "AI Solution Development"

  ],

  ctaTitle:
    "Ready to Create Smarter Solutions?",

  ctaText:
    "Join Zetech University and develop the practical artificial intelligence and cloud technology skills needed to build intelligent applications, manage modern cloud environments and drive digital transformation.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DIT 111",
              title: "Computer Applications"
            },

            {
              code: "DIT 112",
              title: "ICT and Ethics"
            },

            {
              code: "DAC 123",
              title: "Introduction to Accounting I"
            },

            {
              code: "DMT 111",
              title: "Basic Mathematics"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DSE 111",
              title: "Structured Programming"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DSA 124",
              title: "Big Data and Database Management"
            },

            {
              code: "DIT 122",
              title: "Operating Systems"
            },

            {
              code: "DCS 122",
              title: "Computer Organization and Architecture"
            },

            {
              code: "DCS 121",
              title: "Electronics"
            },

            {
              code: "DIT 123",
              title: "Computer Networks/ CCNA"
            },

            {
              code: "DMT 121",
              title: "Discrete Mathematics"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCE 211",
              title: "Machine Learning Models"
            },

            {
              code: "DSA 213",
              title: "Cloud Computing and Security"
            },

            {
              code: "DSE 222",
              title: "Research Methods in IT (System Proposal)"
            },

            {
              code: "DCE 212",
              title: "AI and IOT"
            },

            {
              code: "DSD 212",
              title: "Digital Design Thinking"
            },

            {
              code: "DIT 212",
              title: "Routing and Switching (CCNA MOD 2)"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DIT 223",
              title: "Cyber Security (CCNA MOD 3)"
            },

            {
              code: "DCE 225",
              title: "Embeddable Artificial Intelligence"
            },

            {
              code: "DCE 226",
              title: "Cloud and Fog Computing"
            },

            {
              code: "DCE 223",
              title: "Recommender Systems and Applications"
            },

            {
              code: "DIT 224",
              title: "Cloud Based Data Management"
            },

            {
              code: "DCE 224",
              title: "Developer Operations"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DSA 123",
              title: "Computer Vision in Data Science"
            },

            {
              code: "DCE 311",
              title: "Robotics"
            },

            {
              code: "DCT 311",
              title: "Ethics in Artificial Intelligence"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCE 312",
              title: "AI for Digital Transformation"
            },

            {
              code: "DSE 315",
              title: "AI Final Project"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 300",
              title: "Attachment (8 Weeks)"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The programme curriculum is structured across five semesters of coursework, followed by an eight-week industrial attachment."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants require a KCSE (or equivalent examination) minimum aggregate grade of C-, a minimum grade of D- in Mathematics, and D- in either English or Kiswahili."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer:
        "Yes. Students undertake an eight-week industrial attachment to gain practical workplace experience."
    },

    {
      question: "Which cloud technologies are covered?",
      answer:
        "The programme introduces learners to leading cloud technologies and platforms including AWS, Microsoft Azure and Google Cloud, alongside cloud infrastructure, cloud security, cloud-based data management and DevOps."
    },

    {
      question: "What areas of Artificial Intelligence are covered?",
      answer:
        "The programme covers machine learning, AI and IoT, computer vision, robotics, recommender systems, embeddable AI, AI ethics and AI for digital transformation."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Artificial Intelligence and Cloud Technologies | Zetech University",

    metaDescription:
      "Study the Diploma in Artificial Intelligence and Cloud Technologies at Zetech University and develop practical skills in AI, machine learning, cloud computing, robotics, IoT, cybersecurity and intelligent automation."

  }

},
{
  id: 61,

  slug: "diploma-in-cyber-security-and-forensics",

  title: "Diploma in Cyber Security and Forensics",

  shortTitle: "Diploma in Cyber Security & Forensics",

  code: "DCSC",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Cyber Security and Forensics",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-cyber-security-and-forensics.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-cyber-security-and-forensics-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Protect. Detect. Respond.",

  heroDescription:
    "Develop practical expertise in cybersecurity, ethical hacking, digital forensics and incident response to protect digital systems, investigate cyber threats and respond to evolving security challenges.",

  overview: `
The Diploma in Cyber Security and Forensics is designed to equip students with the technical knowledge and practical skills required to safeguard digital systems and investigate cyber threats in an increasingly connected world.

The programme covers network security, ethical hacking, digital forensics, cybercrime investigation, information security management, vulnerability analysis, threat monitoring, and incident response.

Through practical training with industry-standard tools and techniques, learners develop the expertise to detect, prevent, investigate, and respond to modern cybersecurity challenges across diverse sectors.
`,

  whyStudy: [

    "Gain hands-on cybersecurity experience through practical training in ethical hacking, digital forensics, network security, vulnerability assessment, and incident response.",

    "Learn to protect organizations from cyber threats by developing the skills to identify security risks, investigate cyber incidents, secure digital systems, and respond to evolving cyberattacks across different industries.",

    "Study an industry-focused curriculum that combines technical expertise with emerging technologies such as cloud security, artificial intelligence, secure networking, and cybersecurity governance to prepare you for today's digital economy.",

    "Build professional and workplace-ready skills including critical thinking, problem-solving, ethical decision-making, teamwork, communication, and project-based learning that employers value in cybersecurity professionals.",

    "Learn from experienced faculty in a technology-driven environment with modern computer laboratories, practical projects, and industrial attachment opportunities.",

    "Prepare for a rewarding career and future growth with a strong foundation for roles in cybersecurity, digital forensics, cloud security, ethical hacking, and information security."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of C-.",

    "Minimum grade of D- in Mathematics.",

    "Minimum grade of D- in either English or Kiswahili."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Ethical Hacker",

    "Cyber Security Analyst",

    "Cyber Security Engineer",

    "IT Security Expert",

    "Cloud Security Engineer",

    "Database Administrator",

    "Digital Forensics Expert"

  ],

  skills: [

    "Cybersecurity",

    "Ethical Hacking",

    "Digital Forensics",

    "Network Security",

    "Cyber Security Analysis",

    "Cryptography",

    "Cyber Law",

    "Incident Response",

    "Cloud Security",

    "Vulnerability Assessment",

    "Risk Management",

    "Security Governance",

    "Secure Networking",

    "Cybersecurity Essentials",

    "Artificial Intelligence",

    "Database Security",

    "Information Security",

    "Routing and Switching",

    "Threat Detection",

    "Cybercrime Investigation"

  ],

  ctaTitle:
    "Ready to Protect the Digital World?",

  ctaText:
    "Join Zetech University and develop the practical cybersecurity and digital forensics skills needed to protect systems, investigate cyber incidents and respond to emerging digital threats.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DMT 111",
              title: "Basic Mathematics"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DIT 111",
              title: "Computer Applications"
            },

            {
              code: "DAC 123",
              title: "Financial Accounting I"
            },

            {
              code: "DIT 112",
              title: "ICT & Ethics"
            },

            {
              code: "DSE 111",
              title: "Structured Programming"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DIT 123",
              title: "Computer Networks/ CCNA"
            },

            {
              code: "DCF 121",
              title: "Cyber Security Essentials"
            },

            {
              code: "DIT 124",
              title: "Database Systems"
            },

            {
              code: "DIT 211",
              title: "Object Oriented Programming"
            },

            {
              code: "DIT 122",
              title: "Operating Systems"
            },

            {
              code: "DIT 121",
              title: "System Analysis and Design"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DSA 213",
              title: "Cloud Computing and Security"
            },

            {
              code: "DCF 211",
              title: "Cryptography"
            },

            {
              code: "DCF 212",
              title: "Cyber Law"
            },

            {
              code: "DCF 213",
              title: "Incident and Digital Forensics"
            },

            {
              code: "DSE 222",
              title: "Research Methods in IT (System Proposal)"
            },

            {
              code: "DIT 212",
              title: "Routing and Switching (CCNA 2)"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DSE 313",
              title: "Artificial Intelligence"
            },

            {
              code: "DSE 315",
              title: "Computer Systems Project"
            },

            {
              code: "DIT 223",
              title: "Cyber Security (CCNA MOD 3)"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCF 221",
              title: "Ethical Hacking"
            },

            {
              code: "DCF 222",
              title: "Risk Management and Governance"
            }

          ]
        },

        {
          semester: "Semester Three",

          units: [

            {
              code: "DCU 300",
              title: "Attachment (8 Weeks)"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The programme is structured as a two-year diploma programme, with coursework followed by an eight-week industrial attachment."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants require a KCSE (or equivalent examination) minimum aggregate grade of C-, a minimum grade of D- in Mathematics, and D- in either English or Kiswahili."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer:
        "Yes. Students undertake an eight-week industrial attachment to gain practical workplace experience."
    },

    {
      question: "What areas of cybersecurity are covered?",
      answer:
        "The programme covers cybersecurity essentials, network security, cryptography, cyber law, incident response, digital forensics, ethical hacking, cloud security, risk management and security governance."
    },

    {
      question: "Does the programme cover ethical hacking and digital forensics?",
      answer:
        "Yes. Ethical Hacking and Incident and Digital Forensics are included in the curriculum, alongside cybersecurity, cryptography and incident response."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Cyber Security and Forensics | Zetech University",

    metaDescription:
      "Study the Diploma in Cyber Security and Forensics at Zetech University and develop practical skills in cybersecurity, ethical hacking, digital forensics, cryptography, cloud security and incident response."

  }

},
{
  id: 62,

  slug: "diploma-in-economics-and-finance",

  title: "Diploma in Economics and Finance",

  shortTitle: "Diploma in Economics & Finance",

  code: "DCSC",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Economics and Finance",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-economics-and-finance.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-economics-and-finance-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Understanding Markets. Shaping Outcomes.",

  heroDescription:
    "Develop practical knowledge of economics, finance, accounting and financial markets while building the analytical skills required to understand economic trends, evaluate financial performance and support informed decision-making.",

  overview: `
The Diploma in Economics and Finance introduces students to the principles that shape financial systems, markets, and economic decision-making.

The programme combines economics, finance, accounting, statistics, and public finance to provide students with a practical understanding of how economies function and how financial resources are managed.

Students explore economic trends, financial performance, market dynamics, taxation, financial institutions, public finance, econometrics, microfinance and insurance while developing the analytical skills needed to interpret data and support informed decision-making.

The programme prepares graduates for career opportunities in banking, finance, investment, insurance, public policy, economic research and related business environments.
`,

  whyStudy: [

    "Gain knowledge in economics, finance, accounting, taxation, public finance and financial markets.",

    "Develop practical analytical skills through case studies, data analysis, financial modeling and real-world economic applications.",

    "Learn from experienced faculty with expertise in economics, finance and business.",

    "Develop an understanding of financial institutions, capital markets, public finance and fiscal policy.",

    "Build the analytical skills required to interpret economic and financial data and support informed decision-making.",

    "Prepare for career opportunities in banking, finance, investment, insurance, public policy and economic research."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C- (minus).",

    "OR a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Bank and Loan Officer",

    "Financial Analyst",

    "Risk Analyst",

    "Investment Assistant",

    "Economic Research Assistant",

    "Policy Analyst",

    "Financial Accountant",

    "Auditor Assistant",

    "Insurance Underwriter"

  ],

  skills: [

    "Economic Analysis",

    "Financial Analysis",

    "Accounting",

    "Financial Management",

    "Statistics",

    "Econometrics",

    "Financial Modeling",

    "Public Finance",

    "Fiscal Policy",

    "Financial Markets",

    "Risk Analysis",

    "Investment Analysis",

    "Taxation",

    "Research",

    "Data Analysis"

  ],

  ctaTitle:
    "Ready to Understand Markets and Shape Outcomes?",

  ctaText:
    "Join Zetech University and develop the economic, financial and analytical skills required to understand markets, manage financial resources and support informed decision-making across today's business environment.",

  curriculum: [

    {
      year: "Year One",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "DCU 110", title: "Communication Skills" },
            { code: "DBM 111", title: "Principles of Management" },
            { code: "DHR 112", title: "Introduction to Human Resource Management" },
            { code: "DCU 113", title: "Entrepreneurship and Innovation" },
            { code: "DCU 112", title: "Digital Literacy" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "DBM 121", title: "Introduction to Business" },
            { code: "DEC 122", title: "Introduction to Economics" },
            { code: "DAC 123", title: "Financial Accounting 1" },
            { code: "DCU 123", title: "Health and Wellness" },
            { code: "DMT 125", title: "Introduction to Statistics" }
          ]
        }

      ]
    },

    {
      year: "Year Two",
      semesters: [

        {
          semester: "Semester One",
          units: [
            { code: "DCU 211", title: "Research Methods" },
            { code: "DFN 221", title: "Financial Management" },
            { code: "DAC 212", title: "Financial Accounting II" },
            { code: "DEC 213", title: "Mathematics for Economists" },
            { code: "DFN 225", title: "Financial Institutions and Capital Markets" }
          ]
        },

        {
          semester: "Semester Two",
          units: [
            { code: "DEC 221", title: "Fundamentals of Econometrics" },
            { code: "DFN 223", title: "Public Finance and Fiscal Policy" },
            { code: "DEC 222", title: "Development Economics" },
            { code: "DEC 225", title: "Economics of Microfinance and Insurance" },
            { code: "DAC 224", title: "Principles of Taxation" },
            { code: "DCU 226", title: "Research Project" },
            { code: "DCU 227", title: "Industrial Attachment" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The programme takes two years (four semesters)."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of C- (minus), or a relevant qualification."
    },

    {
      question: "Does the programme include industrial attachment?",
      answer:
        "Yes. The curriculum includes an Industrial Attachment in the second year to provide practical workplace experience."
    },

    {
      question: "What careers can I pursue after the programme?",
      answer:
        "Graduates can pursue opportunities such as Bank and Loan Officer, Financial Analyst, Risk Analyst, Investment Assistant, Economic Research Assistant, Policy Analyst, Financial Accountant, Auditor Assistant and Insurance Underwriter."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Economics and Finance | Zetech University",

    metaDescription:
      "Study the Diploma in Economics and Finance at Zetech University and develop practical skills in economics, finance, accounting, financial markets, statistics and economic analysis."
  }

},
{
  id: 63,

  slug: "diploma-in-digital-marketing",

  title: "Diploma in Digital Marketing",

  shortTitle: "Diploma in Digital Marketing",

  code: "DDM",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Digital Marketing",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-digital-marketing.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-digital-marketing-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Grow Online. Drive Results.",

  heroDescription:
    "Develop practical digital marketing skills to plan, execute and manage effective online campaigns while helping businesses build their digital presence, engage customers and drive measurable growth.",

  overview: `
The Diploma in Digital Marketing equips students with practical skills and up-to-date knowledge to plan, implement, and manage effective digital marketing campaigns.

The programme covers content creation, Search Engine Optimisation (SEO), Pay-Per-Click (PPC) advertising, social media marketing, email marketing, digital analytics, and mobile marketing using modern digital platforms.

Students develop the expertise needed to help businesses expand their online presence, engage target audiences, and drive business growth in an increasingly digital economy.

The programme prepares graduates for rewarding careers in digital marketing while addressing the growing demand for skilled professionals in the evolving digital marketplace.
`,

  whyStudy: [

    "Learn how to create and manage effective online marketing campaigns that help businesses grow.",

    "Gain practical experience by working on real digital marketing projects using industry-standard tools and platforms.",

    "Develop skills in social media marketing, SEO, digital advertising, content creation, email marketing, web analytics, and e-commerce.",

    "Learn how to attract customers, increase online visibility, and create engaging digital content that delivers results.",

    "Graduate ready for careers in digital marketing, social media management, content strategy, SEO, digital advertising, and e-commerce.",

    "Strengthen your practical skills through hands-on projects that prepare you for today's fast-changing digital marketplace."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of C- (minus), or a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Digital Media Manager",

    "Pay-Per-Click Manager",

    "SEM/SEO Specialist",

    "Content Strategist",

    "E-commerce Specialist",

    "Supply Chain Analyst",

    "Brand Marketing Expert",

    "Social Media Marketer",

    "Online Marketer"

  ],

  skills: [

    "Digital Marketing",

    "Search Engine Optimisation (SEO)",

    "Search Engine Marketing (SEM)",

    "Pay-Per-Click (PPC) Advertising",

    "Social Media Marketing",

    "Content Creation",

    "Content Strategy",

    "Email Marketing",

    "Digital Advertising",

    "Digital Analytics",

    "Web Analytics",

    "E-Commerce",

    "Mobile Marketing",

    "Online Marketing"

  ],

  ctaTitle:
    "Ready to Grow in the Digital Marketplace?",

  ctaText:
    "Join Zetech University and develop the practical digital marketing skills needed to build online brands, engage audiences and drive business growth in today's digital economy.",

  curriculum: [
    // Curriculum not provided in the source material.
    // Add the official curriculum here when available.
  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Diploma in Digital Marketing takes two years (four semesters)."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of C- (minus), or a relevant qualification."
    },

    {
      question: "What careers can I pursue after the programme?",
      answer:
        "Graduates can pursue careers in digital marketing, social media management, content strategy, SEO, digital advertising, e-commerce, digital media and online marketing."
    },

    {
      question: "Does the programme provide practical learning?",
      answer:
        "Yes. The programme emphasizes practical digital marketing projects and the use of modern digital marketing tools and platforms."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Digital Marketing | Zetech University",

    metaDescription:
      "Study the Diploma in Digital Marketing at Zetech University and develop practical skills in SEO, social media marketing, digital advertising, content creation, analytics and e-commerce."

  }

},
// {
//   id: 33,

//   slug: "diploma-in-business-intelligence-and-analytics",

//   title: "Diploma in Business Intelligence and Analytics",

//   shortTitle: "Diploma in Business Intelligence & Analytics",

//   code: "DBIA",

//   school: "School of Business and Economics",

//   qualification: "DIPLOMA",

//   qualificationTitle:
//     "Diploma in Business Intelligence and Analytics",

//   award: "Diploma",

//   category: "DIPLOMA",

//   level: "Diploma",

//   nqfLevel: "Level 6",

//   featured: false,

//   image: undergraduate,

//   brochure:
//     "/downloads/brochures/diploma-in-business-intelligence-and-analytics.pdf",

//   feeStructure:
//     "/downloads/fees/diploma-in-business-intelligence-and-analytics-fees.pdf",

//   applyLink: "https://sajili.zetech.ac.ke",

//   enquiryEmail: "admissions@zetech.ac.ke",

//   enquiryPhone: phoneNumber,

//   mantra:
//     "Turn Data into Decisions.",

//   heroDescription:
//     "Develop practical business intelligence and analytics skills to collect, analyze, visualise and interpret data while using modern tools to support strategic decision-making in today's data-driven business environment.",

//   overview: `
// This programme prepares learners to harness data for strategic decision-making in today's data-driven business environment.

// It equips students with practical skills in data collection, analysis, visualisation, and interpretation using industry-relevant tools such as Excel, SQL, and Power BI.

// Learners explore core concepts including data warehousing, business intelligence reporting, predictive analytics, and the development of data-driven strategies.

// The programme combines business knowledge with data and analytics skills, preparing learners to support organizations in making informed, data-driven decisions.
// `,

//   whyStudy: [
//     // The source material did not provide the official
//     // "Why Study" content. Add approved programme-specific
//     // statements when available.
//   ],

//   entryRequirements: [
//     // Minimum entry requirements were not provided
//     // in the supplied programme information.
//   ],

//   // Inferred from the four semesters supplied
//   // in the curriculum.
//   duration: 4,

//   durationType: "Semesters",

//   durationYears: "2 Years",

//   // Mode of delivery was not provided.
//   mode: "",

//   fee: 38850,

//   feeType: "tuition fees per semester",

//   intake: [
//     "January",
//     "May",
//     "September"
//   ],

//   careers: [
//     // Career opportunities were not provided
//     // in the supplied programme information.
//   ],

//   skills: [
//     "Business Intelligence",

//     "Data Analytics",

//     "Data Collection",

//     "Data Analysis",

//     "Data Visualisation",

//     "Data Interpretation",

//     "Data Warehousing",

//     "Business Intelligence Reporting",

//     "Predictive Analytics",

//     "Decision Theory",

//     "Data Strategy",

//     "Machine Learning",

//     "Artificial Intelligence",

//     "Cloud Computing",

//     "Data Ethics and Privacy"
//   ],

//   ctaTitle:
//     "Ready to Turn Data into Business Intelligence?",

//   ctaText:
//     "Join Zetech University and develop practical business intelligence and analytics skills to transform data into insights that support smarter strategic decisions.",

//   curriculum: [

//     {
//       year: "Year One",

//       semesters: [

//         {
//           semester: "Semester One",

//           units: [
//             {
//               code: "DCU 110",
//               title: "Communication Skills"
//             },
//             {
//               code: "DCU 112",
//               title: "Digital Literacy"
//             },
//             {
//               code: "DCE 111",
//               title: "Fundamentals of Business Intelligence and Analytics"
//             },
//             {
//               code: "DBM 111",
//               title: "Principles of Management"
//             },
//             {
//               code: "DBM 121",
//               title: "Introduction to Business"
//             }
//           ]
//         },

//         {
//           semester: "Semester Two",

//           units: [
//             {
//               code: "DAC 123",
//               title: "Financial Accounting I"
//             },
//             {
//               code: "DEC 122",
//               title: "Introduction to Economics"
//             },
//             {
//               code: "DMT 125",
//               title: "Introduction to Statistics"
//             },
//             {
//               code: "DIT 124",
//               title: "Database Systems"
//             },
//             {
//               code: "DBT 223",
//               title: "Web Analytics"
//             }
//           ]
//         }

//       ]
//     },

//     {
//       year: "Year Two",

//       semesters: [

//         {
//           semester: "Semester One",

//           units: [
//             {
//               code: "DIT 213",
//               title: "Data Mining and Warehousing"
//             },
//             {
//               code: "DSA 223",
//               title: "Data Analytics and Visualization"
//             },
//             {
//               code: "DSD 211",
//               title: "Decision Theory and Strategy"
//             },
//             {
//               code: "DSA 213",
//               title: "Cloud Computing and Security"
//             },
//             {
//               code: "DCU 211",
//               title: "Research Methods"
//             }
//           ]
//         },

//         {
//           semester: "Semester Two",

//           units: [
//             {
//               code: "DSA 212",
//               title: "Predictive Analytics"
//             },
//             {
//               code: "DCE 211",
//               title: "Machine Learning Models"
//             },
//             {
//               code: "DDM 223",
//               title: "Data Ethics and Privacy"
//             },
//             {
//               code: "DSE 313",
//               title: "Artificial Intelligence"
//             },
//             {
//               code: "DCU 113",
//               title: "Entrepreneurship and Innovation"
//             },
//             {
//               code: "DCU 226",
//               title: "Research Project"
//             },
//             {
//               code: "DCU 227",
//               title: "Industrial Attachment"
//             }
//           ]
//         }

//       ]
//     }

//   ],

//   faqs: [

//     {
//       question: "How long does the programme take?",
//       answer:
//         "The curriculum provided is structured across four semesters, equivalent to two years."
//     },

//     {
//       question: "What is the mode of study?",
//       answer:
//         "The mode of delivery was not specified in the supplied programme information."
//     },

//     {
//       question: "When are the intakes?",
//       answer:
//         "Students are admitted in January, May and September."
//     },

//     {
//       question: "Does the programme include industrial attachment?",
//       answer:
//         "Yes. Industrial Attachment (DCU 227) is included in Year Two Semester Two."
//     },

//     {
//       question: "What areas does the programme cover?",
//       answer:
//         "The programme covers business intelligence, data analytics, data visualisation, databases, data mining and warehousing, predictive analytics, machine learning, artificial intelligence, cloud computing, data ethics and privacy."
//     }

//   ],

//   seo: {

//     metaTitle:
//       "Diploma in Business Intelligence and Analytics | Zetech University",

//     metaDescription:
//       "Study the Diploma in Business Intelligence and Analytics at Zetech University and develop practical skills in data analytics, business intelligence, data visualisation, predictive analytics and data-driven decision-making."

//   }

// },



{
  id: 34,

  slug: "diploma-in-international-relations-and-diplomacy",

  title: "Diploma in International Relations and Diplomacy",

  shortTitle: "Diploma in International Relations & Diplomacy",

  code: "DIRD",

  school: "School of Education, Arts and Social Sciences",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in International Relations and Diplomacy",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-international-relations-and-diplomacy.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-international-relations-and-diplomacy-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Understand Nations. Shape Relations",

  heroDescription:
    "Build a strong foundation in global affairs, foreign policy and diplomatic practice while developing the communication, negotiation and analytical skills required to understand and engage with an interconnected world.",

  overview: `
The Diploma in International Relations and Diplomacy provides a strong foundation in global affairs, foreign policy, and diplomatic practice.

The programme covers international law, global governance, peace and conflict studies, diplomatic protocol, and international relations while developing communication, negotiation, and analytical skills.

Students explore contemporary global issues, international development, regional integration, peace and security, and international organizations while gaining practical exposure to diplomatic and international relations practices.

Graduates are prepared for entry-level opportunities in diplomacy, government, international organizations, NGOs, humanitarian agencies, and related fields, as well as progression to higher studies.
`,

  whyStudy: [

    "Build a solid foundation in international relations, diplomacy, foreign policy, and global governance to understand today's interconnected world.",

    "Develop practical skills in negotiation, conflict resolution, cross-cultural communication, and diplomatic protocol for success in international and public affairs.",

    "Explore contemporary global issues, international law, peace and security, regional integration, and international development through industry-relevant learning.",

    "Strengthen analytical, research, and critical thinking skills to evaluate global challenges and develop informed policy and diplomatic solutions.",

    "Benefit from practical learning through research projects, French language training, and exposure to real-world diplomatic and international relations practices.",

    "Graduate with the knowledge, professional skills, and confidence to pursue careers in diplomacy, government, international organizations, NGOs, humanitarian agencies, and multinational institutions, or progress to higher studies."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Diplomat",

    "Intelligence Specialist",

    "Political Analyst",

    "Communications Specialist in NGOs"

  ],

  skills: [

    "International Relations",

    "Diplomacy",

    "Foreign Policy",

    "Global Governance",

    "International Law",

    "Negotiation",

    "Conflict Resolution",

    "Mediation",

    "Diplomatic Protocol",

    "Cross-Cultural Communication",

    "Political Analysis",

    "International Development",

    "Peace and Security",

    "Research and Analysis",

    "French Language",

    "Communication Skills"

  ],

  ctaTitle:
    "Ready to Understand Nations and Shape Relations?",

  ctaText:
    "Join Zetech University and develop the knowledge, analytical skills and professional competence required to engage with diplomacy, international relations and global affairs.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DIRD 111",
              title: "Introduction to International Relations and Diplomacy"
            },

            {
              code: "DIRD 112",
              title: "Culture and International Integration"
            },

            {
              code: "DIRD 113",
              title: "Introduction to Sociology"
            },

            {
              code: "DIRD 114",
              title: "Leadership, Governance, and Society"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 112",
              title: "Digital Literacy"
            },

            {
              code: "DIRD 121",
              title: "Conflicts, Negotiation & Mediation in International Studies"
            },

            {
              code: "DIRD 122",
              title: "Geopolitics and International Development"
            },

            {
              code: "DIRD 123",
              title: "International Organizations and Agencies"
            },

            {
              code: "DIRD 124",
              title: "International Development and Economics"
            },

            {
              code: "DMT 125",
              title: "Introduction to Business Statistics"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 211",
              title: "Research Methods"
            },

            {
              code: "DFR 111",
              title: "French I"
            },

            {
              code: "DIRD 215",
              title: "Development Issues in Africa"
            },

            {
              code: "DIRD 216",
              title: "Foreign Policy Formulation and Diplomacy"
            },

            {
              code: "DIRD 217",
              title: "Gender and International Relations"
            },

            {
              code: "DIRD 218",
              title: "Global Peace and Security"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DFR 112",
              title: "French II"
            },

            {
              code: "DIRD 221",
              title: "Diplomatic Missions and Consular Practice"
            },

            {
              code: "DIRD 222",
              title: "Globalization and Development"
            },

            {
              code: "DIRD 223",
              title: "International Trade, Banking and Finance"
            },

            {
              code: "DIRD 224",
              title: "Introduction to International Law"
            },

            {
              code: "DIRD 225",
              title: "Refugee, Displaced Persons and Development"
            },

            {
              code: "DIRD 226",
              title: "Research Project"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in International Relations and Diplomacy take?",

      answer:
        "The programme takes two years (four semesters)."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-."
    },

    {
      question: "Does the programme include French language training?",

      answer:
        "Yes. The curriculum includes French I and French II."
    },

    {
      question: "What career opportunities are available after the programme?",

      answer:
        "Graduates can pursue entry-level opportunities such as Diplomat, Intelligence Specialist, Political Analyst, and Communications Specialist in NGOs, as well as opportunities in government, international organizations, humanitarian agencies and related fields."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in International Relations and Diplomacy | Zetech University",

    metaDescription:
      "Study the Diploma in International Relations and Diplomacy at Zetech University and develop skills in diplomacy, international relations, foreign policy, global governance, negotiation and international development."

  }

},
{
  id: 35,

  slug: "diploma-in-communication-and-media-studies",

  title: "Diploma in Communication and Media Studies",

  shortTitle: "Diploma in Communication & Media Studies",

  code: "DCMS",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Communication and Media Studies",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-communication-and-media-studies.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-communication-and-media-studies-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Crafting Messages that Matter",

  heroDescription:
    "Build practical skills in journalism, broadcasting, public relations, digital media and strategic communication while learning to create engaging content across multiple media platforms.",

  overview: `
The Diploma in Communication and Media Studies provides students with a strong foundation in journalism, media, and strategic communication.

The programme combines theoretical knowledge with practical training in media writing, public relations, radio and television production, digital media, photography, video editing, advertising, corporate communication, and media ethics.

By integrating creativity with modern media technologies, the programme develops versatile communication professionals capable of creating engaging content and communicating effectively across multiple media platforms.

Students gain practical experience through media projects and hands-on training, preparing them for careers across journalism, broadcasting, public relations, advertising, digital media, content creation, and corporate communication.
`,

  whyStudy: [

    "Learn how to create clear, engaging, and impactful messages for different audiences and media platforms.",

    "Gain practical experience in journalism, broadcasting, public relations, photography, video production, and digital media.",

    "Learn to create content using modern media technologies, digital tools, and industry-standard software.",

    "Develop skills in researching, analysing information, creating compelling stories, and developing communication campaigns.",

    "Graduate ready for careers in journalism, broadcasting, public relations, advertising, digital media, content creation, and corporate communication.",

    "Strengthen practical skills through media projects and hands-on training that prepare you for the workplace."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 5,

  durationType: "Semesters",

  durationYears: "2.5 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "TV Presenter",

    "TV Reporter",

    "TV Producer",

    "TV Camera Operator",

    "PR Practitioner",

    "Media Consultant",

    "Photographer",

    "Video Editor",

    "Radio Producer",

    "Radio Reporter",

    "Radio Editor",

    "Newspaper Reporter",

    "Sub-editor",

    "Newspaper Editor",

    "Book Publisher"

  ],

  skills: [

    "Mass Communication",

    "Journalism",

    "News Writing and Reporting",

    "Public Relations",

    "Advertising",

    "Strategic Communication",

    "Broadcast Journalism",

    "Radio Production",

    "Television Production",

    "Video Production and Editing",

    "Photojournalism",

    "Photography",

    "Digital Media",

    "Data Journalism",

    "Investigative Journalism",

    "Media Research",

    "Media Law and Ethics",

    "Sub-editing",

    "Desktop Publishing",

    "Media House Management",

    "Communication Campaigns",

    "Corporate Communication"

  ],

  ctaTitle:
    "Ready to Craft Messages that Matter?",

  ctaText:
    "Join Zetech University and develop the practical communication, journalism, media production, and digital content skills needed to inform audiences, tell compelling stories, and create meaningful impact.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCM 111",
              title: "Principles of Mass Communication"
            },

            {
              code: "DCM 112",
              title: "English for Journalists"
            },

            {
              code: "DCM 113",
              title: "Media House Management and Regulation"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 112",
              title: "Digital Literacy"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCM 121",
              title: "Media Law and Ethics"
            },

            {
              code: "DCM 122",
              title: "Photojournalism"
            },

            {
              code: "DCM 123",
              title: "News Writing and Reporting"
            },

            {
              code: "DIT 105",
              title: "Desktop Publishing"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCM 211",
              title: "Media Social Context"
            },

            {
              code: "DCM 212",
              title: "Principles of Public Relations"
            },

            {
              code: "DCM 213",
              title: "Principles of Advertising"
            },

            {
              code: "DCM 216",
              title: "Sub-editing"
            },

            {
              code: "DCM 217",
              title: "Video Production and Editing"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCM 221",
              title: "Advertising Messaging and Campaigns"
            },

            {
              code: "DCM 225",
              title: "Communication Research"
            },

            {
              code: "DCM 223",
              title: "Strategic Public Relations"
            },

            {
              code: "DCM 224",
              title: "Broadcast Journalism"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCM 310",
              title: "Media Project"
            },

            {
              code: "DCM 316",
              title: "Investigative Journalism"
            },

            {
              code: "DCM 312",
              title: "Studio Technical Operations"
            },

            {
              code: "DCM 317",
              title: "Data Journalism"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question:
        "How long does the Diploma in Communication and Media Studies take?",

      answer:
        "The programme takes five semesters, equivalent to approximately two and a half years."
    },

    {
      question:
        "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question:
        "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question:
        "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-."
    },

    {
      question:
        "What areas does the programme cover?",

      answer:
        "The programme covers journalism, media writing, public relations, radio and television production, digital media, photography, video editing, advertising, corporate communication, media ethics, and communication research."
    },

    {
      question:
        "What career opportunities are available after the programme?",

      answer:
        "Graduates can pursue careers as TV presenters, reporters, producers, camera operators, PR practitioners, media consultants, photographers, video editors, radio producers, newspaper reporters, sub-editors, editors, and book publishers."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Communication and Media Studies | Zetech University",

    metaDescription:
      "Study the Diploma in Communication and Media Studies at Zetech University and develop practical skills in journalism, broadcasting, public relations, digital media, photography, video production, advertising and strategic communication."

  }

},
{
  id: 36,

  slug: "diploma-in-film-and-television-production",

  title: "Diploma in Film and Television Production",

  shortTitle: "Diploma in Film & Television Production",

  code: "DFT",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Film and Television Production",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-film-and-television-production.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-film-and-television-production-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Turning Ideas into Cinematic Impact",

  heroDescription:
    "Develop the creative, technical and production skills required to bring compelling visual stories to life through film, television and digital media.",

  overview: `
The Diploma in Film and Television Production is designed to equip students with the creative, technical, and production skills required to bring compelling visual stories to life.

The programme covers scriptwriting, directing, cinematography, lighting, sound design, video editing, post-production, media ethics, and visual storytelling, providing a comprehensive understanding of the film and television production process.

Through practical training and the use of industry-standard equipment and software, learners develop the expertise to produce professional content for film, television, and digital media platforms.

Students gain hands-on experience through documentaries, commercials, music videos, short films, and class productions while developing a professional portfolio and entrepreneurial skills.
`,

  whyStudy: [

    "Learn by creating real film and television productions using modern studios, industry-standard equipment, and professional editing software.",

    "Develop practical skills in scriptwriting, directing, cinematography, sound production, video editing, and digital content creation that meet the needs of today's creative industry.",

    "Learn from dedicated faculty with industry knowledge who guide you through every stage of your creative and professional journey.",

    "Build the confidence to launch your own production company, create digital content, or work as a freelance filmmaker while developing entrepreneurial skills.",

    "Work on documentaries, commercials, music videos, short films, and class productions that help you build a strong professional portfolio before graduation.",

    "Study in a supportive university environment that combines practical training, digital technologies, and industry-focused learning to prepare you for careers in film, television, broadcasting, and digital media."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 5,

  durationType: "Semesters",

  durationYears: "2.5 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Film/Video Editor",

    "Lighting Technician",

    "Music Producer",

    "Film Director",

    "Television/Film/Video Producer",

    "Broadcast Engineer",

    "Broadcast Journalist",

    "Photographer",

    "Sound Engineer",

    "Special Effects Technician",

    "Television Camera Operator"

  ],

  skills: [

    "Film Production",

    "Television Production",

    "Screenplay Writing",

    "Directing",

    "Cinematography",

    "Lighting Design",

    "Sound Design and Production",

    "Video Editing",

    "Post-Production",

    "Film Marketing and Distribution",

    "Documentary Production",

    "Commercial Production",

    "Music Video Production",

    "Audio Production",

    "Special Effects",

    "Acting for the Screen",

    "Make-up and Costume Design",

    "Film Representation",

    "Visual Storytelling",

    "Production Management",

    "Digital Content Creation"

  ],

  ctaTitle:
    "Ready to Turn Your Ideas into Cinematic Impact?",

  ctaText:
    "Join Zetech University and develop the creative, technical and production expertise needed to create compelling films, television programmes and digital media content.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DFT 110",
              title: "Theatre and Film Development"
            },

            {
              code: "DFT 114",
              title: "Introduction to Film"
            },

            {
              code: "DFT 113",
              title: "Screenplay Writing"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 112",
              title: "Digital Literacy"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DFT 121",
              title: "Sound Design and Production"
            },

            {
              code: "DFT 122",
              title: "Lighting Design for Film and Television"
            },

            {
              code: "DFT 123",
              title: "Directing"
            },

            {
              code: "DFT 125",
              title: "Cinematography"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DFT 216",
              title: "Editing for Film and Television"
            },

            {
              code: "DFT 212",
              title: "Local Scouting and Design"
            },

            {
              code: "DFT 217",
              title: "Special Topics in Film"
            },

            {
              code: "DFT 214",
              title: "Acting for the Screen"
            },

            {
              code: "DFT 218",
              title: "Make-up and Costume Design"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DFT 221",
              title: "Special Effects for Film"
            },

            {
              code: "DFT 226",
              title: "Production of Commercials"
            },

            {
              code: "DFT 227",
              title: "Film and Society"
            },

            {
              code: "DFT 228",
              title: "Class Production"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DFT 310",
              title: "Film Project"
            },

            {
              code: "DFT 311",
              title: "Music Video and Audio Production"
            },

            {
              code: "DFT 312",
              title: "Film Marketing and Distribution"
            },

            {
              code: "DFT 313",
              title: "Documentary Film Production"
            },

            {
              code: "DFT 314",
              title: "Film Representation"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question:
        "How long does the Diploma in Film and Television Production take?",

      answer:
        "The programme takes five semesters, equivalent to approximately two and a half years."
    },

    {
      question:
        "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question:
        "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question:
        "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE (or equivalent examination) certificate with a minimum aggregate grade of C-."
    },

    {
      question:
        "What areas does the programme cover?",

      answer:
        "The programme covers screenplay writing, directing, cinematography, lighting, sound production, film and television editing, special effects, documentary production, commercial production, music video production, film marketing and distribution, and visual storytelling."
    },

    {
      question:
        "What career opportunities are available after the programme?",

      answer:
        "Graduates can pursue careers as film and video editors, lighting technicians, music producers, film directors, television and video producers, broadcast engineers, broadcast journalists, photographers, sound engineers, special effects technicians, and television camera operators."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Film and Television Production | Zetech University",

    metaDescription:
      "Study the Diploma in Film and Television Production at Zetech University and develop practical skills in filmmaking, directing, cinematography, sound production, video editing, special effects, documentary production and digital media."

  }

},
{
  id: 37,

  slug: "diploma-in-hospitality-management",

  title: "Diploma in Hospitality Management",

  shortTitle: "Diploma in Hospitality Management",

  code: "DHM",

  school: "School of Education, Arts and Social Sciences",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Hospitality Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-hospitality-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-hospitality-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Elevate Service. Inspire Hospitality",

  heroDescription:
    "Develop the practical knowledge, technical skills and professional competence required to thrive in the hospitality industry through training in hotel operations, food and beverage management, front office services, housekeeping, event management and customer experience.",

  overview: `
The Diploma in Hospitality Management is designed to equip learners with the practical knowledge, technical skills, and professional competence required to thrive in the hospitality industry.

The programme covers hotel operations, food and beverage management, front office services, housekeeping, event management, hospitality marketing, service quality and customer experience while integrating practical industry exposure.

Students develop hands-on competencies in food and beverage production and service, front office operations, housekeeping, hospitality law, hospitality marketing, food and beverage control, service quality, and hospitality operations.

Through practical training, field attachment and industry-focused learning, graduates develop the professional confidence, entrepreneurial mindset and technical skills required to support hospitality operations and deliver quality guest experiences.
`,

  whyStudy: [

    "Develop practical hospitality management skills through hands-on training in hotel operations, food and beverage service, front office management, housekeeping, and event coordination.",

    "Gain industry-relevant experience using modern hospitality technologies and best practices to deliver exceptional customer service and guest experiences.",

    "Learn from experienced hospitality professionals in a career-focused environment that emphasizes professionalism, leadership, teamwork, and service excellence.",

    "Build competencies in hospitality operations, marketing, quality assurance, and business management to prepare for leadership roles across the hospitality and tourism industry.",

    "Benefit from industrial attachment opportunities that provide real-world exposure and strengthen your employability in hotels, resorts, restaurants, and related establishments.",

    "Graduate with the practical knowledge, entrepreneurial mindset, and professional confidence required to excel in hospitality management or establish your own hospitality enterprise."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 5,

  durationType: "Semesters",

  durationYears: "2.5 Years",

  mode: "Physical & Online",

  fee: 44850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Accommodation Manager",

    "Fast Food Restaurant Manager",

    "Hotel Manager",

    "Public House Manager",

    "Restaurant Manager",

    "Sommelier",

    "Customer Service Officer",

    "Event & Conference Organiser"

  ],

  skills: [

    "Hospitality Management",

    "Hotel Operations",

    "Food and Beverage Production",

    "Food and Beverage Service",

    "Front Office Operations",

    "Housekeeping Operations",

    "Food and Beverage Control",

    "Hospitality Marketing",

    "Hospitality Law",

    "Service Quality Management",

    "Food Science and Nutrition",

    "Event Management",

    "Customer Service",

    "French Language",

    "Hospitality Entrepreneurship"

  ],

  ctaTitle:
    "Ready to Elevate Your Hospitality Career?",

  ctaText:
    "Join Zetech University and develop the practical skills, professional confidence and industry experience required to deliver exceptional hospitality experiences and manage modern hospitality operations.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DCU 112",
              title: "Information Communication Technology & Ethics"
            },

            {
              code: "DHM 111",
              title: "Food and Beverage Production Theory"
            },

            {
              code: "HTM 111",
              title: "Fundamentals of Hospitality and Tourism Management"
            },

            {
              code: "DHM 113",
              title: "Food and Beverage Production Practical"
            },

            {
              code: "DFR 111",
              title: "French Language 1"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 113",
              title: "Entrepreneurship"
            },

            {
              code: "DHM 121",
              title: "Food and Beverage Service Theory"
            },

            {
              code: "DHM 122",
              title: "Front Office Operations"
            },

            {
              code: "DHM 124",
              title: "Food and Beverage Service Practical"
            },

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DFR 121",
              title: "French Language II"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DHM 212",
              title: "Housekeeping Operations"
            },

            {
              code: "DHM 215",
              title: "Food and Beverage Control"
            },

            {
              code: "DHM 216",
              title: "Hospitality Law"
            },

            {
              code: "HTM 211",
              title: "Marketing for Hospitality and Tourism"
            },

            {
              code: "DHM 218",
              title: "Food & Beverage Production Management Practical"
            },

            {
              code: "DFR 211",
              title: "French Language III"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 211",
              title: "Research Methods"
            },

            {
              code: "DHM 221",
              title: "Wine and Bar Operations"
            },

            {
              code: "DHM 222",
              title: "Food and Beverage Service Management"
            },

            {
              code: "DHM 223",
              title: "Food Science and Nutrition"
            },

            {
              code: "DFR 221",
              title: "French Language IV"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DHR 112",
              title: "Human Resource Management"
            },

            {
              code: "DAC 123",
              title: "Accounting for Hospitality and Tourism"
            },

            {
              code: "DHM 311",
              title: "Trade Project"
            },

            {
              code: "DHM 312",
              title: "Service Quality"
            },

            {
              code: "DHM 313",
              title: "Mixology Practice"
            },

            {
              code: "DHM 314",
              title: "Housekeeping & Laundry Operations Practicals"
            },

            {
              code: "DCU 300",
              title: "Field Attachment"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Hospitality Management take?",

      answer:
        "The programme takes five semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE or equivalent examination certificate with a minimum aggregate grade of C-."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The curriculum includes practical training in food and beverage production, food and beverage service, housekeeping, mixology and other hospitality operations."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Field Attachment as part of the programme to gain practical industry exposure."
    },

    {
      question: "What career opportunities are available after graduation?",

      answer:
        "Graduates can pursue careers such as Accommodation Manager, Hotel Manager, Restaurant Manager, Customer Service Officer, Event and Conference Organiser, Fast Food Restaurant Manager, Public House Manager and Sommelier."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Hospitality Management | Zetech University",

    metaDescription:
      "Study the Diploma in Hospitality Management at Zetech University and gain practical skills in hotel operations, food and beverage management, front office services, housekeeping, hospitality marketing and service quality."
  }

},
{
  id: 38,

  slug: "diploma-in-tourism-management",

  title: "Diploma in Tourism Management",

  shortTitle: "Diploma in Tourism Management",

  code: "DTM",

  school: "School of Education, Arts and Social Sciences",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Tourism Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-tourism-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-tourism-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Explore More. Inspire Adventure",

  heroDescription:
    "Develop the knowledge, practical skills and professional competencies required to thrive in the tourism and travel industry through training in travel operations, tour guiding, destination management, tourism marketing, sustainable tourism and tourism product development.",

  overview: `
The Diploma in Tourism Management is designed to equip learners with the knowledge, practical skills, and professional competencies required to thrive in the tourism and travel industry.

The programme covers travel and tour operations, destination management, tourism marketing, sustainable tourism, customer service, airline booking systems, tour guiding, and holiday package planning to provide a solid foundation in tourism management.

Students develop practical knowledge of tourism products and services while exploring sustainable tourism, travel operations, tourism geography, community wildlife and destination development.

Through practical learning and industrial attachment, graduates gain the professional experience, communication skills and entrepreneurial mindset required to support the development, promotion and management of tourism products and services across diverse tourism settings.
`,

  whyStudy: [

    "Gain practical skills in travel operations, tour guiding, destination management, and tourism planning through an industry-focused curriculum.",

    "Learn to use modern tourism technologies, airline reservation systems, and customer service practices to enhance visitor experiences.",

    "Develop expertise in sustainable tourism, tourism marketing, and tourism product development to support the growth of local and international destinations.",

    "Benefit from hands-on learning and industrial attachment opportunities that provide real-world experience within the tourism and hospitality industry.",

    "Build strong communication, intercultural, and leadership skills required to work confidently with diverse clients, stakeholders, and tourism professionals.",

    "Graduate with the professional knowledge, practical experience, and entrepreneurial mindset needed to excel in travel agencies, tour companies, tourism organizations, or establish your own tourism enterprise."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Tour Manager",

    "Tourism Consultant",

    "Tourism Officer",

    "Tourism Information Center Manager",

    "Travel Agency Manager",

    "Archives Officer"

  ],

  skills: [

    "Tourism Management",

    "Travel Operations",

    "Tour Guiding",

    "Destination Management",

    "Tourism Planning",

    "Sustainable Tourism",

    "Tourism Marketing",

    "Tourism Product Development",

    "Airline Booking Systems",

    "Airfares and Ticketing",

    "Customer Care",

    "Tourism Project Management",

    "Community Wildlife Management",

    "French Language",

    "Tourism Research"

  ],

  ctaTitle:
    "Ready to Explore a Career in Tourism?",

  ctaText:
    "Join Zetech University and develop the practical skills, industry knowledge and professional confidence required to manage tourism experiences, develop destinations and create opportunities within the global tourism industry.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DCU 112",
              title: "ICT & Ethics"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DFR 111",
              title: "French I"
            },

            {
              code: "HTM 111",
              title: "Fundamentals of Hospitality and Tourism"
            },

            {
              code: "DTM 118",
              title: "Airline Booking System"
            },

            {
              code: "DTM 116",
              title: "Attractions and Facilities"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 123",
              title: "Health and Wellness"
            },

            {
              code: "DTM 121",
              title: "Natural History of Flora and Fauna"
            },

            {
              code: "DTM 122",
              title: "Managing Sustainable Tourism"
            },

            {
              code: "DTM 124",
              title: "Geography of East Africa"
            },

            {
              code: "DTM 125",
              title: "Travel Operations & Customer Care"
            },

            {
              code: "DFR 121",
              title: "French II"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DFR 211",
              title: "French III"
            },

            {
              code: "DAC 123",
              title: "Introduction to Accounting"
            },

            {
              code: "DTM 215",
              title: "Tourism Product Development"
            },

            {
              code: "DCU 211",
              title: "Research Methods"
            },

            {
              code: "DTM 214",
              title: "Legal Aspects of Tourism"
            },

            {
              code: "HTM 211",
              title: "Marketing for Hospitality and Tourism"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DFR 221",
              title: "French IV"
            },

            {
              code: "DTM 226",
              title: "Tour Guiding and Techniques"
            },

            {
              code: "DTM 222",
              title: "Tourism Project Management"
            },

            {
              code: "DTM 224",
              title: "Airfares and Ticketing"
            },

            {
              code: "DTM 223",
              title: "Community Wildlife"
            },

            {
              code: "DTM 225",
              title: "Research Project"
            },

            {
              code: "DTM 300",
              title: "Industrial Attachment"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Tourism Management take?",

      answer:
        "The programme takes four semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE or equivalent examination certificate with a minimum aggregate grade of C-."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake Industrial Attachment as part of the programme to gain practical experience within the tourism and hospitality industry."
    },

    {
      question: "Does the programme include French language training?",

      answer:
        "Yes. The programme includes French I, French II, French III and French IV."
    },

    {
      question: "What career opportunities are available after graduation?",

      answer:
        "Graduates can pursue careers such as Tour Manager, Tourism Consultant, Tourism Officer, Tourism Information Center Manager, Travel Agency Manager and Archives Officer."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Tourism Management | Zetech University",

    metaDescription:
      "Study the Diploma in Tourism Management at Zetech University and gain practical skills in travel operations, tour guiding, destination management, sustainable tourism, tourism marketing and tourism product development."

  }

},
{
  id: 39,

  slug: "diploma-in-information-technology",

  title: "Diploma in Information Technology",

  shortTitle: "Diploma in Information Technology",

  code: "DIT",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Information Technology",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-information-technology.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Technology Skills for a Smarter Future",

  heroDescription:
    "Build a strong foundation in computing and Information and Communication Technology through practical training in programming, networking, database systems, web development, operating systems, cybersecurity and IT support.",

  overview: `
The Diploma in Information Technology is designed to provide students with a solid foundation in computing and Information and Communication Technology (ICT).

The programme covers essential areas including programming, networking, database systems, web development, operating systems, cybersecurity, computer systems and IT support, combining theoretical knowledge with practical application.

Students gain exposure to modern technologies and industry-relevant tools while developing the technical competencies required to install, maintain, troubleshoot and manage IT systems across diverse organisational environments.

Through practical projects, research, web development, programming, networking and industrial attachment, learners develop the problem-solving and technical skills required to support technology-driven organizations and pursue careers in the ICT industry.
`,

  whyStudy: [

    "Learn the practical skills needed to install, manage, and support modern computer systems and networks.",

    "Gain real-world experience by working on practical projects using industry-standard tools and technologies.",

    "Build expertise in programming, networking, databases, web development, cybersecurity, and IT support.",

    "Be taught by experienced lecturers who combine quality teaching with practical industry knowledge.",

    "Develop the technical and problem-solving skills needed to support organizations in today's technology-driven world.",

    "Learn how to use your IT skills to start a business or provide technology solutions to clients while strengthening your career readiness through practical projects and industrial attachment."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-.",

    "A minimum grade of D- in Mathematics.",

    "A minimum grade of D- in either English or Kiswahili."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "IT Manager",

    "System Analyst",

    "IT Infrastructure Engineer",

    "Network Consultant",

    "Computer Support Engineer",

    "Software Engineer",

    "Web Developer"

  ],

  skills: [

    "Computer Applications",

    "Information Technology",

    "Programming",

    "Object-Oriented Programming",

    "Software Engineering",

    "Database Systems",

    "Computer Networks",

    "Routing and Switching",

    "Web Development",

    "Operating Systems",

    "Cybersecurity",

    "Computer Support and Maintenance",

    "System Analysis and Design",

    "Artificial Intelligence",

    "Desktop Publishing",

    "IT Project Management"

  ],

  ctaTitle:
    "Ready to Build Your Future in Technology?",

  ctaText:
    "Join Zetech University and develop practical computing, programming, networking and IT support skills that can help you build a career in today's technology-driven world.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DIT 111",
              title: "Computer Applications"
            },

            {
              code: "DIT 112",
              title: "ICT and Ethics"
            },

            {
              code: "DAC 123",
              title: "Introduction to Accounting I"
            },

            {
              code: "DMT 111",
              title: "Basic Mathematics"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DIT 105",
              title: "Desktop Publishing"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DIT 121",
              title: "System Analysis and Design"
            },

            {
              code: "DIT 122",
              title: "Operating Systems"
            },

            {
              code: "DSE 111",
              title: "Structured Programming"
            },

            {
              code: "DIT 124",
              title: "Database Systems"
            },

            {
              code: "DCS 121",
              title: "Electronics"
            },

            {
              code: "DIT 123",
              title: "Computer Networks / CCNA"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DIT 211",
              title: "Object Oriented Programming"
            },

            {
              code: "DIT 212",
              title: "Routing and Switching (CCNA 2)"
            },

            {
              code: "DSE 211",
              title: "Software Engineering"
            },

            {
              code: "DSE 222",
              title: "Research Methods in IT (System Proposal)"
            },

            {
              code: "DSE 213",
              title: "Web Development I"
            },

            {
              code: "DSE 313",
              title: "Artificial Intelligence"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DIT 221",
              title: "Object Oriented Programming II"
            },

            {
              code: "DIT 222",
              title: "Principles of Computer Support and Maintenance"
            },

            {
              code: "DIT 223",
              title: "Cyber Security (CCNA MOD 3)"
            },

            {
              code: "DSE 223",
              title: "Web Development II"
            },

            {
              code: "DSE 315",
              title: "Computer Systems Project"
            }

          ]
        },

        {
          semester: "Semester Three",

          units: [

            {
              code: "DCU 300",
              title: "Attachment (8 Weeks)"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Information Technology take?",

      answer:
        "The programme is listed as four semesters in the programme details."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE or equivalent qualification with a minimum aggregate grade of C-, a minimum grade of D- in Mathematics, and D- in either English or Kiswahili."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The programme includes practical work in programming, networking, database systems, web development, computer support, cybersecurity and computer systems projects."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. The supplied curriculum includes an eight-week attachment under Year Two Semester Three."
    },

    {
      question: "What career opportunities are available after graduation?",

      answer:
        "Graduates can pursue careers such as IT Manager, System Analyst, IT Infrastructure Engineer, Network Consultant, Computer Support Engineer, Software Engineer and Web Developer."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Information Technology | Zetech University",

    metaDescription:
      "Study the Diploma in Information Technology at Zetech University and develop practical skills in programming, networking, database systems, web development, cybersecurity, operating systems and IT support."

  }

},
{
  id: 40,

  slug: "diploma-in-computer-science",

  title: "Diploma in Computer Science",

  shortTitle: "Diploma in Computer Science",

  code: "DCS",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Computer Science",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-computer-science.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-computer-science-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Advancing Expertise in a Digital World",

  heroDescription:
    "Build a strong foundation in computing, programming and software development while gaining practical skills in computer systems, databases, networking, cybersecurity and emerging technologies.",

  overview: `
The Diploma in Computer Science is designed to provide students with a solid foundation in computing, programming, and software development.

The programme covers core areas such as computer architecture, data structures, algorithms, programming languages, database systems, operating systems, computer networks, and software engineering.

Combining theoretical knowledge with practical application, the curriculum enables learners to design, develop, test, document, and deploy computer systems while exploring emerging technologies shaping the future of computing.

Through practical projects and industrial attachment, students develop the technical, analytical and problem-solving skills required to create innovative computing solutions and contribute effectively to today's digital economy.
`,

  whyStudy: [

    "Learn the fundamentals of programming, software development, computer systems, and computational problem-solving.",

    "Gain practical experience by building software, managing computer systems, and working on real-world technology projects.",

    "Build expertise in programming, databases, networking, cybersecurity, software engineering, and computer architecture.",

    "Develop the ability to analyze problems and create innovative computing solutions for real-world challenges.",

    "Strengthen practical skills through computing projects and industrial attachment that prepare you for the workplace.",

    "Graduate ready for careers in software development, systems administration, networking, IoT, database management, and technical support."

  ],

  entryRequirements: [

    "KCSE (or equivalent) with a minimum aggregate grade of C- (Minus).",

    "A minimum grade of D- in Mathematics.",

    "A minimum grade of D- in either English or Kiswahili."

  ],

  duration: 5,

  durationType: "Semesters",

  durationYears: "5 Semesters",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Systems Engineer",

    "IoT Developer",

    "Hardware Engineer",

    "Project Leader",

    "System Administrator",

    "Database Administrator"

  ],

  skills: [

    "Computer Programming",

    "Object-Oriented Programming",

    "Software Development",

    "Web Development",

    "Database Management",

    "Computer Networking",

    "Network Design and Administration",

    "Cybersecurity",

    "Computer Systems",

    "Operating Systems",

    "Software Engineering",

    "Systems Analysis and Design",

    "Distributed Systems",

    "Computer Architecture",

    "IT Support",

    "Artificial Intelligence",

    "Problem Solving"

  ],

  ctaTitle:
    "Ready to Advance Your Computing Expertise?",

  ctaText:
    "Join Zetech University and develop the programming, software development, networking, cybersecurity and computer systems skills needed to build innovative solutions in today's digital world.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DIT 111",
              title: "Computer Applications"
            },

            {
              code: "DIT 112",
              title: "ICT and Ethics"
            },

            {
              code: "DAC 123",
              title: "Introduction to Accounting I"
            },

            {
              code: "DMT 111",
              title: "Basic Mathematics"
            },

            {
              code: "DCU 110",
              title: "Communication Skills"
            },

            {
              code: "DSE 111",
              title: "Structured Programming"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DIT 121",
              title: "System Analysis and Design"
            },

            {
              code: "DIT 122",
              title: "Operating Systems"
            },

            {
              code: "DIT 123",
              title: "Computer Networks / CCNA"
            },

            {
              code: "DCS 122",
              title: "Computer Organization and Architecture"
            },

            {
              code: "DCS 121",
              title: "Electronics"
            },

            {
              code: "DIT 124",
              title: "Database Systems"
            }

          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DIT 211",
              title: "Object Oriented Programming"
            },

            {
              code: "DSE 213",
              title: "Web Development I"
            },

            {
              code: "DMT 211",
              title: "Probability and Statistics"
            },

            {
              code: "DSE 121",
              title: "Discrete Mathematics"
            },

            {
              code: "DCS 211",
              title: "Programming with Net Framework"
            },

            {
              code: "DIT 212",
              title: "Routing and Switching (CCNA MOD 2)"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DSE 211",
              title: "Software Engineering"
            },

            {
              code: "DIT 221",
              title: "Object Oriented Programming II"
            },

            {
              code: "DMT 221",
              title: "Calculus"
            },

            {
              code: "DIT 223",
              title: "Cyber Security (CCNA MOD 3)"
            },

            {
              code: "DSE 222",
              title: "Research Methods in IT (System Proposal)"
            },

            {
              code: "DCS 221",
              title: "Distributed Systems"
            }

          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [

            {
              code: "DSE 223",
              title: "Web Development II"
            },

            {
              code: "DCS 311",
              title: "Network Design and Administration"
            },

            {
              code: "DBT 211",
              title: "Management Information Systems (MIS)"
            },

            {
              code: "DCU 113",
              title: "Entrepreneurship and Innovation"
            },

            {
              code: "DSE 315",
              title: "Computer Systems Project"
            },

            {
              code: "DCS 312",
              title: "Computer Security"
            }

          ]
        },

        {
          semester: "Semester Two",

          units: [

            {
              code: "DCU 300",
              title: "Attachment (8 Weeks)"
            }

          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Computer Science take?",

      answer:
        "The programme is structured to take five academic semesters, followed by an industrial attachment component."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The Diploma in Computer Science is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE (or equivalent) minimum aggregate grade of C- (Minus), a minimum grade of D- in Mathematics, and a minimum grade of D- in either English or Kiswahili."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students undertake an eight-week industrial attachment to gain practical workplace experience."
    },

    {
      question: "What careers can I pursue after completing the programme?",

      answer:
        "Graduates can pursue opportunities in systems engineering, IoT development, hardware engineering, project leadership, systems administration and database administration, among other computing-related fields."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Computer Science | Zetech University",

    metaDescription:
      "Study the Diploma in Computer Science at Zetech University and develop practical skills in programming, software development, databases, networking, cybersecurity, computer systems and emerging technologies."

  }

},
{
  id: 41,

  slug: "diploma-in-software-engineering",

  title: "Diploma in Software Engineering",

  shortTitle: "Diploma in Software Engineering",

  code: "DSE",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Software Engineering",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  nqfLevel: "Level 6",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-software-engineering.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-software-engineering-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Smart Coding, Shape the Future",

  heroDescription:
    "The Diploma in Software Engineering is designed to provide students with a solid foundation in software design, development, and maintenance. The programme covers programming, software development methodologies, database systems, user interface design, mobile and web application development, project planning, and version control, equipping learners with the technical competencies to build, test, deploy, and manage modern software solutions.",

  overview: `
The Diploma in Software Engineering is designed to provide students with a solid foundation in software design, development, and maintenance.

The programme covers programming, software development methodologies, database systems, user interface design, mobile and web application development, project planning, and version control.

Students develop the technical competencies required to build, test, deploy, and manage modern software solutions while gaining practical experience through projects and industrial attachment.
`,

  whyStudy: [

    "Gain practical skills to design, develop, test, and maintain software for real-world applications.",

    "Build websites, mobile apps, and software solutions through practical projects that reflect industry practice.",

    "Learn programming, web development, mobile application development, cloud computing, artificial intelligence, and cybersecurity.",

    "Learn how to analyze user needs and create secure, reliable, and user-friendly software solutions.",

    "Strengthen your skills through practical projects and industrial attachment that prepare you for the workplace.",

    "Graduate ready for careers in software development, mobile app development, web development, software testing, DevOps, and IT support."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-.",

    "A minimum of D- in Mathematics.",

    "Either English or Kiswahili D."

  ],

  duration: 5,

  durationType: "Semesters",

  durationYears: "2.5 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "System Administrators",

    "Mobile Application Developers",

    "Web Master",

    "Software Engineer",

    "DevOps Engineer",

    "Software Tester",

    "Network Programmer",

    "Full Stack Developer",

    "Information Systems Auditor"

  ],

  skills: [

    "Software Development",

    "Programming",

    "Web Development",

    "Mobile Application Development",

    "Database Systems",

    "Object-Oriented Programming",

    "Software Engineering",

    "Cloud Computing",

    "Artificial Intelligence",

    "Cybersecurity",

    "Data Structures & Algorithms",

    "DevOps",

    "Software Testing",

    "Human Computer Interaction"

  ],

  ctaTitle:
    "Ready to Build the Future with Software?",

  ctaText:
    "Join Zetech University and develop the programming, software development and problem-solving skills required to build modern digital solutions and pursue a career in the technology industry.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DAC 123", title: "Financial Accounting I" },
            { code: "DCU 110", title: "Communication Skills" },
            { code: "DIT 111", title: "Computer Applications" },
            { code: "DIT 112", title: "ICT & Ethics" },
            { code: "DMT 111", title: "Basic Mathematics" },
            { code: "DSE 111", title: "Structured Programming" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DIT 121", title: "System Analysis and Design" },
            { code: "DIT 122", title: "Operating Systems" },
            { code: "DIT 123", title: "Computer Networks/ CCNA" },
            { code: "DIT 211", title: "Object Oriented Programming" },
            { code: "DMT 121", title: "Discrete Mathematics" }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DCS 211", title: "Programming Desktop Applications" },
            { code: "DIT 124", title: "Database Systems" },
            { code: "DIT 212", title: "Routing and Switching (Ccna 2)" },
            { code: "DSE 211", title: "Software Engineering" },
            { code: "DMT 211", title: "Probability and Statistics" },
            { code: "DSE 212", title: "Data Science" },
            { code: "DSE 213", title: "Web Development" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DCS 221", title: "Distributed Systems" },
            { code: "DIT 221", title: "Object Oriented Programming II" },
            { code: "DIT 223", title: "Cyber Security (CCNA MOD 3)" },
            { code: "DSE 221", title: "Human Computer Interaction" },
            { code: "DSE 222", title: "Research Methods in IT (System Proposal)" },
            { code: "DSE 223", title: "Web Development II" }
          ]
        }

      ]
    },

    {
      year: "Year Three",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DCU 113", title: "Entrepreneurship and Innovation" },
            { code: "DSE 311", title: "Mobile Programming" },
            { code: "DSE 312", title: "Cloud Computing" },
            { code: "DSE 313", title: "Artificial Intelligence" },
            { code: "DSE 314", title: "Data Structures & Algorithms" },
            { code: "DSE 315", title: "Computer Systems Project" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DCU 300", title: "Attachment (8 Weeks)" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Software Engineering take?",

      answer:
        "The programme takes 5 semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should hold a KCSE or equivalent certificate with a minimum aggregate of C-, a minimum of D- in Mathematics, and either English or Kiswahili D."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students complete an attachment of 8 weeks during the final semester."
    },

    {
      question: "What careers can I pursue after completing the programme?",

      answer:
        "Graduates can pursue careers including System Administrator, Mobile Application Developer, Web Master, Software Engineer, DevOps Engineer, Software Tester, Network Programmer, Full Stack Developer, and Information Systems Auditor."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Software Engineering | Zetech University",

    metaDescription:
      "Study the Diploma in Software Engineering at Zetech University and develop practical skills in programming, software development, web and mobile applications, cloud computing, AI, cybersecurity and modern software technologies."

  }

},
{
  id: 42,

  slug: "diploma-in-business-information-technology",

  title: "Diploma in Business Information Technology",

  shortTitle: "Diploma in Business Information Technology",

  code: "DBIT",

  school: "School of ICT, Media and Engineering",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Business Information Technology",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-business-information-technology.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-business-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Intergrate IT. Excel in Business",

  heroDescription:
    "The Diploma in Business Information Technology integrates core business management principles with essential information technology skills. The programme equips learners with knowledge in computer applications, programming, database management, systems analysis, e-commerce, and IT project management. It prepares learners to analyze business challenges and develop effective IT-based solutions. Graduates gain the technical, analytical, and communication skills needed to meet the evolving demands of the dynamic business environment.",

  overview: `
The Diploma in Business Information Technology integrates core business management principles with essential information technology skills.

The programme equips learners with knowledge in computer applications, programming, database management, systems analysis, e-commerce, and IT project management.

It prepares learners to analyse business challenges and develop effective IT-based solutions. Graduates gain the technical, analytical, and communication skills needed to meet the evolving demands of the dynamic business environment.
`,

  whyStudy: [

    "Learn how to use technology to solve everyday business challenges and improve organisational performance.",

    "Gain practical skills by developing business systems, websites, databases, and software applications.",

    "Build expertise in programming, networking, cybersecurity, databases, e-commerce, and business information systems.",

    "Develop the technical, business, and communication skills employers look for in today's digital economy.",

    "Strengthen your skills through practical projects and industrial attachment that prepare you for the workplace.",

    "Graduate ready for careers in IT support, web development, software development, business analysis, systems administration, and database management."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of C-.",

    "A minimum of D- in Mathematics.",

    "Either English or Kiswahili D-."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 38850,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "IT Manager",

    "Chief Technology Officer",

    "System Administrators",

    "Cloud Security Engineer",

    "IT Infrastructure Engineer",

    "Business Analyst",

    "Database Administrators",

    "Software Engineer",

    "Web Developer",

    "Business Manager"

  ],

  skills: [

    "Business Information Technology",

    "Computer Applications",

    "Programming",

    "Systems Analysis and Design",

    "Database Management",

    "Web Development",

    "Computer Networking",

    "Cybersecurity",

    "E-Commerce",

    "Business Information Systems",

    "Management Information Systems",

    "Business Computerised Accounting",

    "IT Project Management",

    "Object-Oriented Programming",

    "Business Analysis"

  ],

  ctaTitle:
    "Ready to Integrate IT with Business?",

  ctaText:
    "Join Zetech University and develop the technical, business and analytical skills needed to create technology-driven solutions for today's dynamic business environment.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DIT 111", title: "Computer Application" },
            { code: "DIT 112", title: "ICT and Ethics" },
            { code: "DAC 123", title: "Introduction to Accounting 1" },
            { code: "DCU 110", title: "Communication Skills" },
            { code: "DBM 121", title: "Introduction to Business" },
            { code: "DMT 125", title: "Introduction to Business Statistics" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DIT 121", title: "System Analysis and Design" },
            { code: "DIT 122", title: "Operating Systems" },
            { code: "DSE 111", title: "Structured Programming" },
            { code: "DSE 213", title: "Web Development 1" },
            { code: "DIT 123", title: "Computer Networks/ CCNA" },
            { code: "DEC 122", title: "Micro Economics" },
            { code: "DFN 213", title: "Business Law" }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DIT 211", title: "Object Oriented Programming" },
            { code: "DIT 124", title: "Database Systems" },
            { code: "DSE 223", title: "Web Development" },
            { code: "DSE 222", title: "Research Methods in IT (System Proposal)" },
            { code: "DBT 211", title: "Management Information Systems (MIS)" },
            { code: "DIT 212", title: "Routing and Switching (CCNA MOD 2)" },
            { code: "DBT 212", title: "E-commerce" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DCU 113", title: "Entrepreneurship Skills" },
            { code: "DSE 315", title: "Computer Systems Project" },
            { code: "DBT 402", title: "Business Computerised Accounting" },
            { code: "DIT 223", title: "Cyber Security (CCNA MOD 3)" },
            { code: "DMK 223", title: "Principles of Marketing" },
            { code: "DIT 221", title: "Object Oriented Programming II" }
          ]
        },

        {
          semester: "Semester Three",

          units: [
            { code: "DCU 300", title: "Attachment (8 WEEKS)" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Business Information Technology take?",

      answer:
        "The programme takes 4 semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should hold a KCSE or equivalent examination certificate with a minimum aggregate of C-, a minimum of D- in Mathematics, and either English or Kiswahili D-."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. Students complete an 8-week attachment during the final semester."
    },

    {
      question: "What careers can I pursue after completing the programme?",

      answer:
        "Graduates can pursue careers including IT Manager, Chief Technology Officer, System Administrator, Cloud Security Engineer, IT Infrastructure Engineer, Business Analyst, Database Administrator, Software Engineer, Web Developer, and Business Manager."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Business Information Technology | Zetech University",

    metaDescription:
      "Study the Diploma in Business Information Technology at Zetech University and develop practical skills in programming, databases, networking, cybersecurity, e-commerce, web development and business information systems."

  }

},
{
  id: 43,

  slug: "diploma-in-business-administration-and-management",

  title: "Diploma in Business Management and Administration",

  shortTitle: "Diploma in Business Administration & Management",

  code: "DBMA",

  school: "School of Business and Economics",

  qualification: "DIPLOMA",

  qualificationTitle:
    "Diploma in Business Administration and Management",

  award: "Diploma",

  category: "DIPLOMA",

  level: "Diploma",

  featured: false,

  image: diploma,

  brochure:
    "/downloads/brochures/diploma-in-business-administration-and-management.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-business-administration-and-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Building Competence for Business Success",

  heroDescription:
    "The Diploma in Business Administration and Management offers a practical understanding of how organizations operate and succeed in today's business environment. The programme covers core areas such as management, marketing, finance, human resource management, and entrepreneurship, providing insight into the functions that drive business performance. Students gain exposure to business operations, organisational management, and decision-making processes while strengthening the skills required to support business growth and efficiency.",

  overview: `
The Diploma in Business Administration and Management offers a practical understanding of how organizations operate and succeed in today's business environment.

The programme covers core areas such as management, marketing, finance, human resource management, and entrepreneurship, providing insight into the functions that drive business performance.

Students gain exposure to business operations, organisational management, and decision-making processes while strengthening the skills required to support business growth and efficiency.
`,

  whyStudy: [

    "Industry-Relevant Curriculum covering management, marketing, finance, human resource management, entrepreneurship, and business operations.",

    "Practical Learning Experience through case studies, business simulations, and real-world projects that develop workplace skills.",

    "Experienced Faculty with academic expertise and industry experience in business and management.",

    "Flexible Learning Options with both Physical and Online study modes to accommodate diverse learning needs.",

    "Career-Focused Training that prepares graduates for leadership, administrative, and entrepreneurial roles across various industries."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."

  ],

  duration: 4,

  durationType: "Semesters",

  durationYears: "2 Years",

  mode: "Physical & Online",

  fee: 33650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Human Resource Officer",

    "Marketing Manager",

    "Office Administrator",

    "Accountant",

    "Financial Officer",

    "Operations Officer"

  ],

  skills: [

    "Business Administration",

    "Business Management",

    "Organisational Management",

    "Human Resource Management",

    "Marketing",

    "Financial Management",

    "Entrepreneurship",

    "Business Operations",

    "Business Decision-Making",

    "Procurement",

    "Risk Management",

    "Business Law",

    "Taxation",

    "Business Mathematics",

    "Research"

  ],

  ctaTitle:
    "Ready to Build Your Business Career?",

  ctaText:
    "Join Zetech University and develop the practical business, management and administrative skills needed to support organisational growth, improve business performance and pursue entrepreneurial opportunities.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DCU 110", title: "Communication Skills" },
            { code: "DBM 111", title: "Principles of Management" },
            { code: "DHR 112", title: "Introduction to Human Resource Management" },
            { code: "DCU 113", title: "Entrepreneurship and Innovation" },
            { code: "DCU 112", title: "Digital Literacy" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DBM 121", title: "Introduction to Business" },
            { code: "DEC 122", title: "Introduction to Economics" },
            { code: "DAC 123", title: "Financial Accounting 1" },
            { code: "DCU 123", title: "Health and Wellness" },
            { code: "DMT 125", title: "Introduction to Statistics" }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            { code: "DCU 211", title: "Research Methods" },
            { code: "DAC 212", title: "Financial Accounting II" },
            { code: "DFN 213", title: "Business Law" },
            { code: "DMT 214", title: "Business Mathematics" },
            { code: "DPS 215", title: "Principles of Procurement" }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            { code: "DHR 220", title: "Organization Behavior" },
            { code: "DFN 221", title: "Financial Management" },
            { code: "DBM 222", title: "Insurance and Risk Management" },
            { code: "DMK 223", title: "Principles of Marketing" },
            { code: "DAC 224", title: "Principles of Taxation" },
            { code: "DCU 226", title: "Research Project" },
            { code: "DCU 227", title: "Industrial Attachment" }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the Diploma in Business Administration and Management take?",

      answer:
        "The programme takes 4 semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should hold a KCSE certificate with a minimum aggregate of C- (minus), or a relevant qualification."
    },

    {
      question: "Does the programme include industrial attachment?",

      answer:
        "Yes. The curriculum includes Industrial Attachment during the final semester."
    },

    {
      question: "What career opportunities are available after completing the programme?",

      answer:
        "Graduates can pursue opportunities as Human Resource Officers, Marketing Managers, Office Administrators, Accountants, Financial Officers and Operations Officers."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Business Administration and Management | Zetech University",

    metaDescription:
      "Study the Diploma in Business Administration and Management at Zetech University and develop practical skills in management, marketing, finance, human resource management, entrepreneurship and business operations."

  }

},

/* ===========================
   CERTIFICATE
=========================== */
{
  id: 44,

  slug: "certificate-in-purchasing-and-supply-chain-management",

  title: "Certificate in Purchasing and Supply Chain Management",

  shortTitle: "Certificate in Purchasing & Supply Chain Management",

  code: "CPSM",

  school: "School of Business and Economics",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Purchasing and Supply Chain Management",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: certificate,

  brochure:
    "/downloads/brochures/certificate-in-purchasing-and-supply-chain-management.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-purchasing-and-supply-chain-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Source Smart. Supply Efficiently",

  heroDescription:
    "Build a strong foundation in purchasing, procurement, logistics, inventory management, warehousing and supply chain operations while developing the practical skills needed to support efficient movement of goods, materials and services within organizations.",

  overview: `
The Certificate in Purchasing and Supply Chain Management introduces learners to the fundamentals of procurement, logistics, inventory management, warehousing, transport operations, and supply chain processes.

The programme provides a practical understanding of how goods and services move through organizations while highlighting the role of purchasing and supply functions in supporting operational efficiency.

It offers a strong foundation for entry-level opportunities and progression to higher qualifications in purchasing and supply chain management.
`,

  whyStudy: [

    "Build a solid foundation in purchasing, procurement, inventory management, and supply chain operations through a practical, industry-focused curriculum.",

    "Develop hands-on skills in stores management, stock control, procurement procedures, and public purchasing that prepare you for entry-level roles across diverse industries.",

    "Gain practical knowledge of logistics and supply chain coordination to support efficient movement of goods, materials, and services within organizations.",

    "Learn from experienced faculty in a flexible learning environment with both Physical and Online study options designed to accommodate different learning needs.",

    "Prepare for careers in procurement, logistics, warehousing, inventory control, and supply chain support while building a pathway to diploma and degree studies.",

    "Graduate with workplace-ready competencies in communication, entrepreneurship, digital literacy, and professional ethics that enhance employability in today's dynamic supply chain sector."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of D+ (plus), or a relevant qualification"

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 29050,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Logistics Analyst",

    "Supply Management Analyst",

    "New Product Procurement Planner",

    "Procurement Officer"

  ],

  skills: [

    "Purchasing",

    "Procurement",

    "Supply Chain Management",

    "Logistics",

    "Inventory Management",

    "Stores Management",

    "Stock Control",

    "Public Procurement",

    "Supply Chain Coordination",

    "Transport Operations",

    "Digital Literacy",

    "Entrepreneurship",

    "Professional Ethics"

  ],

  ctaTitle:
    "Ready to Build Your Supply Chain Career?",

  ctaText:
    "Join Zetech University and build practical skills in purchasing, procurement, logistics and supply chain operations while preparing for entry-level opportunities and progression to higher qualifications.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CBM 111",
              title: "Fundamentals of Management"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CCU 113",
              title: "Digital Literacy"
            },
            {
              code: "CHR 111",
              title: "Principles of Human Resource Management"
            },
            {
              code: "CPS 111",
              title: "Introduction to Supply Chain Management"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CAC 121",
              title: "Fundamentals of Accounting"
            },
            {
              code: "CCU 120",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "CPS 121",
              title: "Stores Management and Stock Control"
            },
            {
              code: "CPS 122",
              title: "Principles of Purchasing"
            },
            {
              code: "CPS 123",
              title: "Introduction to Public Procurement"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Purchasing and Supply Chain Management takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of D+ (plus), or a relevant qualification."
    },

    {
      question: "What career opportunities are available after completing the programme?",
      answer:
        "Graduates can pursue entry-level opportunities such as Logistics Analyst, Supply Management Analyst, New Product Procurement Planner, and Procurement Officer."
    },

    {
      question: "Can I progress to higher qualifications after the certificate?",
      answer:
        "Yes. The programme provides a foundation for progression to higher qualifications in purchasing and supply chain management."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Purchasing and Supply Chain Management | Zetech University",

    metaDescription:
      "Study the Certificate in Purchasing and Supply Chain Management at Zetech University and develop practical skills in purchasing, procurement, logistics, inventory management, warehousing and supply chain operations."

  }

},

// {
//     id:45,
//     title:"Certificate in Development Studies",
//     code:"CDS",
//     school:"School of Education, Arts and Social Sciences",
//     category:"Certificate",
//     feeType:"Per Semester",
//     fee:26050,
//     duration:2,
//     durationType:"Semesters",
//     intake:["January","May","September"]
// },

{
  id: 45,

  slug: "certificate-in-digital-marketing",

  title: "Certificate in Digital Marketing",

  shortTitle: "Certificate in Digital Marketing",

  code: "CDS",

  school: "School of Business and Economics",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Digital Marketing",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-digital-marketing.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-digital-marketing-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  feeType: "tuition fees per semester",

  fee: 29050,

  duration: 2,

  durationType: "Per Semester",

  durationYears: null,

  intake: [
    "January",
    "May",
    "September"
  ],

  mantra:
    "Building Brands in the Digital Space",

  heroDescription:
    "Build practical digital marketing skills in social media marketing, content creation, SEO, email marketing, digital advertising, web analytics, and mobile marketing for employment, business, and further studies.",

  overview: `
The Certificate in Digital Marketing introduces learners to the tools, platforms, and techniques used to promote products, services, and brands in the digital space.

The programme covers social media marketing, content creation, search engine optimisation (SEO), email marketing, digital advertising, web analytics, and mobile marketing, providing practical exposure to modern marketing practices.

It offers a solid foundation for individuals seeking to build digital marketing skills for employment, business, or further studies.
`,

  whyStudy: [

    "Learn how to promote brands, products, and services using today's most popular digital marketing platforms and tools.",

    "Gain practical experience by creating digital campaigns, managing social media, and working on real-world marketing projects.",

    "Develop skills in social media marketing, content creation, SEO, email marketing, digital advertising, and web analytics.",

    "Learn how to increase online visibility, engage audiences, and grow brands in today's digital marketplace.",

    "Graduate ready for entry-level roles in digital marketing, social media management, content creation, e-commerce, and digital advertising.",

    "Use your certificate as a pathway to diploma and degree programmes in marketing and related fields.",

    "Study in a modern learning environment that encourages creativity, innovation, and digital excellence."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of D+ (plus), or a relevant qualification"

  ],

  mode: "Both Physical & Online",

  deliveryMode: "Both Physical & Online",

  durationDetails: {

    duration: "2 Semesters",

    modeOfDelivery: "Both Physical & Online",

    intake: "January, May & September intakes"

  },

  careers: [

    "Digital Media Manager",

    "Pay-Per-Click Manager",

    "SEM/SEO Specialist",

    "Content Strategist",

    "E-commerce Specialist",

    "Brand Marketing Expert",

    "Social Media Marketer"

  ],

  careerOpportunities: [

    "Digital Media Manager",

    "Pay-Per-Click Manager",

    "SEM/SEO Specialist",

    "Content Strategist",

    "E-commerce Specialist",

    "Brand Marketing Expert",

    "Social Media Marketer"

  ],

  skills: [

    "Digital Marketing",

    "Social Media Marketing",

    "Content Creation",

    "Search Engine Optimisation (SEO)",

    "Search Engine Marketing (SEM)",

    "Email Marketing",

    "Digital Advertising",

    "Pay-Per-Click Advertising",

    "Web Analytics",

    "Mobile Marketing",

    "Digital Campaign Management",

    "Social Media Management",

    "E-commerce Marketing",

    "Brand Marketing",

    "Online Brand Management",

    "Audience Engagement",

    "Content Strategy",

    "Digital Marketing Analytics"

  ],

  ctaTitle:
    "Ready to Build Your Digital Marketing Career?",

  ctaText:
    "Join Zetech University and develop practical digital marketing skills in social media, content creation, SEO, digital advertising, email marketing, web analytics and e-commerce, with flexible Physical and Online learning options.",

  curriculum: [],

  faqs: [

    {
      question: "How long does the Certificate in Digital Marketing take?",

      answer:
        "The Certificate in Digital Marketing takes 2 semesters to complete."
    },

    {
      question: "What is the mode of delivery?",

      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate of D+ (plus), or a relevant qualification."
    },

    {
      question: "What does the Certificate in Digital Marketing cover?",

      answer:
        "The programme covers social media marketing, content creation, search engine optimisation (SEO), email marketing, digital advertising, web analytics and mobile marketing."
    },

    {
      question: "Will I gain practical digital marketing experience?",

      answer:
        "Yes. The programme provides practical exposure through digital campaign creation, social media management and real-world marketing projects."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Career opportunities include Digital Media Manager, Pay-Per-Click Manager, SEM/SEO Specialist, Content Strategist, E-commerce Specialist, Brand Marketing Expert and Social Media Marketer."
    },

    {
      question: "Can I continue with further studies after the certificate?",

      answer:
        "Yes. The certificate provides a pathway to diploma and degree programmes in marketing and related fields."
    },

    {
      question: "Can I study the programme online?",

      answer:
        "Yes. The programme is offered through both Physical and Online learning."
    },

    {
      question: "Does the programme cover SEO and digital advertising?",

      answer:
        "Yes. Learners develop skills in search engine optimisation (SEO), search engine marketing (SEM), digital advertising and pay-per-click marketing."
    },

    {
      question: "Does the programme cover social media marketing?",

      answer:
        "Yes. Social media marketing and social media management are key areas covered by the programme."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Digital Marketing | Zetech University",

    metaDescription:
      "Study the Certificate in Digital Marketing at Zetech University and develop practical skills in social media marketing, content creation, SEO, email marketing, digital advertising, web analytics, e-commerce and digital brand management."

  }

},


{
  id: 64,

  slug: "certificate-in-film-and-television-production",

  title: "Certificate in Film and Television Production",

  shortTitle: "Certificate in Film & Television Production",

  code: "CFT",

  school: "School of ICT, Media and Engineering",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Film and Television Production",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: "Level 5",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-film-and-television-production.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-film-and-television-production-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Where Stories Come Alive.",

  heroDescription:
    "Develop practical skills in visual storytelling and media production, covering scriptwriting, cinematography, directing, lighting, sound recording, video editing and production planning for film, television and digital media.",

  overview: `
The Certificate in Film and Television Production is designed to introduce learners to the fundamentals of visual storytelling and media production.

The programme covers scriptwriting, camera operation, lighting, sound recording, video editing, production planning, and the creative techniques behind film and television content.

By combining creative expression with practical production skills, the programme provides a solid foundation for learners aspiring to pursue further studies or opportunities in the film, television, and digital media industries.
`,

  whyStudy: [

    "Build a strong foundation in film and media production by learning scriptwriting, cinematography, directing, lighting, sound recording, video editing, and visual storytelling through practical, hands-on training.",

    "Develop creative and technical production skills that enable you to plan, produce, edit, and deliver professional-quality content for film, television, social media, and other digital platforms.",

    "Learn in a creative, industry-focused environment with experienced faculty, practical production projects and modern media equipment.",

    "Strengthen essential workplace skills including creativity, collaboration, communication, problem-solving, project planning, and storytelling.",

    "Gain practical experience for entry-level creative careers in film production, television, digital content creation, photography, video editing, and media production.",

    "Create a pathway for future success by earning a recognized qualification that supports progression to diploma programmes and entrepreneurship."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of D+."

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 29650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Film and Television Producer",

    "Content Creator",

    "Screenplay Writer",

    "Editor",

    "Lighting Technician",

    "Cinematographer (Director of Photography)",

    "Brand Expert",

    "Social Media Marketer"

  ],

  skills: [

    "Scriptwriting",

    "Film Production",

    "Television Production",

    "Cinematography",

    "Directing",

    "Video Editing",

    "Lighting",

    "Sound Recording",

    "Set and Location Design",

    "Make-up and Costume",

    "Visual Storytelling",

    "Production Planning",

    "Digital Content Creation",

    "Creative Collaboration"

  ],

  ctaTitle:
    "Ready to Bring Stories to Life?",

  ctaText:
    "Join Zetech University and develop the creative, technical and production skills needed to tell compelling stories across film, television and today's digital media platforms.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CCU 100",
              title: "Communication Skills"
            },
            {
              code: "CCU 113",
              title: "Digital Literacy"
            },
            {
              code: "CCU 102",
              title: "Health and Wellness Management"
            },
            {
              code: "CFV 111",
              title: "Scripting for Film and Television"
            },
            {
              code: "CFV 112",
              title: "Film Production"
            },
            {
              code: "CFV 113",
              title: "Set and Location Design"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CFV 121",
              title: "Film and Television Editing"
            },
            {
              code: "CFV 122",
              title: "Lighting for Film and Television"
            },
            {
              code: "CFV 123",
              title: "Cinematography"
            },
            {
              code: "CCU 120",
              title: "Entrepreneurship Education"
            },
            {
              code: "CFV 124",
              title: "Make-up and Costume"
            },
            {
              code: "CFV 125",
              title: "Directing"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Film and Television Production takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE or equivalent examination certificate with a minimum aggregate grade of D+."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The programme covers scripting, film production, set and location design, film and television editing, lighting, cinematography, directing, make-up and costume."
    },

    {
      question: "What careers can I pursue after the programme?",
      answer:
        "Graduates can pursue opportunities as film and television producers, content creators, screenplay writers, editors, lighting technicians, cinematographers, brand experts and social media marketers."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Film and Television Production | Zetech University",

    metaDescription:
      "Study the Certificate in Film and Television Production at Zetech University and develop practical skills in scriptwriting, film production, cinematography, editing, lighting and directing."

  }

},
{
  id: 46,

  slug: "certificate-in-electrical-and-electronics-engineering",

  title: "Certificate in Electrical and Electronics Engineering",

  shortTitle: "Certificate in Electrical & Electronics Engineering",

  code: "CEE",

  school: "School of ICT, Media and Engineering",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Electrical and Electronics Engineering",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: "Level 5",

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-electrical-and-electronics-engineering.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-electrical-and-electronics-engineering-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Powering Tomorrow's Engineers.",

  heroDescription:
    "Build foundational knowledge and practical skills in electrical and electronic systems, including electrical installations, electronics, renewable energy, electrical machines, testing and maintenance.",

  overview: `
The Certificate in Electrical and Electronics Engineering is designed to provide learners with the foundational knowledge and practical skills required to work with electrical and electronic systems.

The programme introduces domestic, commercial, industrial, agricultural, and renewable energy installations while covering electrical equipment, motors, generators, testing, maintenance, and basic site operations.

It establishes a strong technical foundation for entry into the electrical engineering field and progression to higher levels of study.
`,

  whyStudy: [

    "Build a strong foundation in electrical engineering by learning electrical installations, electronics, wiring systems, renewable energy technologies, electrical machines, and engineering principles through practical, hands-on training.",

    "Develop technical skills that employers value by gaining the ability to install, test, troubleshoot, maintain, and repair electrical and electronic systems used in residential, commercial, and industrial environments.",

    "Learn in a practical engineering environment with experienced instructors, modern workshops, industry-standard equipment, and project-based learning that prepares you for real-world electrical engineering work.",

    "Strengthen essential professional skills including problem-solving, technical drawing, teamwork, workplace safety, critical thinking, and project management while applying industry standards and best engineering practices.",

    "Gain practical experience for entry-level engineering careers in electrical installation, maintenance, renewable energy, industrial operations, and technical support while building confidence to work across diverse engineering sectors.",

    "Create a pathway for career growth and further studies by earning a recognized qualification that supports progression to diploma programmes, professional certifications, entrepreneurship, and rewarding careers in electrical and electronics engineering."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of D+.",

    "Minimum grade of D- in Mathematics.",

    "Minimum grade of D- in either English or Kiswahili."

  ],

  duration: 3,

  durationType: "Semesters",

  durationYears: "1.5 Years",

  mode: "Physical Classes Only",

  fee: 29650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Controls Engineer",

    "Project Engineer",

    "Test Engineer",

    "Design Engineer",

    "Electrical Engineer"

  ],

  skills: [

    "Electrical Installation",

    "Electrical Principles",

    "Electrical Engineering",

    "Digital Electronics",

    "Analogue Electronics",

    "Micro-electronics",

    "Electrical Machines",

    "Solar Installation Systems",

    "Engineering Drawing",

    "Technical Mathematics",

    "Workshop Practice",

    "Electrical Testing",

    "Electrical Maintenance",

    "Troubleshooting",

    "Project and Contracts Management"

  ],

  ctaTitle:
    "Ready to Power Your Engineering Future?",

  ctaText:
    "Join Zetech University and develop the practical electrical and electronics engineering skills needed to build a strong technical career and progress to higher levels of study.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CCU 100",
              title: "Communication Skills"
            },
            {
              code: "CEE 101",
              title: "Applied Science I"
            },
            {
              code: "CEE 102",
              title: "Electrical Principles I"
            },
            {
              code: "CEE 103",
              title: "Electrical Installation Technology I"
            },
            {
              code: "CEE 104",
              title: "Engineering Drawing"
            },
            {
              code: "CCU 113",
              title: "Digital Literacy"
            },
            {
              code: "CEE 105",
              title: "Basic Mathematics"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CEE 200",
              title: "Digital Electronics"
            },
            {
              code: "CCU 201",
              title: "Health and Wellness Management"
            },
            {
              code: "CEE 202",
              title: "Applied Science II"
            },
            {
              code: "CEE 203",
              title: "Electrical Principles II"
            },
            {
              code: "CEE 204",
              title: "Projects and Contracts Management"
            },
            {
              code: "CEE 205",
              title: "Technical Mathematics I"
            },
            {
              code: "CEE 206",
              title: "Workshop Practice I"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CEE 300",
              title: "Electrical Installation Technology II"
            },
            {
              code: "CEE 301",
              title: "Micro-electronics"
            },
            {
              code: "CEE 302",
              title: "Technical Mathematics II"
            },
            {
              code: "CEE 303",
              title: "Analogue Electronics"
            },
            {
              code: "CEE 304",
              title: "Solar Installation Systems"
            },
            {
              code: "CEE 305",
              title: "Electrical Machines Technology"
            },
            {
              code: "CEE 306",
              title: "Workshop Practice II"
            },
            {
              code: "CEE 307",
              title: "Trade Project"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The curriculum is structured across three semesters."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through Physical Classes only."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE or equivalent examination certificate with a minimum aggregate grade of D+, a minimum grade of D- in Mathematics, and D- in either English or Kiswahili."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The programme covers electrical installation, electrical principles, electronics, engineering drawing, applied science, technical mathematics, solar installation systems, electrical machines, workshop practice and trade projects."
    },

    {
      question: "What careers can I pursue after the programme?",
      answer:
        "Graduates can pursue opportunities in controls, project engineering, testing, design and electrical engineering."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Electrical and Electronics Engineering | Zetech University",

    metaDescription:
      "Study the Certificate in Electrical and Electronics Engineering at Zetech University and develop practical skills in electrical installations, electronics, renewable energy, electrical machines, testing and maintenance."

  }

},
{
  id: 47,

  slug: "certificate-in-cyber-security-and-forensics",

  title: "Certificate in Cyber Security and Forensics",

  shortTitle: "Certificate in Cyber Security & Forensics",

  code: "CCF",

  school: "School of ICT, Media and Engineering",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Cyber Security and Forensics",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-cyber-security-and-forensics.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-cyber-security-and-forensics-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Protect. Detect. Respond.",

  heroDescription:
    "Build foundational skills in cybersecurity and digital investigations, covering network security, ethical hacking, digital forensics, cybercrime investigation, vulnerability assessment, incident response, and data protection.",

  overview: `
The Certificate in Cyber Security and Forensics is designed to introduce learners to the fundamentals of cybersecurity and digital investigations.

The programme explores key areas including network security, ethical hacking, digital forensics, cybercrime investigation, vulnerability assessment, incident response, and data protection.

It provides a solid foundation in safeguarding digital systems while preparing learners for progression to higher qualifications in cybersecurity and related ICT fields.
`,

  whyStudy: [

    "Build a strong foundation in cybersecurity by learning network security, ethical hacking, digital forensics, cyber law, cloud security, and threat monitoring through practical, hands-on training.",

    "Develop essential skills to protect digital systems by learning how to identify security risks, secure computer networks and detect cyber threats.",

    "Learn in a technology-driven environment with experienced faculty, modern computer laboratories and practical projects.",

    "Strengthen professional and workplace skills including critical thinking, problem-solving, ethical decision-making, communication, teamwork, and digital literacy.",

    "Gain practical experience for entry-level IT and cybersecurity roles in technical support, information security, systems administration, network operations, and cyber risk management.",

    "Create a pathway for career growth and further studies by earning a recognized qualification that supports progression to diploma programmes, professional cybersecurity certifications and entrepreneurship."

  ],

  entryRequirements: [

    "KCSE (or equivalent examination) with a minimum aggregate grade of D+.",

    "Minimum grade of D- in Mathematics.",

    "Or a relevant qualification."

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 29650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Cyber Security Analyst",

    "Administrative Assistant",

    "Cyber Security Systems Assistant",

    "IT Security Assistant",

    "Ethical Hacker"

  ],

  skills: [

    "Cybersecurity",

    "Network Security",

    "Ethical Hacking",

    "Digital Forensics",

    "Cyber Law",

    "Cybersecurity Compliance",

    "Cloud Security",

    "Threat Monitoring",

    "Information Security",

    "Vulnerability Assessment",

    "Incident Response",

    "Data Protection",

    "Operating Systems",

    "ICT Ethics",

    "Computer Applications"

  ],

  ctaTitle:
    "Ready to Protect the Digital World?",

  ctaText:
    "Join Zetech University and build the foundational cybersecurity and digital investigation skills needed to protect systems, identify threats and pursue further opportunities in the fast-growing cybersecurity industry.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CMT 111",
              title: "Basic Mathematics"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CIT 111",
              title: "Computer Applications"
            },
            {
              code: "CCF 111",
              title: "Fundamentals of Information Security"
            },
            {
              code: "CIT 112",
              title: "ICT and Ethics"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CCF 123",
              title: "Cloud Computing and Security"
            },
            {
              code: "CCF 124",
              title: "Cyber Law and Compliance"
            },
            {
              code: "CCF 122",
              title: "Ethical Hacking and Penetration Testing"
            },
            {
              code: "CIT 121",
              title: "Introduction to Operating Systems"
            },
            {
              code: "CCF 125",
              title: "Threat Monitoring"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Cyber Security and Forensics takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE or equivalent examination certificate with a minimum aggregate grade of D+ and a minimum grade of D- in Mathematics, or hold a relevant qualification."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The programme covers information security, cloud security, cyber law and compliance, ethical hacking and penetration testing, operating systems, threat monitoring, computer applications and ICT ethics."
    },

    {
      question: "What careers can I pursue after the programme?",
      answer:
        "Graduates can pursue entry-level opportunities such as Cyber Security Analyst, Cyber Security Systems Assistant, IT Security Assistant and Ethical Hacker."
    },

    {
      question: "Can I progress to further studies?",
      answer:
        "Yes. The programme provides a foundation for progression to diploma programmes, professional cybersecurity certifications and further studies in related ICT fields."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Cyber Security and Forensics | Zetech University",

    metaDescription:
      "Study the Certificate in Cyber Security and Forensics at Zetech University and develop practical skills in cybersecurity, ethical hacking, digital forensics, cloud security, cyber law and threat monitoring."

  }

},


{
  id: 65,

  slug: "certificate-in-journalism-and-media-studies",

  title: "Certificate in Journalism and Media Studies",

  shortTitle: "Certificate in Journalism & Media Studies",

  code: "CJMS",

  school: "School of ICT, Media and Engineering",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Journalism and Media Studies",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: certificate,

  brochure:
    "/downloads/brochures/certificate-in-journalism-and-media-studies.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-journalism-and-media-studies-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Where Great Stories Begin",

  heroDescription:
    "Build a strong foundation in journalism, communication, and media practice while developing essential skills in news writing, reporting, photography, public relations, media ethics, and digital communication.",

  overview: `
The Certificate in Journalism and Media Studies is designed to introduce learners to the fundamentals of journalism, communication, and media practice.

The programme explores key areas including news writing and reporting, media ethics, photography, public relations, and digital media literacy, providing a solid foundation in effective communication and storytelling.

It prepares learners with the essential knowledge and skills needed to pursue further studies or begin their journey in the dynamic world of media and communication.
`,

  whyStudy: [

    "Build a strong foundation in journalism and media by learning news writing, reporting, photography, broadcasting, media ethics, and digital communication.",

    "Develop professional communication and storytelling skills that enable you to create engaging content, communicate confidently, and connect effectively with audiences.",

    "Learn in a creative, industry-focused environment with experienced faculty, practical media projects and modern learning resources.",

    "Strengthen essential workplace skills including critical thinking, creativity, teamwork, interviewing, presentation, ethical decision-making, and digital literacy.",

    "Gain practical experience for entry-level media careers in journalism, broadcasting, public relations, digital content creation, photography, and media production while building confidence to work in diverse communication environments.",

    "Create a pathway for future success by earning a recognized qualification that supports progression to diploma programmes, professional development, entrepreneurship, and rewarding careers in journalism, media, and communication."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of D+"

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 29650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Journalist",

    "Camera Technician",

    "News Anchor",

    "Reporter",

    "Editor",

    "Producer"

  ],

  skills: [

    "Journalism",

    "News Writing",

    "News Reporting",

    "Broadcast Production",

    "Photojournalism",

    "Media Ethics",

    "Media Law",

    "Mass Communication",

    "Digital Literacy",

    "Desktop Publishing",

    "Communication Skills",

    "Storytelling",

    "Interviewing",

    "Presentation",

    "Public Relations",

    "Media Production"

  ],

  ctaTitle:
    "Ready to Tell Stories That Matter?",

  ctaText:
    "Join Zetech University and build the journalism, communication, storytelling and digital media skills needed to begin your journey in the dynamic world of media and communication.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CJM 111",
              title: "Introduction to Mass Communication"
            },
            {
              code: "CJM 112",
              title: "English for Beginning Journalists"
            },
            {
              code: "CJM 113",
              title: "Introduction to Media House Management"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CCU 113",
              title: "Digital Literacy"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CIT 124",
              title: "Desktop Publishing"
            },
            {
              code: "CJM 122",
              title: "Introduction to Media Law and Ethics"
            },
            {
              code: "CJM 126",
              title: "Basics of News Writing"
            },
            {
              code: "CJM 124",
              title: "Broadcast Production"
            },
            {
              code: "CJM 125",
              title: "Photojournalism"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Journalism and Media Studies takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should be holders of a KCSE or equivalent examination certificate with a minimum aggregate grade of D+."
    },

    {
      question: "What career opportunities are available?",
      answer:
        "Graduates can pursue opportunities as journalists, camera technicians, news anchors, reporters, editors and producers."
    },

    {
      question: "Can I progress to further studies after completing the certificate?",
      answer:
        "Yes. The certificate provides a pathway for progression to diploma programmes, professional development and further studies in journalism, media and communication."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Journalism and Media Studies | Zetech University",

    metaDescription:
      "Study the Certificate in Journalism and Media Studies at Zetech University and develop practical skills in journalism, news writing, broadcasting, photojournalism, media ethics and digital communication."

  }

},
{
  id: 66,

  slug: "certificate-in-hospitality-and-tourism-management",

  title: "Certificate in Hospitality and Tourism Management",

  shortTitle: "Certificate in Hospitality & Tourism Management",

  code: "CHTM",

  school: "School of Education, Arts and Social Sciences",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Hospitality and Tourism Management",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: certificate,

  brochure:
    "/downloads/brochures/certificate-in-hospitality-and-tourism-management.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-hospitality-and-tourism-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Building Hospitality Professionals",

  heroDescription:
    "Build foundational knowledge and practical skills for entry-level careers in hospitality and tourism, with training in food and beverage service, front office operations, housekeeping, travel and tour operations, customer care, and tourism management.",

  overview: `
The Certificate in Hospitality and Tourism Management provides students with foundational knowledge and practical skills for entry-level careers in the hospitality and tourism industry.

The curriculum covers food and beverage service, front office operations, housekeeping, customer care, travel and tour operations, health and wellness services, service quality management, hotel distribution, crisis management, and destination management.

Students gain an understanding of hospitality operations and the managerial processes involved in travel and tourism businesses.

The programme prepares graduates for employment in the hospitality and tourism sector or progression to higher studies in the field.
`,

  whyStudy: [

    "Learn the essential skills needed to start a successful career in the hospitality and tourism industry.",

    "Gain practical experience in food and beverage service, front office operations, customer care, and travel management.",

    "Learn how to create memorable guest experiences through professional service and effective communication.",

    "Graduate ready for entry-level roles in hotels, restaurants, travel agencies, tour companies, airlines, and event management.",

    "Build practical skills in hotel operations, tourism management, airline booking systems, and customer service that employers value.",

    "Use your certificate as a pathway to diploma and degree programmes in hospitality and tourism management."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of D+"

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 35650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Tour Manager",

    "Tourism Consultant",

    "Tourism Officer",

    "Hotel Manager",

    "Restaurant Manager",

    "Sommelier",

    "Customer Service Officer",

    "Event & Conference Organiser"

  ],

  skills: [

    "Hospitality Management",

    "Tourism Management",

    "Food and Beverage Service",

    "Food Production",

    "Front Office Operations",

    "Customer Care",

    "Travel Operations",

    "Tour Operations",

    "Airline Booking Systems",

    "Hotel Operations",

    "Service Quality Management",

    "Destination Management",

    "Communication Skills",

    "French Language",

    "Computer Applications"

  ],

  ctaTitle:
    "Ready to Build Your Hospitality Career?",

  ctaText:
    "Join Zetech University and develop the practical hospitality and tourism skills needed to create exceptional guest experiences, support tourism operations, and build a rewarding career in the industry.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CCU 113",
              title: "Introduction to Computer Applications"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CHT 111",
              title: "Food and Beverage Production"
            },
            {
              code: "CHT 113",
              title: "Food Production Practical"
            },
            {
              code: "CHT 114",
              title: "Introduction to Tours and Travel Operations"
            },
            {
              code: "CHT 115",
              title: "Fundamentals of Hospitality and Tourism"
            },
            {
              code: "CFR 111",
              title: "French I"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CHT 121",
              title: "Food and Beverage Service Theory"
            },
            {
              code: "CHT 122",
              title: "Introduction to Food and Beverage Control"
            },
            {
              code: "CHT 123",
              title: "Airline Booking System (Amadeus / Galileo)"
            },
            {
              code: "CHT 124",
              title: "Food and Beverage Service Practical"
            },
            {
              code: "CHT 125",
              title: "Attractions and Facilities"
            },
            {
              code: "CFR 112",
              title: "French Language II"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Hospitality and Tourism Management takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should be holders of a KCSE or equivalent examination certificate with a minimum aggregate grade of D+."
    },

    {
      question: "What career opportunities are available?",
      answer:
        "Graduates can pursue opportunities in tourism, hospitality, travel and events, including roles such as Tour Manager, Tourism Officer, Hotel Manager, Restaurant Manager, Customer Service Officer, and Event & Conference Organiser."
    },

    {
      question: "Can I progress to higher qualifications?",
      answer:
        "Yes. The certificate provides a pathway to diploma and degree programmes in hospitality and tourism management."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Hospitality and Tourism Management | Zetech University",

    metaDescription:
      "Study the Certificate in Hospitality and Tourism Management at Zetech University and develop practical skills in hospitality operations, food and beverage service, travel, tourism, customer care and airline booking systems."

  }

},
{
  id: 48,

  slug: "certificate-in-information-technology",

  title: "Certificate in Information Technology",

  shortTitle: "Certificate in Information Technology",

  code: "CIT",

  school: "School of ICT, Media and Engineering",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Information Technology",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: certificate,

  brochure:
    "/downloads/brochures/certificate-in-information-technology.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-information-technology-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Powering the Digital Future",

  heroDescription:
    "Build a strong foundation in computing and digital technologies while developing practical skills in computer applications, programming, hardware, networking, operating systems, databases, and basic IT support.",

  overview: `
The Certificate in Information Technology is designed to provide learners with a strong foundation in computing and digital technologies.

The programme introduces essential concepts in computer applications, programming, computer hardware, networking fundamentals, and internet technologies while building the digital literacy skills required in today's technology-driven environment.

It lays the groundwork for providing basic IT support services and offers a pathway for progression to higher levels of study in Information Technology.
`,

  whyStudy: [

    "Build a strong foundation in modern IT by learning computer applications, programming, networking, databases, operating systems, and digital technologies through practical, hands-on training.",

    "Develop workplace-ready technical skills that enable you to install, configure, troubleshoot and support computer systems, networks, and business applications across different organizations.",

    "Strengthen your career readiness through practical projects and industrial attachment.",

    "Strengthen essential professional skills including problem-solving, communication, teamwork, critical thinking, digital literacy, and ethical ICT practices that employers highly value.",

    "Gain practical experience for entry-level IT careers in technical support, computer operations, networking, system administration, and business technology while building confidence to work in both public and private sector organizations.",

    "Create a pathway for career growth and further studies by earning a recognized qualification that allows you to progress to diploma programmes, professional ICT certifications, entrepreneurship, and advanced studies in Information Technology."

  ],

  entryRequirements: [

    "Be a holder of a KCSE (or equivalent examination) certificate with a minimum aggregate of D+.",

    "A minimum of D- in Mathematics.",

    "Either English or Kiswahili with a minimum grade of D-."

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 32650,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "System Administrator",

    "Database Administrator",

    "Administrative Assistant",

    "IT Technical Support"

  ],

  skills: [

    "Computer Applications",

    "Information Technology",

    "Programming",

    "Computer Hardware",

    "Networking Fundamentals",

    "Operating Systems",

    "Database Management",

    "Desktop Publishing",

    "Digital Literacy",

    "ICT Ethics",

    "IT Support",

    "Problem Solving",

    "Communication",

    "Teamwork",

    "Critical Thinking"

  ],

  ctaTitle:
    "Ready to Power Your Digital Future?",

  ctaText:
    "Join Zetech University and build the practical computing and digital technology skills needed to begin your IT career and progress to higher qualifications in Information Technology.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CBM 112",
              title: "Introduction to Business"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CIT 112",
              title: "ICT & Ethics"
            },
            {
              code: "CIT 111",
              title: "Computer Applications"
            },
            {
              code: "CMT 111",
              title: "Basic Mathematics"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CAC 121",
              title: "Fundamentals of Accounting"
            },
            {
              code: "CIT 121",
              title: "Introduction to Operating Systems"
            },
            {
              code: "CIT 122",
              title: "Introduction to Database Management"
            },
            {
              code: "CIT 123",
              title: "Introduction to Programming"
            },
            {
              code: "CIT 124",
              title: "Desktop Publishing"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Information Technology takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE or equivalent examination certificate with a minimum aggregate grade of D+, a minimum of D- in Mathematics, and either English or Kiswahili with a minimum grade of D-."
    },

    {
      question: "What career opportunities are available?",
      answer:
        "Graduates can pursue entry-level opportunities such as System Administrator, Database Administrator, Administrative Assistant and IT Technical Support."
    },

    {
      question: "Can I progress to further studies after completing the certificate?",
      answer:
        "Yes. The certificate provides a pathway to diploma programmes, professional ICT certifications, entrepreneurship and advanced studies in Information Technology."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Information Technology | Zetech University",

    metaDescription:
      "Study the Certificate in Information Technology at Zetech University and develop practical skills in computer applications, programming, operating systems, databases, ICT and digital technologies."

  }

},


{
  id: 49,

  slug: "certificate-in-business-management",

  title: "Certificate in Business Management",

  shortTitle: "Certificate in Business Management",

  code: "CBM",

  school: "School of Business and Economics",

  qualification: "CERTIFICATE",

  qualificationTitle:
    "Certificate in Business Management",

  award: "Certificate",

  category: "CERTIFICATE",

  level: "Certificate",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-business-management.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-business-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra:
    "Building Foundations for Business Success",

  heroDescription:
    "Build practical knowledge in business operations, management, marketing, accounting, entrepreneurship and office administration for entry-level careers, entrepreneurship and further studies.",

  overview: `
The Certificate in Business Management introduces learners to the fundamentals of business operations and management.

The programme covers business communication, management, marketing, accounting, entrepreneurship, and office administration, providing practical knowledge that can be applied in the workplace or in running a business.

It offers a strong foundation for entry-level business roles and further studies in business-related fields.
`,

  whyStudy: [

    "Learn the essential business skills needed to succeed in the workplace or run your own business.",

    "Gain hands-on knowledge in business operations, office administration, customer service, and entrepreneurship.",

    "Build expertise in management, marketing, accounting, finance, business communication, and human resource management.",

    "Develop the confidence and skills needed to work in organizations or start and grow your own business.",

    "Learn how to identify business opportunities, manage resources, and turn ideas into successful ventures.",

    "Use your certificate as a pathway to diploma and degree programmes in business and related fields."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate grade of D+ (plus), or a relevant qualification."

  ],

  duration: 2,

  durationType: "Semesters",

  durationYears: "1 Year",

  mode: "Physical & Online",

  fee: 29050,

  feeType: "tuition fees per semester",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Financial Officer",

    "Operating Manager",

    "Clerk"

  ],

  skills: [

    "Business Management",

    "Business Operations",

    "Office Administration",

    "Entrepreneurship",

    "Marketing",

    "Accounting",

    "Finance",

    "Human Resource Management",

    "Business Communication",

    "Supply Chain Management",

    "Business Law",

    "Customer Service"

  ],

  ctaTitle:
    "Ready to Build Your Business Career?",

  ctaText:
    "Join Zetech University and build a strong foundation in business management, entrepreneurship and essential workplace skills while preparing for further studies and career growth.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CBM 111",
              title: "Fundamentals of Management"
            },
            {
              code: "CCU 110",
              title: "Communication Skills"
            },
            {
              code: "CCU 113",
              title: "Digital Literacy"
            },
            {
              code: "CHR 111",
              title: "Principles of Human Resource Management"
            },
            {
              code: "CPS 111",
              title: "Introduction to Supply Chain Management"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CCU 120",
              title: "Entrepreneurship and Innovation"
            },
            {
              code: "CAC 121",
              title: "Fundamentals of Accounting"
            },
            {
              code: "CFN 121",
              title: "Introduction to Business Law"
            },
            {
              code: "CMK 121",
              title: "Principles of Marketing"
            },
            {
              code: "CFN 123",
              title: "Principles of Finance"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The Certificate in Business Management takes two semesters, equivalent to one year."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through both Physical and Online learning."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of D+ (plus), or a relevant qualification."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The programme covers management, communication, digital literacy, human resource management, supply chain management, entrepreneurship, accounting, business law, marketing and finance."
    },

    {
      question: "What career opportunities are available?",
      answer:
        "The programme prepares graduates for opportunities such as Financial Officer, Operating Manager and Clerk."
    },

    {
      question: "Can I progress to further studies?",
      answer:
        "Yes. The certificate provides a pathway to diploma and degree programmes in business and related fields."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Business Management | Zetech University",

    metaDescription:
      "Study the Certificate in Business Management at Zetech University and develop practical skills in management, accounting, marketing, entrepreneurship, finance and business operations."

  }

},

/* ===========================
   TVET
=========================== */
{
  id: 51,

  slug: "diploma-in-electrical-engineering-power-knec",

  title: "Diploma in Electrical Engineering (Power) (KNEC)",

  shortTitle: "Diploma in Electrical Engineering (Power) (KNEC)",

  code: "DEE",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Diploma in Electrical Engineering (Power) (KNEC)",

  award: "Diploma",

  category: "TVET",

  level: "TVET",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/diploma-in-electrical-engineering-power-knec.pdf",

  feeStructure:
    "/downloads/fees/diploma-in-electrical-engineering-power-knec-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Design. Install. Power.",

  heroDescription:
    "Develop practical electrical engineering and power systems skills through a recognized KNEC qualification designed to prepare learners for electrical installation, maintenance, power systems, renewable energy, industrial applications and further professional development.",

  overview: `
The Diploma in Electrical Engineering (Power) is designed to equip learners with the technical knowledge and practical competencies required to plan, install, test, commission, maintain, and repair a wide range of electrical systems.

The programme covers domestic, commercial, industrial, agricultural, and horticultural electrical installations, alongside specialised areas such as generators, motors, solar energy systems, HVAC, Integrated Building Management Systems (IBMS), and security installations.

It prepares graduates with the expertise needed to meet the evolving demands of the electrical engineering industry.
`,

  whyStudy: [

    "Build advanced practical engineering skills through hands-on training in electrical installations, power systems, industrial control systems, renewable energy, motors, generators, and electrical testing using industry-standard equipment.",

    "Develop the expertise to design, install, and maintain electrical systems for residential, commercial, industrial, and renewable energy projects while applying modern engineering practices and industry standards.",

    "Learn in a practical engineering environment with experienced faculty, well-equipped engineering workshops, project-based learning, industrial exposure, and physical classes that prepare you for real-world engineering challenges.",

    "Strengthen professional engineering competencies including technical problem-solving, analytical thinking, teamwork, project management, workplace safety, and compliance with electrical codes and regulations valued by employers.",

    "Gain industry-ready experience through practical projects and technical training that prepare you for careers in electrical engineering, power generation, industrial automation, construction, manufacturing, and infrastructure development.",

    "Create a pathway for professional growth and leadership with a recognized KNEC qualification that supports career advancement, entrepreneurship, professional engineering certifications, and further studies in electrical and electronics engineering."

  ],

  entryRequirements: [

    "Be a holder of KCSE (or equivalent examination) certificate with a minimum aggregate of C-",

    "A PASS in Zetech University Certificate.",

    "Any other relevant qualifications approved by the Zetech University Senate"

  ],

  duration: 9,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 15000,

  feeType: "Per Term",

  intake: [
    "January",
    "May",
    "September"
  ],

  /*
   * Retained from the original programme data
   * for compatibility with existing components.
   */
  durationDetails: {
    duration: "9 Terms",
    modeOfDelivery: "Physical classes only",
    intake: "January, May & September intakes"
  },

  /*
   * New standard career field used by the
   * updated programme component.
   */
  careers: [

    "Electrical Technician",

    "Controls Engineer",

    "Test Engineer",

    "Electrical Project Manager",

    "Electrical Designer",

    "Sustainability Engineer",

    "Electrical Engineer"

  ],

  /*
   * Retained from the original programme data
   * so older components referencing careerOpportunities
   * continue to work.
   */
  careerOpportunities: [

    "Electrical technician",

    "Controls engineer",

    "Test engineer",

    "Electrical project manager",

    "Electrical designer",

    "Sustainability engineer",

    "Electrical engineer"

  ],

  skills: [

    "Electrical Installation",

    "Electrical Testing and Commissioning",

    "Power Systems",

    "Electrical Maintenance",

    "Electrical Wiring and Installation",

    "Electrical Motors",

    "Electrical Generators",

    "Industrial Control Systems",

    "Renewable Energy Systems",

    "Solar Energy Systems",

    "HVAC Systems",

    "Integrated Building Management Systems (IBMS)",

    "Security Installation Systems",

    "Electrical Design",

    "Electrical Safety",

    "Power Generation",

    "Electrical Troubleshooting",

    "Electrical Project Management",

    "Technical Problem-Solving",

    "Workplace Safety and Compliance"

  ],

  ctaTitle:
    "Ready to Power Your Engineering Future?",

  ctaText:
    "Join Zetech University and develop practical electrical engineering, power systems and technical skills through a recognized KNEC qualification designed to prepare you for careers in electrical installations, maintenance, power generation, renewable energy, industrial systems, construction, manufacturing and infrastructure development.",

  curriculum: [],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The Diploma in Electrical Engineering (Power) takes 9 terms to complete."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should be holders of a KCSE or equivalent examination certificate with a minimum aggregate of C-, a pass in a Zetech University Certificate, or any other relevant qualification approved by the Zetech University Senate."
    },

    {
      question: "Is this a KNEC programme?",

      answer:
        "Yes. The programme is a Diploma in Electrical Engineering (Power) offered under KNEC."
    },

    {
      question: "What areas does the programme cover?",

      answer:
        "The programme covers domestic, commercial, industrial, agricultural and horticultural electrical installations, as well as generators, motors, solar energy systems, HVAC, Integrated Building Management Systems (IBMS), security installations, electrical testing, commissioning, maintenance and repair."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Graduates can pursue career opportunities such as Electrical Technician, Controls Engineer, Test Engineer, Electrical Project Manager, Electrical Designer, Sustainability Engineer and Electrical Engineer."
    },

    {
      question: "Does the programme cover renewable energy?",

      answer:
        "Yes. The programme covers renewable energy applications, including solar energy systems, giving learners practical knowledge relevant to the growing renewable energy sector."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The programme emphasizes practical training, hands-on engineering skills, electrical installations, testing, maintenance, project-based learning and exposure to real-world engineering applications."
    },

    {
      question: "Can I work in the power sector after completing the programme?",

      answer:
        "Yes. The programme provides technical knowledge and practical competencies relevant to electrical installations, power systems, generation, maintenance, industrial applications and related areas within the electrical engineering sector."
    },

    {
      question: "Can I progress to further studies?",

      answer:
        "Yes. The qualification provides a pathway for further studies and professional development in electrical and electronics engineering and related technical and engineering fields."
    }

  ],

  seo: {

    metaTitle:
      "Diploma in Electrical Engineering (Power) (KNEC) | Zetech University",

    metaDescription:
      "Study the Diploma in Electrical Engineering (Power) (KNEC) at Zetech University and gain practical skills in electrical installation, power systems, motors, generators, solar energy, industrial control systems, HVAC, maintenance and electrical testing."

  }

},
{
  id: 54,

  slug: "certified-public-accountant-cpa",

  title: "Certified Public Accountant - CPA (KASNEB)",

  shortTitle: "Certified Public Accountant - CPA (KASNEB)",

  code: "CPA",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Certified Public Accountant - CPA (KASNEB)",

  award: "Professional Qualification",

  category: "Professional",

  level: "Professional",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certified-public-accountant-cpa.pdf",

  feeStructure:
    "/downloads/fees/certified-public-accountant-cpa-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Master Finance.",

  heroDescription:
    "Build professional accounting, auditing, taxation and financial management expertise through the KASNEB Certified Public Accountant (CPA) qualification, designed to prepare learners for professional practice, career advancement and further academic progression.",

  overview: `
The Certified Public Accountant (CPA) programme is a professional qualification offered by KASNEB that prepares individuals for careers in accounting, auditing, taxation, and financial management.

Designed to develop technical competence, ethical grounding, and strategic thinking, the CPA qualification is structured in three levels; Foundation, Intermediate, and Advanced, each building on the other to equip learners with comprehensive knowledge and practical skills.
`,

  whyStudy: [

    "Prepare for a globally respected accounting profession by gaining comprehensive knowledge in financial accounting, auditing, taxation, business law, financial management, and corporate governance through the KASNEB curriculum.",

    "Develop practical skills for today's business world by learning how to prepare financial reports, analyze financial information, manage business finances, ensure regulatory compliance, and support strategic decision-making across diverse organizations.",

    "Learn from experienced lecturers in a professional learning environment with industry-focused instruction, physical classes, academic support, and practical case studies that prepare you for KASNEB examinations and professional practice.",

    "Strengthen essential professional competencies including analytical thinking, ethical decision-making, communication, leadership, problem-solving, and critical reasoning that are highly valued in accounting, finance, and business careers.",

    "Unlock diverse career opportunities in accounting, auditing, taxation, financial management, banking, consulting, and business advisory services across both the public and private sectors, while building the confidence to pursue entrepreneurial ventures.",

    "Advance your academic and professional journey with a recognized KASNEB qualification that provides progression to degree programmes, professional membership, leadership roles, and lifelong career growth in accounting and finance."

  ],

  entryRequirements: [

    "KCSE aggregate average of at least grade C+ (C plus) or its equivalent.",

    "Kenya Advanced Certificate of Education (KACE) with at least two Principal passes, provided that the applicant has credits in Mathematics and English at Kenya Certificate of Education (KCE) level or equivalent qualifications.",

    "KASNEB technician, diploma or professional examination certificate.",

    "A degree from a recognized university.",

    "International General Certificate of Secondary Education (IGCSE) examination grade C in 6 papers with C in both English and Mathematics.",

    "Such other certificates or diplomas as may be approved by KASNEB."

  ],

  duration: 6,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 18000,

  feeType: "Per Programme",

  intake: [
    "January",
    "May",
    "September"
  ],

  /*
   * Original delivery field retained for
   * compatibility with existing components.
   */
  deliveryMode: "Physical classes only",

  /*
   * Original career field retained.
   */
  careerOpportunities: [

    "Professional Accountants",

    "Auditors",

    "Finance Managers",

    "Tax Consultants",

    "Practitioners in public and private sectors"

  ],

  /*
   * Standard career field used by the
   * newer programme components.
   */
  careers: [

    "Professional Accountants",

    "Auditors",

    "Finance Managers",

    "Tax Consultants",

    "Practitioners in public and private sectors"

  ],

  skills: [

    "Financial Accounting",

    "Auditing",

    "Taxation",

    "Financial Management",

    "Financial Reporting",

    "Business Law",

    "Corporate Governance",

    "Economics",

    "Quantitative Analysis",

    "Information Communication Technology",

    "Communication Skills",

    "Financial Analysis",

    "Regulatory Compliance",

    "Strategic Decision-Making",

    "Ethical Decision-Making",

    "Professional Accounting Practice",

    "Business Advisory",

    "Problem-Solving",

    "Critical Thinking",

    "Leadership"

  ],

  /*
   * Original progression information retained.
   */
  progression:
    "Progression to degree: Part 3 (CPA K) Year 2 Sem 1",

  ctaTitle:
    "Ready to Master Finance?",

  ctaText:
    "Join Zetech University and build professional expertise in accounting, auditing, taxation and financial management through the KASNEB CPA qualification, designed to support professional growth, career advancement, further studies and leadership opportunities.",

  curriculum: [

    {
      year: "Year One",

      semester: "Semester One",

      units: [

        {
          code: "CPA1A",
          title: "Financial Accounting"
        },

        {
          code: "CPA2A",
          title: "Communication Skills"
        },

        {
          code: "CPA3A",
          title: "Introduction to Law and Governance"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Two",

      units: [

        {
          code: "CPA1B",
          title: "Financial Accounting"
        },

        {
          code: "CPA2B",
          title: "Communication Skills"
        },

        {
          code: "CPA3B",
          title: "Introduction to Law and Governance"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester One",

      units: [

        {
          code: "CPA4A",
          title: "Economics"
        },

        {
          code: "CPA5A",
          title: "Quantitative Analysis"
        },

        {
          code: "CPA6A",
          title: "Information Communication Technology"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester Two",

      units: [

        {
          code: "CPA4B",
          title: "Economics"
        },

        {
          code: "CPA5B",
          title: "Quantitative Analysis"
        },

        {
          code: "CPA6B",
          title: "Information Communication Technology"
        }

      ]
    }

  ],

  faqs: [

    {
      question: "What is the Certified Public Accountant (CPA) programme?",

      answer:
        "The Certified Public Accountant (CPA) is a professional qualification offered by KASNEB that prepares learners for careers in accounting, auditing, taxation and financial management."
    },

    {
      question: "How long does the programme take?",

      answer:
        "The programme information specifies a duration of 6 terms."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants may qualify with a KCSE aggregate average of at least C+ or its equivalent, KACE with at least two Principal passes subject to the stated Mathematics and English requirements, a KASNEB technician, diploma or professional examination certificate, a degree from a recognized university, an IGCSE qualification meeting the stated requirements, or other certificates or diplomas approved by KASNEB."
    },

    {
      question: "Who offers the CPA qualification?",

      answer:
        "The Certified Public Accountant programme is a professional qualification offered by KASNEB."
    },

    {
      question: "What subjects are covered in the programme?",

      answer:
        "The curriculum includes Financial Accounting, Communication Skills, Introduction to Law and Governance, Economics, Quantitative Analysis and Information Communication Technology."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Career opportunities include Professional Accountant, Auditor, Finance Manager, Tax Consultant and practitioner roles in public and private sector organizations."
    },

    {
      question: "Can I progress to a degree programme?",

      answer:
        "Yes. The programme information specifies progression to degree at Part 3 (CPA K), Year 2, Semester 1."
    },

    {
      question: "Does CPA prepare learners for accounting and finance careers?",

      answer:
        "Yes. The programme develops knowledge and professional competencies in accounting, auditing, taxation, financial management, financial reporting, business law, governance and related areas."
    },

    {
      question: "Is the CPA qualification suitable for public and private sector careers?",

      answer:
        "Yes. The qualification supports career opportunities across both public and private sector organizations, including accounting, auditing, taxation, finance and business advisory roles."
    }

  ],

  seo: {

    metaTitle:
      "Certified Public Accountant (CPA) | Zetech University",

    metaDescription:
      "Study the Certified Public Accountant (CPA) programme at Zetech University and develop professional skills in accounting, auditing, taxation, financial management, business law, governance and financial analysis."

  }

},
{
  id: 52,

  slug: "certificate-in-electrical-engineering-power",

  title: "Certificate in Electrical Engineering (Power) (KNEC)",

  shortTitle: "Certificate in Electrical Engineering (Power) (KNEC)",

  code: "CEE",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Certificate in Electrical Engineering (Power) (KNEC)",

  award: "Certificate",

  category: "TVET",

  level: "TVET",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-electrical-engineering-power.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-electrical-engineering-power-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Powering Skilled Technicians.",

  heroDescription:
    "Build practical electrical engineering and power systems skills through a recognized qualification designed to prepare learners for electrical installation, testing, maintenance, repair, solar systems, electrical machines and technical careers.",

  overview: `
The goal of this programme is to equip students with the competencies required to plan, install, manage sites, test and commission, maintain, and repair different types of electrical installations.

The programme is designed in a way that grounds the students on the installation types ranging from domestic, commercial, industrial, horticultural, agricultural, electrical installations, and includes generator, motor, water boiling, and solar installations.
`,

  whyStudy: [

    "Build a strong foundation in electrical engineering through practical training in electrical installations, wiring systems, electronics, solar energy, electrical machines, and engineering principles using industry-standard equipment.",

    "Develop hands-on technical skills to install, test, troubleshoot, maintain, and repair electrical systems for residential, commercial, industrial, and renewable energy applications while following industry best practices.",

    "Learn in a practical engineering environment with experienced instructors, well-equipped workshops, project-based learning, and physical classes that prepare you for real-world engineering and technical careers.",

    "Strengthen essential professional skills including technical problem-solving, teamwork, workplace safety, engineering drawing, communication, and project management that are highly valued across the engineering industry.",

    "Gain industry-ready experience through practical workshops, trade projects, and industrial attachment opportunities that build the confidence to work effectively in electrical installation, maintenance, construction, manufacturing, and energy sectors.",

    "Create a pathway for career growth and further studies with a recognized KNEC qualification that supports progression to diploma programmes, professional certifications, entrepreneurship, and rewarding careers in electrical engineering and power systems."

  ],

  entryRequirements: [

    "KCSE certificate with a minimum aggregate of D (plain)",

    "Pass in Artisan Certificate Level in a relevant programme",

    "A relevant qualification"

  ],

  duration: 6,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 15000,

  feeType: "Per Term",

  intake: [
    "January",
    "May",
    "September"
  ],

  /*
   * Retained exactly from the original programme
   * for compatibility with existing components.
   */
  durationDetails: {
    duration: "3 Semesters",
    modeOfDelivery: "Physical classes only",
    intake: "January, May & September intakes"
  },

  /*
   * New standard career field.
   */
  careers: [

    "Controls Engineer",

    "Project Engineer",

    "Test Engineer",

    "Design Engineer",

    "Electrical Engineer"

  ],

  /*
   * Original field retained for backward compatibility.
   */
  careerOpportunities: [

    "Controls engineer",

    "Project engineer",

    "Test engineer",

    "Design engineer",

    "Electrical engineer"

  ],

  skills: [

    "Electrical Installation",

    "Electrical Wiring",

    "Electrical Testing and Commissioning",

    "Electrical Maintenance",

    "Electrical Troubleshooting",

    "Electrical Repair",

    "Electrical Principles",

    "Electrical Machines",

    "Digital Electronics",

    "Analogue Electronics",

    "Micro-Electronics",

    "Solar Installation Systems",

    "Engineering Drawing",

    "Technical Mathematics",

    "Workshop Practice",

    "Applied Science",

    "Project and Contract Management",

    "ICT and Ethics",

    "Workplace Safety",

    "Electrical Engineering Principles"

  ],

  ctaTitle:
    "Ready to Build Your Electrical Engineering Future?",

  ctaText:
    "Join Zetech University and develop practical electrical engineering, installation, maintenance, electronics, solar energy and power systems skills through a career-focused programme designed to prepare you for technical careers, further studies and entrepreneurship.",

  curriculum: [

    {
      year: "Year One",

      semester: "Semester One",

      units: [

        {
          code: "CCU 100",
          name: "Communication Skills and writing",
          title: "Communication Skills and writing"
        },

        {
          code: "CEE 101",
          name: "Applied science I",
          title: "Applied science I"
        },

        {
          code: "CEE 102",
          name: "Electrical Principles I",
          title: "Electrical Principles I"
        },

        {
          code: "CEE 103",
          name: "Electrical Installation Technology I",
          title: "Electrical Installation Technology I"
        },

        {
          code: "CEE 104",
          name: "Engineering Drawing",
          title: "Engineering Drawing"
        },

        {
          code: "CCU 101",
          name: "ICT & Ethics",
          title: "ICT & Ethics"
        },

        {
          code: "CEE 100",
          name: "Basic Mathematics",
          title: "Basic Mathematics"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Two",

      units: [

        {
          code: "CEE 200",
          name: "Digital Electronics",
          title: "Digital Electronics"
        },

        {
          code: "CCU 102",
          name: "Health and wellness",
          title: "Health and wellness"
        },

        {
          code: "CEE 202",
          name: "Applied science II",
          title: "Applied science II"
        },

        {
          code: "CEE 203",
          name: "Electrical Principles II",
          title: "Electrical Principles II"
        },

        {
          code: "CEE 204",
          name: "Projects and contracts management",
          title: "Projects and contracts management"
        },

        {
          code: "CEE 201",
          name: "Technical mathematics I",
          title: "Technical mathematics I"
        },

        {
          code: "CEE 205",
          name: "Workshop Practice I",
          title: "Workshop Practice I"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester One",

      units: [

        {
          code: "CEE 300",
          name: "Electrical Installation Technology II",
          title: "Electrical Installation Technology II"
        },

        {
          code: "CEE 301",
          name: "Micro-Electronics",
          title: "Micro-Electronics"
        },

        {
          code: "CEE 302",
          name: "Technical mathematics II",
          title: "Technical mathematics II"
        },

        {
          code: "CEE 303",
          name: "Analogue electronics",
          title: "Analogue electronics"
        },

        {
          code: "CEE 304",
          name: "Solar installation systems",
          title: "Solar installation systems"
        },

        {
          code: "CEE 305",
          name: "Electrical Machines Technology",
          title: "Electrical Machines Technology"
        },

        {
          code: "CEE 306",
          name: "Workshop practice II",
          title: "Workshop practice II"
        },

        {
          code: "CEE 307",
          name: "Trade Project",
          title: "Trade Project"
        },

        {
          code: "CEE 400",
          name: "Attachment",
          title: "Attachment"
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme information specifies a duration of 6 terms, with the programme structure presented across three semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE certificate with a minimum aggregate grade of D (plain), a pass in an Artisan Certificate Level in a relevant programme, or a relevant qualification."
    },

    {
      question: "What areas does the programme cover?",

      answer:
        "The programme covers electrical installation technology, electrical principles, applied science, engineering drawing, mathematics, digital electronics, micro-electronics, analogue electronics, solar installation systems, electrical machines, workshop practice, projects and contracts management, and trade projects."
    },

    {
      question: "Does the programme cover solar energy?",

      answer:
        "Yes. The curriculum includes Solar Installation Systems, providing learners with practical knowledge relevant to solar energy installations."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The programme includes Workshop Practice I, Workshop Practice II, Trade Project and Attachment, providing learners with practical exposure to electrical engineering applications."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Career opportunities listed for the programme include Controls Engineer, Project Engineer, Test Engineer, Design Engineer and Electrical Engineer."
    },

    {
      question: "Can I progress to further studies?",

      answer:
        "Yes. The qualification provides a pathway for progression to diploma programmes, professional certifications, entrepreneurship and further studies in electrical engineering and related fields."
    },

    {
      question: "Is industrial attachment included?",

      answer:
        "Yes. The curriculum includes an Attachment unit, providing an opportunity for practical exposure to workplace and industry environments."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Electrical Engineering (Power) | Zetech University",

    metaDescription:
      "Study the Certificate in Electrical Engineering (Power) at Zetech University and develop practical skills in electrical installation, electronics, solar energy, electrical machines, testing, maintenance, engineering drawing and workshop practice."

  }

},
{
  id: 53,

  slug: "certificate-in-food-production-sales-and-service-management",

  title: "Certificate in Food Production, Sales and Service Management (KNEC)",

  shortTitle:
    "Certificate in Food Production, Sales and Service Management (KNEC)",

  code: "CFPSSM",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Certificate in Food Production, Sales and Service Management (KNEC)",

  award: "Certificate",

  category: "TVET",

  level: "TVET",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-food-production-sales-and-service-management.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-food-production-sales-and-service-management-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "Where Culinary Skills Meet Service Excellence",

  heroDescription:
    "Build practical culinary, food production, sales and hospitality service skills through a career-focused certificate programme designed to prepare learners for opportunities in hotels, restaurants, catering establishments, resorts and other food service environments.",

  overview: `
The Certificate in Food Production, Sales and Service (KNEC) is designed to equip learners with foundational skills in culinary arts, food preparation, customer service, and hospitality operations.

It focuses on practical training in cooking techniques, menu planning, kitchen hygiene, food and beverage service, and basic sales and marketing strategies in the hospitality industry.

Ideal for aspiring chefs, kitchen assistants, and service personnel, this course prepares graduates to work in hotels, restaurants, catering establishments, and related settings.
`,

  whyStudy: [

    "Build practical culinary and hospitality skills through hands-on training in food preparation, kitchen operations, food and beverage service, menu planning, and customer care using industry-standard practices.",

    "Develop the confidence to work in professional hospitality environments by learning food presentation, restaurant service, catering operations, kitchen hygiene, and hospitality management techniques that meet industry expectations.",

    "Learn in a practical hospitality environment with experienced trainers, well-equipped training kitchens, real-world practical sessions, and physical classes that prepare you for successful careers in the hospitality industry.",

    "Strengthen essential workplace skills including teamwork, communication, time management, professionalism, customer service, problem-solving, and attention to detail that are highly valued by hospitality employers.",

    "Gain industry-ready experience through practical training that prepares you for opportunities in hotels, restaurants, catering companies, resorts, institutions, and other food service establishments while building the confidence to deliver exceptional guest experiences.",

    "Create a pathway for career growth and entrepreneurship with a recognized KNEC qualification that supports progression to higher hospitality programmes, professional development, and opportunities to establish your own catering, restaurant, or food service business."

  ],

  entryRequirements: [

    "KCSE D plain",

    "KCPE Certificate for artisan level"

  ],

  duration: 5,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 15000,

  feeType: "Per Term",

  intake: [
    "January",
    "May",
    "September"
  ],

  /*
   * Original duration information retained
   * for compatibility with existing components.
   */
  durationDetails: {
    duration: "3 Semesters",
    modeOfDelivery: "Physical classes only",
    intake: [
      "January",
      "May",
      "September"
    ]
  },

  /*
   * Standard career field used by the
   * newer programme components.
   */
  careers: [

    "Waiter/Waitress",

    "Chef",

    "Instructor in Vocational Training Centers"

  ],

  /*
   * Original career field retained so any
   * existing component using careerOpportunities
   * continues to work.
   */
  careerOpportunities: [

    "Waiter/Waitress",

    "Chef",

    "Instructor in Vocational Training Centers"

  ],

  skills: [

    "Food Production",

    "Food Preparation",

    "Food and Beverage Production",

    "Food and Beverage Service",

    "Food Service",

    "Culinary Arts",

    "Kitchen Operations",

    "Food Presentation",

    "Menu Planning",

    "Kitchen Hygiene",

    "Customer Service",

    "Hospitality Operations",

    "Restaurant Service",

    "Catering Operations",

    "Food Service Management",

    "Hospitality Management",

    "Sales and Marketing",

    "Teamwork and Communication",

    "Professional Hospitality Practice",

    "Food Service Entrepreneurship"

  ],

  ctaTitle:
    "Ready to Start Your Hospitality Career?",

  ctaText:
    "Join Zetech University and develop practical culinary, food production, sales and hospitality service skills through a recognized qualification designed to prepare you for careers in hotels, restaurants, catering, food service and hospitality entrepreneurship.",

  curriculum: [

    {
      year: "Year One",

      semester: "Semester One",

      units: [

        {
          code: "AFB 111",
          title: "Food Production Practice"
        },

        {
          code: "AFB 112",
          title: "Project"
        },

        {
          code: "AFB 113",
          title: "Food and Beverage Production Theory"
        },

        {
          code: "AFB 114",
          title: "Food and Beverage Service Theory"
        },

        {
          code: "AFB 115",
          title: "Food and Beverage Service Practice"
        },

        {
          code: "AFB 116",
          title: "General Subject"
        },

        {
          code: "EEE 613",
          title: "Science"
        },

        {
          code: "EEE 614",
          title: "Mathematics"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Two",

      units: [

        {
          code: "AFB 121",
          title: "Food Production Practice"
        },

        {
          code: "AFB 122",
          title: "Project"
        },

        {
          code: "AFB 123",
          title: "Food and Beverage Production Theory"
        },

        {
          code: "AFB 124",
          title: "Food and Beverage Service Theory"
        },

        {
          code: "AFB 125",
          title: "Food Service Practice"
        },

        {
          code: "AFB 126",
          title: "General Subject"
        },

        {
          code: "EEE 623",
          title: "Science"
        },

        {
          code: "EEE 624",
          title: "Mathematics"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Three",

      units: [

        {
          code: "AFB 131",
          title: "Food Production Practice"
        },

        {
          code: "AFB 132",
          title: "Project"
        },

        {
          code: "AFB 133",
          title: "Food Beverage Production Theory"
        },

        {
          code: "AFB 134",
          title: "Food and Beverage Service Theory"
        },

        {
          code: "AFB 135",
          title: "Food Service Practice"
        },

        {
          code: "AFB 136",
          title: "General Subject"
        },

        {
          code: "EEE 633",
          title: "Science"
        },

        {
          code: "EEE 634",
          title: "Mathematics"
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme information specifies a duration of 5 terms, with the curriculum structured across three semesters."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have a KCSE D plain qualification or a KCPE Certificate for artisan level."
    },

    {
      question: "Is this a KNEC programme?",

      answer:
        "Yes. The programme information identifies it as a Certificate in Food Production, Sales and Service (KNEC)."
    },

    {
      question: "What areas does the programme cover?",

      answer:
        "The curriculum covers food production practice, food and beverage production theory, food and beverage service theory, food and beverage service practice, food service practice, projects, general subjects, science and mathematics."
    },

    {
      question: "Does the programme include practical training?",

      answer:
        "Yes. The programme includes practical training in food production, food and beverage service, food service practice and related hospitality operations."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Career opportunities listed for the programme include Waiter/Waitress, Chef and Instructor in Vocational Training Centers."
    },

    {
      question: "Can I work in hotels and restaurants after completing the programme?",

      answer:
        "Yes. The programme prepares learners for opportunities in hotels, restaurants, catering establishments, resorts, institutions and other food service environments."
    },

    {
      question: "Can I start my own food business?",

      answer:
        "Yes. The programme provides practical hospitality and food service skills that can support entrepreneurship and opportunities to establish a catering, restaurant or other food service business."
    },

    {
      question: "Can I progress to further studies?",

      answer:
        "Yes. The qualification provides a pathway for progression to higher hospitality programmes and further professional development in the hospitality and food service sector."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Food Production, Sales and Service Management | Zetech University",

    metaDescription:
      "Study the Certificate in Food Production, Sales and Service Management at Zetech University and develop practical skills in food production, culinary arts, food and beverage service, hospitality operations, customer service and catering."

  }

},
{
  id: 50,

  slug: "certificate-in-business-management-knec",

  title: "Certificate in Business Management (KNEC)",

  shortTitle: "Certificate in Business Management (KNEC)",

  code: "CBM KNEC",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Certificate in Business Management (KNEC)",

  award: "Certificate",

  category: "TVET",

  level: "TVET",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-business-management-knec.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-business-management-knec-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "",

  heroDescription:
    "Build practical business management and operational skills through a recognized KNEC qualification designed to prepare learners for business careers, entrepreneurship and progression to higher levels of business studies.",

  overview: `
The Certificate in Business Management (KNEC) offers skills on how to effectively and efficiently manage business activities.

Emphasis is placed on the importance of business management and operational skills. The course further serves as a foundation for students who wish to venture into business management and entrepreneurship as well as those who want to pursue higher levels in business studies.
`,

  whyStudy: [

    "Build a strong foundation in business management by learning entrepreneurship, accounting, finance, marketing, business law, human resource management, office administration, and business operations through practical, industry-focused training.",

    "Develop practical business and leadership skills that enable you to manage daily business operations, support decision-making, coordinate administrative functions, and contribute to the growth of organizations across different industries.",

    "Learn in a career-focused environment with experienced lecturers, practical case studies, project-based learning, and physical classes that prepare you for the realities of today's competitive business world.",

    "Strengthen essential workplace competencies including communication, teamwork, critical thinking, problem-solving, customer service, leadership, and entrepreneurial skills that employers value across both public and private sectors.",

    "Gain industry-ready knowledge that prepares you for entry-level careers in business administration, office management, finance, sales, customer service, and operations while building the confidence to start and manage your own business.",

    "Create a pathway for career growth and further studies with a recognized KNEC qualification that supports progression to diploma programmes, professional certifications, entrepreneurship, and rewarding careers in business and management."

  ],

  entryRequirements: [

    "KCSE with a minimum aggregate grade of D (plain).",

    "Pass in Artisan Certificate Level, where applicable.",

    "A relevant qualification."

  ],

  duration: 5,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 15000,

  feeType: "Per Term",

  intake: [
    "January",
    "May",
    "September"
  ],

  careers: [

    "Administrative Assistants",

    "Financial Assistants",

    "Operations Assistants",

    "Clerk"

  ],

  skills: [

    "Business Management",

    "Business Operations",

    "Financial Accounting",

    "Business Finance",

    "Entrepreneurship",

    "Business Law",

    "Economics",

    "Human and Public Relations",

    "Office Organization",

    "Sales and Marketing",

    "Business Research",

    "Business Calculations and Statistics",

    "Information Communication Technology"

  ],

  ctaTitle:
    "Ready to Build Your Business Future?",

  ctaText:
    "Join Zetech University and develop practical business management, operational and entrepreneurial skills through a recognized KNEC qualification designed to support career growth, entrepreneurship and further studies.",

  curriculum: [

    {
      year: "Year One",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CMB 113",
              title: "Business Calculations & Statistics"
            },
            {
              code: "CMB 114",
              title: "Commerce"
            },
            {
              code: "CMB 115",
              title: "Communication Skills"
            },
            {
              code: "CMB 112",
              title: "Entrepreneurship Education"
            },
            {
              code: "CMB 111",
              title: "Financial Accounting"
            },
            {
              code: "CMB 116",
              title: "Fundamentals of Management and Environment"
            },
            {
              code: "ICT 111",
              title: "Information Communication Technology - Theory"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CMB 123",
              title: "Business Calculations & Statistics"
            },
            {
              code: "CMB 124",
              title: "Commerce"
            },
            {
              code: "CMB 125",
              title: "Communication Skills"
            },
            {
              code: "CMB 122",
              title: "Entrepreneurship Education"
            },
            {
              code: "CMB 121",
              title: "Financial Accounting"
            },
            {
              code: "CMB 126",
              title: "Fundamentals of Management & Environment"
            },
            {
              code: "ICT 121",
              title: "Information Communication Technology"
            }
          ]
        },

        {
          semester: "Semester Three",

          units: [
            {
              code: "CMB 133",
              title: "Business Calculations & Statistics"
            },
            {
              code: "CMB 134",
              title: "Commerce"
            },
            {
              code: "CMB 135",
              title: "Communication Skills"
            },
            {
              code: "CMB 131",
              title: "Financial Accounting"
            },
            {
              code: "CMB 136",
              title: "Fundamentals of Management & Environment"
            },
            {
              code: "ICT 131",
              title: "Information Communication Technology"
            }
          ]
        }

      ]
    },

    {
      year: "Year Two",

      semesters: [

        {
          semester: "Semester One",

          units: [
            {
              code: "CMB 216",
              title: "Business Finance"
            },
            {
              code: "CMB 214",
              title: "Business Law"
            },
            {
              code: "CSW 125",
              title: "Business Research Methods"
            },
            {
              code: "CMB 212",
              title: "Economics"
            },
            {
              code: "CMB 211",
              title: "Human and Public Relations"
            },
            {
              code: "CMB 215",
              title: "Office Organization"
            },
            {
              code: "CMB 213",
              title: "Sales and Marketing"
            }
          ]
        },

        {
          semester: "Semester Two",

          units: [
            {
              code: "CMB 226",
              title: "Business Finance"
            },
            {
              code: "CMB 224",
              title: "Business Law"
            },
            {
              code: "CMB 222",
              title: "Economics"
            },
            {
              code: "CMB 221",
              title: "Human & Public Relations"
            },
            {
              code: "CMB 225",
              title: "Office Organization"
            },
            {
              code: "CMB 223",
              title: "Sales and Marketing"
            }
          ]
        },

        {
          semester: "Semester Three",

          units: [
            {
              code: "CMB 236",
              title: "Business Finance"
            },
            {
              code: "CMB 234",
              title: "Business Law"
            },
            {
              code: "CMB 232",
              title: "Economics"
            },
            {
              code: "CMB 231",
              title: "Human & Public Relations"
            },
            {
              code: "CMB 235",
              title: "Office Organization"
            },
            {
              code: "CMB 233",
              title: "Sales and Marketing"
            }
          ]
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",
      answer:
        "The programme information specifies a duration of 5 terms."
    },

    {
      question: "What is the mode of study?",
      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",
      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",
      answer:
        "Applicants should have a KCSE qualification with a minimum aggregate grade of D (plain), a pass in Artisan Certificate Level where applicable, or a relevant qualification."
    },

    {
      question: "Is this a KNEC programme?",
      answer:
        "Yes. The programme is a Certificate in Business Management offered under KNEC."
    },

    {
      question: "What areas does the programme cover?",
      answer:
        "The curriculum covers business calculations and statistics, commerce, communication skills, entrepreneurship education, financial accounting, management, ICT, business finance, business law, research methods, economics, human and public relations, office organization, sales and marketing."
    },

    {
      question: "What career opportunities are available?",
      answer:
        "Career opportunities listed for the programme include Administrative Assistant, Financial Assistant, Operations Assistant and Clerk."
    },

    {
      question: "Can I progress to further studies?",
      answer:
        "Yes. The programme provides a foundation for progression to diploma programmes, professional certifications, entrepreneurship and higher levels of business studies."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in Business Management (KNEC) | Zetech University",

    metaDescription:
      "Study the Certificate in Business Management (KNEC) at Zetech University and develop practical skills in business management, accounting, finance, entrepreneurship, marketing, business law and operations."

  }

},
{
  id: 55,

  slug: "certificate-in-ict-knec",

  title: "Certificate in ICT (KNEC)",

  shortTitle: "Certificate in ICT (KNEC)",

  code: "KNEC ICT",

  school: "TVET",

  qualification: "TVET",

  qualificationTitle:
    "Certificate in ICT (KNEC)",

  award: "Certificate",

  category: "TVET",

  level: "TVET",

  nqfLevel: null,

  featured: false,

  image: undergraduate,

  brochure:
    "/downloads/brochures/certificate-in-ict-knec.pdf",

  feeStructure:
    "/downloads/fees/certificate-in-ict-knec-fees.pdf",

  applyLink: "https://sajili.zetech.ac.ke",

  enquiryEmail: "admissions@zetech.ac.ke",

  enquiryPhone: phoneNumber,

  mantra: "",

  heroDescription:
    "Build practical ICT skills in computer applications, hardware and software systems, operating systems, programming, computer support and digital technologies through a recognized KNEC qualification designed to prepare learners for today's digital workplace.",

  overview: `
This entry-level programme is designed to provide learners with fundamental skills in computer applications, hardware and software systems, networking, and basic programming.

The course equips students with practical knowledge to operate, manage, and support ICT systems in various professional settings.
`,

  whyStudy: [

    "Build practical ICT skills from day one through hands-on training in computer applications, networking, hardware maintenance, programming, and digital technologies using modern computer laboratories.",

    "Learn from experienced lecturers who combine academic knowledge with real-world industry experience, ensuring you graduate with skills employers value.",

    "Gain career-ready knowledge by working on practical projects that prepare you to install, maintain, troubleshoot, and support ICT systems across different organizations.",

    "Develop problem-solving and digital innovation skills that enable you to create simple software solutions, support business technology, and adapt to emerging ICT trends.",

    "Study in a flexible and supportive learning environment with quality facilities, student support services, career guidance, and opportunities to progress to Diploma and Degree programmes.",

    "Join an ISO 9001:2015 Certified university recognized for academic excellence, innovation, industry partnerships, and producing graduates who are ready for today's digital workplace."

  ],

  entryRequirements: [

    "An aggregate grade D Plain and grades D in Mathematics and English.",

    "Pass in Artisan Level where applicable.",

    "Any other equivalent qualification as approved by KNEC."

  ],

  duration: 5,

  durationType: "Terms",

  durationYears: null,

  mode: "Physical classes only",

  fee: 15000,

  feeType: "Per Term",

  intake: [
    "January",
    "May",
    "September"
  ],

  /*
   * Original duration information retained
   * for compatibility with existing components.
   */
  durationDetails: {
    duration: "5 terms",
    modeOfDelivery: "Physical classes only",
    intake: "January, May & September intakes"
  },

  /*
   * Standard career field used by the
   * newer programme components.
   */
  careers: [

    "ICT Assistant",

    "Data Entry Clerk",

    "ICT Consultant",

    "Web Developer",

    "ICT Specialist",

    "Data Modeler"

  ],

  /*
   * Original career field retained so older
   * components continue to work.
   */
  careerOpportunities: [

    "ICT Assistant",

    "Data Entry Clerk",

    "ICT Consultant",

    "Web developer",

    "ICT specialist",

    "Data modeler"

  ],

  skills: [

    "Information Communication Technology",

    "Computer Applications",

    "Computer Hardware",

    "Computer Software",

    "Operating Systems",

    "Computer Support and Maintenance",

    "Computer Applications II",

    "Structured Programming",

    "Basic Electronics",

    "Mathematics",

    "Entrepreneurship",

    "Communication Skills",

    "Business Research Methods",

    "Networking",

    "ICT Troubleshooting",

    "Digital Technologies",

    "Technical Support",

    "Software Problem-Solving",

    "ICT Project Development",

    "Computer Systems Management"

  ],

  ctaTitle:
    "Ready to Start Your ICT Career?",

  ctaText:
    "Join Zetech University and develop practical ICT skills in computer applications, hardware, software, programming, operating systems and computer support through a recognized KNEC qualification designed to prepare you for today's digital workplace and further studies.",

  curriculum: [

    {
      year: "Year One",

      semester: "Semester One",

      units: [

        {
          code: "CMB 112",
          title: "Entrepreneurship Education"
        },

        {
          code: "CMB 115",
          title: "Communication Skills"
        },

        {
          code: "CTZ 111",
          title: "Introduction to Information Communication Technology"
        },

        {
          code: "CTZ 112",
          title: "Computer Applications"
        },

        {
          code: "CTZ 113",
          title: "Basic Electronics"
        },

        {
          code: "CTZ 114",
          title: "Mathematics"
        },

        {
          code: "CTZ 115",
          title: "Operating Systems"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Two",

      units: [

        {
          code: "CMB 122",
          title: "Entrepreneurship Education"
        },

        {
          code: "CMB 125",
          title: "Communication Skills"
        },

        {
          code: "CTZ 121",
          title: "Introduction to Information Communication Technology"
        },

        {
          code: "CTZ 122",
          title: "Computer Applications"
        },

        {
          code: "CTZ 123",
          title: "Basic Electronics"
        },

        {
          code: "CTZ 124",
          title: "Mathematics"
        },

        {
          code: "CTZ 125",
          title: "Operating Systems"
        }

      ]
    },

    {
      year: "Year One",

      semester: "Semester Three",

      units: [

        {
          code: "CMB 132",
          title: "Entrepreneurship Education"
        },

        {
          code: "CMB 135",
          title: "Communication Skills"
        },

        {
          code: "CTZ 131",
          title: "Introduction to Information Communication Technology"
        },

        {
          code: "CTZ 132",
          title: "Computer Applications"
        },

        {
          code: "CTZ 133",
          title: "Basic Electronics"
        },

        {
          code: "CTZ 134",
          title: "Mathematics"
        },

        {
          code: "CTZ 135",
          title: "Operating Systems"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester One",

      units: [

        {
          code: "CSW 125",
          title: "Business Research Methods"
        },

        {
          code: "CTZ 211",
          title: "Computer Support and Maintenance"
        },

        {
          code: "CTZ 212",
          title: "Computer Applications II"
        },

        {
          code: "CTZ 213",
          title: "Structured Programming"
        },

        {
          code: "CTZ 214",
          title: "Course Specialization - Project"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester Two",

      units: [

        {
          code: "CTZ 221",
          title: "Computer Support and Maintenance"
        },

        {
          code: "CTZ 222",
          title: "Computer Applications II"
        },

        {
          code: "CTZ 223",
          title: "Structured Programming"
        },

        {
          code: "CTZ 224",
          title: "Course Specialization - Project"
        }

      ]
    },

    {
      year: "Year Two",

      semester: "Semester Three",

      units: [

        {
          code: "CTZ 231",
          title: "Computer Support and Maintenance"
        },

        {
          code: "CTZ 232",
          title: "Computer Applications II"
        },

        {
          code: "CTZ 233",
          title: "Structured Programming"
        },

        {
          code: "CTZ 234",
          title: "Course Specialization - Project"
        }

      ]
    }

  ],

  faqs: [

    {
      question: "How long does the programme take?",

      answer:
        "The programme takes 5 terms to complete."
    },

    {
      question: "What is the mode of study?",

      answer:
        "The programme is offered through Physical classes only."
    },

    {
      question: "When are the intakes?",

      answer:
        "Students are admitted in January, May and September."
    },

    {
      question: "What are the minimum entry requirements?",

      answer:
        "Applicants should have an aggregate grade of D Plain with grades D in Mathematics and English, a pass in Artisan Level where applicable, or any other equivalent qualification approved by KNEC."
    },

    {
      question: "Is this a KNEC programme?",

      answer:
        "Yes. The programme is a Certificate in ICT offered under KNEC."
    },

    {
      question: "What areas does the programme cover?",

      answer:
        "The curriculum covers entrepreneurship, communication skills, information communication technology, computer applications, basic electronics, mathematics, operating systems, computer support and maintenance, structured programming, business research methods and course specialization projects."
    },

    {
      question: "Does the programme include practical ICT training?",

      answer:
        "Yes. The programme provides practical training in computer applications, computer support and maintenance, programming, operating systems, hardware-related areas and course specialization projects."
    },

    {
      question: "What career opportunities are available?",

      answer:
        "Career opportunities listed for the programme include ICT Assistant, Data Entry Clerk, ICT Consultant, Web Developer, ICT Specialist and Data Modeler."
    },

    {
      question: "Can I progress to further studies?",

      answer:
        "Yes. The programme provides opportunities to progress to Diploma and Degree programmes in ICT and related fields."
    },

    {
      question: "Does the programme cover programming?",

      answer:
        "Yes. The curriculum includes Structured Programming, providing learners with foundational programming knowledge and practical problem-solving skills."
    },

    {
      question: "Does the programme cover computer maintenance?",

      answer:
        "Yes. Computer Support and Maintenance is included in the Year Two curriculum."
    },

    {
      question: "Does the programme cover computer applications?",

      answer:
        "Yes. Computer Applications is covered throughout Year One, followed by Computer Applications II in Year Two."
    }

  ],

  seo: {

    metaTitle:
      "Certificate in ICT (KNEC) | Zetech University",

    metaDescription:
      "Study the Certificate in ICT (KNEC) at Zetech University and develop practical skills in computer applications, hardware, software, operating systems, programming, computer support, maintenance and digital technologies."

  }

},

// {
//     id:56,
//     title:"Diploma in ICT (KNEC)",
//     code:"KNEC DICT",
//     school:"TVET",
//     category:"TVET",
//     feeType:"Per Term",
//     fee:15000,
//     duration:7,
//     durationType:"Terms",
//     intake:["January","May","September"]
// }

];

